// import React, { useContext, useEffect, useState, useMemo } from 'react';
// import AdminContext from '../../StateContext/Application';
// import "./Dashboard.css"
// import * as XLSX from 'xlsx';
// import jsPDF from 'jspdf';
// import html2canvas from 'html2canvas';
// import {
//   PieChart, Pie, Cell, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LabelList
// } from 'recharts';
// import { useLanguage } from '../../../../lang/langcontext/LanguageContext';
// import { apiurl } from '../../../../path';
// import autoTable from "jspdf-autotable";
// import { jwtDecode } from "jwt-decode";
// import GooglePagination from '../../styles/GooglePagination';

// const MISReport = () => {
//   // ... existing states ...
//   const [userData, setUserData] = useState(null);

//   useEffect(() => {
//     const token = localStorage.getItem("Token");
//     if (token) {
//       try {
//         // Decode the JWT token to get user details
//         const decoded = jwtDecode(token);
//         setUserData(decoded);
//         console.log("Logged User Info:", decoded);
//       } catch (error) {
//         console.error("Invalid token:", error);
//       }
//     }
//   }, []);

//   console.log("userData: ", userData);

//   const { language, toggleLanguage, t } = useLanguage();
//   const context = useContext(AdminContext);
//   const { Getyears, GetBudgetHeadInfo, TechnicalOutwards, GetProgressReportOutwardsFucntion, GetDemandRequestOutwardsFunction, WorkOutwards } = context;
//   const [showspecific, setShowSpecific] = useState(0);
//   const [showGraph, setShowGraph] = useState("Table");
//   const [releasefromfdutf, setreleasefromfdutf] = useState([]);
//   const [proposal, setproposal] = useState([]);
//   const [demandgeneration, setdemandgeneration] = useState([]);
//   const [selectedYear, setSelectedYear] = useState('2026-2027');
//   const [selectedDistrict, setSelectedDistrict] = useState('');
//   const [selectedTaluka, setSelectedTaluka] = useState('');
//   const [selectedBillDistrict, setSelectedBillDistrict] = useState('');
//   const [billDistrictSearch, setBillDistrictSearch] = useState('');
//   const [selectedTalukaHeadCode, setSelectedTalukaHeadCode] = useState("");
//   const [showDemandDistrictTable, setShowDemandDistrictTable] = useState(false);
//   const [selectedDemandDistrict, setSelectedDemandDistrict] = useState('');
//   const [exportingPDF, setExportingPDF] = useState(false);

//   const [selectedWorkname, setSelectedWorkname] = useState();
//   const [selectedDemandID, setSelectedDemandID] = useState();
//   const [selectedDemandTaluka, setSelectedDemandTaluka] = useState('');
//   const [selectedContractor, setSelectedContractor] = useState();
//   const [selectedGR, setSelectedGR] = useState();

//   const [filteredreleaseudf, setfilterreleaseudf] = useState([]);
//   const [talukawiseProposalData, settalukawiseProposalData] = useState();
//   const [fetchSpecificProposalData, setFetchSpecificProposalData] = useState();
//   const [fetchAllDemandBYDistrict, setFetchAllDemandBYDistrict] = useState([]);
//   const [fetchSpecificDemandDeductionDetail, setfetchSpecficDemandDeductionDetail] = useState([]);
//   const [talukawiseDemandData, setTalukawiseDemandData] = useState([]);
//   const [sortedDemandDatabytaluka, setSortedDemanddatabytaluka] = useState([]);
//   const [SpecificContractorDetail, setSpecificConstractorDetail] = useState();
//   const [ContractorBillDetail, setConstractorBillDetail] = useState([]);
//   const [totalGRCreated, setTotalGRCreated] = useState();
//   const [AllGRS, setALLGRS] = useState([]);
//   const [totalTSCreated, setTotalTSCreated] = useState([]);
//   const [allTSData, setallTSData] = useState([]);
//   const [originalTSData, setOriginalTSData] = useState([]);
//   const [MHUIDnumber, setMHUID] = useState();
//   const [totaldemandreqAMT, setTotaldemandreqAMT] = useState();
//   const [DRtableData, setDRtableData] = useState([]);
//   const [originalDRtableData, setOriginalDRtableData] = useState([]);
//   const [workorderlength, setworkorderlength] = useState('0');
//   const [workOrderData, setWorkOrderData] = useState([]);
//   const [originalworkOrderData, setOriginalWorkOrderData] = useState([]);
//   const [ProposalDetailByGR, setProposalDetailByGR] = useState([]);
//   const [FilterDataOfMHUID, setFilterDataOfMHUID] = useState();
//   const [loading, setLoading] = useState(false);
//   const [searchBill, setSearchBill] = useState();
//   const [searchTaluka, setSearchTaluka] = useState();
//   const [searchGR, setSearchGR] = useState();
//   const [searchGRSummary, setSearchGRSummary] = useState("");
//   const [HeadCode, setHeadCode] = useState([]);
//   const [selectedHeadCode, setSelectedHeadCode] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);

//   const [districtGRSummary, setDistrictGRSummary] = useState([]);
//   const [filteredGRS, setFilteredGRS] = useState([]);

//   const [districtTSSummary, setDistrictTSSummary] = useState([]);
//   const [filteredTSData, setFilteredTSData] = useState([]);
//   const [selectedTSDistrict, setSelectedTSDistrict] = useState("");
//   const [selectedAllTSDistrict, setSelectedAllTSDistrict] = useState("");
//   const [selectedAllTSTaluka, setSelectedAllTSTaluka] = useState("");
//   const [selectedAllTSHeadCode, setSelectedAllTSHeadCode] = useState("");
//   const [searchAllTS, setSearchAllTS] = useState("");

//   const [districtDRSummary, setDistrictDRSummary] = useState([]);
//   const [filteredDRData, setFilteredDRData] = useState([]);

//   const [districtWOSummary, setDistrictWOSummary] = useState([]);
//   const [filteredWOData, setFilteredWOData] = useState([]);
//   const [selectedWOHeadCode, setSelectedWOHeadCode] = useState("");
//   const [searchWorkOrder, setSearchWorkOrder] = useState("");
//   const [districtPage, setDistrictPage] = useState(1);
//   const [showAllDistrict, setShowAllDistrict] = useState(false);
//   const [talukaPage, setTalukaPage] = useState(1);
//   const [showAllTaluka, setShowAllTaluka] = useState(false);
//   const [talukaDemandPage, setTalukaDemandPage] = useState(1);
//   const [showAllTalukaDemand, setShowAllTalukaDemand] = useState(false);
//   const [districtGRPage, setDistrictGRPage] = useState(1);
//   const [showAllDistrictGR, setShowAllDistrictGR] = useState(false);
//   const [selectedGRDistrict, setSelectedGRDistrict] = useState('');
//   const [searchTSSummary, setSearchTSSummary] = useState("");
//   const [showAllGR, setShowAllGR] = useState(false);
//   const [showAllProposalGR, setShowAllProposalGR] = useState(false);
//   const [showAllTS, setShowAllTS] = useState(false);
//   const [showAllTSDetails, setShowAllTSDetails] = useState(false);
//   const [districtWOPage, setDistrictWOPage] = useState(1);
//   const [showAllDistrictWO, setShowAllDistrictWO] = useState(false);
//   const [selectedWODistrict, setSelectedWODistrict] = useState("");
//   const [searchWO, setSearchWO] = useState("");
//   const [selectedTableHeadCode, setSelectedTableHeadCode] = useState("");

//   const getMainDistrict = (district) => {
//     if (!district) return "";

//     return String(district).split("-")[0].trim();
//   };

//   const isDistrictMatch = (itemDistrict, selectedDistrict) => {
//     if (!selectedDistrict) return true;

//     return getMainDistrict(itemDistrict) === getMainDistrict(selectedDistrict);
//   };


//   const itemsPerPage = 10;

//   const indexOfLastGRS = currentPage * itemsPerPage;
//   const indexOfFirstGRS = indexOfLastGRS - itemsPerPage;

//   const billRecordsPerPage = 10;

//   const totalBillRecords = ContractorBillDetail?.length || 0;

//   const indexOfLastBill = currentPage * billRecordsPerPage;

//   const indexOfFirstBill = indexOfLastBill - billRecordsPerPage;
//   const totalBillPages = Math.ceil(
//     totalBillRecords / billRecordsPerPage
//   );
//   console.log("totalGRCreated ::", totalGRCreated);
//   console.log("AllGRS ::", AllGRS);

//   console.log("allTSData ::", allTSData);
//   console.log("originalTSData ::", originalTSData);

//   console.log("DRtableData ::", DRtableData);
//   console.log("originalDRtableData ::", originalDRtableData);

//   console.log("workOrderData ::", workOrderData);
//   console.log("originalworkOrderData ::", originalworkOrderData);

//   console.log("selectedYear: ", selectedYear);
//   console.log("selectedHeadCode: ", selectedHeadCode);

//   const currentBills = ContractorBillDetail?.slice(
//     indexOfFirstBill,
//     indexOfLastBill
//   ) || [];

//   // const indexOfLastGRS = currentPage * recordsPerPage;
//   // const indexOfFirstGRS = indexOfLastBill - recordsPerPage;
//   const currentAllGRS = AllGRS.slice(
//     indexOfFirstGRS,
//     indexOfLastGRS
//   ) || [];

//   // const displayedGRS = exportingPDF ? AllGRS : paginatedGRS;

//   const recordsPerPageUDF = 10;
//   const totalUDFRecords = talukawiseProposalData?.length || 0;
//   const totalUDFPages = Math.ceil(totalUDFRecords / recordsPerPageUDF);

//   const indexOfLastUDF = currentPage * recordsPerPageUDF;
//   const indexOfFirstUDF = indexOfLastUDF - recordsPerPageUDF;

//   const currenttalukawiseProposalData = Array.isArray(talukawiseProposalData)
//     ? talukawiseProposalData.slice(indexOfFirstUDF, indexOfLastUDF)
//     : [];

//   // total records
//   const totalRecordsDemandDatabytaluka =
//     Array.isArray(sortedDemandDatabytaluka) ? sortedDemandDatabytaluka.length : 0;

//   // total pages
//   const totalPagesDatabytaluka = Math.ceil(
//     totalRecordsDemandDatabytaluka / billRecordsPerPage
//   );

//   // pagination indexes
//   const lastRecordIndexDatabytaluka = currentPage * billRecordsPerPage;
//   const firstRecordIndexDatabytaluka =
//     lastRecordIndexDatabytaluka - billRecordsPerPage;

//   // current page data
//   const talukaDemandRecordsPerPage = 10;

//   const totalTalukaDemandPages = Math.ceil(
//     sortedDemandDatabytaluka.length / talukaDemandRecordsPerPage
//   );

//   const currentTalukaDemandData = showAllTalukaDemand
//     ? sortedDemandDatabytaluka
//     : sortedDemandDatabytaluka.slice(
//       (talukaDemandPage - 1) * talukaDemandRecordsPerPage,
//       talukaDemandPage * talukaDemandRecordsPerPage
//     );

//   const tsRecordsPerPage = 10;

//   const filteredDistrictTSSummary = districtTSSummary.filter((item) => {
//     // District filter
//     const districtMatch =
//       isDistrictMatch(item.District, selectedTSDistrict);

//     // Random search
//     const searchText = searchTSSummary.trim().toLowerCase();

//     const searchMatch =
//       !searchText ||
//       [
//         item.District,
//         selectedYear,
//         item.TotalTS,
//         item.TotalAmount,
//       ].some((value) =>
//         String(value ?? "")
//           .toLowerCase()
//           .includes(searchText)
//       );

//     return districtMatch && searchMatch;
//   });

//   const totalTSPages = Math.ceil(
//     filteredDistrictTSSummary.length / tsRecordsPerPage
//   );

//   const paginatedTSData = showAllTS
//     ? filteredDistrictTSSummary
//     : filteredDistrictTSSummary.slice(
//       (districtPage - 1) * tsRecordsPerPage,
//       districtPage * tsRecordsPerPage
//     );


//   const [currentPageProgress, setCurrentPageProgress] = useState(1);

//   const recordsPerPageProgress = 10;

//   const totalProgressPages = Math.ceil(
//     (FilterDataOfMHUID?.length || 0) / recordsPerPageProgress
//   );

//   const lastRecordIndexProgress =
//     currentPageProgress * recordsPerPageProgress;

//   const firstRecordIndexProgress =
//     lastRecordIndexProgress - recordsPerPageProgress;

//   const currentProgressData = FilterDataOfMHUID?.slice(
//     firstRecordIndexProgress,
//     lastRecordIndexProgress
//   ) || [];

//   const woRecordsPerPage = 10;

//   const filteredDistrictWOSummary = districtWOSummary.filter((item) => {
//     const districtMatch =
//       isDistrictMatch(item.District, selectedWODistrict);

//     const searchValue = searchWO.trim().toLowerCase();

//     const searchMatch =
//       !searchValue ||
//       [
//         item.District,
//         selectedYear,
//         item.TotalWO,
//         item.TotalAmount,
//       ].some((value) =>
//         String(value ?? "")
//           .toLowerCase()
//           .includes(searchValue)
//       );

//     return districtMatch && searchMatch;
//   });

//   const totalWOPages = Math.ceil(
//     filteredDistrictWOSummary.length / woRecordsPerPage
//   );

//   const paginatedWOData = showAllDistrictWO
//     ? filteredDistrictWOSummary
//     : filteredDistrictWOSummary.slice(
//       (districtWOPage - 1) * woRecordsPerPage,
//       districtWOPage * woRecordsPerPage
//     );

//   const [currentPageAllTSData, setCurrentPageAllTSData] = useState(1);
//   const recordsPerPageAllTSData = 10;

//   // index calculation
//   const lastRecordIndexAllTSData =
//     currentPageAllTSData * recordsPerPageAllTSData;

//   const firstRecordIndexAllTSData =
//     lastRecordIndexAllTSData - recordsPerPageAllTSData;

//   const [currentPageProposalDetailByGR, setCurrentPageProposalDetailByGR] = useState(1);
//   const recordsPerPageProposalDetailByGR = 10;
//   // total records
//   const totalRecordsProposalDetailByGR = ProposalDetailByGR?.length || 0;

//   // total pages
//   const totalPagesProposalDetailByGR = Math.ceil(
//     totalRecordsProposalDetailByGR / recordsPerPageProposalDetailByGR
//   );

//   // index calculation
//   const lastRecordIndexProposalDetailByGR =
//     currentPageProposalDetailByGR * recordsPerPageProposalDetailByGR;

//   const firstRecordIndexProposalDetailByGR =
//     lastRecordIndexProposalDetailByGR - recordsPerPageProposalDetailByGR;

//   // current page data
//   const currentProposalDetailByGR = ProposalDetailByGR.slice(
//     firstRecordIndexProposalDetailByGR,
//     lastRecordIndexProposalDetailByGR
//   );

//   /////////////////////
//   const [currentPageDRtableData, setCurrentPageDRtableData] = useState(1);
//   const recordsPerPageDRtableData = 10;

//   // index calculation
//   const lastRecordIndexDRtableData =
//     currentPageDRtableData * recordsPerPageDRtableData;

//   const firstRecordIndexDRtableData =
//     lastRecordIndexDRtableData - recordsPerPageDRtableData;

//   /////////////////////////
//   const [currentPageWorkOrderData, setCurrentPageWorkOrderData] = useState(1);
//   const recordsPerPageWorkOrderData = 10;

//   // index calculation
//   const lastRecordIndexWorkOrderData =
//     currentPageWorkOrderData * recordsPerPageWorkOrderData;

//   const firstRecordIndexWorkOrderData =
//     lastRecordIndexWorkOrderData - recordsPerPageWorkOrderData;

//   const fetchAllHeads = async () => {
//     try {
//       let res = await GetBudgetHeadInfo('null', "AllHeadCode");
//       const sortedData = res.sort((a, b) =>
//         new Date(a.Date) - new Date(b.Date)
//       );
//       setHeadCode(sortedData);
//     }
//     catch (err) {
//       console.log(err);
//     }
//   }

//   useEffect(() => {
//     fetchAllHeads();
//   }, [])

//   const fetchData = async () => {
//     const data = await Getyears("oldCode", "ALL", selectedHeadCode);
//     setreleasefromfdutf(data?.projectQuery || []);
//     setproposal(data?.ProposalQuery || []);   //this is setting empty
//     setdemandgeneration(data?.projectQuery || []);
//     console.log("Fetched Data of de gene:", data?.projectQuery);
//   };

//   useEffect(() => {
//     fetchData();
//   }, [selectedYear, selectedHeadCode]);

//   const fetchAllData = async () => {
//     try {
//       const data1 = await Getyears("fetchTotalGRCreated", selectedYear, selectedHeadCode);
//       setTotalGRCreated(data1.count);
//       setALLGRS(data1.grs)
//     }
//     catch (err) {
//       console.log(err);
//     }
//   }
//   //fetching data or TS
//   const fetchforTS = async () => {
//     try {
//       const data1 = await TechnicalOutwards("Technical");
//       console.log("data for TS", data1);
//       setTotalTSCreated(data1.message.length);
//       setallTSData(data1.message);
//       setOriginalTSData(data1.message);
//     }
//     catch (err) {
//       console.log(err);
//     }
//   }

//   //here to fetch MHUID details after clicking 
//   const FetchDataForMHUID = async (selectedYear, MHUIDno, selectedHeadCode) => {
//     try {
//       let res = await GetProgressReportOutwardsFucntion();
//       const { status, message } = res;

//       if (status) {
//         const sortedData = message.sort((a, b) =>
//           new Date(a.Date) - new Date(b.Date)
//         );
//         console.log("✅ Progress Report Outwards Data:", sortedData);
//         const filtered = sortedData.filter(item => item.ProposalYear === selectedYear && item.TechnicalUID === MHUIDno && item.Head_Code === selectedHeadCode);
//         console.log("Filtered Data:", filtered);
//         setFilterDataOfMHUID(filtered);
//         setMHUID(MHUIDno);
//         setShowSpecific(111);
//       }
//       else {
//         alert(message);
//       }
//     } catch (error) {
//       console.error("❌ Error fetching progress report outwards:", error);
//     }

//   };

//   //fetching data for demand requ

//   const getTechnicalInwardsList = async () => {
//     let data = await GetDemandRequestOutwardsFunction('', '')
//     const { status, message } = data;
//     if (status) {
//       const sortedData = message.sort((a, b) =>
//         new Date(a.created_At) - new Date(b.created_At)
//       );
//       console.log("Demand Request Outwards Data:", sortedData);
//       const totalDRAmount = sortedData.reduce((sum, row) => {
//         //just becuase we have declare varchar instead of int
//         const value = Number(String(row.DRAmount || "0").replace(/,/g, ""));
//         return sum + value;
//       }, 0);
//       setTotaldemandreqAMT(totalDRAmount);
//       setDRtableData(sortedData);
//       setOriginalDRtableData(sortedData);
//       console.log("Total DRAmount:", totalDRAmount);
//       // setTechnicalInwards(sortedData);
//       // setProposalList(sortedData);
//     }
//     else {
//       alert(message);
//     }

//   }

//   // fetch work order details
//   const workOrderDetails = async () => {
//     let data = await WorkOutwards()
//     setworkorderlength(data.message.length)
//     setWorkOrderData(data.message)
//     setOriginalWorkOrderData(data.message)
//     console.log("this is for work order outward", data);
//   }


//   useEffect(() => {
//     if (selectedYear && selectedHeadCode) {
//       fetchAllData();
//       fetchforTS();
//       getTechnicalInwardsList();
//       workOrderDetails();
//     }
//   }, [selectedYear, selectedHeadCode]);

//   // const allYears = [
//   //   ...new Set([
//   //     ...releasefromfdutf.map(item => item.ProposalYear),
//   //   ]),
//   // ].filter(Boolean).sort();

//   const filterDemandByYear = (demandgeneration, selectedYear, selectedHeadCode) => {

//     if (!selectedYear || !demandgeneration) return [];
//     return demandgeneration.filter(item =>
//       item.ProposalYear == selectedYear &&
//       item.HeadCode == selectedHeadCode
//     );
//   };

//   const filteredDemandGenerationData = filterDemandByYear(demandgeneration, selectedYear, selectedHeadCode);
//   console.log("filteredDemandGenerationData", filteredDemandGenerationData);
//   const totalDemandAmount = filteredDemandGenerationData.reduce((sum, item) => {
//     return sum + (parseFloat(item.BillPaidAmount) || 0);
//   }, 0);

//   const demandDistrictSummary = filteredDemandGenerationData.reduce((acc, curr) => {
//     const district = curr.talulka;
//     const amount = parseFloat(curr.BillPaidAmount) || 0;

//     if (!acc[district]) {
//       acc[district] = { District: district, TotalBillAmount: amount };
//     } else {
//       acc[district].TotalBillAmount += amount;
//     }

//     return acc;
//   }, {});

//   const demandDistrictData = Object.values(demandDistrictSummary);

//   const filteredBillDistrictData = demandDistrictData.filter((item) => {
//     const matchesDistrict =
//       isDistrictMatch(item.District, selectedBillDistrict);

//     const searchText = billDistrictSearch.toLowerCase().trim();

//     const matchesSearch =
//       !searchText ||
//       String(item.District ?? "").toLowerCase().includes(searchText) ||
//       String(selectedYear ?? "").toLowerCase().includes(searchText) ||
//       String(item.HeadCode ?? selectedHeadCode ?? "").toLowerCase().includes(searchText) ||
//       String(item.TotalBillAmount ?? "").toLowerCase().includes(searchText);

//     return matchesDistrict && matchesSearch;
//   });


//   const districtRecordsPerPage = 10;

//   const totalDistrictPages = Math.ceil(
//     filteredBillDistrictData.length / districtRecordsPerPage
//   );

//   const paginatedDistrictData = showAllDistrict
//     ? filteredBillDistrictData
//     : filteredBillDistrictData.slice(
//       (districtPage - 1) * districtRecordsPerPage,
//       districtPage * districtRecordsPerPage
//     );


//   const filteredTalukaData = talukawiseDemandData.filter(
//     (t) =>
//       !searchTaluka ||
//       t.taluka?.toLowerCase().includes(searchTaluka.toLowerCase())
//   );

//   const talukaRecordsPerPage = 10;

//   const totalTalukaPages = Math.ceil(
//     filteredTalukaData.length / talukaRecordsPerPage
//   );

//   const paginatedTalukaData = showAllTaluka
//     ? filteredTalukaData
//     : filteredTalukaData.slice(
//       (talukaPage - 1) * talukaRecordsPerPage,
//       talukaPage * talukaRecordsPerPage
//     );

//   const demandDataForDistrict = selectedDemandDistrict
//     ? filteredDemandGenerationData.filter(item => isDistrictMatch(item.District, selectedDemandDistrict))
//     : [];

//   const filteredreleasefromfdutf = selectedYear
//     ? releasefromfdutf.filter(item => item.ProposalYear === selectedYear && item.HeadCode == selectedHeadCode && item.HeadCode == selectedHeadCode)
//     : [];

//   const hasData = (selectedYear) && (
//     filteredreleasefromfdutf.length > 0
//   );

//   const districtSummary = filteredreleasefromfdutf.reduce((acc, curr) => {
//     const district = curr.District;
//     const amount = parseFloat(curr.OriginalLimitAllocatedAmount) || 0;

//     if (!acc[district]) {
//       acc[district] = { District: district, TotalLimitAllottedAmount: amount };
//     } else {
//       acc[district].TotalLimitAllottedAmount += amount;
//     }

//     return acc;
//   }, {});

//   const uniqueDistrictsData = Object.values(districtSummary);
//   const districtGRRecordsPerPage = 10;

//   const filteredDistrictGRSummary = districtGRSummary.filter((item) => {
//     const districtMatch =
//       isDistrictMatch(item.District, selectedGRDistrict);

//     const searchText = searchGRSummary.trim().toLowerCase();

//     const searchMatch =
//       !searchText ||
//       [
//         item.District,
//         selectedYear,
//         item.TotalGR,
//         item.TotalAmount,
//       ].some((value) =>
//         String(value ?? "")
//           .toLowerCase()
//           .includes(searchText)
//       );

//     return districtMatch && searchMatch;
//   });
//   const totalDistrictGRPages = Math.ceil(
//     filteredDistrictGRSummary.length / districtGRRecordsPerPage
//   );

//   const paginatedDistrictGR = showAllDistrictGR
//     ? filteredDistrictGRSummary
//     : filteredDistrictGRSummary.slice(
//       (districtGRPage - 1) * districtGRRecordsPerPage,
//       districtGRPage * districtGRRecordsPerPage
//     );
//   const proposalGRRecordsPerPage = 10;

//   const paginatedProposalGR = showAllProposalGR
//     ? ProposalDetailByGR
//     : ProposalDetailByGR.slice(
//       firstRecordIndexProposalDetailByGR,
//       lastRecordIndexProposalDetailByGR
//     );

//   const detailedDistrictData = selectedDistrict
//     ? filteredreleasefromfdutf.filter(item => isDistrictMatch(item.District, selectedDistrict))
//     : [];

//   const filteredProposalData = selectedTaluka
//     ? proposal.filter(
//       item =>
//         item.Proposal_year === selectedYear &&
//         item.HeadCode == selectedHeadCode &&
//         item.District === selectedDistrict &&
//         item.Taluka === selectedTaluka
//     )
//     : [];


//   const releasefromfdutfFields = ['District', 'Year', 'HeadCode', 'TotalLimitAllottedAmount'];

//   // new function added fit release
//   const totalLimitAllocationAmount = releasefromfdutf
//     .filter(item => item.ProposalYear == selectedYear && item.HeadCode == selectedHeadCode)
//     .reduce((sum, item) => {
//       return sum + (parseFloat(item.OriginalLimitAllocatedAmount) || 0);
//     }, 0);

//   const fetchreleasefromUdfData = (year, district, selectedHeadCode) => {
//     setSelectedDistrict(district);
//     setSelectedYear(year);
//     setSelectedHeadCode(selectedHeadCode);
//     console.log("para i get :: ", year, district)
//     let res = releasefromfdutf.filter((item) => item.ProposalYear == year && item.District == district && item.HeadCode == selectedHeadCode);
//     let filtered = releasefromfdutf.filter((item) => item.ProposalYear == year && item.District == district && item.HeadCode == selectedHeadCode);

//     const groupedByTaluka = {};

//     filtered.forEach((item) => {
//       const taluka = item.Taluka || "Unknown";
//       const year = item.Proposal_year || "Unknown";
//       const head = item.HeadCode || "Unknown";

//       if (!groupedByTaluka[taluka]) {
//         groupedByTaluka[taluka] = {
//           year: year,
//           head: head,
//           Taluka: taluka,
//           totalLimitAllocated: 0,
//           totalRemainingLimit: 0,
//           totalReleaseAmount: 0
//         };
//       }

//       groupedByTaluka[taluka].totalProposalCost += parseFloat(item.ProposalCost || 0);
//       groupedByTaluka[taluka].totalLimitAllocated += parseFloat(item.OriginalLimitAllocatedAmount || 0);
//       groupedByTaluka[taluka].totalRemainingLimit += parseFloat(item.LimitAllottedAmount || 0);
//       groupedByTaluka[taluka].totalReleaseAmount += parseFloat(item.ReleaseAmountTillDate || 0);
//       // groupedByTaluka[taluka].records.push(item);
//     });

//     const talukaWiseData = Object.values(groupedByTaluka);
//     console.log("Taluka-wise Aggregated Data ::", talukaWiseData);

//     console.log("data set LL ", res);
//     setfilterreleaseudf(talukaWiseData);
//     setShowSpecific(2);
//   };

//   const fetchProposalfromReleaseBytaluka = (tal) => {
//     let res = releasefromfdutf.filter((item) => item.Taluka == tal && item.ProposalYear == selectedYear);
//     settalukawiseProposalData(res);
//     setSelectedTaluka(tal);
//     setShowSpecific(3);
//   }

//   const ProposalDataUsingSelectedProposal = async (ID) => {
//     try {
//       let res = await Getyears("FetchProposalbyworkname", ID, selectedHeadCode);
//       setFetchSpecificProposalData(res);
//       setSelectedWorkname(ID);
//       setShowSpecific(4);
//     }
//     catch (err) {
//       console.log(err);
//     }
//   }

//   // Dmeand generation 
//   const DemandGenerationSortByDistrict = async (district) => {
//     try {
//       let obj = {
//         district: district,
//         year: selectedYear,
//         head: selectedHeadCode
//       }
//       let res = await Getyears("FetchDemandbyDistrict", obj, selectedHeadCode);
//       setFetchAllDemandBYDistrict(res);
//       console.log("qww", res)
//       setSelectedDemandDistrict(district);

//       const talukaTotalsMap = {};

//       res.forEach(item => {
//         const taluka = item.ulb || "Unknown";
//         const year = item.ProposalYear || "Unknown";
//         const head = item.BudgetHead || "Unknown";
//         const key = `${taluka}-${year}`;

//         if (!talukaTotalsMap[key]) {
//           talukaTotalsMap[key] = {
//             totalBillAmount: 0,
//             totalNetPayable: 0,
//             totalDeduction: 0,
//             taluka: taluka,
//             year: selectedYear,
//             head: selectedHeadCode
//           };
//         }

//         talukaTotalsMap[key].totalBillAmount += parseFloat(item.BillAmount || 0);
//         talukaTotalsMap[key].totalNetPayable += parseFloat(item.NetPayableAmount || 0);
//         talukaTotalsMap[key].totalDeduction += parseFloat(item.DeductionAmount || 0);
//       });

//       const talukaTotalsArray = Object.values(talukaTotalsMap);

//       setTalukawiseDemandData(talukaTotalsArray);
//       setShowSpecific(51);
//       console.log("Demand filtered by taluka:", talukaTotalsArray);
//       setShowSpecific(51);
//     }
//     catch (err) {
//       console.log(err);
//     }
//   }

//   const DemandGenerationSortByTaluka = (tal) => {
//     let res = fetchAllDemandBYDistrict.filter((item) => item.ulb == tal);
//     setSortedDemanddatabytaluka(res);
//     setSelectedDemandTaluka(tal);
//     setShowSpecific(52);
//   }

//   const DemandDeductionDetailByBillID = async (ID, showid) => {
//     console.log("ID and showid", ID, showid);

//     try {
//       let res = await Getyears("FetchDemandDeductionDetailbyBillID", ID, selectedHeadCode);
//       console.log("resForDeduction", res);

//       setfetchSpecficDemandDeductionDetail(res);
//       setSelectedDemandID(ID);
//       setShowSpecific(showid);
//     }
//     catch (err) {
//       console.log(err);
//     }
//   }

//   const VendorBillDetailByContractorName = async (name) => {
//     try {
//       let obj = {
//         year: selectedYear,
//         vendor: name,

//       }
//       let res = await Getyears("FetchVendorBillDetailByName", obj, selectedHeadCode);
//       console.log("resVendor", res);

//       setConstractorBillDetail(res);
//       setSelectedContractor(name);
//       setShowSpecific(57);
//     }
//     catch (err) {
//       console.log(err);
//     }
//   }

//   const ContractorDetailByContractorName = async (name) => {
//     try {
//       let res = await Getyears("FetchContractorDetailByName", name, "null");
//       setSpecificConstractorDetail(res);
//       setSelectedContractor(name);
//       setShowSpecific(58);
//     }
//     catch (err) {
//       console.log(err);
//     }
//   }

//   // gr operation 
//   const proposalDetailbyGR = async (GID) => {
//     try {
//       let res = await Getyears("FetchProposalDetailByGRID", GID, selectedHeadCode);
//       setProposalDetailByGR(res);
//       setSelectedGR(GID);
//       setShowSpecific(101);
//     }
//     catch (err) {
//       console.log(err);
//     }
//   }

//   // useEffect(() => {
//   //   if (selectedYear && selectedDistrict) {
//   //     fetchreleasefromUdfData(selectedYear, selectedDistrict);
//   //   }
//   // }, [selectedDistrict, selectedYear]);


//   // const exportTableByClassToExcel = (classname, filename = "Export.xlsx") => {
//   //   const table = document.querySelector(`.${classname}`);
//   //   if (!table) {
//   //     alert("Table with the specified class not found!");
//   //     return;
//   //   }

//   //   // Create worksheet from table
//   //   const worksheet = XLSX.utils.table_to_sheet(table);

//   //   const numCols = table.rows[0].cells.length;
//   //   worksheet['!cols'] = Array(numCols).fill({ wch: 20 });
//   //   worksheet['!freeze'] = { xSplit: 0, ySplit: 1 };

//   //   worksheet['!autofilter'] = {
//   //     ref: XLSX.utils.encode_range({
//   //       s: { r: 0, c: 0 },
//   //       e: { r: table.rows.length - 1, c: numCols - 1 }
//   //     })
//   //   };

//   //   const workbook = XLSX.utils.book_new();
//   //   XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
//   //   XLSX.writeFile(workbook, filename);
//   // };
//   const exportTableByClassToExcel = async (classname, filename = "Export.xlsx") => {
//     // ---------- 0. Show ALL rows temporarily (no UI/button change needed) ----------
//     const showAllMap = {
//       "50:AllGR": [setShowAllDistrict, showAllDistrict],
//       "100:AllGR": [setShowAllGR, showAllGR],
//       "51:TalukaWiseDemandTable": [setShowAllTaluka, showAllTaluka],
//       "52:BillsDataTable": [setShowAllTalukaDemand, showAllTalukaDemand],
//       "99:ALlDistrictFinanceData": [setShowAllDistrictGR, showAllDistrictGR],
//       "109:ALlDistrictFinanceData": [setShowAllTS, showAllTS],
//       "115:ALlDistrictFinanceData": [setShowAllDistrictWO, showAllDistrictWO],
//       "101:ProposalContainer": [setShowAllProposalGR, showAllProposalGR],
//       "110:ALlTechnicalSData": [setShowAllTSDetails, showAllTSDetails],
//     };
//     const entry = showAllMap[`${showspecific}:${classname}`];
//     const setShowAll = entry ? entry[0] : null;
//     const previousShowAll = entry ? entry[1] : null;

//     if (setShowAll && !previousShowAll) {
//       setShowAll(true);
//       await new Promise((res) => setTimeout(res, 700)); // wait for all rows to render
//     }

//     try {
//       const table = document.querySelector(`.${classname}`);

//       if (!table) {
//         alert("Table with the specified class not found!");
//         return;
//       }

//       const tableText = table.innerText.toLowerCase();
//       const hasTotals =
//         tableText.includes("page total") && tableText.includes("gross total");

//       let worksheet;
//       let bodyCount = 0;

//       if (hasTotals) {
//         const data = Array.from(table.rows).map((row) =>
//           Array.from(row.cells).map((cell) => cell.innerText.trim())
//         );

//         const header = data[0];

//         const body = Array.from(table.querySelectorAll("tbody tr"))
//           .map((row) =>
//             Array.from(row.cells).map((cell) => cell.innerText.trim())
//           )
//           .filter((row) => {
//             const text = row.join(" ").toLowerCase();

//             return (
//               !text.includes("page total") &&
//               !text.includes("gross total") &&
//               !text.includes("no data") &&
//               row.length > 1
//             );
//           });

//         // Renumber Sr No from 1
//         const firstHeader = String(header[0] || "").toLowerCase();
//         if (firstHeader.startsWith("sr")) {
//           body.forEach((row, i) => {
//             row[0] = i + 1;
//           });
//         }

//         // const isAmt = (s) => /^₹\s*-?[\d,]+(\.\d+)?$/.test(String(s ?? ""));
//         // const toNum = (s) => Number(String(s).replace(/[₹,\s]/g, ""));

//         const isAmt = (s) => {
//           const value = String(s ?? "").trim();

//           if (!value) return false;

//           return /^₹?\s*-?[\d,]+(\.\d+)?$/.test(value);
//         };

//         const toNum = (s) =>
//           Number(String(s ?? "").replace(/[₹,\s]/g, ""));

//         // Amount columns = columns whose filled cells all look like "₹ 1,234"
//         // const amountCols = header
//         //   .map((_, c) => {
//         //     const filled = body.filter((r) => r[c] !== undefined && r[c] !== "");
//         //     return filled.length > 0 && filled.every((r) => isAmt(r[c])) ? c : -1;
//         //   })
//         //   .filter((c) => c >= 0);

//         const amountCols = header
//   .map((headerName, c) => {
//     if (c === 0) return -1; // don't treat Sr.No as amount

//     const filled = body
//       .map((r) => r[c])
//       .filter((v) => v !== undefined && String(v).trim() !== "");

//     const headerText = String(headerName || "").toLowerCase();

//     const isAmountHeader =
//       headerText.includes("amount") ||
//       headerText.includes("cost") ||
//       headerText.includes("bill") ||
//       headerText.includes("value");

//     const isNumericColumn =
//       filled.length > 0 && filled.every((v) => isAmt(v));

//     return isAmountHeader && isNumericColumn ? c : -1;
//   })
//   .filter((c) => c >= 0);

//         // Convert "₹ 1,128,498" -> 1128498 (real number)
//         const numericBody = body.map((row) =>
//           row.map((cell, c) =>
//             amountCols.includes(c) && isAmt(cell) ? toNum(cell) : cell
//           )
//         );

//         // Single Total row with sums
//         const totalRow = new Array(header.length).fill("");
//         // const labelCol = amountCols.length ? Math.max(amountCols[0] - 1, 0) : 0;
//         // totalRow[labelCol] = "Total";

//         if (amountCols.length > 0) {
//           totalRow[amountCols[0] - 1] = "Total";
//         } else {
//           totalRow[0] = "Total";
//         }

//         amountCols.forEach((c) => {
//           totalRow[c] = numericBody.reduce(
//             (sum, r) => sum + (typeof r[c] === "number" ? r[c] : 0),
//             0
//           );
//         });

//         bodyCount = numericBody.length;
//         worksheet = XLSX.utils.aoa_to_sheet([header, ...numericBody, totalRow]);

//         // Thousands separators on the amount cells
//         for (let r = 1; r <= bodyCount + 1; r++) {
//           amountCols.forEach((c) => {
//             const cell = worksheet[XLSX.utils.encode_cell({ r, c })];
//             if (cell && cell.t === "n") cell.z = "#,##0";
//           });
//         }
//       } else {
//         worksheet = XLSX.utils.table_to_sheet(table);
//         bodyCount = XLSX.utils.decode_range(worksheet["!ref"]).e.r;
//       }

//       const numCols = table.rows[0].cells.length;

//       worksheet["!cols"] = Array(numCols).fill({ wch: 20 });

//       // Autofilter on header + data rows only (Total row excluded)
//       worksheet["!autofilter"] = {
//         ref: XLSX.utils.encode_range({
//           s: { r: 0, c: 0 },
//           e: { r: bodyCount, c: numCols - 1 },
//         }),
//       };

//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
//       XLSX.writeFile(workbook, filename);
//     } catch (error) {
//       console.error("Excel Export Error:", error);
//     } finally {
//       // Restore the previous pagination view
//       if (setShowAll) setShowAll(previousShowAll);
//     }
//   };

//   const isElementVisible = (element) => {
//     if (!element) return false;
//     const style = window.getComputedStyle(element);
//     return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
//   };

//   // Main function - Downloads both table and chart
//   const downloadPageAsPDF = async (tableClass, chartClass, filename, title) => {
//     setLoading(true);

//     try {
//       const pdf = new jsPDF('p', 'mm', 'a4');
//       const pageWidth = pdf.internal.pageSize.getWidth();
//       const pageHeight = pdf.internal.pageSize.getHeight();
//       let currentY = 15;

//       if (title) {
//         pdf.setFontSize(18);
//         pdf.setFont(undefined, 'bold');
//         pdf.text(title, pageWidth / 2, currentY, { align: 'center' });
//         currentY += 10;
//       }

//       const originalShowGraph = showGraph;
//       let chartAdded = false;
//       let tableAdded = false;

//       // Capture Chart
//       if (originalShowGraph !== "Chart") {
//         setShowGraph("Chart");
//         await new Promise(resolve => setTimeout(resolve, 500));
//       }

//       const chartElement = document.querySelector(`.${chartClass}`);

//       if (chartElement && isElementVisible(chartElement)) {
//         pdf.setFontSize(14);
//         pdf.text('Chart View', pageWidth / 2, currentY, { align: 'center' });
//         currentY += 5;

//         const chartCanvas = await html2canvas(chartElement, {
//           scale: 2,
//           useCORS: true,
//           logging: false,
//           backgroundColor: '#ffffff'
//         });

//         const chartImgData = chartCanvas.toDataURL('image/png');
//         const chartWidth = pageWidth - 20;
//         const chartHeight = (chartCanvas.height * chartWidth) / chartCanvas.width;

//         // If chart image too tall for portrait page, put it on a landscape page
//         if (chartHeight > pageHeight - currentY - 10) {
//           // create a new landscape page and render chart there
//           pdf.addPage('l');
//           const landscapeWidth = pdf.internal.pageSize.getWidth();
//           const landscapeHeight = pdf.internal.pageSize.getHeight();

//           currentY = 15;
//           pdf.setFontSize(14);
//           pdf.text('Chart View', landscapeWidth / 2, currentY, { align: 'center' });
//           currentY += 5;

//           const adjustedWidth = landscapeWidth - 20;
//           const adjustedHeight = (chartCanvas.height * adjustedWidth) / chartCanvas.width;

//           pdf.addImage(chartImgData, 'PNG', 10, currentY, adjustedWidth, Math.min(adjustedHeight, landscapeHeight - 25));
//         } else {
//           pdf.addImage(chartImgData, 'PNG', 10, currentY, chartWidth, chartHeight);
//           currentY += chartHeight + 10;
//         }

//         chartAdded = true;
//       }

//       // Capture Table
//       setShowGraph("Table");
//       await new Promise(resolve => setTimeout(resolve, 500));

//       const tableElement = document.querySelector(`.${tableClass}`);

//       if (tableElement && isElementVisible(tableElement)) {
//         // If a chart was already added to the PDF's current page, create a new portrait page for the table.
//         // If chart was NOT added, use the existing (first) page to render the table (avoids blank first page).
//         if (chartAdded) {
//           pdf.addPage('p');
//         } else {
//           // ensure we start at top of the existing page
//           pdf.setPage(1);
//         }

//         currentY = 15;
//         pdf.setFontSize(14);
//         pdf.text('Table View', pdf.internal.pageSize.getWidth() / 2, currentY, { align: 'center' });
//         currentY += 5;

//         const tableCanvas = await html2canvas(tableElement, {
//           scale: 2,
//           useCORS: true,
//           logging: false,
//           backgroundColor: '#ffffff'
//         });

//         const tableImgData = tableCanvas.toDataURL('image/png');
//         const tableWidth = pdf.internal.pageSize.getWidth() - 20;
//         const tableHeight = (tableCanvas.height * tableWidth) / tableCanvas.width;

//         // If table image is taller than a single page, let jsPDF split pages automatically by calculating placement.
//         // For simplicity add the full image and let it flow (it will be placed starting at currentY).
//         pdf.addImage(tableImgData, 'PNG', 10, currentY, tableWidth, tableHeight);

//         tableAdded = true;
//       }

//       setShowGraph(originalShowGraph);

//       if (!chartAdded && !tableAdded) {
//         alert('No content found to export!');
//         setLoading(false);
//         return;
//       }

//       const totalPages = pdf.internal.getNumberOfPages();
//       for (let i = 1; i <= totalPages; i++) {
//         pdf.setPage(i);
//         const currentPageWidth = pdf.internal.pageSize.getWidth();
//         const currentPageHeight = pdf.internal.pageSize.getHeight();

//         pdf.setFontSize(8);
//         pdf.setTextColor(128);
//         pdf.text(
//           `Generated on: ${new Date().toLocaleDateString()} | Page ${i} of ${totalPages}`,
//           currentPageWidth / 2,
//           currentPageHeight - 5,
//           { align: 'center' }
//         );
//       }

//       pdf.save(filename);
//       alert('PDF downloaded successfully!');

//     } catch (error) {
//       console.error('Error generating PDF:', error);
//       alert('Failed to download PDF. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // // Download only table
//   const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
//     setExportingPDF(true);

//     // ---------- 0. Show ALL rows temporarily (no UI/button change needed) ----------
//     const showAllMap = {
//       "50:AllGR": [setShowAllDistrict, showAllDistrict],
//       "100:AllGR": [setShowAllGR, showAllGR],
//       "51:TalukaWiseDemandTable": [setShowAllTaluka, showAllTaluka],
//       "52:BillsDataTable": [setShowAllTalukaDemand, showAllTalukaDemand],
//       "99:ALlDistrictFinanceData": [setShowAllDistrictGR, showAllDistrictGR],
//       "109:ALlDistrictFinanceData": [setShowAllTS, showAllTS],
//       "115:ALlDistrictFinanceData": [setShowAllDistrictWO, showAllDistrictWO],
//       "101:ProposalContainer": [setShowAllProposalGR, showAllProposalGR],
//       "110:ALlTechnicalSData": [setShowAllTSDetails, showAllTSDetails],
//     };
//     const entry = showAllMap[`${showspecific}:${tableClass}`];
//     const setShowAll = entry ? entry[0] : null;
//     const previousShowAll = entry ? entry[1] : null;

//     if (setShowAll && !previousShowAll) {
//       setShowAll(true);
//       await new Promise((res) => setTimeout(res, 700)); // wait for all rows to render
//     } else {
//       await new Promise((res) => setTimeout(res, 300));
//     }

//     const originalTable = document.querySelector(`.${tableClass}`);
//     if (!originalTable) {
//       if (setShowAll) setShowAll(previousShowAll);
//       setExportingPDF(false);
//       return;
//     }

//     let clonedTable = null;
//     let wrapper = null;

//     try {
//       // ---------- 1. Remove Page Total / Gross Total rows ----------
//       const originalRows = Array.from(
//         originalTable.querySelectorAll("tbody tr")
//       ).filter((row) => {
//         const text = row.textContent.trim().toLowerCase();
//         return !text.includes("page total") && !text.includes("gross total");
//       });

//       // Real data rows only (skip "No data found" rows)
//       const dataRows = originalRows.filter(
//         (row) => row.querySelectorAll("td").length > 1
//       );

//       // ---------- 2. Detect amount columns (cells like "₹ 1,23,456") ----------
//       const isAmt = (s) => /^₹\s*-?[\d,]+(\.\d+)?$/.test(String(s ?? "").trim());
//       const toNum = (s) => Number(String(s).replace(/[₹,\s]/g, ""));

//       const colCount = dataRows.length
//         ? dataRows[0].querySelectorAll("td").length
//         : 0;

//       const amountCols = [];
//       for (let c = 1; c < colCount; c++) {
//         const filled = dataRows
//           .map((r) => r.querySelectorAll("td")[c]?.textContent.trim())
//           .filter((v) => v !== undefined && v !== "");
//         if (filled.length > 0 && filled.every(isAmt)) amountCols.push(c);
//       }

//       // ---------- 3. Sum each amount column ----------
//       const sums = {};
//       amountCols.forEach((c) => {
//         sums[c] = dataRows.reduce((sum, row) => {
//           const txt = row.querySelectorAll("td")[c]?.textContent.trim();
//           return sum + (isAmt(txt) ? toNum(txt) : 0);
//         }, 0);
//       });

//       // ---------- 4. Build cloned table ----------
//       clonedTable = originalTable.cloneNode(true);
//       const clonedTbody = clonedTable.querySelector("tbody");

//       const firstHeader = originalTable
//         .querySelector("thead th")
//         ?.textContent.trim()
//         .toLowerCase();
//       const hasSrNo = firstHeader && firstHeader.startsWith("sr");

//       if (clonedTbody) {
//         clonedTbody.innerHTML = "";

//         dataRows.forEach((row, index) => {
//           const clonedRow = row.cloneNode(true);

//           // Renumber Sr No from 1
//           if (hasSrNo) {
//             const firstCell = clonedRow.querySelector("td");
//             if (firstCell) firstCell.textContent = index + 1;
//           }

//           clonedTbody.appendChild(clonedRow);
//         });

//         // ---------- 5. Single Total row ----------
//         if (dataRows.length > 0 && amountCols.length > 0) {
//           const firstAmt = amountCols[0];
//           const totalRow = document.createElement("tr");
//           const base =
//             "font-weight:bold;font-size:18px;padding:10px;background:#f0f0f0;";

//           const labelCell = document.createElement("td");
//           labelCell.colSpan = firstAmt;
//           labelCell.textContent = "Total";
//           labelCell.style.cssText = base + "text-align:right;";
//           totalRow.appendChild(labelCell);

//           for (let c = firstAmt; c < colCount; c++) {
//             const cell = document.createElement("td");
//             cell.style.cssText = base + "text-align:left;";
//             cell.textContent = amountCols.includes(c)
//               ? "₹ " + sums[c].toLocaleString("en-IN")
//               : "";
//             totalRow.appendChild(cell);
//           }

//           clonedTbody.appendChild(totalRow);
//         }
//       }

//       // ---------- 6. Make header visible ----------
//       clonedTable.querySelectorAll("thead th").forEach((th) => {
//         th.style.backgroundColor = "#2C78DB";
//         th.style.color = "#fff";
//         th.style.fontWeight = "bold";
//         th.style.position = "static"; // remove sticky behaviour in the clone
//       });
//       const clonedThead = clonedTable.querySelector("thead");
//       if (clonedThead) clonedThead.style.position = "static";

//       wrapper = document.createElement("div");
//       wrapper.className = "tableDesign DistrictTableContianer";
//       wrapper.style.cssText =
//         "position:absolute;left:-9999px;top:0;background:#2C78DB;overflow:visible;max-height:none;width:" +
//         originalTable.scrollWidth +
//         "px;";
//       wrapper.appendChild(clonedTable);
//       document.body.appendChild(wrapper);

//       // ---------- 7. Render to PDF (page-by-page slices) ----------
//       const pdf = new jsPDF("p", "mm", "a4");
//       const pageWidth = pdf.internal.pageSize.getWidth();
//       const pageHeight = pdf.internal.pageSize.getHeight();

//       const drawTitle = () => {
//         pdf.setFontSize(16);
//         pdf.setFont("helvetica", "bold");
//         pdf.text(title, pageWidth / 2, 15, { align: "center" });
//       };

//       const imgWidth = pageWidth - 20;                 // mm
//       const startY = 25;
//       const wrapW = wrapper.offsetWidth;               // css px
//       const pxPerMm = wrapW / imgWidth;                // css px per mm
//       const limitPx = (pageHeight - startY - 8) * pxPerMm - 4; // small safety margin

//       // ---- Measure header and every row (css px) ----
//       const theadEl = clonedTable.querySelector("thead");
//       const headH = theadEl ? theadEl.getBoundingClientRect().height : 0;
//       const bodyRows = Array.from(clonedTable.querySelectorAll("tbody tr"));
//       const heights = bodyRows.map((r) => r.getBoundingClientRect().height);

//       // ---- Group whole rows into pages ----
//       const pages = [];
//       let current = [];
//       let used = headH;

//       heights.forEach((h, i) => {
//         if (current.length > 0 && used + h > limitPx) {
//           pages.push(current);
//           current = [];
//           used = headH;
//         }
//         current.push(i);
//         used += h;
//       });
//       if (current.length) pages.push(current);

//       // ---- Render each page separately: header + its rows ----
//       for (let p = 0; p < pages.length; p++) {
//         const pageWrapper = wrapper.cloneNode(false); // keeps class, width, background
//         const pageTable = clonedTable.cloneNode(false);

//         if (theadEl) pageTable.appendChild(theadEl.cloneNode(true));
//         const tb = document.createElement("tbody");
//         pages[p].forEach((i) => tb.appendChild(bodyRows[i].cloneNode(true)));
//         pageTable.appendChild(tb);

//         pageWrapper.appendChild(pageTable);
//         document.body.appendChild(pageWrapper);

//         const pageCanvas = await html2canvas(pageWrapper, {
//           scale: 2,
//           useCORS: true,
//           backgroundColor: "#fff",
//         });
//         document.body.removeChild(pageWrapper);

//         if (p > 0) pdf.addPage();
//         drawTitle();
//         pdf.addImage(
//           pageCanvas.toDataURL("image/png"),
//           "PNG",
//           10,
//           startY,
//           imgWidth,
//           (pageCanvas.height * imgWidth) / pageCanvas.width
//         );
//       }

//       pdf.save(filename);
//     } catch (error) {
//       console.error("PDF Export Error:", error);
//     } finally {
//       if (wrapper && wrapper.parentNode) {
//         wrapper.parentNode.removeChild(wrapper);
//       }
//       // Restore the previous pagination view
//       if (setShowAll) setShowAll(previousShowAll);
//       setExportingPDF(false);
//     }
//   };
//   // const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
//   //   setExportingPDF(true);

//   //   // allow DOM re-render
//   //   await new Promise(res => setTimeout(res, 300));

//   //   const table = document.querySelector(`.${tableClass}`);
//   //   if (!table) return;

//   //   const pdf = new jsPDF("p", "mm", "a4");
//   //   const pageWidth = pdf.internal.pageSize.getWidth();
//   //   const pageHeight = pdf.internal.pageSize.getHeight();

//   //   pdf.setFontSize(16);
//   //   pdf.setFont("helvetica", "bold");
//   //   pdf.text(title, pageWidth / 2, 15, { align: "center" });

//   //   const canvas = await html2canvas(table, {
//   //     scale: 2,
//   //     useCORS: true,
//   //     backgroundColor: "#fff",
//   //   });

//   //   const imgData = canvas.toDataURL("image/png");
//   //   const imgWidth = pageWidth - 20;
//   //   const imgHeight = (canvas.height * imgWidth) / canvas.width;

//   //   let heightLeft = imgHeight;
//   //   let position = 25;

//   //   pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
//   //   heightLeft -= pageHeight;

//   //   while (heightLeft > 0) {
//   //     position = heightLeft - imgHeight + 25;
//   //     pdf.addPage();
//   //     pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
//   //     heightLeft -= pageHeight;
//   //   }

//   //   pdf.save(filename);

//   //   setExportingPDF(false);
//   // };
//   // const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
//   //   setExportingPDF(true);

//   //   // allow DOM re-render
//   //   await new Promise((res) => setTimeout(res, 300));

//   //   const originalTable = document.querySelector(`.${tableClass}`);
//   //   if (!originalTable) {
//   //     setExportingPDF(false);
//   //     return;
//   //   }

//   //   try {
//   //     // =====================================================
//   //     // Find "Amount" column index from header text
//   //     // =====================================================
//   //     const headerCellsRef = Array.from(
//   //       originalTable.querySelectorAll("thead tr th")
//   //     );
//   //     const headerColCount = headerCellsRef.length;

//   //     let amountColIndex = headerCellsRef.findIndex((th) =>
//   //       th.textContent.trim().toLowerCase().includes("amount")
//   //     );
//   //     if (amountColIndex === -1) {
//   //       amountColIndex = headerColCount - 1; // fallback: last column
//   //     }

//   //     // =====================================================
//   //     // Drop "Page Total" / "Gross Total" rows
//   //     // =====================================================
//   //     const allOriginalRows = Array.from(
//   //       originalTable.querySelectorAll("tbody tr")
//   //     );

//   //     const originalRows = allOriginalRows.filter((row) => {
//   //       const text = row.textContent.trim().toLowerCase();
//   //       if (text.includes("page total")) return false;
//   //       if (text.includes("gross total")) return false;
//   //       return true;
//   //     });

//   //     // =====================================================
//   //     // Calculate overall Bill Amount total
//   //     // =====================================================
//   //     let totalAmount = 0;

//   //     originalRows.forEach((row) => {
//   //       const cells = row.querySelectorAll("td");
//   //       const amountCell = cells[amountColIndex];

//   //       if (amountCell) {
//   //         const amountText = amountCell.textContent
//   //           .replace(/,/g, "")
//   //           .replace(/[₹$]/g, "")
//   //           .replace(/\s+/g, "")
//   //           .trim();

//   //         const amount = parseFloat(amountText);
//   //         if (!isNaN(amount)) {
//   //           totalAmount += amount;
//   //         }
//   //       }
//   //     });

//   //     // =====================================================
//   //     // Build cloned table: filtered rows, renumbered Sr No,
//   //     // plus a single Total row
//   //     // =====================================================
//   //     const clonedTable = originalTable.cloneNode(true);
//   //     const clonedTbody = clonedTable.querySelector("tbody");

//   //     if (clonedTbody) {
//   //       clonedTbody.innerHTML = "";

//   //       originalRows.forEach((row, index) => {
//   //         const clonedRow = row.cloneNode(true);

//   //         // Renumber Sr No starting from 1
//   //         const firstCell = clonedRow.querySelector("td");
//   //         if (firstCell) {
//   //           firstCell.textContent = index + 1;
//   //         }

//   //         clonedTbody.appendChild(clonedRow);
//   //       });

//   //       // Append single Total row
//   //       const totalRow = document.createElement("tr");

//   //       const totalLabelCell = document.createElement("td");
//   //       totalLabelCell.textContent = "Total";
//   //       totalLabelCell.style.fontWeight = "bold";
//   //       totalLabelCell.style.fontSize = "18px";
//   //       totalLabelCell.style.textAlign = "right";
//   //       totalLabelCell.style.padding = "10px";
//   //       totalLabelCell.colSpan = Math.max(amountColIndex, 1);
//   //       totalRow.appendChild(totalLabelCell);

//   //       const totalAmountCell = document.createElement("td");
//   //       totalAmountCell.textContent = totalAmount.toLocaleString("en-IN", {
//   //         minimumFractionDigits: 2,
//   //         maximumFractionDigits: 2,
//   //       });
//   //       totalAmountCell.style.fontWeight = "bold";
//   //       totalAmountCell.style.fontSize = "18px";
//   //       totalAmountCell.style.textAlign = "right";
//   //       totalAmountCell.style.padding = "10px";
//   //       totalRow.appendChild(totalAmountCell);

//   //       const remainingCols = headerColCount - amountColIndex - 1;
//   //       if (remainingCols > 0) {
//   //         const emptyCell = document.createElement("td");
//   //         emptyCell.colSpan = remainingCols;
//   //         totalRow.appendChild(emptyCell);
//   //       }

//   //       clonedTbody.appendChild(totalRow);
//   //     }

//   //     // Hide cloned table from view, ensure full width for wide tables
//   //     clonedTable.style.position = "absolute";
//   //     clonedTable.style.left = "-9999px";
//   //     clonedTable.style.top = "0";
//   //     clonedTable.style.width = originalTable.scrollWidth + "px";
//   //     document.body.appendChild(clonedTable);

//   //     const pdf = new jsPDF("p", "mm", "a4");
//   //     const pageWidth = pdf.internal.pageSize.getWidth();
//   //     const pageHeight = pdf.internal.pageSize.getHeight();

//   //     pdf.setFontSize(16);
//   //     pdf.setFont("helvetica", "bold");
//   //     pdf.text(title, pageWidth / 2, 15, { align: "center" });

//   //     const canvas = await html2canvas(clonedTable, {
//   //       scale: 2,
//   //       useCORS: true,
//   //       backgroundColor: "#fff",
//   //     });

//   //     document.body.removeChild(clonedTable);

//   //     const imgData = canvas.toDataURL("image/png");
//   //     const imgWidth = pageWidth - 20;
//   //     const imgHeight = (canvas.height * imgWidth) / canvas.width;

//   //     let heightLeft = imgHeight;
//   //     let position = 25;

//   //     pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
//   //     heightLeft -= pageHeight;

//   //     while (heightLeft > 0) {
//   //       position = heightLeft - imgHeight + 25;
//   //       pdf.addPage();
//   //       pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
//   //       heightLeft -= pageHeight;
//   //     }

//   //     pdf.save(filename);
//   //   } catch (error) {
//   //     console.error("PDF Export Error:", error);
//   //   } finally {
//   //     setExportingPDF(false);
//   //   }
//   // };
//   // Download only chart
//   const downloadChartOnlyAsPDF = async (chartClass, filename, title) => {
//     setLoading(true);

//     try {
//       const chartElement = document.querySelector(`.${chartClass}`);

//       if (!chartElement) {
//         alert('Chart not found!');
//         setLoading(false);
//         return;
//       }

//       const pdf = new jsPDF('l', 'mm', 'a4');
//       const pageWidth = pdf.internal.pageSize.getWidth();
//       const pageHeight = pdf.internal.pageSize.getHeight();

//       pdf.setFontSize(16);
//       pdf.setFont(undefined, 'bold');
//       pdf.text(title, pageWidth / 2, 15, { align: 'center' });

//       const chartCanvas = await html2canvas(chartElement, {
//         scale: 2,
//         useCORS: true,
//         logging: false,
//         backgroundColor: '#ffffff'
//       });

//       const chartImgData = chartCanvas.toDataURL('image/png');
//       const chartWidth = pageWidth - 20;
//       const chartHeight = (chartCanvas.height * chartWidth) / chartCanvas.width;

//       pdf.addImage(chartImgData, 'PNG', 10, 25, chartWidth, Math.min(chartHeight, pageHeight - 30));
//       pdf.save(filename);

//     } catch (error) {
//       console.error('Error downloading chart:', error);
//       alert('Failed to download chart as PDF');
//     } finally {
//       setLoading(false);
//     }
//   };
//   // pie 

//   const COLORS = ['#4f46e5', '#22c55e', '#f97316', '#06b6d4', '#ec4899', '#facc15', '#8b5cf6'];


//   const yearMap = {};

//   const years = [
//     ...new Set(
//       demandgeneration
//         .map(item => item.Proposal_year)
//         .filter(year => year) // Remove undefined/null
//     )
//   ].sort()
//   console.log("years", years);
//   years.forEach(year => {
//     yearMap[year] = {
//       year,
//       totalRelease: 0,
//       totalDemand: 0
//     };
//   });


//   releasefromfdutf.forEach(item => {
//     const year = item.ProposalYear;
//     console.log("item", item);
//     const releaseAmount = parseFloat(item.OriginalLimitAllocatedAmount || 0);

//     if (yearMap[year]) {
//       yearMap[year].totalRelease += releaseAmount;
//       console.log("year data", yearMap[year]);
//     }
//   });

//   demandgeneration.forEach(item => {
//     const year = item.Proposal_year;
//     const demandAmount = parseFloat(item.BillAmount || 0);
//     console.log("demand item", demandAmount);
//     if (yearMap[year]) {
//       yearMap[year].totalDemand += demandAmount;
//       console.log("year data demand", yearMap[year]);
//     }
//   });


//   const barChartData = useMemo(() => {
//     // Filter data based on selectedHeadCode (if selected, otherwise show all)
//     let filteredReleases = selectedHeadCode
//       ? releasefromfdutf.filter(item => item.HeadCode === selectedHeadCode)
//       : releasefromfdutf;

//     let filteredDemands = selectedHeadCode
//       ? demandgeneration.filter(item => item.HeadCode === selectedHeadCode)
//       : demandgeneration;

//     if (selectedYear) {
//       filteredReleases = filteredReleases.filter(item => item.ProposalYear === selectedYear);
//       filteredDemands = filteredDemands.filter(item => item.ProposalYear === selectedYear);
//     }

//     console.log("Filtered Releases for chart:", filteredReleases);
//     console.log("Filtered Demands for chart:", filteredDemands);

//     const yearMap = {};

//     // Get all unique years from both datasets
//     const releaseYears = filteredReleases.map(item => item.ProposalYear).filter(Boolean);
//     const demandYears = filteredDemands.map(item => item.ProposalYear).filter(Boolean);

//     const years = [...new Set([...releaseYears, ...demandYears])].sort();

//     console.log("All years for chart:", years);

//     // Initialize yearMap for all years
//     years.forEach(year => {
//       yearMap[year] = {
//         year,
//         totalRelease: 0,
//         totalDemand: 0
//       };
//     });

//     // Calculate releases per year
//     filteredReleases.forEach(item => {
//       const year = item.ProposalYear;
//       const releaseAmount = parseFloat(item.ApprovedWorkAmount || 0);

//       if (year && yearMap[year]) {
//         yearMap[year].totalRelease += releaseAmount;
//       }
//     });

//     // Calculate demands per year
//     filteredDemands.forEach(item => {
//       const year = item.ProposalYear;
//       const demandAmount = parseFloat(item.BillPaidAmount || 0);

//       if (year && yearMap[year]) {
//         yearMap[year].totalDemand += demandAmount;
//       }
//     });

//     console.log("Year Map:", yearMap);

//     // Convert to chart data format
//     const chartData = years.map(year => ({
//       year,
//       release: +(yearMap[year].totalRelease / 100000).toFixed(2), // Convert to Lakh
//       demand: +(yearMap[year].totalDemand / 100000).toFixed(2)
//     }));

//     console.log("Final Bar Chart Data:", chartData);

//     return chartData;

//   }, [releasefromfdutf, demandgeneration, selectedHeadCode, selectedYear]);

//   console.log("barchartdata", barChartData);


//   useEffect(() => {
//     setShowGraph("Table");
//   }, [showspecific])

//   function extractCoords(raw) {
//     if (!raw) return "";

//     // Remove escaped quotes
//     const str = String(raw).replace(/\\"/g, '"');

//     const start = str.indexOf('[[');
//     const end = str.lastIndexOf(']]');

//     if (start === -1 || end === -1) return raw;

//     return str.substring(start, end + 2); // full [[...]]
//   }

//   const proposalChartData = React.useMemo(() => {
//     if (!talukawiseProposalData || talukawiseProposalData.length === 0) return [];

//     const map = {};

//     talukawiseProposalData.forEach(item => {
//       const proposal = item.ProposalID;
//       const amountRs = Number(item.OriginalLimitAllocatedAmount || 0);

//       if (!map[proposal]) {
//         map[proposal] = {
//           proposal,
//           amountRs: 0,
//           amountCr: 0,
//         };
//       }

//       map[proposal].amountRs += amountRs;
//       map[proposal].amountCr += amountRs / 10000000; // convert to Cr
//     });

//     return Object.values(map);
//   }, [talukawiseProposalData]);

//   const grouped = talukawiseDemandData.reduce((acc, cur) => {
//     const taluka = (cur.taluka || "Unknown").trim();
//     const amount = parseFloat(cur.totalBillAmount || 0);

//     if (!acc[taluka]) acc[taluka] = 0;
//     acc[taluka] += amount;

//     return acc;
//   }, {});

//   const chartData = Object.keys(grouped).map(taluka => ({
//     taluka,
//     rawAmount: grouped[taluka],                                // ₹
//     amountCr: Number((grouped[taluka] / 10000000).toFixed(3)) // Cr
//   }));

//   const demandChartData = sortedDemandDatabytaluka.map(item => {
//     const billRs = Number(item.BillAmount || 0);

//     return {
//       proposal: item.Work_name,
//       amountRs: billRs,
//       amountCr: billRs / 10000000   // ₹ → Cr (number)
//     };
//   });

//   useEffect(() => {
//     setCurrentPage(1);
//   }, [selectedContractor]);

//   const exportContractorBillsToExcel = (data, filename = "ContractorBills.xlsx") => {
//     if (!data || data.length === 0) {
//       alert("No data available!");
//       return;
//     }

//     const worksheetData = [
//       [
//         "Vendor Name",
//         "Year",
//         "Bill ID",
//         "Bill Amount",
//         "Payable Amount",
//         "Deduction Amount",
//         "Date"
//       ],
//       ...data.map(item => [
//         item.ContractorName,
//         selectedYear,
//         item.DemandGenerationID,
//         item.BillAmount,
//         item.NetPayableAmount,
//         item.DeductionAmount,
//         item.Date ? new Date(item.Date).toLocaleString() : ""
//       ])
//     ];

//     const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

//     worksheet['!cols'] = [
//       { wch: 25 },
//       { wch: 10 },
//       { wch: 20 },
//       { wch: 15 },
//       { wch: 18 },
//       { wch: 18 },
//       { wch: 22 }
//     ];

//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Bills");

//     XLSX.writeFile(workbook, filename);
//   };

//   const downloadContractorBillsTablePDF = (data, filename, title) => {
//     if (!data || data.length === 0) {
//       alert("No data available");
//       return;
//     }

//     const pdf = new jsPDF("l", "mm", "a4"); // landscape for better width

//     // Title
//     pdf.setFontSize(14);
//     pdf.text(title, pdf.internal.pageSize.getWidth() / 2, 12, {
//       align: "center",
//     });

//     // Prepare table body
//     const tableBody = data.map((item, index) => ([
//       index + 1,
//       item.ContractorName,
//       selectedYear,
//       item.DemandGenerationID,
//       Number(item.BillAmount).toLocaleString(),
//       Number(item.NetPayableAmount).toLocaleString(),
//       Number(item.DeductionAmount).toLocaleString(),
//       item.Date ? new Date(item.Date).toLocaleDateString() : "",
//     ]));

//     autoTable(pdf, {
//       startY: 18,
//       head: [[
//         "Sr No",
//         "Vendor Name",
//         "Year",
//         "Bill ID",
//         "Bill Amount",
//         "Payable Amount",
//         "Deduction Amount",
//         "Date",
//       ]],
//       body: tableBody,
//       theme: "grid",
//       styles: {
//         fontSize: 9,
//         cellPadding: 3,
//         halign: "center",
//       },
//       headStyles: {
//         fillColor: [79, 70, 229], // blue header
//         textColor: 255,
//         halign: "center",
//       },
//       columnStyles: {
//         1: { halign: "left" }, // Contractor Name
//         3: { halign: "left" }, // Bill ID
//       },
//       didDrawPage: (data) => {
//         pdf.setFontSize(9);
//         pdf.text(
//           `Page ${pdf.internal.getNumberOfPages()}`,
//           pdf.internal.pageSize.getWidth() - 20,
//           pdf.internal.pageSize.getHeight() - 10
//         );
//       },
//     });

//     pdf.save(filename);
//   };

//   const handlePageChange = (page) => {
//     if (page < 1 || page > totalPages) return;
//     setCurrentPage(page);
//   };

//   const contractorTotalRow = {
//     ContractorName: "Total Amount",
//     Year: "",
//     DemandGenerationID: "",
//     BillAmount: ContractorBillDetail.reduce(
//       (s, v) => s + Number(v.BillAmount || 0),
//       0
//     ),
//     NetPayableAmount: ContractorBillDetail.reduce(
//       (s, v) => s + Number(v.NetPayableAmount || 0),
//       0
//     ),
//     DeductionAmount: ContractorBillDetail.reduce(
//       (s, v) => s + Number(v.DeductionAmount || 0),
//       0
//     ),
//     Date: ""
//   };

//   const contractorExportData = [
//     ...ContractorBillDetail,
//     contractorTotalRow
//   ];

//   const getDistrictGRSummary = (data) => {
//     const map = {};

//     data.forEach((gr) => {
//       const district = gr.ZillaParishad || "Unknown";

//       if (!map[district]) {
//         map[district] = {
//           District: district,
//           TotalGR: 0,
//           TotalAmount: 0,
//         };
//       }

//       map[district].TotalGR += 1;
//       map[district].TotalAmount += Number(gr.GRAmount || 0);
//     });

//     return Object.values(map).sort((a, b) => b.TotalGR - a.TotalGR);
//   };

//   useEffect(() => {
//     if (AllGRS?.length) {
//       setDistrictGRSummary(getDistrictGRSummary(AllGRS));
//     }
//   }, [AllGRS]);

//   const showDistrictGR = (district) => {
//     const filtered = AllGRS.filter(
//       (gr) => gr.ZillaParishad === district
//     );

//     setFilteredGRS(filtered);
//     setShowSpecific(100); // open your GR table view
//   };

//   // choose data source
//   const sourceGRS = filteredGRS.length ? filteredGRS : AllGRS;

//   // ✅ SORT FIRST (newest first)
//   const sortedGRS = [...sourceGRS].sort(
//     (a, b) => Number(b.ID) - Number(a.ID)
//   );

//   // pagination calculations
//   const totalPages = Math.ceil(sortedGRS.length / itemsPerPage);

//   const paginatedGRS = sortedGRS.slice(
//     indexOfFirstGRS,
//     indexOfLastGRS
//   );

//   console.log("paginatedGRS: ", paginatedGRS);

//   const filteredHeadCodes = useMemo(() => {

//     const roleHeadMap = {
//       "State-2515-RDD Checker(ASO)": [
//         "2515-1238(MLA Representative)"
//       ],
//       "State-2515-RDD Section Officer": [
//         "2515-1238(MLA Representative)"
//       ],

//       "State-RDD Checker(ASO)": [
//         "3054-2419(Roads and bridge repair maintenance program)"
//       ],
//       "State-RDD Section Officer": [
//         "3054-2419(Roads and bridge repair maintenance program)"
//       ],

//       "State-Deputy Secretary": [
//         "3054-2419(Roads and bridge repair maintenance program)",
//         "2515-1238(MLA Representative)"
//       ],
//     };

//     const allowedHeads = roleHeadMap[userData?.FullName];

//     if (allowedHeads) {
//       return HeadCode.filter(val =>
//         allowedHeads.includes(val.HeadName)
//       );
//     }

//     return HeadCode;

//   }, [userData, HeadCode]);

//   useEffect(() => {
//     if (!filteredHeadCodes?.length) return;

//     const role = userData?.FullName;

//     // Roles that must auto-select single option
//     const autoSelectRoles = [
//       "State-2515-RDD Checker(ASO)",
//       "State-2515-RDD Section Officer",
//       "State-RDD Checker(ASO)",
//       "State-RDD Section Officer",
//     ];

//     // Default selection for Deputy Secretary
//     if (role !== "State-2515-RDD Checker(ASO)" &&
//       role !== "State-2515-RDD Section Officer") {
//       const defaultHead = filteredHeadCodes.find(
//         h => h.HeadName ===
//           "3054-2419(Roads and bridge repair maintenance program)"
//       );

//       if (defaultHead && !selectedHeadCode) {
//         setSelectedHeadCode(defaultHead.HeadID);
//       }
//       return;
//     }

//     // Auto select when only one option
//     if (autoSelectRoles.includes(role) && filteredHeadCodes.length === 1) {
//       setSelectedHeadCode(filteredHeadCodes[0].HeadID);
//     }

//   }, [filteredHeadCodes, userData]);

//   const getDistrictTSSummary = (data) => {
//     const map = {};

//     data.forEach((ts) => {
//       const district = ts.District || "Unknown";

//       if (!map[district]) {
//         map[district] = {
//           District: district,
//           TotalTS: 0,
//           TotalAmount: 0,
//         };
//       }

//       map[district].TotalTS += 1;
//       map[district].TotalAmount += Number(ts.TechnicalSanctionAmt || 0);
//     });

//     return Object.values(map).sort((a, b) => b.TotalTS - a.TotalTS);
//   };

//   useEffect(() => {
//     if (allTSData?.length) {
//       setDistrictTSSummary(getDistrictTSSummary(allTSData));
//     }
//   }, [allTSData]);

//   const showDistrictTS = (district) => {
//     const filtered = allTSData.filter(
//       (ts) => ts.District === district
//     );

//     setFilteredTSData(filtered);
//     setCurrentPageAllTSData(1);   // ⭐ important for pagination
//     setShowSpecific(110);
//   };

//   const activeTSData = filteredTSData.length
//     ? filteredTSData
//     : allTSData;

//   const filteredAllTSData = activeTSData.filter((item) => {
//     const districtMatch =
//       isDistrictMatch(item.District, selectedAllTSDistrict);

//     const talukaMatch =
//       !selectedAllTSTaluka ||
//       item.Taluka === selectedAllTSTaluka;

//     const headCodeMatch =
//       !selectedAllTSHeadCode ||
//       item.HeadCode === selectedAllTSHeadCode;

//     const searchKeyword = searchAllTS.trim().toLowerCase();

//     const searchMatch =
//       !searchKeyword ||
//       [
//         item.WorkName,
//         item.HeadCode,
//         item.TS_ID,
//         item.TechnicalSanctionNo,
//         item.Area,
//         item.GR_UID,
//         item.SanctionYear,
//         item.ConstituencyName,
//         item.District,
//         item.Taluka,
//         item.GramPanchayat,
//         item.TypeofWork,
//         item.TechnicalSanctionAmt,
//         item.TechnicalSanctionCopy,
//         item.EditedBy,
//         item.Date,
//       ].some((value) =>
//         String(value || "").toLowerCase().includes(searchKeyword)
//       );

//     return (
//       districtMatch &&
//       talukaMatch &&
//       headCodeMatch &&
//       searchMatch
//     );
//   });

//   // SORT FIRST
//   const sortedTS = [...filteredAllTSData].sort(
//     (a, b) => new Date(b.Date || 0) - new Date(a.Date || 0)
//   );

//   const totalRecordsAllTSData = sortedTS.length;

//   const totalPagesAllTSData = Math.ceil(
//     totalRecordsAllTSData / recordsPerPageAllTSData
//   );

//   const currentAllTSData = showAllTSDetails
//     ? sortedTS
//     : sortedTS.slice(
//       firstRecordIndexAllTSData,
//       lastRecordIndexAllTSData
//     );

//   // Page Total - only currently visible records
//   const pageTotalAllTSAmount = currentAllTSData.reduce(
//     (sum, val) => sum + parseFloat(val.TechnicalSanctionAmt || 0),
//     0
//   );

//   // Grand Total - all filtered records
//   const grandTotalAllTSAmount = sortedTS.reduce(
//     (sum, val) => sum + parseFloat(val.TechnicalSanctionAmt || 0),
//     0
//   );
//   const getDistrictDRSummary = (data) => {
//     const map = {};

//     data.forEach((dr) => {
//       const district = dr.District || "Unknown";

//       if (!map[district]) {
//         map[district] = {
//           District: district,
//           TotalDemand: 0,
//           TotalAmount: 0,
//         };
//       }

//       map[district].TotalDemand += 1;
//       map[district].TotalAmount += Number(dr.ApprovedDemandRequest || 0);
//     });

//     return Object.values(map).sort((a, b) => b.TotalDemand - a.TotalDemand);
//   };

//   useEffect(() => {
//     if (DRtableData?.length) {
//       setDistrictDRSummary(getDistrictDRSummary(DRtableData));
//     }
//   }, [DRtableData]);

//   const showDistrictDR = (district) => {
//     const filtered = DRtableData.filter(
//       (dr) => dr.District === district
//     );

//     setFilteredDRData(filtered);
//     setCurrentPageDRtableData(1);   // ⭐ reset pagination
//     setShowSpecific(113);
//   };

//   const activeDRData = filteredDRData?.length
//     ? filteredDRData
//     : DRtableData;

//   // ✅ SORT FIRST (newest first)
//   const sortedDR = [...activeDRData].sort((a, b) => new Date(b.created_At || 0) - new Date(a.created_At || 0));

//   const totalRecordsDRtableData = sortedDR.length;

//   const totalPagesDRtableData = Math.ceil(
//     totalRecordsDRtableData / recordsPerPageDRtableData
//   );

//   const currentDRtableData = sortedDR.slice(
//     firstRecordIndexDRtableData,
//     lastRecordIndexDRtableData
//   );

//   const getDistrictWOSummary = (data) => {
//     const map = {};

//     data.forEach((wo) => {
//       const district = wo.talulka || "Unknown";

//       if (!map[district]) {
//         map[district] = {
//           District: district,
//           TotalWO: 0,
//           TotalAmount: 0,
//         };
//       }

//       map[district].TotalWO += 1;
//       map[district].TotalAmount += Number(wo.ApprovedWorkAmount || 0);
//     });

//     return Object.values(map).sort((a, b) => b.TotalWO - a.TotalWO);
//   };

//   useEffect(() => {
//     if (workOrderData?.length) {
//       setDistrictWOSummary(getDistrictWOSummary(workOrderData));
//     }
//   }, [workOrderData]);

//   const showDistrictWO = (district) => {
//     const filtered = workOrderData.filter(
//       (wo) => wo.talulka === district
//     );

//     setFilteredWOData(filtered);
//     setCurrentPageWorkOrderData(1);   // ⭐ important
//     setShowSpecific(114);
//   };

//   const activeWOData = filteredWOData.length
//     ? filteredWOData
//     : workOrderData;

//   // HeadCode + Random Search
//   const filteredWorkOrderData = activeWOData.filter((item) => {

//     // HeadCode filter
//     const headCodeMatch =
//       !selectedWOHeadCode ||
//       String(item.HeadCode || "") === String(selectedWOHeadCode);

//     // Random search
//     const searchText = searchWorkOrder.trim().toLowerCase();

//     const searchMatch =
//       !searchText ||
//       [
//         item.WorkOrderID,
//         item.WorkOrderNo,
//         item.WorkName,
//         item.HeadCode,
//         item.TechnicalUID,
//         item.ProposalID,
//         item.ProposalYear,
//         item.talulka,
//         item.ApprovedWorkAmount,
//         item.BillRemainingAmount,
//         item.BillPaidAmount,
//         item.WorkOrderDate,
//         item.WorkEndDate,
//         item.CopyofWorkOrder,
//         item.Date,
//         item.EditedBy,
//       ].some((value) =>
//         String(value ?? "").toLowerCase().includes(searchText)
//       );

//     return headCodeMatch && searchMatch;
//   });

//   // SORT FIRST
//   const sortedWO = [...filteredWorkOrderData].sort(
//     (a, b) =>
//       new Date(b.WorkOrderDate || 0) -
//       new Date(a.WorkOrderDate || 0)
//   );

//   const totalRecordsWorkOrderData = sortedWO.length;

//   const totalPagesWorkOrderData = Math.ceil(
//     totalRecordsWorkOrderData / recordsPerPageWorkOrderData
//   );

//   const currentWorkOrderData = sortedWO.slice(
//     firstRecordIndexWorkOrderData,
//     lastRecordIndexWorkOrderData
//   );

//   // Page Total - current page only
//   const pageTotalWOApprovedAmount = currentWorkOrderData.reduce(
//     (sum, item) =>
//       sum + parseFloat(item.ApprovedWorkAmount || 0),
//     0
//   );

//   const pageTotalWORemainingAmount = currentWorkOrderData.reduce(
//     (sum, item) =>
//       sum + parseFloat(item.BillRemainingAmount || 0),
//     0
//   );

//   const pageTotalWOPaidAmount = currentWorkOrderData.reduce(
//     (sum, item) =>
//       sum + parseFloat(item.BillPaidAmount || 0),
//     0
//   );

//   // Grand Total - all filtered records
//   const grandTotalWOApprovedAmount = sortedWO.reduce(
//     (sum, item) =>
//       sum + parseFloat(item.ApprovedWorkAmount || 0),
//     0
//   );

//   const grandTotalWORemainingAmount = sortedWO.reduce(
//     (sum, item) =>
//       sum + parseFloat(item.BillRemainingAmount || 0),
//     0
//   );

//   const grandTotalWOPaidAmount = sortedWO.reduce(
//     (sum, item) =>
//       sum + parseFloat(item.BillPaidAmount || 0),
//     0
//   );


//   useEffect(() => {
//     // Always start from the original full list
//     let filtered = [...originalTSData];

//     // filter by head code
//     // Ensure we check for "null" string if your select default is value="null"
//     if (selectedHeadCode && selectedHeadCode !== "null") {
//       filtered = filtered.filter(
//         item => String(item.HeadCode) === String(selectedHeadCode)
//       );
//     }

//     // filter by year
//     if (selectedYear) {
//       filtered = filtered.filter(
//         item => item.SanctionYear === selectedYear || item.ProposalYear === selectedYear
//       );
//     }

//     setallTSData(filtered);
//     setTotalTSCreated(filtered.length);

//     // Always start from the original full list
//     let filteredDR = [...originalDRtableData];

//     // filter by head code
//     // Ensure we check for "null" string if your select default is value="null"
//     if (selectedHeadCode && selectedHeadCode !== "null") {
//       filteredDR = filteredDR.filter(
//         item => String(item.HeadCode) === String(selectedHeadCode)
//       );
//     }

//     // filter by year
//     if (selectedYear) {
//       filteredDR = filteredDR.filter(
//         item => item.Year === selectedYear || item.ProposalYear === selectedYear
//       );
//     }

//     const totalDRAmount = filteredDR.reduce((sum, row) => {
//       //just becuase we have declare varchar instead of int
//       const value = Number(String(row.DRAmount || "0").replace(/,/g, ""));
//       return sum + value;
//     }, 0);

//     setDRtableData(filteredDR);
//     setTotaldemandreqAMT(totalDRAmount);

//     // Always start from the original full list
//     let filteredWO = [...originalworkOrderData];

//     // filter by head code
//     // Ensure we check for "null" string if your select default is value="null"
//     if (selectedHeadCode && selectedHeadCode !== "null") {
//       filteredWO = filteredWO.filter(
//         item => String(item.HeadCode) === String(selectedHeadCode)
//       );
//     }

//     // filter by year
//     if (selectedYear) {
//       filteredWO = filteredWO.filter(
//         item => item.ProposalYear === selectedYear || item.ProposalYear === selectedYear
//       );
//     }

//     setWorkOrderData(filteredWO);
//     setworkorderlength(filteredWO.length)

//   }, [selectedHeadCode, selectedYear, originalTSData, originalDRtableData, originalworkOrderData]);

//   return (
//     <>
//       <div className="col-12" style={{ backgroundColor: "#EFF3F8", overflowY: 'auto', height: '90vh' }}>

//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             padding: "10px 4rem",
//           }}
//         >
//           <h4
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: "5px",
//               margin: 0,
//             }}
//           >
//             <img src="\MIS-Report-Blue-64.png" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
//             {t("MIS Report")}
//           </h4>
//         </div>

//         {
//           showspecific === 0 &&
//           (
//             <div className='col-12' style={{ padding: '1rem', width: '100%' }}>
//               <div style={{ padding: '30px', borderRadius: '10px', background: "linear-gradient(135deg, rgba(56, 67, 159, 0.2), rgba(4, 142, 204, 0.2))", boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', marginBottom: '20px' }}>
//                 <div style={{ display: 'flex', gap: '2rem' }}>
//                   <div style={{ flex: 1 }}>
//                     <span style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', padding: '0px 3rem' }}>
//                       <label style={{ width: '12rem', fontWeight: "700" }}>{t("Select Year")}</label>
//                       <select value={selectedYear} onChange={(e) => { setSelectedYear(e.target.value); setSelectedDistrict(''); setSelectedDemandDistrict(''); }} style={{ width: '100%', padding: '0.5rem', borderRadius: 6, border: '1px solid #4338ca', fontSize: 16, color: '#4338ca' }}>
//                         <option value="" disabled>{t("Select Year")}</option>
//                         <option value="2019-2020">2019-2020</option>
//                         <option value="2020-2021">2020-2021</option>
//                         <option value="2021-2022">2021-2022</option>
//                         <option value="2022-2023">2022-2023</option>
//                         <option value="2023-2024">2023-2024</option>
//                         <option value="2024-2025">2024-2025</option>
//                         <option value="2025-2026">2025-2026</option>
//                         <option value="2026-2027" selected>2026-2027</option>
//                         {/* {allYears.map(year => (<option key={year} value={year}>{year}</option>))} */}
//                       </select>
//                     </span>
//                   </div>

//                   <div style={{ flex: 1 }}>

//                     <span style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', padding: '0px 0rem' }}>
//                       <label style={{ width: '18rem', fontWeight: "700" }}>{t("Choose Head Code")}</label>
//                       <select value={selectedHeadCode} onChange={(e) => { setSelectedHeadCode(e.target.value); setSelectedDistrict(''); setSelectedDemandDistrict(''); }} style={{ width: '100%', padding: '0.5rem', borderRadius: 6, border: '1px solid #4338ca', fontSize: 16, color: '#4338ca' }}>
//                         < option value="null">{t("Choose Head Code")}</option>
//                         {filteredHeadCodes && filteredHeadCodes.map((val, index) => {
//                           return (
//                             <option key={index} value={val.HeadID}>{val.HeadName}</option>
//                           )
//                         })
//                         }
//                       </select>
//                     </span>
//                   </div>
//                 </div>
//               </div>

//               <div className='col-12'>
//                 <div
//                   style={{
//                     display: "grid",
//                     gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
//                     gap: "2rem",
//                     width: "100%",
//                     justifyItems: "center",
//                     marginTop: "20px"
//                   }}
//                 >

//                   {/* <div className='icon-wrapper'>
//                     <div className='col-12'>
//                       {
//                         selectedYear && selectedHeadCode && (
//                           <div
//                             onClick={() => {
//                               setShowDemandDistrictTable(!showDemandDistrictTable);
//                               setSelectedDemandDistrict("");
//                               setShowSpecific(1);
//                             }}
//                             style={{
//                               width: "22rem",
//                               height: "6rem",
//                               borderRadius: "14px",
//                               background: "#f2e2d9",
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "space-between",
//                               padding: "1rem 1.25rem",
//                               boxShadow: "0 8px 18px rgba(0,0,0,0.06)",
//                               cursor: "pointer"
//                             }}
//                           >
//                             <div style={{
//                               width: "40px",
//                               height: "40px",
//                               borderRadius: "12px",
//                               background: "#f2e2d9",
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "center",
//                               flexShrink: 0
//                             }}>
//                               <img
//                                 src="/Total-Original-Limit-Allocated.png"
//                                 style={{ width: "70px", height: "70px", objectFit: "contain" }}
//                               />
//                             </div>

//                             <div style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
//                               <span style={{ fontSize: "0.9rem", fontWeight: 600, color: "#444" }}>
//                                 {t("Total Original LimitAllocated:")}
//                               </span>
//                               <span style={{ fontSize: "1.3rem", fontWeight: 700 }}>
//                                 ₹{Number(totalLimitAllocationAmount).toLocaleString("en-IN")}
//                               </span>
//                             </div>

//                             <div className='arrow-icon'>
//                               <img src="/Arrow-Total-Original-Limit-Allocated.png" style={{
//                                 width: "42px",
//                                 height: "42px",
//                                 borderRadius: "50%",
//                                 background: "#f2e2d9",
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "center"
//                               }} />
//                             </div>
//                           </div>
//                         )}
//                     </div>
//                   </div> */}

//                   <div className='icon-wrapper'>
//                     <div className='col-12'>
//                       {selectedYear && selectedHeadCode && (
//                         <div
//                           onClick={() => {
//                             if (totalDemandAmount > 0) {
//                               setShowDemandDistrictTable(!showDemandDistrictTable);
//                               setSelectedDemandDistrict("");
//                               setShowSpecific(50);
//                             }
//                           }}
//                           style={{
//                             width: "22rem",
//                             height: "6rem",
//                             borderRadius: "14px",
//                             background: "#ddd9f3",
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "space-between",
//                             padding: "1rem 1.25rem",
//                             boxShadow: "0 8px 18px rgba(0,0,0,0.06)",
//                             cursor: totalDemandAmount > 0 ? "pointer" : "not-allowed",
//                             opacity: totalDemandAmount > 0 ? 1 : 0.6,
//                           }}
//                         >
//                           <div style={{
//                             width: "40px",
//                             height: "40px",
//                             borderRadius: "12px",
//                             background: "#ddd9f3",
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             flexShrink: 0
//                           }}>
//                             <img
//                               src="/Total-Bill-Amount-for.png"
//                               style={{ width: "70px", height: "70px", objectFit: "contain" }}
//                             />
//                           </div>

//                           <div style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
//                             <span style={{ fontSize: "0.9rem", fontWeight: 600, color: "#444" }}>
//                               {t("Total Bill Amount:")}
//                             </span>
//                             <span style={{ fontSize: "1.3rem", fontWeight: 700 }}>
//                               ₹{Number(totalDemandAmount).toLocaleString("en-IN")}
//                             </span>
//                           </div>

//                           <div className='arrow-icon'>
//                             <img src="/Arrow-Total-Bill-Amount-for.png" style={{
//                               width: "42px",
//                               height: "42px",
//                               borderRadius: "50%",
//                               background: "#ddd9f3",
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "center"
//                             }} />
//                           </div>
//                         </div>

//                       )}
//                     </div>
//                   </div>

//                   <div className='icon-wrapper'>
//                     <div className='col-12'>
//                       {selectedYear && selectedHeadCode &&
//                         (
//                           <div
//                             onClick={() => {
//                               if (totalGRCreated > 0) setShowSpecific(99);
//                             }}
//                             style={{
//                               width: "20rem",
//                               height: "6rem",
//                               borderRadius: "14px",
//                               background: "#d7e9e2",
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "space-between",
//                               padding: "1rem 1.25rem",
//                               boxShadow: "0 8px 18px rgba(0,0,0,0.06)",
//                               cursor: totalGRCreated > 0 ? "pointer" : "not-allowed",
//                               opacity: totalGRCreated > 0 ? 1 : 0.6,
//                             }}
//                           >
//                             <div style={{
//                               width: "40px",
//                               height: "40px",
//                               borderRadius: "12px",
//                               background: "#d7e9e2",
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "center",
//                               flexShrink: 0
//                             }}>
//                               <img
//                                 src="/Total-Demand-Request-Created.png"
//                                 style={{ width: "70px", height: "70px", objectFit: "contain" }}
//                               />
//                             </div>

//                             <div style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
//                               <span style={{ fontSize: "0.9rem", fontWeight: 600, color: "#444" }}>
//                                 {t("Total GR Created:")}
//                               </span>
//                               <span style={{ fontSize: "1.3rem", fontWeight: 700 }}>
//                                 {totalGRCreated || 0}
//                               </span>
//                             </div>

//                             <div className='arrow-icon'>
//                               <img src="/Arrow-Total-Demand-Request-Created.png"
//                                 style={{
//                                   width: "42px",
//                                   height: "42px",
//                                   borderRadius: "50%",
//                                   background: "#d7e9e2",
//                                   display: "flex",
//                                   alignItems: "center",
//                                   justifyContent: "center"
//                                 }} />
//                             </div>
//                           </div>

//                         )}
//                     </div>
//                   </div>

//                   <div className='icon-wrapper'>
//                     <div className='col-12'>
//                       {
//                         selectedYear && selectedHeadCode && (
//                           <div
//                             onClick={() => {
//                               if (totalTSCreated > 0) setShowSpecific(109);
//                             }}
//                             style={{
//                               width: "22rem",
//                               height: "6rem",
//                               borderRadius: "14px",
//                               background: "#d1e5fa",
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "space-between",
//                               padding: "1rem 1.25rem",
//                               boxShadow: "0 8px 18px rgba(0,0,0,0.06)",
//                               cursor: totalTSCreated > 0 ? "pointer" : "not-allowed",
//                               opacity: totalTSCreated > 0 ? 1 : 0.6,
//                             }}
//                           >
//                             {/* Left Icon Box */}
//                             <div style={{
//                               width: "40px",
//                               height: "40px",
//                               borderRadius: "12px",
//                               background: "#d1e5fa",
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "center",
//                               flexShrink: 0
//                             }}>
//                               <img
//                                 src="/Total-Technical_S-Created.png"
//                                 style={{ width: "70px", height: "70px", objectFit: "contain" }}
//                               />
//                             </div>

//                             {/* Text */}
//                             <div style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
//                               <span style={{ fontSize: "0.9rem", fontWeight: 600, color: "#444" }}>
//                                 {t("Total Technical_S Created:")}
//                               </span>
//                               <span style={{ fontSize: "1.3rem", fontWeight: 700 }}>
//                                 {totalTSCreated || 0}
//                               </span>
//                             </div>

//                             {/* Right Arrow */}
//                             <div className='arrow-icon'>
//                               <img src="/Arrow-Total-Technical_S-Created.png" style={{
//                                 width: "42px",
//                                 height: "42px",
//                                 borderRadius: "50%",
//                                 background: "#d1e5fa",
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "center"
//                               }} />
//                             </div>
//                           </div>


//                         )}
//                     </div>
//                   </div>

//                   {/* <div className='icon-wrapper'>
//                     <div className='col-12'>
//                       {
//                         selectedYear && selectedHeadCode && (
//                           <div
//                             onClick={() => {

//                               setShowSpecific(112);
//                             }}
//                             style={{
//                               width: "22rem",
//                               height: "6rem",
//                               borderRadius: "14px",
//                               background: "#fff1dc",
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "space-between",
//                               padding: "1rem 1.25rem",
//                               boxShadow: "0 8px 18px rgba(0,0,0,0.06)",
//                               cursor: "pointer"
//                             }}
//                           >
//                             <div style={{
//                               width: "40px",
//                               height: "40px",
//                               borderRadius: "12px",
//                               background: "#fff1dc",
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "center",
//                               flexShrink: 0
//                             }}>
//                               <img
//                                 src="/Total-GR-Created.png"
//                                 style={{ width: "70px", height: "70px", objectFit: "contain" }}
//                               />
//                             </div>

//                             <div style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
//                               <span style={{ fontSize: "0.9rem", fontWeight: 600, color: "#444" }}>
//                                 {t("Total Demand Request Created:")}
//                               </span>
//                               <span style={{ fontSize: "1.3rem", fontWeight: 700 }}>
//                                 ₹{Number(totaldemandreqAMT || 0).toLocaleString("en-IN")}
//                               </span>
//                             </div>

//                             <div className='arrow-icon'>
//                               <img src="/Arrow-Total-GR-Created.png" style={{
//                                 width: "42px",
//                                 height: "42px",
//                                 borderRadius: "50%",
//                                 background: "#fff1dc",
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "center"
//                               }} />
//                             </div>
//                           </div>


//                         )}
//                     </div>
//                   </div> */}

//                   <div className='icon-wrapper'>
//                     <div className='col-12'>
//                       {
//                         selectedYear && selectedHeadCode && (
//                           <div
//                             onClick={() => {
//                               if (workorderlength > 0) setShowSpecific(115);
//                             }}
//                             style={{
//                               width: "20rem",
//                               height: "6rem",
//                               borderRadius: "14px",
//                               background: "#ffe1e8",
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "space-between",
//                               padding: "1rem 1.25rem",
//                               boxShadow: "0 8px 18px rgba(0,0,0,0.06)",
//                               cursor: workorderlength > 0 ? "pointer" : "not-allowed",
//                               opacity: workorderlength > 0 ? 1 : 0.6,
//                             }}
//                           >
//                             {/* Left Icon Box */}
//                             <div style={{
//                               width: "40px",
//                               height: "40px",
//                               borderRadius: "12px",
//                               background: "#ffe1e8",
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "center",
//                               flexShrink: 0
//                             }}>
//                               <img
//                                 src="/Total-Work-Order-Created.png"
//                                 style={{ width: "70px", height: "70px", objectFit: "contain" }}
//                               />
//                             </div>

//                             {/* Text */}
//                             <div style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
//                               <span style={{ fontSize: "0.9rem", fontWeight: 600, color: "#444" }}>
//                                 {t("Total Work Order Created:")}
//                               </span>
//                               <span style={{ fontSize: "1.3rem", fontWeight: 700 }}>
//                                 {workorderlength || 0}
//                               </span>
//                             </div>

//                             {/* Right Arrow */}
//                             <div className='arrow-icon'>
//                               <img src="/Arrow-Total-Work-Order-Created.png" style={{
//                                 width: "42px",
//                                 height: "42px",
//                                 borderRadius: "50%",
//                                 background: "#ffe1e8",
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "center"
//                               }} />
//                             </div>
//                           </div>


//                         )}
//                     </div>
//                   </div>

//                 </div>
//               </div>

//               {
//                 selectedYear && selectedHeadCode &&
//                 (
//                   <>

//                     <div className="col-12 my-5 bar-chart-container" >
//                       <div className="col-11 mx-auto">
//                         <h4 className="text-center mb-4" style={{ color: '#1f2937', fontWeight: '700' }}>
//                           {t("Year-wise Demand vs Release Comparison (in ₹ Lakhs)")}
//                         </h4>

//                         <ResponsiveContainer width="100%" height={420}>
//                           <BarChart
//                             data={barChartData}
//                             margin={{ top: 30, right: 40, left: 40, bottom: 30 }}
//                             barCategoryGap="20%"
//                             barSize={100}
//                           >
//                             <CartesianGrid strokeDasharray="3 3" />
//                             <XAxis
//                               dataKey="year"
//                               tick={{ fontSize: 12, fill: "#374151" }}
//                               label={{ value: "Year", position: "bottom", offset: 30, fontSize: 15 }}
//                             />
//                             <YAxis
//                               tick={{ fontSize: 12, fill: "#374151" }}
//                               tickFormatter={(value) => `${value} Lakhs`}
//                               label={{ value: "Amount (₹ Lakhs)", angle: -90, position: "insideLeft", offset: -30, fontSize: 15 }}
//                             />
//                             <Tooltip
//                               formatter={(value) => `₹ ${Number(value).toLocaleString("en-IN")} L`}
//                               contentStyle={{ fontSize: 13 }}
//                             />
//                             <Legend wrapperStyle={{ fontSize: 13 }} />

//                             <Bar dataKey="release" fill="#4f46e5" name="Work order Aprroved Amount (L)" radius={[4, 4, 0, 0]}>
//                               <LabelList dataKey="release" position="top" formatter={(v) => `${v} L`} style={{ fontSize: 12, fill: '#111827' }} />
//                             </Bar>
//                             <Bar dataKey="demand" fill="#10b981" name="Bill Paid Amount (L)" radius={[4, 4, 0, 0]}>
//                               <LabelList dataKey="demand" position="top" formatter={(v) => `${v} L`} style={{ fontSize: 12, fill: '#111827' }} />
//                             </Bar>
//                           </BarChart>
//                         </ResponsiveContainer>
//                       </div>
//                     </div>

//                   </>
//                 )
//               }
//             </div>

//           )
//         }

//         {/* Series for Part 1 for Release from UdF */}
//         {
//           selectedYear &&
//           showspecific === 1 &&
//           (
//             <>

//               <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
//                 <div className="col-11 m-auto">
//                   <div className='col-12' >

//                     <div className="col-12">
//                       <button className='btn btn-danger px-3 rounded-4 mb-3 mt-3' onClick={() => setShowSpecific(0)}>{t("Back")}</button>
//                     </div>

//                     <div className="col-11 my-0 mx-auto">
//                       <div className="row">
//                         <div className="col-12 py-2 d-flex justify-content-left align-items-center">

//                           <h5 className="my-auto fw-bold d-flex align-items-center">
//                             <img
//                               src="/GR-Approval64.png"
//                               alt=""
//                               style={{ width: "24px", height: "24px" }}
//                               className="me-2"
//                             />
//                             <span>
//                               {t("Limit Allocation Detail for Year")} {selectedYear}
//                             </span>
//                           </h5>
//                         </div>

//                         <div className="col-12 d-flex justify-content-end mt-3 mb-3 gap-2">
//                           <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("ALlDistrictFinanceData", "AllDistrictReleaseData.xlsx")}>{t("Download Excel")}</button>
//                           <button className='btn btn-danger px-4' onClick={() => downloadPageAsPDF('ALlDistrictFinanceData', `ALlDistrictFinanceData_${selectedYear}.pdf`, `ALlDistrict Finance Data ${selectedYear}`)}>{t("Download Pdf")}</button>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="col-12 pb-5">
//                       <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>

//                         <div className='col-12 tableDesign DistrictTableContianerModel2' style={{ background: '#2C78DB', overflowX: 'auto' }}>
//                           <table className='m-0 py-0 ALlDistrictFinanceData' style={{ width: '100%', borderCollapse: 'collapse' }}>
//                             <thead>
//                               <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
//                                 <th style={{ minWidth: "250px", padding: "8px" }}>{t("District")}</th>
//                                 <th style={{ minWidth: "250px", padding: "8px" }}>{t("Year")}</th>
//                                 <th style={{ minWidth: "250px", padding: "8px" }}>{t("HeadCode")}</th>
//                                 <th style={{ minWidth: "250px", padding: "8px" }}>{t("Total Limit Allocated Amount")}</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {
//                                 uniqueDistrictsData &&
//                                   uniqueDistrictsData.length > 0 ? (
//                                   uniqueDistrictsData.map((item, idx) => {
//                                     const bgColor = idx % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                     return (
//                                       <tr key={idx} style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "400" }}>
//                                         <td><a
//                                           href="#"
//                                           className='my-auto'
//                                           style={{ color: '#4f46e5', textDecoration: 'underline' }}
//                                           onClick={(e) => {
//                                             e.preventDefault();
//                                             fetchreleasefromUdfData(selectedYear, item.District, selectedHeadCode);
//                                           }}
//                                         >
//                                           {item.District}
//                                         </a></td>
//                                         <td>{selectedYear}</td>
//                                         <td>{selectedHeadCode}</td>
//                                         <td>
//                                           ₹ {Number(item.TotalLimitAllottedAmount).toLocaleString("en-IN")}
//                                         </td>
//                                       </tr>
//                                     )
//                                   })

//                                 )
//                                   :
//                                   (
//                                     <tr>
//                                       <td colSpan={5} className='fw-bold'>{t("No data found")}</td>
//                                     </tr>
//                                   )
//                               }
//                             </tbody>
//                           </table>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//             </>
//           )
//         }

//         {
//           selectedDistrict &&
//           showspecific === 2 &&
//           (
//             <>
//               <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
//                 <div className="col-11 m-auto">
//                   <div className='col-12' >

//                     <div className="col-12">
//                       {/* Smart Back: if in Chart view, go to Table; otherwise go back to previous screen */}
//                       <button
//                         className='btn btn-danger px-3 rounded-4 mb-3 mt-3'
//                         onClick={() => {
//                           if (showGraph === "Chart") {
//                             // stay on showspecific===2 but switch to Table view
//                             setShowGraph("Table");
//                           } else {
//                             // go back to parent screen
//                             setShowSpecific(1);
//                           }
//                         }}
//                       >
//                         {t("Back")}
//                       </button>
//                     </div>

//                     {
//                       showGraph === "Table" &&
//                       (
//                         <>
//                           <div className="col-11 my-4 mx-auto">
//                             <div className="row">
//                               <div className="d-flex justify-content-between align-items-center flex-wrap">
//                                 <h5 className="my-auto fw-bold d-flex align-items-center">
//                                   <img src="/GR-Approval64.png" alt="" style={{ width: "24px", height: "24px" }} className="me-2" />
//                                   <span>{t("All Entries for District:")}{selectedDistrict}</span>
//                                 </h5>
//                               </div>

//                               <div className="col-12 d-flex justify-content-end mt-3 mb-3 gap-2">
//                                 <button className="btn btn-primary px-4"
//                                   onClick={() =>
//                                     downloadPageAsPDF(
//                                       "TalukaWiseDemandTable",
//                                       "bar-chart-container",
//                                       `DistrictWiseProposalTable_${selectedYear}.pdf`,
//                                       `District Wise Table ${selectedYear}`
//                                     )}
//                                 >
//                                   📄 {t("Download Complete Report")}
//                                 </button>

//                                 <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("TalukaWiseDemandTable", "TalukaWiseReleasedata.xlsx")}>{t("Download Excel")}</button>

//                                 <button
//                                   className="btn btn-danger px-4"
//                                   onClick={() =>
//                                     downloadTableOnlyAsPDF(
//                                       "TalukaWiseDemandTable",          // ✅ TABLE CLASS
//                                       `District_Table_${selectedYear}.pdf`,
//                                       `All Entries of ${selectedYear}`
//                                     )
//                                   }
//                                 >
//                                   {t("Download Pdf")}
//                                 </button>
//                               </div>
//                             </div>
//                           </div>

//                           <div className="col-12 pb-5">
//                             <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>
//                               <div className="col-md-6 col-sm-12 d-flex justify-content-start mb-3 text-center">
//                                 <button className={showGraph === "Table" ? "px-5 btn btn-success mx-2" : "px-5 btn btn-secondary mx-2"} onClick={() => setShowGraph("Table")}>{t("Table")}</button>
//                                 <button className={showGraph === "Chart" ? "px-5 btn btn-success" : "px-5 btn btn-secondary"} onClick={() => setShowGraph("Chart")} >{t("Chart")}</button>
//                               </div>

//                               <div className="m-auto tableDesign DistrictTableContianerModel2" style={{
//                                 background: '#2C78DB', overflowX: "auto",
//                                 overflowY: "auto",
//                                 maxHeight: "600px", // change height as needed
//                                 position: "relative"
//                               }}>
//                                 <table className='m-0 p-0 TalukaWiseDemandTable' style={{ width: '100%', borderCollapse: 'collapse' }}>
//                                   <thead style={{
//                                     position: "sticky", backgroundColor: "#1976d2",
//                                     top: 0,
//                                     zIndex: 10,
//                                   }}>
//                                     <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
//                                       <th style={{ width: "10%" }}>{t("Sr No")}</th>
//                                       <th style={{ width: "20%" }}>{t("Taluka")}</th>
//                                       <th style={{ width: "15%" }}>{t("Year")}</th>
//                                       <th style={{ width: "35%" }}>{t("HeadCode")}</th>
//                                       <th style={{ width: "20%" }}>{t("Limit Allocated Amount")}</th>
//                                       <th style={{ width: "25%" }}>{t("Remaining Limit")}</th>
//                                       <th style={{ width: "25%" }}>{t("Release Amount")}</th>
//                                     </tr>
//                                   </thead>
//                                   <tbody>
//                                     {
//                                       filteredreleaseudf && filteredreleaseudf.length > 0 ? (() => {
//                                         const totalLamount = filteredreleaseudf.reduce((sum, val) => sum + parseFloat(val.totalLimitAllocated || 0), 0);
//                                         const totalRemainingLamount = filteredreleaseudf.reduce((sum, val) => sum + parseFloat(val.totalRemainingLimit || 0), 0);
//                                         const totalRamount = filteredreleaseudf.reduce((sum, val) => sum + parseFloat(val.totalReleaseAmount || 0), 0);

//                                         return (
//                                           <>
//                                             {
//                                               filteredreleaseudf.map((val, index) => {
//                                                 const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                                 return (
//                                                   <tr key={index} style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "400" }}>
//                                                     <td>{index + 1}</td>
//                                                     <td onClick={() => fetchProposalfromReleaseBytaluka(val.Taluka)}>
//                                                       <p className='makeitlink my-auto'>{val.Taluka}</p>
//                                                     </td>
//                                                     <td>{selectedYear}</td>
//                                                     <td>{val.head || selectedHeadCode}</td>
//                                                     <td>{Number(val.totalLimitAllocated).toLocaleString("en-IN")}</td>
//                                                     <td>{Number(val.totalRemainingLimit).toLocaleString("en-IN")}</td>
//                                                     <td>{Number(val.totalReleaseAmount).toLocaleString("en-IN")}</td>
//                                                   </tr>
//                                                 );
//                                               })
//                                             }

//                                             <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>
//                                               <td colSpan={4}>{t("Total Amount")}</td>
//                                               <td>₹ {Number(totalLamount).toLocaleString("en-IN")}</td>
//                                               <td>₹ {Number(totalRemainingLamount).toLocaleString("en-IN")}</td>
//                                               <td>₹ {Number(totalRamount).toLocaleString("en-IN")}</td>
//                                             </tr>
//                                           </>
//                                         )
//                                       })() : (
//                                         <tr>
//                                           <td colSpan={7} className='fw-bold'>{t("No data found")}</td>
//                                         </tr>
//                                       )
//                                     }
//                                   </tbody>
//                                 </table>
//                               </div>
//                             </div>
//                           </div>
//                         </>
//                       )
//                     }
//                   </div>
//                 </div>

//                 {
//                   // ---------- Chart Section: use aggregated data from filteredreleaseudf ----------
//                   showGraph === "Chart" &&
//                   filteredreleaseudf &&
//                   filteredreleaseudf.length > 0 && (
//                     <div className="col-12 mb-5 bar-chart-container">
//                       <div className="col-11 mx-auto">
//                         <h4 className="text-center mb-4" style={{ color: '#1f2937', fontWeight: '700' }}>
//                           {t("Taluka-wise Limit Allocated (in ₹ Crores)")}
//                         </h4>

//                         {(() => {
//                           // Aggregate by Taluka (same source as the table)
//                           const grouped = filteredreleaseudf.reduce((acc, cur) => {
//                             const tal = (cur.Taluka || 'Unknown').toString().trim();
//                             const amount = parseFloat(cur.totalLimitAllocated || 0) || 0;
//                             if (!acc[tal]) acc[tal] = 0;
//                             acc[tal] += amount;
//                             return acc;
//                           }, {});

//                           // convert to array and convert to Crores for display
//                           const chartData = Object.keys(grouped).map(tal => ({
//                             Taluka: tal,
//                             rawAmount: grouped[tal], // rupees
//                             totalLimitAllocatedInCr: Number((grouped[tal] / 10000000).toFixed(4)) // crore (keep some precision)
//                           })).sort((a, b) => b.rawAmount - a.rawAmount);

//                           // debug: verify chartData contains all talukas
//                           console.log("Taluka chartData:", chartData);

//                           return (
//                             <ResponsiveContainer width="100%" height={450}>
//                               <BarChart
//                                 data={chartData}
//                                 margin={{ top: 30, right: 40, left: 40, bottom: 60 }}
//                                 barCategoryGap="20%"
//                                 barGap={6}
//                               >
//                                 <CartesianGrid strokeDasharray="3 3" />

//                                 <XAxis
//                                   dataKey="Taluka"
//                                   tick={{ fontSize: 12, fill: "#374151" }}
//                                   interval={0}
//                                   angle={-25}
//                                   textAnchor="end"
//                                   height={80}
//                                   tickFormatter={(v) => (v && v.length > 16 ? v.slice(0, 16) + '...' : v)}
//                                 />

//                                 <YAxis
//                                   tick={{ fontSize: 12, fill: "#374151" }}
//                                   tickFormatter={(value) => `${value} Cr`}
//                                   label={{ value: "Amount (₹ Cr)", angle: -90, position: "insideLeft", offset: -30, fontSize: 13 }}
//                                 />

//                                 <Tooltip
//                                   formatter={(value, name, props) => {
//                                     // value = Cr number, payload.rawAmount is rupee number
//                                     const raw = props.payload && props.payload.rawAmount ? props.payload.rawAmount : 0;
//                                     return [`₹ ${Number(raw).toLocaleString("en-IN")}`, `${name} (₹)`];
//                                   }}
//                                   labelFormatter={(label) => `Taluka: ${label}`}
//                                   contentStyle={{ fontSize: 13, fontWeight: "600" }}
//                                   cursor={{ fill: 'rgba(0, 0, 0, 0.05)' }}
//                                 />

//                                 <Legend wrapperStyle={{ fontSize: 13 }} />

//                                 <Bar
//                                   dataKey="totalLimitAllocatedInCr"
//                                   fill="#4f46e5"
//                                   name="Limit Allocated (Cr)"
//                                   radius={[4, 4, 0, 0]}
//                                   barSize={40}
//                                   minPointSize={6}            // CRITICAL: ensures very small values still render visibly
//                                 >
//                                   <LabelList
//                                     dataKey="totalLimitAllocatedInCr"
//                                     position="top"
//                                     formatter={(v) => `${v} Cr`}
//                                     style={{ fontSize: 12, fill: '#111827', fontWeight: "600" }}
//                                   />
//                                 </Bar>
//                               </BarChart>
//                             </ResponsiveContainer>
//                           );
//                         })()}
//                       </div>
//                     </div>
//                   )
//                 }

//               </div>
//             </>
//           )
//         }

//         {
//           selectedDistrict &&
//           showspecific === 3 &&
//           (
//             <>
//               <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
//                 <div className="col-11 m-auto">
//                   <div className='col-12' >

//                     <div className="col-12">
//                       <button
//                         className='btn btn-danger px-3 rounded-4 mb-3 mt-3'
//                         onClick={() => {
//                           if (showGraph === "Chart") {
//                             setShowGraph("Table");   // go back to table inside same level
//                           } else {
//                             setShowSpecific(2);      // go back to District level
//                           }
//                         }}
//                       >
//                         {t("Back")}
//                       </button>
//                     </div>

//                     {
//                       showGraph === "Table" &&
//                       (
//                         <>
//                           <div className="col-11 my-4 mx-auto">
//                             <div className="row">

//                               <div className="d-flex justify-content-between align-items-center flex-wrap">
//                                 <h5 className="my-auto fw-bold d-flex align-items-center">
//                                   <img
//                                     src="/GR-Approval64.png"
//                                     alt=""
//                                     style={{ width: "24px", height: "24px" }}
//                                     className="me-2"
//                                   />
//                                   <span>
//                                     {t("All Entries for Taluka:")} {selectedTaluka}
//                                   </span>
//                                 </h5>
//                               </div>

//                               <div className="col-12 d-flex justify-content-end mt-3 gap-2">
//                                 <button
//                                   className="btn btn-primary px-4"
//                                   onClick={() =>
//                                     downloadPageAsPDF(
//                                       "TalukaWiseProposalData",
//                                       "bar-chart-container",
//                                       `TalukaWiseProposalData_${selectedYear}.pdf`,
//                                       `TalukaWise Proposal Data ${selectedYear}`
//                                     )
//                                   }
//                                 >
//                                   📄 {t("Download Complete Report")}
//                                 </button>
//                                 <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("TalukaWiseProposalData", "TalukaWiseProposalData.xlsx")}>{t("Download Excel")}</button>
//                                 <button className='btn btn-danger px-4' onClick={() => downloadTableOnlyAsPDF('TalukaWiseProposalData', 'All Entries of Taluka', `TalukaWiseProposalData_${selectedYear}.pdf`, `TalukaWise Proposal Data ${selectedYear}`)}>{t("Download Pdf")}</button>
//                               </div>
//                             </div>
//                           </div>
//                           <div className="col-12 pb-5">
//                             <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>
//                               <div className="col-md-6 col-sm-12 d-flex justify-content-start mb-3 text-center"></div>
//                               <div className="col-md-6 col-sm-12 d-flex justify-content-start mb-3 text-center">
//                                 <button className={showGraph === "Table" ? "px-5 btn btn-success mx-2" : "px-5 btn btn-secondary mx-2"} onClick={() => setShowGraph("Table")}>Table</button>
//                                 <button className={showGraph === "Chart" ? "px-5 btn btn-success" : "px-5 btn btn-secondary"} onClick={() => setShowGraph("Chart")} >Chart</button>
//                               </div>
//                               <div className="m-auto tableDesign DistrictTableContianer" style={{
//                                 background: '#2C78DB', overflowX: "auto",
//                                 overflowY: "auto",
//                                 maxHeight: "600px", // change height as needed
//                                 position: "relative"
//                               }}>
//                                 <table className='m-0 p-0 TalukaWiseProposalData' style={{ width: '100%', borderCollapse: 'collapse' }}>
//                                   <thead style={{
//                                     position: "sticky", backgroundColor: "#1976d2",
//                                     top: 0,
//                                     zIndex: 10,
//                                   }}>
//                                     <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
//                                       <th style={{ width: "6%" }}>{t("Sr No")}</th>
//                                       <th style={{ width: "15%" }}>{t("Proposal Name")}</th>
//                                       <th style={{ width: "10%" }}>{t("Year")}</th>
//                                       <th style={{ width: "10%" }}>{t("HeadCode")}</th>
//                                       <th style={{ width: "15%" }}>{t("Proposal Amount")}</th>
//                                       <th style={{ width: "15%" }}>{t("Limit Allocated Amount")}</th>
//                                       <th style={{ width: "15%" }}>{t("Remaining Limit")}</th>
//                                       <th style={{ width: "15%" }}>{t("Release Amount")}</th>
//                                     </tr>
//                                   </thead>
//                                   <tbody>
//                                     {
//                                       currenttalukawiseProposalData &&
//                                         currenttalukawiseProposalData.length > 0 ? (() => {
//                                           const totalProposalamount = currenttalukawiseProposalData.reduce((sum, val) => sum + parseFloat(val.ProposalCost || 0), 0);
//                                           const totalLimitamount = currenttalukawiseProposalData.reduce((sum, val) => sum + parseFloat(val.OriginalLimitAllocatedAmount || 0), 0);
//                                           const totalRemainingLimit = currenttalukawiseProposalData.reduce((sum, val) => sum + parseFloat(val.LimitAllottedAmount || 0), 0);
//                                           const totalReleaseamount = currenttalukawiseProposalData.reduce((sum, val) => sum + parseFloat(val.ReleaseAmountTillDate || 0), 0);

//                                           return (
//                                             <>
//                                               {
//                                                 [...currenttalukawiseProposalData]
//                                                   .sort((a, b) => b.ID - a.ID) //newest first
//                                                   .map((val, index) => {
//                                                     const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                                     return (
//                                                       <tr key={index} style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "400" }}>
//                                                         <td>{indexOfFirstUDF + index + 1}</td>
//                                                         <td onClick={() => ProposalDataUsingSelectedProposal(val.ProposalID)}>
//                                                           <p className='makeitlink my-auto'>{val.ProposalID}</p>
//                                                         </td>
//                                                         <td>{selectedYear}</td>
//                                                         <td>{selectedHeadCode}</td>
//                                                         <td>₹ {Number(val.ProposalCost).toLocaleString("en-IN")}</td>
//                                                         <td>₹ {Number(val.OriginalLimitAllocatedAmount).toLocaleString("en-IN")}</td>
//                                                         <td>₹ {Number(val.LimitAllottedAmount).toLocaleString("en-IN")}</td>
//                                                         <td>₹ {Number(val.ReleaseAmountTillDate).toLocaleString("en-IN")}</td>
//                                                       </tr>
//                                                     );
//                                                   }
//                                                   )
//                                               }

//                                               <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>
//                                                 <td colSpan={4}>{t("Total Amount")}</td>
//                                                 <td>₹ {Number(totalProposalamount).toLocaleString("en-IN")}</td>
//                                                 <td>₹ {Number(totalLimitamount).toLocaleString("en-IN")}</td>
//                                                 <td>₹ {Number(totalRemainingLimit).toLocaleString("en-IN")}</td>
//                                                 <td>₹ {Number(totalReleaseamount).toLocaleString("en-IN")}</td>
//                                               </tr>


//                                             </>
//                                           )

//                                         }
//                                         )()
//                                         :
//                                         (
//                                           <tr>
//                                             <td colSpan={5} className='fw-bold'>{t("No data found")}</td>
//                                           </tr>
//                                         )
//                                     }
//                                   </tbody>
//                                 </table>
//                               </div>
//                               <div className='col-12 mt-4 mb-2'>
//                                 <div className="row">
//                                   <div className='col-6'>
//                                     <p className="text-gray-600" style={{ fontSize: "14px" }}>{t("Showing")} {indexOfFirstUDF + 1} {t("to")} {Math.min(indexOfLastUDF, talukawiseProposalData.length)} {t("of")} {talukawiseProposalData.length} {t("entries")}</p>
//                                   </div>
//                                   <div className='col-6' style={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
//                                     <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
//                                       style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', width: '2rem' }}>&laquo;</button>
//                                     <button onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}
//                                       style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>&lt;</button>
//                                     <button
//                                       style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '20px', width: '2.4rem', border: '1px solid lightgrey', borderLeft: "none" }}>
//                                       {currentPage}
//                                     </button>
//                                     <button onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === totalUDFPages || totalUDFPages === 0}
//                                       style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>&gt;</button>
//                                     <button onClick={() => setCurrentPage(totalUDFPages)} disabled={currentPage === totalUDFPages || totalUDFPages === 0}
//                                       style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>&raquo;</button>
//                                   </div>
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </>
//                       )
//                     }
//                   </div>
//                 </div>
//                 {
//                   showGraph === "Chart" &&
//                   talukawiseProposalData &&
//                   talukawiseProposalData.length > 0 && (
//                     <div className="col-12 mb-5 bar-chart-container">
//                       <div className="col-11 mx-auto">
//                         <h4 className="text-center mb-4" style={{ color: '#1f2937', fontWeight: '700' }}>
//                           {t("Proposal-wise Limit Allocated (in ₹ Crores)")}
//                         </h4>

//                         <ResponsiveContainer width="100%" height={500}>
//                           <BarChart
//                             data={proposalChartData}
//                             margin={{ top: 40, right: 30, left: 40, bottom: 140 }}
//                             barCategoryGap="30%"
//                           >
//                             <CartesianGrid strokeDasharray="3 3" />

//                             <XAxis
//                               dataKey="proposal"
//                               interval={0}
//                               angle={-30}
//                               textAnchor="end"
//                               height={120}
//                               tick={{ fontSize: 12 }}
//                               label={{
//                                 value: t("Proposal Name"),
//                                 position: "bottom",
//                                 offset: 90,
//                                 fontSize: 14
//                               }}
//                             />

//                             <YAxis
//                               tickFormatter={(v) => `${v} Cr`}
//                               label={{
//                                 value: t("Amount (₹ Cr)"),
//                                 angle: -90,
//                                 position: "insideLeft",
//                                 offset: -10,
//                                 fontSize: 14
//                               }}
//                             />

//                             <Tooltip
//                               formatter={(value, name, props) => {
//                                 const rs = props.payload.amountRs;
//                                 return [`₹ ${rs.toLocaleString("en-IN")}`, t("Limit Allocated")];
//                               }}
//                               labelFormatter={(label) => `${t("Proposal")}: ${label}`}
//                               contentStyle={{ fontSize: 13, fontWeight: 600 }}
//                             />

//                             <Legend />

//                             <Bar
//                               dataKey="amountCr"
//                               name={t("Limit Allocated (Cr)")}
//                               fill="#4f46e5"
//                               radius={[6, 6, 0, 0]}
//                               maxBarSize={60}
//                             >
//                               <LabelList
//                                 dataKey="amountCr"
//                                 position="top"
//                                 formatter={(v) => `${v} Cr`}
//                                 style={{ fontSize: 11, fontWeight: 600 }}
//                               />
//                             </Bar>
//                           </BarChart>
//                         </ResponsiveContainer>
//                       </div>
//                     </div>
//                   )
//                 }

//               </div>


//             </>
//           )
//         }

//         {
//           selectedWorkname &&
//           showspecific === 4 &&
//           <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
//             <div className="col-11 m-auto">
//               <div className='col-12' >

//                 <div className="col-12">
//                   <button className='btn btn-danger px-3 rounded-4 mb-3 mt-3' onClick={() => setShowSpecific(3)}>{t("Back")}</button>
//                 </div>

//                 <div className="col-11 my-4 mx-auto">
//                   <div className="row">

//                     <div className="d-flex justify-content-between align-items-center flex-wrap">
//                       <h5 className="my-auto fw-bold d-flex align-items-center">
//                         <img
//                           src="/GR-Approval64.png"
//                           alt=""
//                           style={{ width: "24px", height: "24px" }}
//                           className="me-2"
//                         />
//                         <span>
//                           {t("Proposal :")}{selectedWorkname}
//                         </span>
//                       </h5>
//                     </div>

//                     <div className="col-12 d-flex justify-content-end mt-3 gap-2">
//                       <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("ProposalDataTable", "Proposal.xlsx")}>Download Excel</button>
//                       <button className='btn btn-danger px-4' onClick={() => downloadTableOnlyAsPDF('ProposalDataTable', `ProposalDataTable${selectedYear}.pdf`, `Proposal Data Table ${selectedYear}`)}>Download Pdf</button>
//                     </div>
//                   </div>
//                 </div>


//                 <div className="m-auto tableDesign DistrictTableContianer" style={{
//                   background: '#2C78DB', overflowX: "auto",
//                   overflowY: "auto",
//                   maxHeight: "600px", // change height as needed
//                   position: "relative"
//                 }}>
//                   <table className='p-0 m-0 ProposalDataTable' style={{ width: '100%', borderCollapse: 'collapse' }}>
//                     <thead style={{
//                       position: "sticky", backgroundColor: "#1976d2",
//                       top: 0,
//                       zIndex: 10,
//                     }}>
//                       <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
//                         {/* <th style={{ width: "10%" }}>Proposal ID</th> */}
//                         <th style={{ width: "20%" }}>{t("Proposal Name")}</th>
//                         {/* <th style={{ width: "20%" }}>Scheme</th> */}
//                         <th style={{ width: "20%" }}>{t("Constituency Name")}</th>
//                         <th style={{ width: "20%" }}>{t("Proposal Amount")}</th>
//                         <th style={{ width: "20%" }}>{t("Date")}</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {
//                         fetchSpecificProposalData &&
//                           fetchSpecificProposalData.length > 0 ? (
//                           fetchSpecificProposalData.map((val, index) => {
//                             const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                             return (
//                               <tr key={index} style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "400" }}>
//                                 <td><p className='my-auto'>{val.Work_name}</p></td>
//                                 {/* <td>{val.SchemeName}</td> */}
//                                 <td>{val.Constituency_name}</td>
//                                 <td>₹ {Number(val.Proposal_amount).toLocaleString("en-IN")}</td>
//                                 <td>{new Date(val.created_at).toLocaleString("en-IN")}</td>
//                               </tr>
//                             )
//                           })
//                         )
//                           :
//                           (
//                             <tr>
//                               <td colSpan={5} className='fw-bold'>{t("No data found")}</td>
//                             </tr>
//                           )
//                       }
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             </div>
//           </div>
//         }

//         {/* Series for part 2 For Demand Reliated Data */}
//         {
//           selectedYear &&
//           showspecific === 50 &&
//           (
//             <>
//               <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
//                 <div className="col-11 m-auto">
//                   <div className='col-12' >

//                     <div className="col-12">
//                       <button
//                         className='btn btn-danger px-3 rounded-4 mb-3 mt-3'
//                         onClick={() => {
//                           setSelectedBillDistrict('');
//                           setBillDistrictSearch('');
//                           setDistrictPage(1);
//                           setShowAllDistrict(false);
//                           setShowSpecific(0);
//                         }}
//                       >
//                         {t("Back")}
//                       </button>
//                     </div>

//                     {
//                       showGraph === "Table" && (
//                         <>
//                           <div className="col-11 my-4 mx-auto">
//                             <div className="row align-items-center justify-content-between">
//                               <div className="col-md-6 col-sm-12 my-auto">
//                                 <h5 className='my-auto fw-bold'>
//                                   <img src="/GR-Approval64.png" alt="" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
//                                   <span className='my-auto'>{t("Bill Amount by District for")} {selectedYear} </span>
//                                 </h5>
//                               </div>

//                               <div className="col-md-6 col-sm-12 d-flex justify-content-end gap-2">
//                                 <button className='btn btn-success px-2 mb-2' onClick={() => exportTableByClassToExcel("AllGR", "ProposalAmount.xlsx")}>{t("Download Excel")}</button>
//                                 <button className='btn btn-danger px-2 mb-2' onClick={() => downloadTableOnlyAsPDF('AllGR', `AllGR_${selectedYear}.pdf`, `All GR for ${selectedYear}`)}>
//                                   {t("Download PDF")}
//                                 </button>
//                               </div>
//                             </div>
//                           </div>
//                           <div
//                             className="d-flex justify-content-end mb-3"
//                             style={{ gap: "10px" }}
//                           >
//                             {userData?.Department_Name === "State" && (
//                               <select
//                                 className="form-select"
//                                 value={selectedBillDistrict}
//                                 onChange={(e) => {
//                                   setSelectedBillDistrict(e.target.value);
//                                   setDistrictPage(1);
//                                   setShowAllDistrict(false);
//                                 }}
//                                 style={{
//                                   width: "220px",
//                                   border: "1px solid #ccc",
//                                   borderRadius: "8px",
//                                   padding: "8px 12px",
//                                   fontSize: "16px",
//                                 }}
//                               >
//                                 <option value="">All Districts</option>

//                                 {[...new Set(
//                                   demandDistrictData
//                                     .map(item => getMainDistrict(item.District))
//                                     .filter(Boolean)
//                                 )]
//                                   .sort()
//                                   .map((district, index) => (
//                                     <option key={index} value={district}>
//                                       {district}
//                                     </option>
//                                   ))}
//                               </select>
//                             )}

//                             <input
//                               type="text"
//                               className="form-control"
//                               placeholder="Search..."
//                               value={billDistrictSearch}
//                               onChange={(e) => {
//                                 setBillDistrictSearch(e.target.value);
//                                 setDistrictPage(1);
//                                 setShowAllDistrict(false);
//                               }}
//                               style={{
//                                 width: "220px",
//                                 border: "1px solid #ccc",
//                                 borderRadius: "8px",
//                                 padding: "8px 12px",
//                                 fontSize: "16px",
//                               }}
//                             />
//                           </div>
//                           <div className="col-12 pb-5">
//                             <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>
//                               <div className='col-12 tableDesign DistrictTableContianerModel2' style={{
//                                 background: '#2C78DB', overflowX: "auto",
//                                 overflowY: "auto",
//                                 maxHeight: "600px", // change height as needed
//                                 position: "relative"
//                               }}>
//                                 <table className='m-0 p-0 AllGR' style={{ width: '100%', borderCollapse: 'collapse', tableLayout: "fixed", fontSize: "18px" }}>
//                                   <thead style={{
//                                     position: "sticky", backgroundColor: "#1976d2",
//                                     top: 0,
//                                     zIndex: 10,
//                                   }}>
//                                     <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
//                                       <th style={{ width: "12%", fontSize: "18px" }}>{t("Sr No")}</th>
//                                       <th style={{ width: "45%", fontSize: "18px" }}>{t("District")}</th>
//                                       <th style={{ width: "45%", fontSize: "18px" }}>{t("Year")}</th>
//                                       <th style={{ width: "45%", fontSize: "18px" }}>{t("HeadCode")}</th>
//                                       <th style={{ width: "43%", fontSize: "18px" }}>{t("Bill Amount")}</th>
//                                     </tr>
//                                   </thead>
//                                   <tbody>
//                                     {
//                                       demandDistrictData &&
//                                         demandDistrictData.length > 0 ?
//                                         (() => {
//                                           const totalamount = filteredBillDistrictData.reduce((sum, val) => sum + parseFloat(val.TotalBillAmount || 0), 0);
//                                           const pageTotalAmount = paginatedDistrictData.reduce(
//                                             (sum, val) => sum + parseFloat(val.TotalBillAmount || 0),
//                                             0
//                                           );

//                                           return (
//                                             <>
//                                               {
//                                                 paginatedDistrictData.map((val, index) => {
//                                                   const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                                   return (
//                                                     <tr key={index} style={{ backgroundColor: bgColor, fontSize: "18px", fontWeight: "400", fontSize: "18px" }}>
//                                                       <td style={{ fontSize: "18px" }}>
//                                                         {showAllDistrict
//                                                           ? index + 1
//                                                           : (districtPage - 1) * districtRecordsPerPage + index + 1}
//                                                       </td>
//                                                       <td style={{ fontSize: "18px", textAlign: 'center' }}>
//                                                         <p style={{ fontSize: "18px", textAlign: 'center' }} className='makeitlink my-auto' onClick={() => DemandGenerationSortByDistrict(val.District)}>{val.District}</p>
//                                                       </td>
//                                                       <td style={{ fontSize: "18px" }}>{selectedYear}</td>
//                                                       <td style={{ fontSize: "18px" }}>{selectedHeadCode}</td>
//                                                       <td style={{ fontSize: "18px" }}>₹ {Number(val.TotalBillAmount).toLocaleString("en-IN")}</td>
//                                                     </tr>
//                                                   );
//                                                 })
//                                               }

//                                               <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0', fontSize: "18px", textAlign: "right" }}>
//                                                 <td colSpan={4} style={{ fontSize: "18px" }}>
//                                                   {t("Page Total")}
//                                                 </td>
//                                                 <td style={{ fontSize: "18px" }}>
//                                                   ₹ {Number(pageTotalAmount).toLocaleString("en-IN")}
//                                                 </td>
//                                               </tr>
//                                               <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0', fontSize: "18px", textAlign: "right" }}>
//                                                 <td colSpan={4} style={{ fontSize: "18px" }}>{t("Gross Total")}</td>
//                                                 <td style={{ fontSize: "18px" }}>₹ {Number(totalamount).toLocaleString("en-IN")}</td>
//                                               </tr>
//                                             </>
//                                           );
//                                         })()
//                                         :
//                                         (
//                                           <tr>
//                                             <td colSpan={5} className='fw-bold'>{t("No data found")}</td>
//                                           </tr>
//                                         )
//                                     }
//                                   </tbody>
//                                 </table>
//                               </div>

//                               <div
//                                 style={{
//                                   display: "flex",
//                                   justifyContent: "space-between",
//                                   alignItems: "center",
//                                   marginTop: "20px",
//                                 }}
//                               >
//                                 <p className="text-gray-600 m-0" style={{ fontSize: "18px" }}>
//                                   {t("Showing")}{" "}
//                                   {demandDistrictData.length > 0
//                                     ? showAllDistrict
//                                       ? 1
//                                       : (districtPage - 1) * districtRecordsPerPage + 1
//                                     : 0}{" "}
//                                   {t("to")}{" "}
//                                   {showAllDistrict
//                                     ? demandDistrictData.length
//                                     : Math.min(
//                                       districtPage * districtRecordsPerPage,
//                                       demandDistrictData.length
//                                     )}{" "}
//                                   {t("of")} {demandDistrictData.length} {t("entries")}
//                                 </p>

//                                 <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//                                   <button
//                                     type="button"
//                                     onClick={() => {
//                                       setShowAllDistrict(!showAllDistrict);
//                                       setDistrictPage(1);
//                                     }}
//                                     style={{
//                                       border: "none",
//                                       outline: "none",
//                                       cursor: "pointer",
//                                       padding: "8px 16px",
//                                       borderRadius: "20px",
//                                       fontSize: "13px",
//                                       fontWeight: "600",
//                                       color: "#fff",
//                                       background: showAllDistrict
//                                         ? "linear-gradient(135deg, #28a745, #20c997)"
//                                         : "linear-gradient(135deg, #0067ab, #0098d5)",
//                                       boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
//                                       transition: "all 0.3s ease",
//                                     }}
//                                   >
//                                     {showAllDistrict ? "✓ Showing All" : "View All"}
//                                   </button>

//                                   {!showAllDistrict && (
//                                     <GooglePagination
//                                       currentPage={districtPage}
//                                       totalPages={totalDistrictPages}
//                                       onPageChange={setDistrictPage}
//                                     />
//                                   )}
//                                 </div>
//                               </div>
//                             </div>
//                           </div>

//                         </>
//                       )
//                     }
//                   </div>
//                 </div>
//                 {
//                   showGraph === "Chart" &&
//                   demandDistrictData &&
//                   demandDistrictData.length > 0 && (
//                     <div className="col-12 mb-5 bar-chart-container">
//                       <div className="col-11 mx-auto">
//                         <h4 className="text-center mb-4" style={{ color: '#1f2937', fontWeight: '700' }}>
//                           {t("District-wise Demand Generated (in ₹ Crores)")}
//                         </h4>

//                         <ResponsiveContainer width="100%" height={450}>
//                           <BarChart
//                             data={demandDistrictData.map(item => ({
//                               District: item.District,
//                               totalBillAmount: (parseFloat(item.TotalBillAmount || 0) / 10000000).toFixed(2) // Convert to Cr
//                             }))}
//                             margin={{ top: 30, right: 40, left: 40, bottom: 30 }}
//                             barCategoryGap="1%"
//                             barSize={100}
//                             barGap={0}

//                           >
//                             <CartesianGrid strokeDasharray="3 3" />

//                             <XAxis
//                               dataKey="District"
//                               tick={{ fontSize: 12, fill: "#374151" }}
//                               interval={0}
//                               angle={0}
//                               textAnchor="end"
//                               height={70}
//                               label={{ value: "District", position: "bottom", offset: -30, fontSize: 15 }}
//                             />

//                             <YAxis
//                               tick={{ fontSize: 12, fill: "#374151" }}
//                               tickFormatter={(value) => `${value} Cr`}
//                               label={{ value: "Amount (₹ Cr)", angle: -90, position: "insideLeft", offset: -30, fontSize: 15 }}
//                             />

//                             <Tooltip
//                               formatter={(value) => `₹ ${Number(value).toLocaleString("en-IN")} Cr`}
//                               contentStyle={{ fontSize: 13, fontWeight: "600" }}
//                               cursor={{ fill: 'rgba(0, 0, 0, 0.1)' }}
//                             />

//                             <Legend wrapperStyle={{ fontSize: 13 }} />

//                             <Bar dataKey="totalBillAmount" fill="#4f46e5" name="Demand Generated (Cr)" radius={[4, 4, 0, 0]}>
//                               <LabelList
//                                 dataKey="totalBillAmount"
//                                 position="top"
//                                 formatter={(v) => `${v} Cr`}
//                                 style={{ fontSize: 12, fill: '#111827', fontWeight: "600" }}

//                               />
//                             </Bar>
//                           </BarChart>
//                         </ResponsiveContainer>
//                       </div>
//                     </div>
//                   )
//                 }
//               </div>
//             </>
//           )
//         }

//         {/* district  */}
//         {
//           fetchAllDemandBYDistrict &&
//           showspecific === 51 && (
//             <>
//               <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
//                 <div className="col-11 m-auto">
//                   <div className='col-12' >

//                     <div className="col-12">
//                       <button
//                         className="btn btn-danger px-3 rounded-4 mb-3 mt-3"
//                         onClick={() => {
//                           if (showGraph === "Chart") {
//                             setShowGraph("Table");     // stay in showspecific === 51
//                           } else {
//                             setShowSpecific(50);      // go back to previous screen
//                           }
//                         }}
//                       >
//                         {t("Back")}
//                       </button>
//                     </div>

//                     {
//                       showGraph === "Table" && (
//                         <>
//                           <div className="col-11 my-4 mx-auto">
//                             <div className="row">

//                               <div className="d-flex justify-content-between align-items-center flex-wrap">

//                                 <h5 className="my-auto fw-bold d-flex align-items-center">
//                                   <img
//                                     src="/GR-Approval64.png"
//                                     alt=""
//                                     style={{ width: "24px", height: "24px" }}
//                                     className="me-2"
//                                   />
//                                   <span>
//                                     {t("Total Bill Amount in ")}{selectedDemandDistrict} in {selectedYear}
//                                   </span>
//                                 </h5>
//                               </div>


//                               <div className="col-12 d-flex justify-content-end mt-3 gap-2">
//                                 <button
//                                   className="btn btn-primary px-4"
//                                   onClick={() =>
//                                     downloadPageAsPDF(
//                                       "TalukaWiseDemandTable",      // TABLE
//                                       "bar-chart-container",        // CHART
//                                       `TalukaWiseDemand_Complete_${selectedYear}.pdf`,
//                                       `Taluka-wise Demand Report ${selectedYear}`
//                                     )
//                                   }
//                                 >
//                                   📄 {t("Download Complete Report")}
//                                 </button>

//                                 <button
//                                   className="btn btn-success px-4"
//                                   onClick={() =>
//                                     exportTableByClassToExcel(
//                                       "TalukaWiseDemandTable",
//                                       "TalukaWiseDemandAmount.xlsx"
//                                     )
//                                   }
//                                 >
//                                   {t("Download Excel")}
//                                 </button>

//                                 <button
//                                   className="btn btn-danger px-4"
//                                   onClick={() =>
//                                     downloadTableOnlyAsPDF(
//                                       "TalukaWiseDemandTable",
//                                       `TalukaWiseDemandTable_${selectedYear}.pdf`,
//                                       `Taluka-wise Demand Table ${selectedYear}`
//                                     )
//                                   }
//                                 >
//                                   {t("Download Table PDF")}
//                                 </button>
//                               </div>
//                             </div>
//                           </div>
//                           <div
//                             className="col-12 d-flex align-items-center mb-3"
//                             style={{
//                               gap: "10px",
//                               flexWrap: "nowrap",
//                             }}
//                           >
//                             <button
//                               className={
//                                 showGraph === "Table"
//                                   ? "px-5 btn btn-success mx-2"
//                                   : "px-5 btn btn-secondary mx-2"
//                               }
//                               onClick={() => setShowGraph("Table")}
//                             >
//                               {t("Table")}
//                             </button>

//                             <button
//                               className={
//                                 showGraph === "Chart"
//                                   ? "px-5 btn btn-success"
//                                   : "px-5 btn btn-secondary"
//                               }
//                               onClick={() => setShowGraph("Chart")}
//                             >
//                               {t("Chart")}
//                             </button>

//                             {/* HeadCode Filter */}
//                             {/* {userData?.Department_Name !== "State" && (
//   <select
//     className="form-select"
//     value={selectedTableHeadCode}
//     onChange={(e) => {
//       setSelectedTableHeadCode(e.target.value);
//       setCurrentPage(1);
//       setShowAllTaluka(false);
//     }}
//     style={{
//       width: "180px",
//       height: "54px",
//       border: "1px solid #ccc",
//       borderRadius: "8px",
//       padding: "8px 12px",
//       fontSize: "16px",
//     }}
//   >
//     <option value="">All HeadCodes</option>

//     {filteredHeadCodes?.map((val, index) => (
//       <option key={index} value={val.HeadID}>
//         {val.HeadName}
//       </option>
//     ))}
//   </select>
// )} */}

//                             {/* Search Taluka */}
//                             <div
//                               style={{
//                                 position: "relative",
//                                 width: "250px",
//                                 minWidth: "250px",
//                                 marginLeft: "5px",
//                               }}
//                             >
//                               <img
//                                 src="/Search32.png"
//                                 alt="Search Icon"
//                                 style={{
//                                   position: "absolute",
//                                   top: "50%",
//                                   left: "10px",
//                                   transform: "translateY(-50%)",
//                                   width: "16px",
//                                   height: "16px",
//                                   opacity: 0.6,
//                                 }}
//                               />

//                               <input
//                                 type="text"
//                                 className="form-control ps-4"
//                                 placeholder="Search Taluka"
//                                 value={searchTaluka}
//                                 onChange={(e) => {
//                                   setSearchTaluka(e.target.value);
//                                   setTalukaPage(1);
//                                   setShowAllTaluka(false);
//                                 }}
//                                 style={{
//                                   width: "100%",
//                                   border: "1px solid #ccc",
//                                   borderRadius: "8px",
//                                   padding: "8px 12px 8px 30px",
//                                   fontSize: "16px",
//                                 }}
//                               />
//                             </div>

//                           </div>


//                           <div className="col-12 pb-5">
//                             <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>



//                               <div
//                                 className="col-12 tableDesign DistrictTableContianer"
//                                 style={{
//                                   background: "#2C78DB",
//                                   overflowX: "hidden",
//                                   width: "100%",
//                                 }}
//                               >
//                                 <table
//                                   className="m-0 p-0 TalukaWiseDemandTable"
//                                   style={{
//                                     width: "100%",
//                                     tableLayout: "fixed",
//                                     borderCollapse: "collapse",
//                                   }}
//                                 >
//                                   <thead>
//                                     <tr
//                                       style={{
//                                         color: "white",
//                                         border: "none",
//                                         height: "3rem",
//                                         fontSize: "18px",
//                                       }}
//                                     >
//                                       <th style={{ width: "15%" }}>
//                                         {t("Taluka")}
//                                       </th>

//                                       <th style={{ width: "10%" }}>
//                                         {t("Year")}
//                                       </th>

//                                       <th style={{ width: "15%" }}>
//                                         {t("HeadCode")}
//                                       </th>

//                                       <th
//                                         style={{
//                                           width: "20%",
//                                           textAlign: "left",
//                                           whiteSpace: "normal",
//                                           wordBreak: "break-word",
//                                         }}
//                                       >
//                                         {t("Total Bill Amount")}
//                                       </th>

//                                       <th
//                                         style={{
//                                           width: "20%",
//                                           textAlign: "left",
//                                           whiteSpace: "normal",
//                                           wordBreak: "break-word",
//                                         }}
//                                       >
//                                         {t("Total Net Payable Amount")}
//                                       </th>

//                                       <th
//                                         style={{
//                                           width: "20%",
//                                           textAlign: "left",
//                                           whiteSpace: "normal",
//                                           wordBreak: "break-word",
//                                         }}
//                                       >
//                                         {t("Total Deduction Amount")}
//                                       </th>
//                                     </tr>
//                                   </thead>
//                                   <tbody>
//                                     {
//                                       talukawiseDemandData &&
//                                         talukawiseDemandData.length > 0 ? (() => {
//                                           const filteredData = talukawiseDemandData.filter((t) => {
//                                             const talukaMatch =
//                                               !searchTaluka ||
//                                               t.taluka?.toLowerCase().includes(searchTaluka.toLowerCase());

//                                             const headCodeMatch =
//                                               !selectedTableHeadCode ||
//                                               t.head === selectedTableHeadCode;

//                                             return talukaMatch && headCodeMatch;
//                                           });

//                                           const totalBill = filteredData.reduce((sum, val) => sum + parseFloat(val.totalBillAmount || 0), 0);
//                                           const totalNetPayable = filteredData.reduce((sum, val) => sum + parseFloat(val.totalNetPayable || 0), 0);
//                                           const totalDeduction = filteredData.reduce((sum, val) => sum + parseFloat(val.totalDeduction || 0), 0);

//                                           const pageTotalBill = paginatedTalukaData.reduce(
//                                             (sum, val) => sum + parseFloat(val.totalBillAmount || 0),
//                                             0
//                                           );

//                                           const pageTotalNetPayable = paginatedTalukaData.reduce(
//                                             (sum, val) => sum + parseFloat(val.totalNetPayable || 0),
//                                             0
//                                           );

//                                           const pageTotalDeduction = paginatedTalukaData.reduce(
//                                             (sum, val) => sum + parseFloat(val.totalDeduction || 0),
//                                             0
//                                           );

//                                           return (
//                                             <>
//                                               {paginatedTalukaData.map((item, index) => {
//                                                 const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                                 return (
//                                                   <tr key={index} style={{ backgroundColor: bgColor, fontSize: "18px", fontWeight: "400" }}>
//                                                     <td style={{ fontSize: "18px" }}>
//                                                       <p className='makeitlink my-auto' onClick={() => DemandGenerationSortByTaluka(item.taluka)}>
//                                                         {item.taluka}
//                                                       </p>
//                                                     </td>
//                                                     <td style={{ fontSize: "18px" }}>{item.year || selectedYear}</td>
//                                                     <td style={{ fontSize: "18px" }}>{item.head || selectedHeadCode}</td>
//                                                     <td style={{ textAlign: "left", fontSize: "18px" }}>₹ {Number(item.totalBillAmount).toLocaleString("en-IN")}</td>
//                                                     <td style={{ textAlign: "left", fontSize: "18px" }}>₹ {Number(item.totalNetPayable).toLocaleString("en-IN")}</td>
//                                                     <td style={{ textAlign: "left", fontSize: "18px" }}>₹ {Number(item.totalDeduction).toLocaleString("en-IN")}</td>
//                                                   </tr>
//                                                 );
//                                               })}

//                                               {/* Page Total Row */}
//                                               <tr
//                                                 style={{
//                                                   fontWeight: "bold",
//                                                   backgroundColor: "#f0f0f0",
//                                                   fontSize: "18px"
//                                                 }}
//                                               >
//                                                 <td colSpan={3} style={{ textAlign: "center", fontSize: "18px", textAlign: "right" }}>
//                                                   Page Total
//                                                 </td>

//                                                 <td style={{ textAlign: "left", fontSize: "18px" }}>
//                                                   ₹ {Number(pageTotalBill).toLocaleString("en-IN")}
//                                                 </td>

//                                                 <td style={{ textAlign: "left", fontSize: "18px" }}>
//                                                   ₹ {Number(pageTotalNetPayable).toLocaleString("en-IN")}
//                                                 </td>

//                                                 <td style={{ textAlign: "left", fontSize: "18px" }}>
//                                                   ₹ {Number(pageTotalDeduction).toLocaleString("en-IN")}
//                                                 </td>
//                                               </tr>

//                                               {/* Total Row */}
//                                               <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0', fontSize: "18px", textAlign: "right" }}>
//                                                 <td style={{ fontSize: "18px" }} colSpan={3}>Gross Total</td>
//                                                 <td style={{ textAlign: "left", fontSize: "18px" }}>₹ {Number(totalBill).toLocaleString("en-IN")}</td>
//                                                 <td style={{ textAlign: "left", fontSize: "18px" }}>₹ {Number(totalNetPayable).toLocaleString("en-IN")}</td>
//                                                 <td style={{ textAlign: "left", fontSize: "18px" }}>₹ {Number(totalDeduction).toLocaleString("en-IN")}</td>
//                                               </tr>
//                                             </>
//                                           );
//                                         })() : (
//                                         <tr>
//                                           <td style={{ fontSize: "18px" }} colSpan={5} className='fw-bold'>{t("No data found")}</td>
//                                         </tr>
//                                       )
//                                     }
//                                   </tbody>
//                                 </table>
//                               </div>
//                               <div
//                                 style={{
//                                   display: "flex",
//                                   justifyContent: "space-between",
//                                   alignItems: "center",
//                                   marginTop: "20px",
//                                 }}
//                               >
//                                 <p className="text-gray-600 m-0" style={{ fontSize: "18px" }}>
//                                   {t("Showing")}{" "}
//                                   {filteredTalukaData.length > 0
//                                     ? showAllTaluka
//                                       ? 1
//                                       : (talukaPage - 1) * talukaRecordsPerPage + 1
//                                     : 0}{" "}
//                                   {t("to")}{" "}
//                                   {showAllTaluka
//                                     ? filteredTalukaData.length
//                                     : Math.min(
//                                       talukaPage * talukaRecordsPerPage,
//                                       filteredTalukaData.length
//                                     )}{" "}
//                                   {t("of")} {filteredTalukaData.length} {t("entries")}
//                                 </p>

//                                 <div style={{ display: "flex", alignItems: "center", gap: "10px", fontSize: "18px" }}>
//                                   <button
//                                     type="button"
//                                     onClick={() => {
//                                       setShowAllTaluka(!showAllTaluka);
//                                       setTalukaPage(1);
//                                     }}
//                                     style={{
//                                       border: "none",
//                                       outline: "none",
//                                       cursor: "pointer",
//                                       padding: "8px 16px",
//                                       borderRadius: "20px",
//                                       fontSize: "13px",
//                                       fontWeight: "600",
//                                       color: "#fff",
//                                       background: showAllTaluka
//                                         ? "linear-gradient(135deg, #28a745, #20c997)"
//                                         : "linear-gradient(135deg, #0067ab, #0098d5)",
//                                       boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
//                                       transition: "all 0.3s ease",
//                                     }}
//                                   >
//                                     {showAllTaluka ? "✓ Showing All" : "View All"}
//                                   </button>

//                                   {!showAllTaluka && (
//                                     <GooglePagination
//                                       currentPage={talukaPage}
//                                       totalPages={totalTalukaPages}
//                                       onPageChange={setTalukaPage}
//                                     />
//                                   )}
//                                 </div>
//                               </div>

//                             </div>
//                           </div>
//                         </>
//                       )
//                     }
//                   </div>
//                 </div>

//                 {
//                   showGraph === "Chart" &&
//                   talukawiseDemandData &&
//                   talukawiseDemandData.length > 0 && (
//                     <>
//                       {/* ADD THIS NEW SECTION */}
//                       <div className="col-11 my-4 mx-auto">
//                         <div className="row">
//                           <div className="d-flex justify-content-between align-items-center flex-wrap">
//                             <h5 className="my-auto fw-bold d-flex align-items-center">
//                               <span>
//                                 {t("Total Bill Amount in")} {selectedDemandDistrict} {t("in")} {selectedYear}
//                               </span>
//                             </h5>
//                           </div>

//                           <div className="col-12 d-flex justify-content-end mt-3 gap-2">
//                             <button
//                               className="btn btn-primary px-4"
//                               onClick={() =>
//                                 downloadPageAsPDF(
//                                   "TalukaWiseDemandTable",
//                                   "bar-chart-container",
//                                   `TalukaWiseDemand_Complete_${selectedYear}.pdf`,
//                                   `Taluka-wise Demand Report ${selectedYear}`
//                                 )
//                               }
//                             >
//                               📄 {t("Download Complete Report")}
//                             </button>

//                             <button
//                               className="btn btn-danger px-4"
//                               onClick={() =>
//                                 downloadChartOnlyAsPDF(
//                                   "bar-chart-container",
//                                   `TalukaWiseDemand_Chart_${selectedYear}.pdf`,
//                                   `Taluka-wise Demand Chart ${selectedYear}`
//                                 )
//                               }
//                             >
//                               {t("Download Chart PDF")}
//                             </button>
//                           </div>
//                         </div>
//                       </div>
//                       <div className="col-12 mb-5 bar-chart-container">
//                         <div className="col-11 mx-auto">
//                           <h4 className="text-center mb-4" style={{ color: '#1f2937', fontWeight: '700' }}>
//                             {t("Taluka-wise Demand Generated (in ₹ Crores)")}
//                           </h4>

//                           <ResponsiveContainer width="100%" height={450}>
//                             <BarChart
//                               data={chartData}
//                               margin={{ top: 30, right: 40, left: 40, bottom: 80 }}
//                               barCategoryGap="20%"
//                             >
//                               <CartesianGrid strokeDasharray="3 3" />

//                               <XAxis
//                                 dataKey="taluka"
//                                 interval={0}
//                                 angle={-25}
//                                 textAnchor="end"
//                                 height={90}
//                               />

//                               <YAxis
//                                 tickFormatter={(v) => `${v} Cr`}
//                                 label={{
//                                   value: "Amount (₹ Cr)",
//                                   angle: -90,
//                                   position: "insideLeft",
//                                   offset: -30
//                                 }}
//                               />

//                               <Tooltip
//                                 formatter={(v, _, props) => [
//                                   `₹ ${Number(props.payload.rawAmount).toLocaleString("en-IN")}`,
//                                   "Total Bill Amount"
//                                 ]}
//                               />

//                               <Bar
//                                 dataKey="amountCr"
//                                 fill="#4f46e5"
//                                 minPointSize={6}
//                                 radius={[4, 4, 0, 0]}
//                               >
//                                 <LabelList
//                                   dataKey="amountCr"
//                                   position="top"
//                                   formatter={(v) => `${v} Cr`}
//                                 />
//                               </Bar>
//                             </BarChart>
//                           </ResponsiveContainer>
//                         </div>
//                       </div>
//                     </>
//                   )
//                 }
//               </div>
//             </>
//           )
//         }

//         {/* Demadn Talukd  */}
//         {
//           fetchAllDemandBYDistrict &&
//           showspecific === 52 &&
//           (
//             <>
//               <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
//                 <div className="col-11 m-auto">
//                   <div className='col-12' >

//                     <div className="col-12">
//                       <button className='btn btn-danger px-3 rounded-4 mb-3 mt-3'
//                         onClick={() => {
//                           if (showGraph === "Chart") {
//                             setShowGraph("Table");   // go back to table inside same level
//                           } else {
//                             setShowSpecific(51);      // go back to District level
//                           }
//                         }}
//                       >{t("Back")}</button>
//                     </div>

//                     {
//                       showGraph === "Table" &&
//                       (
//                         <>
//                           <div className="col-11 my-4 mx-auto">
//                             <div className="row">
//                               <div className="d-flex justify-content-between align-items-center flex-wrap">
//                                 <h5 className="my-auto fw-bold d-flex align-items-center">
//                                   <img src="/GR-Approval64.png" alt="" style={{ width: "24px", height: "24px" }} className="me-2" />
//                                   <span className='my-auto'>{t("Bill Created in")} {selectedDemandTaluka} {t("for Year")} {selectedYear}</span>
//                                 </h5>



//                               </div>
//                               <div className="col-12 d-flex justify-content-end mt-3 gap-2">
//                                 <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("BillsDataTable", "BillCreated.xlsx")}>{t("Download Excel")}</button>
//                                 <button className='btn btn-danger px-4'
//                                   onClick={() =>
//                                     downloadTableOnlyAsPDF(
//                                       "BillsDataTable",
//                                       "Bill Created Data",
//                                       `BillsData_${selectedYear}.pdf`,
//                                       `Bills Created in ${selectedDemandTaluka} (${selectedYear})`
//                                     )
//                                   }
//                                 >{t("Download Pdf")}</button>
//                               </div>
//                             </div>
//                           </div>
//                           <div className="col-md-6 col-sm-12 d-flex justify-content-start align-items-center mb-3 text-center" style={{ gap: "12px" }}>
//                             <button className={showGraph === "Table" ? "px-5 btn btn-success" : "px-5 btn btn-secondary"} onClick={() => setShowGraph("Table")}>{t("Table")}</button>
//                             <button className={showGraph === "Chart" ? "px-5 btn btn-success" : "px-5 btn btn-secondary"} onClick={() => setShowGraph("Chart")} >{t("Chart")}</button>
//                             <div style={{ width: "250px", position: "relative" }}>
//                               <img
//                                 src="/Search32.png"
//                                 alt="Search Icon"
//                                 style={{
//                                   position: "absolute",
//                                   top: "50%",
//                                   left: "10px",
//                                   transform: "translateY(-50%)",
//                                   width: "16px",
//                                   height: "16px",
//                                   opacity: 0.6
//                                 }}
//                               />
//                               <input
//                                 type="text"
//                                 className="form-control ps-4"
//                                 placeholder={t("Search Here")}
//                                 value={searchBill}
//                                 onChange={(e) => setSearchBill(e.target.value)}
//                               />
//                             </div>
//                           </div>
//                           <div className="col-12 pb-5">
//                             <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>

//                               <div className='col-12 tableDesign DistrictTableContianerModel2' style={{
//                                 background: '#2C78DB', overflowX: "auto",
//                                 overflowY: "auto",
//                                 maxHeight: "600px", // change height as needed
//                                 position: "relative"
//                               }}>
//                                 <table
//                                   className="m-0 p-0 BillsDataTable"
//                                   id="BillsDataTable"
//                                   style={{ width: '100%', borderCollapse: 'collapse', overflowInline: 'scroll' }}
//                                 >
//                                   <thead style={{
//                                     position: "sticky", backgroundColor: "#1976d2",
//                                     top: 0,
//                                     zIndex: 10,
//                                   }}>
//                                     <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
//                                       <th style={{ width: "6%", fontSize: "18px" }}>{t("Sr No")}</th>
//                                       <th style={{ width: "13%", fontSize: "18px" }}>{t("Work Name")}</th>
//                                       {/* <th style={{ width: "5%" }}>Taluka</th> */}
//                                       <th style={{ width: "12%", fontSize: "18px" }}>{t("Vendor Name")}</th>
//                                       <th style={{ width: "12%", textAlign: "left", fontSize: "18px" }}>{t("Year")}</th>
//                                       <th style={{ width: "12%", textAlign: "left", fontSize: "18px" }}>{t("HeadCode")}</th>
//                                       <th style={{ width: "10%", fontSize: "18px" }}>{t("Date")}</th>
//                                       <th style={{ width: "8%", fontSize: "18px" }}>{t("Approvance")}</th>
//                                       <th style={{ width: "8%", textAlign: "left", fontSize: "18px" }}>{t("Bill Amount")}</th>
//                                       <th style={{ width: "13%", textAlign: "left", fontSize: "18px" }}>{t("Net Payable Amount")}</th>
//                                       <th style={{ width: "12%", textAlign: "left", fontSize: "18px" }}>{t("Deduction Amount")}</th>


//                                     </tr>
//                                   </thead>
//                                   <tbody>
//                                     {
//                                       currentTalukaDemandData &&
//                                         currentTalukaDemandData.length > 0 ? (() => {
//                                           const filteredData = currentTalukaDemandData
//                                             .filter(val => {
//                                               if (!searchBill) return true;

//                                               const keyword = searchBill.toLowerCase();

//                                               return (
//                                                 String(val.ProjectID || "").toLowerCase().includes(keyword) ||
//                                                 String(val.ContractorName || "").toLowerCase().includes(keyword) ||
//                                                 String(val.BillAmount || "").includes(keyword) ||
//                                                 String(val.NetPayableAmount || "").includes(keyword) ||
//                                                 String(val.DeductionAmount || "").includes(keyword)
//                                               );
//                                             })
//                                             .sort((a, b) => b.DemandGenerationID - a.DemandGenerationID) // ✅ newest first

//                                           const totalBill = filteredData.reduce((sum, val) => sum + parseFloat(val.BillAmount || 0), 0);
//                                           const totalNetPayable = filteredData.reduce((sum, val) => sum + parseFloat(val.NetPayableAmount || 0), 0);
//                                           const totalDeduction = filteredData.reduce((sum, val) => sum + parseFloat(val.DeductionAmount || 0), 0);

//                                           // Grand total across ALL pages (not just the current page), respecting the search filter
//                                           const allFilteredDataForGrandTotal = sortedDemandDatabytaluka.filter(val => {
//                                             if (!searchBill) return true;

//                                             const keyword = searchBill.toLowerCase();

//                                             return (
//                                               String(val.ProjectID || "").toLowerCase().includes(keyword) ||
//                                               String(val.ContractorName || "").toLowerCase().includes(keyword) ||
//                                               String(val.BillAmount || "").includes(keyword) ||
//                                               String(val.NetPayableAmount || "").includes(keyword) ||
//                                               String(val.DeductionAmount || "").includes(keyword)
//                                             );
//                                           });

//                                           const grandTotalBill = allFilteredDataForGrandTotal.reduce((sum, val) => sum + parseFloat(val.BillAmount || 0), 0);
//                                           const grandTotalNetPayable = allFilteredDataForGrandTotal.reduce((sum, val) => sum + parseFloat(val.NetPayableAmount || 0), 0);
//                                           const grandTotalDeduction = allFilteredDataForGrandTotal.reduce((sum, val) => sum + parseFloat(val.DeductionAmount || 0), 0);

//                                           return (
//                                             <>
//                                               {filteredData.map((val, index) => {
//                                                 const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                                 return (
//                                                   <tr key={index} style={{ backgroundColor: bgColor, fontSize: "18px", fontWeight: "400" }}>
//                                                     <td style={{ fontSize: "18px" }}>{firstRecordIndexDatabytaluka + index + 1}</td>
//                                                     <td style={{ fontSize: "18px" }}>{val.ProjectID}</td>
//                                                     {/* <td>{val.Taluka}</td> */}
//                                                     <td style={{ fontSize: "18px" }}>
//                                                       <p className='makeitlink my-auto' onClick={() => VendorBillDetailByContractorName(val.ContractorName)}>
//                                                         {val.ContractorName}
//                                                       </p>
//                                                     </td>
//                                                     <td style={{ fontSize: "18px" }}>{selectedYear}</td>
//                                                     <td style={{ fontSize: "18px" }}>{selectedHeadCode}</td>
//                                                     <td style={{ fontSize: "18px" }}>{new Date(val.Date).toLocaleString("en-IN")}</td>
//                                                     <td style={{ fontSize: "18px" }} onClick={() => DemandDeductionDetailByBillID(val.DemandGenerationID, 55)}>
//                                                       <p className='makeitlink my-auto' style={{ textAlign: "center" }}>{t("View")}</p>
//                                                     </td>
//                                                     <td style={{ textAlign: "left", fontSize: "18px" }}>₹ {Number(val.BillAmount).toLocaleString("en-IN")}</td>
//                                                     <td style={{ textAlign: "left", fontSize: "18px" }}>₹ {Number(val.NetPayableAmount).toLocaleString("en-IN")}</td>
//                                                     <td style={{ fontSize: "18px" }} onClick={() => DemandDeductionDetailByBillID(val.DemandGenerationID, 54)}>
//                                                       <p className='makeitlink my-auto' style={{ textAlign: "left" }}>₹ {Number(val.DeductionAmount).toLocaleString("en-IN")}</p>
//                                                     </td>


//                                                   </tr>
//                                                 );
//                                               })}

//                                               {/* Page Total Row - sums only the rows visible on this page */}
//                                               <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0', fontSize: "18px", fontWeight: "600", textAlign: "right" }}>
//                                                 <td style={{ fontSize: "18px" }} colSpan={7}>{t("Page Total")}</td>
//                                                 <td style={{ textAlign: "left", fontSize: "18px" }}>₹ {Number(totalBill).toLocaleString("en-IN")}</td>
//                                                 <td style={{ textAlign: "left", fontSize: "18px" }}>₹ {Number(totalNetPayable).toLocaleString("en-IN")}</td>
//                                                 <td style={{ textAlign: "left", fontSize: "18px" }}>₹ {Number(totalDeduction).toLocaleString("en-IN")}</td>
//                                               </tr>

//                                               {/* Total Amount Row - grand total across all pages */}
//                                               <tr style={{ fontWeight: 'bold', backgroundColor: '#e0e0e0', fontSize: "18px", fontWeight: "600", textAlign: "right" }}>
//                                                 <td style={{ fontSize: "18px" }} colSpan={7}>{t("Gross Total")}</td>
//                                                 <td style={{ textAlign: "left", fontSize: "18px" }}>₹ {Number(grandTotalBill).toLocaleString("en-IN")}</td>
//                                                 <td style={{ textAlign: "left", fontSize: "18px" }}>₹ {Number(grandTotalNetPayable).toLocaleString("en-IN")}</td>
//                                                 <td style={{ textAlign: "left", fontSize: "18px" }}>₹ {Number(grandTotalDeduction).toLocaleString("en-IN")}</td>
//                                               </tr>
//                                             </>
//                                           );
//                                         })() : (
//                                         <tr>
//                                           <td style={{ fontSize: "18px" }} colSpan={10} className='fw-bold'>{t("No data found")}</td>
//                                         </tr>
//                                       )
//                                     }
//                                   </tbody>
//                                 </table>
//                               </div>
//                               <div
//                                 style={{
//                                   display: "flex",
//                                   justifyContent: "space-between",
//                                   alignItems: "center",
//                                   marginTop: "20px",
//                                 }}
//                               >
//                                 <p className="text-gray-600 m-0" style={{ fontSize: "18px" }}>
//                                   {t("Showing")}{" "}
//                                   {sortedDemandDatabytaluka.length > 0
//                                     ? showAllTalukaDemand
//                                       ? 1
//                                       : (talukaDemandPage - 1) * talukaDemandRecordsPerPage + 1
//                                     : 0}{" "}
//                                   {t("to")}{" "}
//                                   {showAllTalukaDemand
//                                     ? sortedDemandDatabytaluka.length
//                                     : Math.min(
//                                       talukaDemandPage * talukaDemandRecordsPerPage,
//                                       sortedDemandDatabytaluka.length
//                                     )}{" "}
//                                   {t("of")} {sortedDemandDatabytaluka.length} {t("entries")}
//                                 </p>

//                                 <div style={{ display: "flex", alignItems: "center", gap: "10px", fontSize: "18px" }}>
//                                   <button
//                                     type="button"
//                                     onClick={() => {
//                                       setShowAllTalukaDemand(!showAllTalukaDemand);
//                                       setTalukaDemandPage(1);
//                                     }}
//                                     style={{
//                                       border: "none",
//                                       outline: "none",
//                                       cursor: "pointer",
//                                       padding: "8px 16px",
//                                       borderRadius: "20px",
//                                       fontSize: "18px",
//                                       fontWeight: "600",
//                                       color: "#fff",
//                                       background: showAllTalukaDemand
//                                         ? "linear-gradient(135deg, #28a745, #20c997)"
//                                         : "linear-gradient(135deg, #0067ab, #0098d5)",
//                                       boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
//                                     }}
//                                   >
//                                     {showAllTalukaDemand ? "✓ Showing All" : "View All"}
//                                   </button>

//                                   {!showAllTalukaDemand && (
//                                     <GooglePagination
//                                       currentPage={talukaDemandPage}
//                                       totalPages={totalTalukaDemandPages}
//                                       onPageChange={setTalukaDemandPage}
//                                     />
//                                   )}
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </>
//                       )
//                     }

//                     {
//                       showGraph === "Chart" &&
//                       currentTalukaDemandData &&
//                       currentTalukaDemandData.length > 0 && (
//                         <div className="col-12 mb-5 bar-chart-container">
//                           <div className="col-11 mx-auto">
//                             <h4 className="text-center mb-4" style={{ color: '#1f2937', fontWeight: '700' }}>
//                               {t("Proposal-wise Demand Generated (in ₹ Crores)")}
//                             </h4>

//                             <ResponsiveContainer width="100%" height={450}>
//                               <BarChart
//                                 data={demandChartData}
//                                 margin={{ top: 40, right: 30, left: 40, bottom: 140 }}
//                                 barCategoryGap="30%"
//                               >
//                                 <CartesianGrid strokeDasharray="3 3" />

//                                 <XAxis
//                                   dataKey="proposal"
//                                   interval={0}
//                                   angle={-30}
//                                   textAnchor="end"
//                                   height={120}
//                                   tick={{ fontSize: 12 }}
//                                   label={{
//                                     value: "Proposals",
//                                     position: "bottom",
//                                     offset: 90,
//                                     fontSize: 14
//                                   }}
//                                 />

//                                 <YAxis
//                                   tickFormatter={(v) => `${v.toFixed(2)} Cr`}
//                                   label={{
//                                     value: "Amount (₹ Cr)",
//                                     angle: -90,
//                                     position: "insideLeft",
//                                     offset: -10,
//                                     fontSize: 14
//                                   }}
//                                   domain={[0, 'auto']}
//                                 />

//                                 <Tooltip
//                                   formatter={(value, name, props) => {
//                                     const rs = props.payload.amountRs;
//                                     return [`₹ ${rs.toLocaleString("en-IN")}`, "Demand Generated"];
//                                   }}
//                                   labelFormatter={(label) => `Proposal: ${label}`}
//                                   contentStyle={{ fontSize: 13, fontWeight: 600 }}
//                                 />

//                                 <Legend />

//                                 <Bar
//                                   dataKey="amountCr"
//                                   name="Demand Generated (Cr)"
//                                   fill="#4f46e5"
//                                   radius={[6, 6, 0, 0]}
//                                   maxBarSize={60}
//                                 >
//                                   <LabelList
//                                     dataKey="amountCr"
//                                     position="top"
//                                     formatter={(v) => `${v.toFixed(2)} Cr`}
//                                     style={{ fontSize: 11, fontWeight: 600 }}
//                                   />
//                                 </Bar>
//                               </BarChart>
//                             </ResponsiveContainer>
//                           </div>
//                         </div>
//                       )
//                     }

//                   </div>
//                 </div>
//               </div>
//             </>
//           )
//         }

//         {
//           selectedDemandID &&
//           showspecific === 54 &&
//           (
//             <>
//               <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "134vh", overflowX: "hidden", overflowY: "scroll" }}>
//                 <div className="col-11 m-auto">
//                   <div className='col-12' >

//                     <div className="col-12">
//                       <button className='btn btn-danger px-3 rounded-4 mb-3 mt-3' onClick={() => setShowSpecific(52)}>{t("Back")}</button>
//                     </div>

//                     <div className="col-11 my-4 mx-auto">
//                       <div className="row">

//                         <div className="d-flex justify-content-between align-items-center flex-wrap">

//                           <h5 className="my-auto fw-bold d-flex align-items-center">
//                             <img src="/GR-Approval64.png" alt="" style={{ width: "24px", height: "24px" }} className="me-2" />
//                             <span>
//                               {t("Deduction Data of Bill")} {selectedDemandID}
//                             </span>
//                           </h5>

//                         </div>

//                         <div className="col-12 d-flex justify-content-end mt-3 gap-2">
//                           <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("DeductionTable", "Deduction.xlsx")}>Download Excel</button>
//                           <button className='btn btn-danger px-4' onClick={() => downloadPageAsPDF('DeductionTable', `Deduction Table_${selectedYear}.pdf`, `Deduction Table ${selectedYear}`)}>Download Pdf</button>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="m-auto tableDesign DistrictTableContianer" style={{
//                       background: '#2C78DB', overflowX: "auto",
//                       overflowY: "auto",
//                       maxHeight: "600px", // change height as needed
//                       position: "relative"
//                     }}>
//                       <table className='m-0 p-0 DeductionTable' style={{ width: '100%', borderCollapse: 'collapse', overflowInline: 'scroll' }}>

//                         <thead style={{
//                           position: "sticky", backgroundColor: "#1976d2",
//                           top: 0,
//                           zIndex: 10,
//                         }}>
//                           <tr style={{ fontSize: "18px" }}>
//                             <th style={{ width: "10%", fontSize: "18px" }}>{t("Sr No")}</th>
//                             <th style={{ width: "45%", fontSize: "18px" }}>{t("Deduction Name")}</th>
//                             <th style={{ width: "45%", textAlign: "left", fontSize: "18px" }}>{t("Deduction Amount")}</th>

//                           </tr>
//                         </thead>
//                         <tbody>
//                           {
//                             fetchSpecificDemandDeductionDetail &&
//                               fetchSpecificDemandDeductionDetail.length > 0 ?
//                               <>
//                                 {
//                                   fetchSpecificDemandDeductionDetail
//                                     .filter((item) => item.TypeOfAmount !== "Total Amount Payable")
//                                     .map((val, index) => {
//                                       const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                       return (
//                                         <tr key={index} style={{ backgroundColor: bgColor, fontSize: "18px", fontWeight: "400" }}>
//                                           <td style={{ fontSize: "18px" }}>{index + 1}</td>
//                                           <td style={{ fontSize: "18px" }}>{val.TypeOfAmount}</td>
//                                           <td style={{ textAlign: "left", fontSize: "18px" }}>₹ {Number(val.TotalAmount).toLocaleString("en-IN")}</td>
//                                         </tr>
//                                       );
//                                     })
//                                 }


//                                 <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0', fontSize: "18px" }}>
//                                   <td style={{ fontSize: "18px" }} colSpan={2}>{t("Total Deduction Amount")}</td>
//                                   <td style={{ textAlign: "left", fontSize: "18px" }}>
//                                     ₹ {Number(
//                                       fetchSpecificDemandDeductionDetail
//                                         .filter(item => item.TypeOfAmount !== "Total Amount Payable")
//                                         .reduce((acc, curr) => acc + parseFloat(curr.TotalAmount || 0), 0)
//                                     ).toLocaleString()
//                                       // .toFixed(2)
//                                     }
//                                   </td>
//                                 </tr>
//                               </>
//                               :
//                               (
//                                 <tr>
//                                   <td style={{ fontSize: "18px" }} colSpan={5} className='fw-bold'>{t("No data found")}</td>
//                                 </tr>
//                               )
//                           }
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </>
//           )
//         }

//         {
//           selectedContractor &&
//           showspecific === 57 && (
//             <div
//               className="col-12"
//               style={{
//                 overflowX: "hidden",
//                 height: "89vh",
//                 overflowY: "scroll",
//                 scrollbarWidth: "none"
//               }}
//             >
//               {/* BACK BUTTON */}
//               <div className="row m-auto px-3">
//                 <div className="col-12 mb-3">
//                   <button
//                     className="btn btn-primary px-5"
//                     onClick={() => setShowSpecific(52)}
//                   >
//                     {t("Back")}
//                   </button>
//                 </div>
//               </div>

//               {/* HEADER */}
//               {/* HEADER */}
//               <div className="row align-items-center px-3 m-auto">

//                 {/* LEFT SIDE - TITLE */}
//                 <div className="col-md-6">
//                   <h2
//                     style={{
//                       color: "#4f46e5",
//                       fontWeight: "700",
//                       fontSize: "1.4rem",
//                       margin: 0
//                     }}
//                   >
//                     Vendor '{selectedContractor}' {t("Bill Details")}
//                   </h2>
//                 </div>

//                 {/* RIGHT SIDE - BUTTONS */}
//                 <div className="col-md-6 d-flex justify-content-md-end gap-2 mt-3 mt-md-0">
//                   <button
//                     className="btn btn-success px-4"
//                     onClick={() =>
//                       exportContractorBillsToExcel(
//                         contractorExportData,
//                         "ContractorBills.xlsx"
//                       )
//                     }
//                   >
//                     {t("Download Excel")}
//                   </button>

//                   <button
//                     className="btn btn-danger px-4"
//                     onClick={() =>
//                       downloadContractorBillsTablePDF(
//                         contractorExportData,
//                         `ContractorBillDetail_${selectedYear}.pdf`,
//                         `Contractor Bill Detail ${selectedYear}`
//                       )
//                     }
//                   >
//                     {t("Download Pdf")}
//                   </button>
//                 </div>
//               </div>

//               {/* TABLE */}
//               <div className="m-auto DistrictTableContianerModel3 mb-5">
//                 <table className="m-auto my-4 ContractorBillDetailTable">
//                   <thead>
//                     <tr style={{ fontSize: "18px" }}>
//                       <th style={{ fontSize: "18px" }}>{t("Vendor Name")}</th>
//                       <th style={{ fontSize: "18px" }}>{t("Year")}</th>
//                       <th style={{ fontSize: "18px" }}>{t("Bill ID")}</th>
//                       <th style={{ fontSize: "18px" }}>{t("Bill Amount")}</th>
//                       <th style={{ fontSize: "18px" }}>{t("Payable Amount")}</th>
//                       <th style={{ fontSize: "18px" }}>{t("Deduction Amount")}</th>
//                       <th style={{ fontSize: "18px" }}>{t("Date")}</th>
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {currentBills.length > 0 ? (
//                       <>
//                         {[...currentBills]
//                           .sort((a, b) => new Date(b.Date || 0) - new Date(a.Date || 0)) // newest first
//                           .map((val, index) => (
//                             <tr key={index}>
//                               <td style={{ fontSize: "18px" }}>
//                                 <p
//                                   className="makeitlink my-auto"
//                                   onClick={() =>
//                                     ContractorDetailByContractorName(val.ContractorName)
//                                   }
//                                 >
//                                   {val.ContractorName}
//                                 </p>
//                               </td>
//                               <td style={{ fontSize: "18px" }}>{selectedYear}</td>
//                               <td style={{ fontSize: "18px" }}>{val.DemandGenerationID}</td>
//                               <td style={{ fontSize: "18px" }}>₹ {Number(val.BillAmount).toLocaleString("en-IN")}</td>
//                               <td style={{ fontSize: "18px" }}>₹ {Number(val.NetPayableAmount).toLocaleString("en-IN")}</td>
//                               <td style={{ fontSize: "18px" }}>₹ {Number(val.DeductionAmount).toLocaleString("en-IN")}</td>
//                               <td style={{ fontSize: "18px" }}>{new Date(val.Date).toLocaleString("en-IN")}</td>
//                             </tr>
//                           ))}

//                         {/* TOTAL ROW (FULL DATA TOTAL) */}
//                         <tr
//                           style={{
//                             fontWeight: "600",
//                             backgroundColor: "#f0f0f0",
//                             fontSize: "18px"
//                           }}
//                         >
//                           <td style={{ fontSize: "18px" }} colSpan={3}>{t("Gross Amount")}</td>
//                           <td style={{ fontSize: "18px" }}>
//                             ₹{" "}
//                             {ContractorBillDetail.reduce(
//                               (s, v) => s + Number(v.BillAmount || 0),
//                               0
//                             ).toLocaleString("en-IN")}
//                           </td>
//                           <td style={{ fontSize: "18px" }}>
//                             ₹{" "}
//                             {ContractorBillDetail.reduce(
//                               (s, v) => s + Number(v.NetPayableAmount || 0),
//                               0
//                             ).toLocaleString("en-IN")}
//                           </td>
//                           <td style={{ fontSize: "18px" }}>
//                             ₹{" "}
//                             {ContractorBillDetail.reduce(
//                               (s, v) => s + Number(v.DeductionAmount || 0),
//                               0
//                             ).toLocaleString("en-IN")}
//                           </td>
//                           <td></td>
//                         </tr>
//                       </>
//                     ) : (
//                       <tr>
//                         <td style={{ fontSize: "18px" }} colSpan={7} className="fw-bold text-center">
//                           {t("No data found")}
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>

//                 {/* PAGINATION */}
//                 <div className='col-12 mt-4 p-2'>
//                   <div className="row">
//                     <div className='col-6'>
//                       <p style={{ fontSize: "18px" }}>
//                         {t("Showing")} {indexOfFirstBill + 1}{" "}
//                         {t("to")}{" "}
//                         {Math.min(indexOfLastBill, totalBillRecords)} {t("of")}{" "}
//                         {totalBillRecords} {t("entries")}
//                       </p>
//                     </div>

//                     <div
//                       className='col-6'
//                       style={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: "end"
//                       }}
//                     >
//                       <GooglePagination
//                         currentPage={currentPage}
//                         totalPages={totalBillPages}
//                         onPageChange={setCurrentPage}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )
//         }

//         {/* 52 -> 55 approvance */}
//         {
//           selectedDemandID &&
//           showspecific == 55 &&
//           <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
//             <div className="col-11 m-auto">
//               <div className='col-12' >

//                 <div className="col-12">
//                   <button className='btn btn-danger px-3 rounded-4 mb-3 mt-3' onClick={() => setShowSpecific(52)}>{t("Back")}</button>
//                 </div>

//                 <div className="col-11 my-4 mx-auto">
//                   <div className="row">

//                     <div className="d-flex justify-content-between align-items-center flex-wrap">
//                       <h5 className="my-auto fw-bold d-flex align-items-center">
//                         <img src="/GR-Approval64.png" alt="" style={{ width: "24px", height: "24px" }} className="me-2" />
//                         <span className='my-auto'> {t("Approvance for Bill ID")} {selectedDemandID} {t("Detail")}</span>
//                       </h5>
//                     </div>

//                     <div className="col-12 d-flex justify-content-end mt-3 gap-2">
//                       <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("DemandApprovanceTable", "DemandApprovanceTable.xlsx")}>{t("Download Excel")}</button>
//                       <button className='btn btn-danger px-4' onClick={() => downloadPageAsPDF('DemandApprovanceTable', `DemandApprovanceTable_${selectedYear}.pdf`, `Demand Approvance Table ${selectedYear}`)}>{t("Download Pdf")}</button>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="m-auto tableDesign DistrictTableContianerModel3" style={{ background: '#2C78DB', overflowX: 'hidden' }}>
//                   <table className='m-0 p-0 DemandApprovanceTable' style={{ width: '100%', borderCollapse: 'collapse' }}>
//                     <thead>
//                       <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
//                         <th style={{ width: "10%", border: "1px solid white" }} rowSpan={2} colSpan={1}>{t("Bill Number")}</th>
//                         <th style={{ width: "80%", border: "1px solid white" }} colSpan={7}>{t("Approved by")}</th>
//                       </tr>
//                       <tr style={{ color: 'white', border: 'none', height: '3rem' }}>
//                         <th style={{ width: "15%", border: "1px solid white" }}>{t("Department Auditor")}</th>
//                         <th style={{ width: "15%", border: "1px solid white" }}>{t("Department HOD(EE)")}</th>
//                         <th style={{ width: "10%", border: "1px solid white" }}>{t("FD Auditor")}</th>
//                         <th style={{ width: "10%", border: "1px solid white" }}>{t("FD AAO")}</th>
//                         {/* <th style={{ width: "10%", border: "1px solid white" }}>{t("FD AO")}</th> */}
//                         <th style={{ width: "10%", border: "1px solid white" }}>{t("Deputy CAFO")}</th>
//                         <th style={{ width: "10%", border: "1px solid white" }}>{t("CAFO")}</th>
//                       </tr>
//                     </thead>

//                     <tbody >
//                       {fetchSpecificDemandDeductionDetail?.length === 0 ? (
//                         <tr>
//                           <td colSpan="10" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
//                             {t("No data available")}
//                           </td>
//                         </tr>
//                       ) : (
//                         fetchSpecificDemandDeductionDetail?.filter(
//                           (proposal, index, self) =>
//                             index === self.findIndex((p) => p.DemandGenerationID === proposal.DemandGenerationID)
//                         )?.map((proposal, index) => {
//                           const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                           return (
//                             <tr key={index} style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "400" }}>
//                               <td className='fw-bold' style={{ fontSize: "12px", padding: "5px" }}>{proposal.DemandGenerationID}</td>
//                               <td style={{ padding: '8px', textAlign: 'center' }}>
//                                 {proposal.Approvance1 === 'true' ? (
//                                   <div className='m-auto'
//                                     style={{
//                                       width: '20px',
//                                       height: '20px',
//                                       borderRadius: '6px',
//                                       backgroundColor: '#16C60C',
//                                       border: 'none',
//                                       display: 'flex',
//                                       justifyContent: 'center',
//                                       alignItems: 'center',
//                                       fontSize: '13px',
//                                       color: 'white',
//                                       boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                     }}
//                                   >
//                                     ✓
//                                   </div>
//                                 ) : proposal.Approvance1 === 'false' ? (
//                                   <div
//                                     className='m-auto'
//                                     style={{
//                                       width: '20px',
//                                       height: '20px',
//                                       borderRadius: '6px',
//                                       backgroundColor: '#dc2626',
//                                       border: 'none',
//                                       display: 'flex',
//                                       justifyContent: 'center',
//                                       alignItems: 'center',
//                                       fontSize: '13px',
//                                       color: 'white',
//                                       boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                     }}
//                                   >
//                                     ✕
//                                   </div>
//                                 ) : '-'}
//                               </td>
//                               <td style={{ padding: '8px', textAlign: 'center' }}>
//                                 {proposal.Approvance2 === 'true' ? (<div className='m-auto'
//                                   style={{
//                                     width: '20px',
//                                     height: '20px',
//                                     borderRadius: '6px',
//                                     backgroundColor: '#16C60C',
//                                     border: 'none',
//                                     display: 'flex',
//                                     justifyContent: 'center',
//                                     alignItems: 'center',
//                                     fontSize: '13px',
//                                     color: 'white',
//                                     boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                   }}
//                                 >
//                                   ✓
//                                 </div>) : proposal.Approvance2 === 'false' ? (<div
//                                   className='m-auto'
//                                   style={{
//                                     width: '20px',
//                                     height: '20px',
//                                     borderRadius: '6px',
//                                     backgroundColor: '#dc2626',
//                                     border: 'none',
//                                     display: 'flex',
//                                     justifyContent: 'center',
//                                     alignItems: 'center',
//                                     fontSize: '13px',
//                                     color: 'white',
//                                     boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                   }}
//                                 >
//                                   ✕
//                                 </div>) : '-'}
//                               </td>
//                               <td style={{ padding: '8px', textAlign: 'center' }}>
//                                 {proposal.Approvance3 === 'true' ? (<div className='m-auto'
//                                   style={{
//                                     width: '20px',
//                                     height: '20px',
//                                     borderRadius: '6px',
//                                     backgroundColor: '#16C60C',
//                                     border: 'none',
//                                     display: 'flex',
//                                     justifyContent: 'center',
//                                     alignItems: 'center',
//                                     fontSize: '13px',
//                                     color: 'white',
//                                     boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                   }}
//                                 >
//                                   ✓
//                                 </div>) : proposal.Approvance3 === 'false' ? (<div
//                                   className='m-auto'
//                                   style={{
//                                     width: '20px',
//                                     height: '20px',
//                                     borderRadius: '6px',
//                                     backgroundColor: '#dc2626',
//                                     border: 'none',
//                                     display: 'flex',
//                                     justifyContent: 'center',
//                                     alignItems: 'center',
//                                     fontSize: '13px',
//                                     color: 'white',
//                                     boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                   }}
//                                 >
//                                   ✕
//                                 </div>) : '-'}
//                               </td>
//                               <td style={{ padding: '8px', textAlign: 'center' }}>
//                                 {proposal.Approvance4 === 'true' ? (<div className='m-auto'
//                                   style={{
//                                     width: '20px',
//                                     height: '20px',
//                                     borderRadius: '6px',
//                                     backgroundColor: '#16C60C',
//                                     border: 'none',
//                                     display: 'flex',
//                                     justifyContent: 'center',
//                                     alignItems: 'center',
//                                     fontSize: '13px',
//                                     color: 'white',
//                                     boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                   }}
//                                 >
//                                   ✓
//                                 </div>) : proposal.Approvance4 === 'false' ? (<div
//                                   className='m-auto'
//                                   style={{
//                                     width: '20px',
//                                     height: '20px',
//                                     borderRadius: '6px',
//                                     backgroundColor: '#dc2626',
//                                     border: 'none',
//                                     display: 'flex',
//                                     justifyContent: 'center',
//                                     alignItems: 'center',
//                                     fontSize: '13px',
//                                     color: 'white',
//                                     boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                   }}
//                                 >
//                                   ✕
//                                 </div>) : '-'}
//                               </td>
//                               {/* <td style={{ padding: '8px', textAlign: 'center' }}>
//                                 {proposal.Approvance5 === 'true' ? (<div className='m-auto'
//                                   style={{
//                                     width: '20px',
//                                     height: '20px',
//                                     borderRadius: '6px',
//                                     backgroundColor: '#16C60C',
//                                     border: 'none',
//                                     display: 'flex',
//                                     justifyContent: 'center',
//                                     alignItems: 'center',
//                                     fontSize: '13px',
//                                     color: 'white',
//                                     boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                   }}
//                                 >
//                                   ✓
//                                 </div>) : proposal.Approvance5 === 'false' ? (<div
//                                   className='m-auto'
//                                   style={{
//                                     width: '20px',
//                                     height: '20px',
//                                     borderRadius: '6px',
//                                     backgroundColor: '#dc2626',
//                                     border: 'none',
//                                     display: 'flex',
//                                     justifyContent: 'center',
//                                     alignItems: 'center',
//                                     fontSize: '13px',
//                                     color: 'white',
//                                     boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                   }}
//                                 >
//                                   ✕
//                                 </div>) : '-'}
//                               </td> */}
//                               <td style={{ padding: '8px', textAlign: 'center' }}>
//                                 {proposal.Approvance6 === 'true' ? (<div className='m-auto'
//                                   style={{
//                                     width: '20px',
//                                     height: '20px',
//                                     borderRadius: '6px',
//                                     backgroundColor: '#16C60C',
//                                     border: 'none',
//                                     display: 'flex',
//                                     justifyContent: 'center',
//                                     alignItems: 'center',
//                                     fontSize: '13px',
//                                     color: 'white',
//                                     boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                   }}
//                                 >
//                                   ✓
//                                 </div>) : proposal.Approvance6 === 'false' ? (<div
//                                   className='m-auto'
//                                   style={{
//                                     width: '20px',
//                                     height: '20px',
//                                     borderRadius: '6px',
//                                     backgroundColor: '#dc2626',
//                                     border: 'none',
//                                     display: 'flex',
//                                     justifyContent: 'center',
//                                     alignItems: 'center',
//                                     fontSize: '13px',
//                                     color: 'white',
//                                     boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                   }}
//                                 >
//                                   ✕
//                                 </div>) : '-'}
//                               </td>
//                               <td style={{ padding: '8px', textAlign: 'center' }}>
//                                 {proposal.Approvance7 === 'true' ? (<div className='m-auto'
//                                   style={{
//                                     width: '20px',
//                                     height: '20px',
//                                     borderRadius: '6px',
//                                     backgroundColor: '#16C60C',
//                                     border: 'none',
//                                     display: 'flex',
//                                     justifyContent: 'center',
//                                     alignItems: 'center',
//                                     fontSize: '13px',
//                                     color: 'white',
//                                     boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                   }}
//                                 >
//                                   ✓
//                                 </div>) : proposal.Approvance7 === 'false' ? (<div
//                                   className='m-auto'
//                                   style={{
//                                     width: '20px',
//                                     height: '20px',
//                                     borderRadius: '6px',
//                                     backgroundColor: '#dc2626',
//                                     border: 'none',
//                                     display: 'flex',
//                                     justifyContent: 'center',
//                                     alignItems: 'center',
//                                     fontSize: '13px',
//                                     color: 'white',
//                                     boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                   }}
//                                 >
//                                   ✕
//                                 </div>) : '-'}
//                               </td>
//                             </tr>

//                           );
//                         })
//                       )}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             </div>
//           </div>
//         }

//         {
//           selectedContractor &&
//           showspecific === 58 &&
//           <div className="col-12">

//             <div className="col-12 m-auto px-4">
//               <button
//                 className="btn btn-danger px-3 rounded-4 mb-3 mt-3"
//                 onClick={() => setShowSpecific(57)}
//               >
//                 {t("Back")}
//               </button>
//             </div>

//             <div className="col-12 my-4 m-auto px-4">
//               <div className="row align-items-center">

//                 {/* LEFT SIDE */}
//                 <div className="col-md-6">
//                   <h2
//                     style={{
//                       color: "#4f46e5",
//                       fontWeight: "700",
//                       fontSize: "1.4rem",
//                       marginBottom: 0
//                     }}
//                   >
//                     {t("Vendor")} {selectedContractor} {t("Detail")}
//                   </h2>
//                 </div>

//                 {/* RIGHT SIDE */}
//                 <div className="col-md-6 d-flex justify-content-md-end gap-2 mt-3 mt-md-0">
//                   <button
//                     className="btn btn-success px-4"
//                     onClick={() =>
//                       exportTableByClassToExcel(
//                         "ContractorDetailTable",
//                         "Contractor.xlsx"
//                       )
//                     }
//                   >
//                     Download Excel
//                   </button>

//                   <button
//                     className="btn btn-danger px-4"
//                     onClick={() =>
//                       downloadPageAsPDF(
//                         "ContractorDetailTable",
//                         `ContractorDetailTable_${selectedYear}.pdf`,
//                         `Contractor Detail Table ${selectedYear}`
//                       )
//                     }
//                   >
//                     Download Pdf
//                   </button>
//                 </div>

//               </div>
//             </div>
//             <div className="m-auto DistrictTableContianerModel3">
//               <table className='m-auto my-4 ContractorDetailTable '>
//                 <thead>
//                   <tr>
//                     <th style={{ width: "20%" }}>{t("Vendor Name")}</th>
//                     <th style={{ width: "5%" }}>{t("City")}</th>
//                     <th style={{ width: "10%" }}>{t("GST Number")}</th>
//                     <th style={{ width: "10%" }}>{t("Adhaar Number")}</th>
//                     {/* <th style={{ width: "10%" }}>Mobile Number</th> */}
//                     <th style={{ width: "10%" }}>{t("Email")}</th>
//                     <th style={{ width: "15%" }}>{t("Bank Name")}</th>
//                     <th style={{ width: "10%" }}>{t("Branch Name")}</th>
//                     <th style={{ width: "10%" }}>{t("Account Number")}</th>
//                     <th style={{ width: "10%" }}>{t("IFSC Code")}</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {
//                     SpecificContractorDetail &&
//                       SpecificContractorDetail.length > 0 ? (
//                       SpecificContractorDetail.map((val, index) => {
//                         return (
//                           <tr key={index}>
//                             <td>{val.Bidder_CompanyName}</td>
//                             <td>{val.City}</td>
//                             <td>{val.GST_No}</td>
//                             <td>{val.AadhaarNo}</td>
//                             {/* <td>{val.Mobile_No}</td> */}
//                             <td>{val.Email}</td>
//                             <td>{val.BANK_NAME}</td>
//                             <td>{val.BranchName}</td>
//                             <td>{val.Account_Number}</td>
//                             <td>{val.IFSC_CODE}</td>
//                           </tr>
//                         )
//                       })
//                     )
//                       :
//                       (
//                         <tr>
//                           <td colSpan={10} className='fw-bold'>{t("No data found")}</td>
//                         </tr>
//                       )
//                   }
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         }

//         {/* Series for Part 3 for Total Gr created */}
//         {
//           districtGRSummary.length > 0 &&
//           showspecific === 99 &&
//           (
//             <>

//               <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
//                 <div className="col-11 m-auto">
//                   <div className='col-12' >

//                     <div className="col-12">
//                       <button
//                         className='btn btn-danger px-3 rounded-4 mb-3 mt-3'
//                         onClick={() => {
//                           setShowSpecific(0);
//                           setSelectedGRDistrict('');
//                           setDistrictGRPage(1);
//                           setShowAllDistrictGR(false);
//                         }}
//                       >{t("Back")}</button>
//                     </div>

//                     <div className="col-11 my-0 mx-auto">
//                       <div className="row">
//                         <div className="col-12 py-2 d-flex justify-content-left align-items-center">

//                           <h5 className="my-auto fw-bold d-flex align-items-center">
//                             <img
//                               src="/GR-Approval64.png"
//                               alt=""
//                               style={{ width: "24px", height: "24px" }}
//                               className="me-2"
//                             />
//                             <span>
//                               {t("GR Created in the Year")} {selectedYear}
//                             </span>
//                           </h5>
//                         </div>

//                         {/* <div className="col-12 d-flex justify-content-end mt-3 mb-3 gap-2">
//                           <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("ALlDistrictFinanceData", "AllDistrictReleaseData.xlsx")}>{t("Download Excel")}</button>
//                           <button className='btn btn-danger px-4' onClick={() => downloadPageAsPDF('ALlDistrictFinanceData', `ALlDistrictFinanceData_${selectedYear}.pdf`, `ALlDistrict Finance Data ${selectedYear}`)}>{t("Download Pdf")}</button>
//                         </div> */}
//                                                 <div className="col-12 d-flex justify-content-end mt-3 mb-3 gap-2">
//   <button
//     className="btn btn-success px-4"
//     onClick={() =>
//       exportTableByClassToExcel(
//         "ALlDistrictFinanceData",
//         `GR_Summary_${selectedYear}.xlsx`
//       )
//     }
//   >
//     {t("Download Excel")}
//   </button>

//   <button
//     className="btn btn-danger px-4"
//     onClick={() =>
//       downloadTableOnlyAsPDF(
//         "ALlDistrictFinanceData",
//         `GR_Summary_${selectedYear}.pdf`,
//         `GR Created in the Year ${selectedYear}`
//       )
//     }
//   >
//     {t("Download PDF")}
//   </button>
// </div>
//                       </div>
//                     </div>
//                     <div
//                       className="col-11 mx-auto d-flex justify-content-end align-items-center mb-3"
//                       style={{
//                         gap: "10px",
//                         flexWrap: "wrap",
//                       }}
//                     >
//                       {/* District Filter - State users only */}
//                       {userData?.Department_Name === "State" && (
//                         <select
//                           className="form-select"
//                           value={selectedGRDistrict}
//                           onChange={(e) => {
//                             setSelectedGRDistrict(e.target.value);
//                             setDistrictGRPage(1);
//                             setShowAllDistrictGR(false);
//                           }}
//                           style={{
//                             width: "220px",
//                             border: "1px solid #ccc",
//                             borderRadius: "8px",
//                             padding: "8px 12px",
//                             fontSize: "16px",
//                           }}
//                         >
//                           <option value="">{t("All Districts")}</option>

//                           {[
//                             ...new Set(
//                               districtGRSummary
//                                 .map((item) => getMainDistrict(item.District))
//                                 .filter(Boolean)
//                             ),
//                           ].map((district, index) => (
//                             <option key={index} value={district}>
//                               {district}
//                             </option>
//                           ))}
//                         </select>
//                       )}

//                       {/* Random Search - All users */}
//                       <input
//                         type="text"
//                         className="form-control"
//                         placeholder="Search anything..."
//                         value={searchGRSummary}
//                         onChange={(e) => {
//                           setSearchGRSummary(e.target.value);
//                           setDistrictGRPage(1);
//                           setShowAllDistrictGR(false);
//                         }}
//                         style={{
//                           width: "250px",
//                           fontSize: "14px",
//                         }}
//                       />
//                     </div>

//                     <div className="col-12 pb-5">
//                       <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>

//                         <div className='col-12 tableDesign DistrictTableContianerModel2' style={{
//                           background: '#2C78DB', overflowX: "auto",
//                           overflowY: "auto",
//                           maxHeight: "600px", // change heigh
//                           position: "relative"
//                         }}>
//                           <table className='m-0 py-0 ALlDistrictFinanceData' style={{ width: '100%', borderCollapse: 'collapse' }}>
//                             <thead style={{
//                               position: "sticky", backgroundColor: "#1976d2",
//                               top: 0,
//                               zIndex: 10,
//                             }} >
//                               <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
//                                 <th style={{ width: "10%", fontSize: "18px" }}>{t("Sr No")}</th>
//                                 <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("District")}</th>
//                                 <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("Year")}</th>
//                                 <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("Total GR")}</th>
//                                 <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("Total Amount")}</th>
//                               </tr>
//                             </thead>

//                             <tbody>
//                               {
//                                 districtGRSummary &&
//                                   districtGRSummary.length > 0 ?
//                                   (() => {
//                                     const totaltscount = filteredDistrictGRSummary.reduce((sum, val) => sum + parseFloat(val.TotalGR || 0), 0);
//                                     const totaltsamount = filteredDistrictGRSummary.reduce((sum, val) => sum + parseFloat(val.TotalAmount || 0), 0);
//                                     const pageTotalGRCount = paginatedDistrictGR.reduce((sum, val) => sum + parseFloat(val.TotalGR || 0), 0);
//                                     const pageTotalGRAmount = paginatedDistrictGR.reduce((sum, val) => sum + parseFloat(val.TotalAmount || 0), 0);
//                                     return (
//                                       <>
//                                         {
//                                           paginatedDistrictGR.map((item, idx) => {
//                                             const bgColor = idx % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                             return (
//                                               <tr key={idx} style={{ backgroundColor: bgColor, fontSize: "18px", fontWeight: "400" }}>
//                                                 <td style={{ fontSize: "18px" }} >{(districtGRPage - 1) * districtGRRecordsPerPage + idx + 1}</td>
//                                                 <td style={{ fontSize: "18px" }}><a
//                                                   href="#"
//                                                   className='my-auto'
//                                                   style={{ color: '#4f46e5', textDecoration: 'underline' }}
//                                                   onClick={(e) => {
//                                                     e.preventDefault();
//                                                     showDistrictGR(item.District);
//                                                   }}
//                                                 >
//                                                   {item.District}
//                                                 </a></td>
//                                                 <td style={{ fontSize: "18px" }}>{selectedYear}</td>
//                                                 <td style={{ fontSize: "18px" }}>{item.TotalGR}</td>
//                                                 <td style={{ fontSize: "18px" }}>
//                                                   ₹ {Number(item.TotalAmount).toLocaleString("en-IN")}
//                                                 </td>
//                                               </tr>
//                                             );
//                                           })
//                                         }

//                                         <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0', fontSize: "18px", textAlign: "right" }}>
//                                           <td colSpan={3} style={{ fontSize: "18px" }}>{t("Page Total")}</td>
//                                           <td style={{ fontSize: "18px" }}>{Number(pageTotalGRCount).toLocaleString("en-IN")}</td>
//                                           <td style={{ fontSize: "18px" }}>₹ {Number(pageTotalGRAmount).toLocaleString("en-IN")}</td>
//                                         </tr>

//                                         <tr style={{ fontWeight: 'bold', backgroundColor: '#e0e0e0', fontSize: "18px", textAlign: "right" }}>
//                                           <td colSpan={3} style={{ fontSize: "18px" }}>{t("Gross Total")}</td>
//                                           <td style={{ fontSize: "18px" }}>{Number(totaltscount).toLocaleString("en-IN")}</td>
//                                           <td style={{ fontSize: "18px" }}>₹ {Number(totaltsamount).toLocaleString("en-IN")}</td>
//                                         </tr>
//                                       </>
//                                     );
//                                   })()
//                                   :
//                                   (
//                                     <tr>
//                                       <td colSpan={5} className='fw-bold'>{t("No data found")}</td>
//                                     </tr>
//                                   )
//                               }
//                             </tbody>
//                           </table>
//                         </div>
//                         <div
//                           style={{
//                             display: "flex",
//                             justifyContent: "space-between",
//                             alignItems: "center",
//                             marginTop: "20px",
//                           }}
//                         >
//                           <p className="text-gray-600 m-0" style={{ fontSize: "18px" }}>
//                             {t("Showing")}{" "}
//                             {filteredDistrictGRSummary.length > 0
//                               ? showAllDistrictGR
//                                 ? 1
//                                 : (districtGRPage - 1) * districtGRRecordsPerPage + 1
//                               : 0}{" "}
//                             {t("to")}{" "}
//                             {showAllDistrictGR
//                               ? filteredDistrictGRSummary.length
//                               : Math.min(
//                                 districtGRPage * districtGRRecordsPerPage,
//                                 filteredDistrictGRSummary.length
//                               )}{" "}
//                             {t("of")} {filteredDistrictGRSummary.length} {t("entries")}
//                           </p>

//                           <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//                             <button
//                               type="button"
//                               onClick={() => {
//                                 setShowAllDistrictGR(!showAllDistrictGR);
//                                 setDistrictGRPage(1);
//                               }}
//                               style={{
//                                 border: "none",
//                                 outline: "none",
//                                 cursor: "pointer",
//                                 padding: "8px 16px",
//                                 borderRadius: "20px",
//                                 fontSize: "13px",
//                                 fontWeight: "600",
//                                 color: "#fff",
//                                 background: showAllDistrictGR
//                                   ? "linear-gradient(135deg, #28a745, #20c997)"
//                                   : "linear-gradient(135deg, #0067ab, #0098d5)",
//                                 boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
//                               }}
//                             >
//                               {showAllDistrictGR ? "✓ Showing All" : "View All"}
//                             </button>

//                             {!showAllDistrictGR && (
//                               <GooglePagination
//                                 currentPage={districtGRPage}
//                                 totalPages={totalDistrictGRPages}
//                                 onPageChange={setDistrictGRPage}
//                               />
//                             )}
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//             </>
//           )
//         }

//         {/* Series for part 3 For GR */}
//         {
//           AllGRS &&
//           showspecific === 100 &&
//           <div className='col-12' style={{
//             backgroundColor: "#EFF3F8",
//             height: exportingPDF ? "auto" : "90vh",
//             overflowY: exportingPDF ? "visible" : "scroll",
//           }}
//           >
//             <div className="col-11 m-auto">
//               <div className='col-12' >

//                 <div className="col-12">
//                   <button className='btn btn-danger px-3 rounded-4 mb-3 mt-3' onClick={() => setShowSpecific(99)}>{t("Back")}</button>
//                 </div>

//                 <div className="col-10 my-4 mx-auto">
//                   <div className="row">
//                     <div className="d-flex justify-content-between align-items-center flex-wrap">
//                       <h5 className="my-auto fw-bold d-flex align-items-center">
//                         <img src="/GR-Approval64.png" alt="" style={{ width: "24px", height: "24px" }} className="me-2" />
//                         <span className='my-auto'> {t("GR Created in")} {paginatedGRS[0]?.ZillaParishad || "Unknown"}</span>
//                       </h5>
//                     </div>
//                   </div>


//                   <div className="col-12 d-flex justify-content-end mt-3 gap-2">
//                     <div style={{ position: "relative", width: "250px" }}>
//                       <img
//                         src="/Search32.png"
//                         alt="Search Icon"
//                         style={{
//                           position: "absolute",
//                           top: "50%",
//                           left: "10px",
//                           transform: "translateY(-50%)",
//                           width: "16px",
//                           height: "16px",
//                           opacity: 0.6
//                         }}
//                       />
//                       <input
//                         type="text"
//                         className="form-control ps-4"
//                         placeholder={t("Search Here")}
//                         value={searchGR}
//                         onChange={(e) => {
//                           setSearchGR(e.target.value);
//                           setCurrentPage(1);
//                           setShowAllGR(false);
//                         }}
//                       />
//                     </div>
//                     <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("AllGR", "GRS.xlsx")}>{t("Download Excel")}</button>
//                     <button
//                       className="btn btn-danger px-4"
//                       onClick={() =>
//                         downloadTableOnlyAsPDF(
//                           "AllGR",
//                           `AllGR_${selectedYear}.pdf`,
//                           `All GR ${selectedYear}`
//                         )
//                       }
//                     >
//                       {t("Download PDF")}
//                     </button>
//                   </div>
//                 </div>
//               </div>
//               <div className="col-12 pb-5">
//                 <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>
//                   <div className='col-12 tableDesign DistrictTableContianerModel2' style={{
//                     background: '#2C78DB', overflowX: "auto",
//                     overflowY: "auto",
//                     maxHeight: "600px", // change height as needed
//                     position: "relative"
//                   }}>
//                     <table className='m-0 p-0 AllGR' style={{ width: '100%', borderCollapse: 'collapse', tableLayout: "fixed" }}>
//                       <thead style={{
//                         position: "sticky", backgroundColor: "#1976d2",
//                         top: 0,
//                         zIndex: 10,
//                       }}>
//                         <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
//                           <th style={{ width: "7%", padding: "4px", fontSize: "18px" }}>{t("Sr No")}</th>
//                           <th style={{ minWidth: "100px", padding: "8px", width: "100px", fontSize: "18px" }}>{t("GR UID")}</th>
//                           <th style={{ minWidth: "100px", padding: "8px", width: "100px", fontSize: "18px" }}>{t("GR Number")}</th>
//                           <th style={{ minWidth: "100px", padding: "8px", width: "100px", fontSize: "18px" }}>{t("District")}</th>
//                           <th style={{ width: "15%", fontSize: "18px" }}>{t("Year")}</th>
//                           <th style={{ width: "35%", padding: "8px", fontSize: "18px" }}>{t("HeadCode")}</th>
//                           <th style={{ width: "20%", fontSize: "18px" }}>{t("GR Date")}</th>
//                           <th style={{ width: "20%", textAlign: "left", fontSize: "18px" }}>{t("GR Amount")}</th>

//                           {/* <th style={{ width: "15%" }}>Status</th> */}
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {
//                           paginatedGRS &&
//                             paginatedGRS.length > 0 ? (() => {
//                               const filteredData = sourceGRS.filter(val =>
//                                 !searchGR ||
//                                 String(val.GRID).toLowerCase().startsWith(searchGR.toLowerCase()) ||
//                                 String(val.GRNumber).toLowerCase().startsWith(searchGR.toLowerCase())
//                               );

//                               const paginatedData = showAllGR
//                                 ? filteredData
//                                 : filteredData.slice(
//                                   (currentPage - 1) * billRecordsPerPage,
//                                   currentPage * billRecordsPerPage
//                                 );

//                               const pageTotalGRAmount = paginatedData.reduce(
//                                 (sum, val) => sum + parseFloat(val.GRAmount || 0),
//                                 0
//                               );

//                               const grandTotalGRAmount = filteredData.reduce(
//                                 (sum, val) => sum + parseFloat(val.GRAmount || 0),
//                                 0
//                               );
//                               return (
//                                 <>
//                                   {
//                                     paginatedData.map((val, index) => {
//                                       const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                       return (
//                                         <tr key={index} style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "400" }}>
//                                           <td style={{ fontSize: "18px" }}>{indexOfFirstGRS + index + 1}</td>
//                                           <td style={{ minWidth: "100px", padding: "8px", width: "100px", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", fontSize: "18px" }}>{val.GRID}</td>
//                                           <td style={{ fontSize: "18px" }}>
//                                             <p className='makeitlink my-auto' onClick={() => proposalDetailbyGR(val.GRID)}>
//                                               {val.GRNumber}
//                                             </p>
//                                           </td>
//                                           <td style={{ fontSize: "18px" }}>{val.ZillaParishad}</td>
//                                           <td style={{ fontSize: "18px" }}>{selectedYear}</td>
//                                           <td style={{ fontSize: "18px" }}>{val.HeadCode}</td>
//                                           <td style={{ fontSize: "18px" }}>{new Date(val.GRDate).toLocaleDateString("en-IN")}</td>
//                                           <td style={{ textAlign: "left", fontSize: "18px" }} >
//                                             ₹ {Number(val.GRAmount).toLocaleString("en-IN")}
//                                           </td>

//                                         </tr>
//                                       );
//                                     })
//                                   }

//                                   {/* Page Total */}
//                                   <tr
//                                     style={{
//                                       fontWeight: "bold",
//                                       backgroundColor: "#f0f0f0",
//                                       fontSize: "18px", textAlign: "right"
//                                     }}
//                                   >
//                                     <td style={{ fontSize: "18px", fontSize: "18px" }} colSpan={7}>{t("Page Total")}</td>
//                                     <td style={{ textAlign: "left", fontSize: "18px" }}>
//                                       ₹ {Number(pageTotalGRAmount).toLocaleString("en-IN")}
//                                     </td>
//                                     <td></td>
//                                   </tr>

//                                   {/* Grand Total */}
//                                   <tr
//                                     style={{
//                                       fontWeight: "bold",
//                                       backgroundColor: "#e0e0e0",
//                                       fontSize: "18px", textAlign: "right"
//                                     }}
//                                   >
//                                     <td style={{ fontSize: "18px" }} colSpan={7}>{t("Gross Total")}</td>
//                                     <td style={{ textAlign: "left", fontSize: "18px" }}>
//                                       ₹ {Number(grandTotalGRAmount).toLocaleString("en-IN")}
//                                     </td>
//                                     <td></td>
//                                   </tr>
//                                 </>
//                               );
//                             })() : (
//                             <tr>
//                               <td style={{ fontSize: "18px" }} colSpan={10} className='fw-bold'>{t("No data found")}</td>
//                             </tr>
//                           )
//                         }
//                       </tbody>
//                     </table>
//                   </div>
//                   <div
//                     style={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "center",
//                       marginTop: "20px",
//                     }}
//                   >
//                     <p className="text-gray-600 m-0" style={{ fontSize: "18px" }}>
//                       {t("Showing")}{" "}
//                       {showAllGR
//                         ? (sourceGRS.length > 0 ? 1 : 0)
//                         : (indexOfFirstGRS + 1)}{" "}
//                       {t("to")}{" "}
//                       {showAllGR
//                         ? sourceGRS.length
//                         : Math.min(indexOfLastGRS, sourceGRS.length)}{" "}
//                       {t("of")} {sourceGRS.length} {t("entries")}
//                     </p>

//                     <div style={{ display: "flex", alignItems: "center", gap: "10px", fontSize: "18px" }}>
//                       <button
//                         type="button"
//                         onClick={() => {
//                           setShowAllGR(!showAllGR);
//                           setCurrentPage(1);
//                         }}
//                         style={{
//                           border: "none",
//                           outline: "none",
//                           cursor: "pointer",
//                           padding: "8px 16px",
//                           borderRadius: "20px",
//                           fontSize: "13px",
//                           fontWeight: "600",
//                           color: "#fff",
//                           background: showAllGR
//                             ? "linear-gradient(135deg, #28a745, #20c997)"
//                             : "linear-gradient(135deg, #0067ab, #0098d5)",
//                           boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
//                         }}
//                       >
//                         {showAllGR ? "✓ Showing All" : "View All"}
//                       </button>

//                       {!showAllGR && (
//                         <GooglePagination
//                           currentPage={currentPage}
//                           totalPages={totalPages}
//                           onPageChange={handlePageChange}
//                         />
//                       )}
//                     </div>
//                   </div>
//                 </div>



//               </div>
//             </div>
//           </div>
//         }

//         {
//           selectedGR &&
//           showspecific === 101 &&
//           <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
//             <div className="col-11 m-auto">
//               <div className='col-12' >
//                 <div className="col-12">
//                   <button className='btn btn-danger px-3 rounded-4 mb-3 mt-3' onClick={() => setShowSpecific(100)}>{t("Back")}</button>
//                 </div>

//                 <div className="col-11 my-4 mx-auto">
//                   <div className="d-flex justify-content-between align-items-center flex-wrap">
//                     {/* Title */}
//                     <h5 className="my-auto fw-bold d-flex align-items-center">
//                       <img src="/GR-Approval64.png" alt="" style={{ width: "24px", height: "24px" }} className="me-2" />
//                       <span className="my-auto">GR {selectedGR} {t("Detail")}</span>
//                     </h5>

//                     {/* Buttons */}
//                     <div className="d-flex gap-2 mt-2 mt-md-0">
//                       <button
//                         className="btn btn-success px-4"
//                         onClick={() =>
//                           exportTableByClassToExcel("ProposalContainer", "ProposalDetail.xlsx")
//                         }
//                       >
//                         {t("Download Excel")}
//                       </button>
//                       <button
//                         className="btn btn-danger px-4"
//                         onClick={() =>
//                           downloadTableOnlyAsPDF(
//                             "ProposalContainer",
//                             `GRdetialTable${selectedYear}.pdf`,
//                             `GR Detail Table ${selectedYear}`
//                           )
//                         }
//                       >
//                         {t("Download PDF")}
//                       </button>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="col-12 pb-5">
//                   <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>
//                     <div className='col-12 tableDesign DistrictTableContianerModel2' style={{
//                       background: '#2C78DB', overflowX: "auto",
//                       overflowY: "auto",
//                       maxHeight: "600px", // change height as needed
//                       position: "relative"
//                     }}>
//                       <table className='m-0 p-0 ProposalContainer' style={{ width: '100%', borderCollapse: 'collapse' }}>
//                         <thead style={{
//                           position: "sticky", backgroundColor: "#1976d2",
//                           top: 0,
//                           zIndex: 10,
//                         }}>
//                           <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
//                             <th style={{ width: "8%", fontSize: "18px" }}>{t("Sr No")}</th>
//                             {/* <th style={{ width: "20%" }}>Proposal ID</th> */}
//                             <th style={{ width: "35%", fontSize: "18px" }}>{t("Proposal Name")}</th>
//                             <th style={{ width: "20%", textAlign: "left", fontSize: "18px" }}>{t("Proposal Amount")}</th>
//                             <th style={{ width: "20%", fontSize: "18px" }}>{t("Date")}</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {
//                             paginatedProposalGR &&
//                               paginatedProposalGR.length > 0 ? (() => {
//                                 // const filteredData = AllGRS.filter(val =>
//                                 //   !searchBill ||
//                                 //   String(val.GRID).toLowerCase().startsWith(searchGR.toLowerCase()) ||
//                                 //   String(val.GRNumber).toLowerCase().startsWith(searchGR.toLowerCase())
//                                 // );

//                                 const totalGRAmount = paginatedProposalGR.reduce((sum, val) => sum + parseFloat(val.Proposal_amount || 0), 0);

//                                 return (
//                                   <>
//                                     {
//                                       paginatedProposalGR.map((val, index) => {
//                                         const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                         return (
//                                           <tr key={index} style={{ backgroundColor: bgColor, fontSize: "18px", fontWeight: "400" }}>
//                                             <td style={{ fontSize: "18px", fontSize: "18px" }}>{firstRecordIndexProposalDetailByGR + index + 1}</td>
//                                             <td style={{ fontSize: "18px" }}>{val.Work_name}</td>

//                                             {/* <td style={{ textAlign: "left" }}>₹ {Number(val.GRAmount).toLocaleString("en-IN")}</td> */}
//                                             <td style={{ fontSize: "18px" }}>
//                                               <p className='my-auto' style={{ textAlign: "left" }} >
//                                                 ₹ {Number(val.Proposal_amount).toLocaleString("en-IN")}
//                                               </p>
//                                             </td>
//                                             <td style={{ fontSize: "18px" }}>{new Date(val.created_at).toLocaleString("en-IN")}</td>
//                                           </tr>
//                                         );
//                                       })}

//                                     {/* Total Row */}
//                                     <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0', fontSize: "18px" }}>
//                                       <td style={{ fontSize: "18px" }} colSpan={2}>{t("Total Proposal Amount")}</td>
//                                       <td style={{ textAlign: "left", fontSize: "18px" }}>₹ {Number(totalGRAmount).toLocaleString("en-IN")}</td>
//                                       <td></td>
//                                     </tr>

//                                   </>
//                                 );
//                               })() : (
//                               <tr>
//                                 <td style={{ fontSize: "18px" }} colSpan={10} className='fw-bold'>{t("No data found")}</td>
//                               </tr>
//                             )
//                           }
//                         </tbody>
//                       </table>
//                     </div>
//                     <div
//                       style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         alignItems: "center",
//                         marginTop: "20px",
//                       }}
//                     >
//                       <p className="text-gray-600 m-0" style={{ fontSize: "14px", fontSize: "18px" }}>
//                         {t("Showing")}{" "}
//                         {ProposalDetailByGR.length > 0
//                           ? showAllProposalGR
//                             ? 1
//                             : firstRecordIndexProposalDetailByGR + 1
//                           : 0}{" "}
//                         {t("to")}{" "}
//                         {showAllProposalGR
//                           ? ProposalDetailByGR.length
//                           : Math.min(
//                             lastRecordIndexProposalDetailByGR,
//                             ProposalDetailByGR.length
//                           )}{" "}
//                         {t("of")} {ProposalDetailByGR.length} {t("entries")}
//                       </p>

//                       <div style={{ display: "flex", alignItems: "center", gap: "10px", fontSize: "18px" }}>
//                         <button
//                           type="button"
//                           onClick={() => {
//                             setShowAllProposalGR(!showAllProposalGR);
//                             setCurrentPageProposalDetailByGR(1);
//                           }}
//                           style={{
//                             border: "none",
//                             outline: "none",
//                             cursor: "pointer",
//                             padding: "8px 16px",
//                             borderRadius: "20px",
//                             fontSize: "13px",
//                             fontWeight: "600",
//                             color: "#fff",
//                             background: showAllProposalGR
//                               ? "linear-gradient(135deg, #28a745, #20c997)"
//                               : "linear-gradient(135deg, #0067ab, #0098d5)",
//                             boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
//                           }}
//                         >
//                           {showAllProposalGR ? "✓ Showing All" : "View All"}
//                         </button>

//                         {!showAllProposalGR && (
//                           <GooglePagination
//                             currentPage={currentPageProposalDetailByGR}
//                             totalPages={totalPagesProposalDetailByGR}
//                             onPageChange={setCurrentPageProposalDetailByGR}
//                           />
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         }

//         {/* Series for Part 4 for Total TS created */}
//         {
//           districtTSSummary.length > 0 &&
//           showspecific === 109 &&
//           (
//             <>

//               <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
//                 <div className="col-11 m-auto">
//                   <div className='col-12' >

//                     <div className="col-12">
//                       <button
//                         className="btn btn-danger px-3 rounded-4 mb-3 mt-3"
//                         onClick={() => {
//                           // Go back to main dashboard
//                           setShowSpecific(0);

//                           // Reset Technical Sanction summary filter
//                           setSelectedTSDistrict("");

//                           // Reset All Technical Sanction filters
//                           setSelectedAllTSTaluka("");
//                           setSelectedAllTSHeadCode("");
//                           setSearchAllTS("");

//                           // Clear previously selected Technical Sanction data
//                           setFilteredTSData([]);

//                           // Reset pagination
//                           setDistrictPage(1);
//                           setCurrentPageAllTSData(1);

//                           // Reset View All
//                           setShowAllTS(false);
//                           setShowAllTSDetails(false);
//                         }}
//                       >
//                         {t("Back")}
//                       </button>
//                     </div>

//                     <div className="col-11 my-0 mx-auto">
//                       <div className="row">
//                         <div className="col-12 py-2 d-flex justify-content-left align-items-center">

//                           <h5 className="my-auto fw-bold d-flex align-items-center">
//                             <img
//                               src="/GR-Approval64.png"
//                               alt=""
//                               style={{ width: "24px", height: "24px" }}
//                               className="me-2"
//                             />
//                             <span>
//                               {t("Technical Sanction in the Year")} {selectedYear}
//                             </span>
//                           </h5>
//                         </div>

//                         {/* <div className="col-12 d-flex justify-content-end mt-3 mb-3 gap-2">
//                           <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("ALlDistrictFinanceData", "AllDistrictReleaseData.xlsx")}>{t("Download Excel")}</button>
//                           <button className='btn btn-danger px-4' onClick={() => downloadPageAsPDF('ALlDistrictFinanceData', `ALlDistrictFinanceData_${selectedYear}.pdf`, `ALlDistrict Finance Data ${selectedYear}`)}>{t("Download Pdf")}</button>
//                         </div> */}
//                                                 <div className="col-12 d-flex justify-content-end mt-3 mb-3 gap-2">
//   <button
//     className="btn btn-success px-4"
//     onClick={() =>
//       exportTableByClassToExcel(
//         "ALlDistrictFinanceData",
//         `TechnicalSanction_Summary_${selectedYear}.xlsx`
//       )
//     }
//   >
//     {t("Download Excel")}
//   </button>

//   <button
//     className="btn btn-danger px-4"
//     onClick={() =>
//       downloadTableOnlyAsPDF(
//         "ALlDistrictFinanceData",
//         `TechnicalSanction_Summary_${selectedYear}.pdf`,
//         `Technical Sanction in the Year ${selectedYear}`
//       )
//     }
//   >
//     {t("Download PDF")}
//   </button>
// </div>
//                       </div>
//                     </div>
//                     <div
//                       className="col-11 mx-auto d-flex justify-content-end align-items-center mb-3"
//                       style={{
//                         gap: "10px",
//                         flexWrap: "wrap",
//                       }}
//                     >
//                       {/* District Filter - State only */}
//                       {userData?.Department_Name === "State" && (
//                         <select
//                           className="form-select"
//                           value={selectedTSDistrict}
//                           onChange={(e) => {
//                             setSelectedTSDistrict(e.target.value);
//                             setDistrictPage(1);
//                             setShowAllTS(false);
//                           }}
//                           style={{
//                             width: "220px",
//                             border: "1px solid #ccc",
//                             borderRadius: "8px",
//                             padding: "8px 12px",
//                             fontSize: "16px",
//                           }}
//                         >
//                           <option value="">{t("All Districts")}</option>

//                           {[
//                             ...new Set(
//                               districtTSSummary
//                                 .map((item) => getMainDistrict(item.District))
//                                 .filter(Boolean)
//                             ),
//                           ].map((district, index) => (
//                             <option key={index} value={district}>
//                               {district}
//                             </option>
//                           ))}
//                         </select>
//                       )}

//                       {/* Random Search - Everyone */}
//                       <input
//                         type="text"
//                         className="form-control"
//                         placeholder="Search anything..."
//                         value={searchTSSummary}
//                         onChange={(e) => {
//                           setSearchTSSummary(e.target.value);
//                           setDistrictPage(1);
//                           setShowAllTS(false);
//                         }}
//                         style={{
//                           width: "250px",
//                           fontSize: "14px",
//                         }}
//                       />
//                     </div>
//                     <div className="col-12 pb-5">
//                       <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>

//                         <div className='col-12 tableDesign DistrictTableContianerModel2' style={{
//                           background: '#2C78DB', overflowX: "auto",
//                           overflowY: "auto",
//                           maxHeight: "600px", // change height as needed
//                           position: "relative",
//                         }}>
//                           <table className='m-0 py-0 ALlDistrictFinanceData' style={{ width: '100%', borderCollapse: 'collapse' }}>
//                             <thead style={{
//                               position: "sticky", backgroundColor: "#1976d2",
//                               top: 0,
//                               zIndex: 10,
//                             }}>
//                               <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
//                                 <th style={{ width: "10%", fontSize: "18px" }}>{t("Sr No")}</th>
//                                 <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("District")}</th>
//                                 <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("Year")}</th>
//                                 <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("Total TS")}</th>
//                                 <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("Total Amount")}</th>
//                               </tr>
//                             </thead>

//                             <tbody>
//                               {
//                                 districtTSSummary &&
//                                   districtTSSummary.length > 0 ?
//                                   (() => {
//                                     const pageTotalTSCount = paginatedTSData.reduce(
//                                       (sum, val) => sum + parseFloat(val.TotalTS || 0),
//                                       0
//                                     );

//                                     const pageTotalTSAmount = paginatedTSData.reduce(
//                                       (sum, val) => sum + parseFloat(val.TotalAmount || 0),
//                                       0
//                                     );

//                                     const grandTotalTSCount = filteredDistrictTSSummary.reduce(
//                                       (sum, val) => sum + parseFloat(val.TotalTS || 0),
//                                       0
//                                     );

//                                     const grandTotalTSAmount = filteredDistrictTSSummary.reduce(
//                                       (sum, val) => sum + parseFloat(val.TotalAmount || 0),
//                                       0
//                                     );

//                                     return (
//                                       <>
//                                         {
//                                           paginatedTSData.map((item, idx) => {
//                                             const bgColor = idx % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                             return (
//                                               <tr key={idx} style={{ backgroundColor: bgColor, fontSize: "18px", fontWeight: "400" }}>
//                                                 <td style={{ fontSize: "18px" }}>
//                                                   {showAllTS
//                                                     ? idx + 1
//                                                     : (districtPage - 1) * tsRecordsPerPage + idx + 1}
//                                                 </td>
//                                                 <td style={{ fontSize: "18px" }}><a
//                                                   href="#"
//                                                   className='my-auto'
//                                                   style={{ color: '#4f46e5', textDecoration: 'underline' }}
//                                                   onClick={(e) => {
//                                                     e.preventDefault();
//                                                     showDistrictTS(item.District);
//                                                   }}
//                                                 >
//                                                   {item.District}
//                                                 </a></td>
//                                                 <td style={{ fontSize: "18px" }}>{selectedYear}</td>
//                                                 <td style={{ fontSize: "18px" }}>{item.TotalTS}</td>
//                                                 <td style={{ fontSize: "18px" }}>
//                                                   ₹ {Number(item.TotalAmount).toLocaleString("en-IN")}
//                                                 </td>
//                                               </tr>
//                                             );
//                                           })
//                                         }

//                                         {/* Page Total */}
//                                         <tr
//                                           style={{
//                                             fontWeight: "bold",
//                                             backgroundColor: "#f0f0f0",
//                                             fontSize: "18px",
//                                             textAlign: "right"
//                                           }}
//                                         >
//                                           <td colSpan={3} style={{ fontSize: "18px" }}>
//                                             {t("Page Total")}
//                                           </td>

//                                           <td style={{ fontSize: "18px" }}>
//                                             {Number(pageTotalTSCount).toLocaleString("en-IN")}
//                                           </td>

//                                           <td style={{ fontSize: "18px" }}>
//                                             ₹ {Number(pageTotalTSAmount).toLocaleString("en-IN")}
//                                           </td>
//                                         </tr>

//                                         {/* Grand Total */}
//                                         <tr
//                                           style={{
//                                             fontWeight: "bold",
//                                             backgroundColor: "#e0e0e0",
//                                             fontSize: "18px",
//                                             textAlign: "right"
//                                           }}
//                                         >
//                                           <td colSpan={3} style={{ fontSize: "18px" }}>
//                                             {t("Gross Total")}
//                                           </td>

//                                           <td style={{ fontSize: "18px" }}>
//                                             {Number(grandTotalTSCount).toLocaleString("en-IN")}
//                                           </td>

//                                           <td style={{ fontSize: "18px" }}>
//                                             ₹ {Number(grandTotalTSAmount).toLocaleString("en-IN")}
//                                           </td>
//                                         </tr>
//                                       </>
//                                     );
//                                   })()
//                                   :
//                                   (
//                                     <tr>
//                                       <td colSpan={5} className='fw-bold'>{t("No data found")}</td>
//                                     </tr>
//                                   )
//                               }
//                             </tbody>

//                           </table>
//                         </div>

//                         <div
//                           style={{
//                             display: "flex",
//                             justifyContent: "space-between",
//                             alignItems: "center",
//                             marginTop: "20px",
//                           }}
//                         >
//                           <p className="text-gray-600 m-0" style={{ fontSize: "14px" }}>
//                             {t("Showing")}{" "}
//                             {districtTSSummary.length > 0
//                               ? showAllTS
//                                 ? 1
//                                 : (districtPage - 1) * tsRecordsPerPage + 1
//                               : 0}{" "}
//                             {t("to")}{" "}
//                             {showAllTS
//                               ? districtTSSummary.length
//                               : Math.min(
//                                 districtPage * tsRecordsPerPage,
//                                 districtTSSummary.length
//                               )}{" "}
//                             {t("of")} {districtTSSummary.length} {t("entries")}
//                           </p>

//                           <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//                             <button
//                               type="button"
//                               onClick={() => {
//                                 setShowAllTS(!showAllTS);
//                                 setDistrictPage(1);
//                               }}
//                               style={{
//                                 border: "none",
//                                 outline: "none",
//                                 cursor: "pointer",
//                                 padding: "8px 16px",
//                                 borderRadius: "20px",
//                                 fontSize: "13px",
//                                 fontWeight: "600",
//                                 color: "#fff",
//                                 background: showAllTS
//                                   ? "linear-gradient(135deg, #28a745, #20c997)"
//                                   : "linear-gradient(135deg, #0067ab, #0098d5)",
//                                 boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
//                               }}
//                             >
//                               {showAllTS ? "✓ Showing All" : "View All"}
//                             </button>

//                             {!showAllTS && (
//                               <GooglePagination
//                                 currentPage={districtPage}
//                                 totalPages={totalTSPages}
//                                 onPageChange={setDistrictPage}
//                               />
//                             )}
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//             </>
//           )
//         }

//         {/* Technical Sanction Page 1 after Clicking */}
//         {
//           selectedYear &&
//           showspecific === 110 &&
//           (
//             <>

//               <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
//                 <div className="col-11 m-auto">
//                   <div className='col-12' >

//                     <div className="col-12">
//                       <button
//                         className="btn btn-danger px-3 rounded-4 mb-3 mt-3"
//                         onClick={() => {
//                           // Go back
//                           setShowSpecific(109);

//                           // Clear filters
//                           setSelectedAllTSTaluka("");
//                           setSelectedAllTSHeadCode("");
//                           setSearchAllTS("");

//                           // Clear previously selected/detail data
//                           setFilteredTSData([]);

//                           // Reset pagination
//                           setCurrentPageAllTSData(1);

//                           // Reset View All
//                           setShowAllTSDetails(false);
//                         }}
//                       >
//                         {t("Back")}
//                       </button>
//                     </div>

//                     <div className="col-11 my-0 mx-auto">
//                       <div className="row">
//                         <div className="col-12 py-2 d-flex justify-content-left align-items-center">

//                           <h5 className="my-auto fw-bold d-flex align-items-center">
//                             <img src="/GR-Approval64.png" alt="" style={{ width: "24px", height: "24px" }} className="me-2" />
//                             <span>
//                               {t("All Technical Sanction in Year")} {selectedYear}
//                             </span>
//                           </h5>
//                         </div>

//                         <div className="col-12 d-flex justify-content-end mt-3 mb-3 gap-2">
//                           <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("ALlTechnicalSData", "ALlTechnicalSData.xlsx")}>{t("Download Excel")}</button>
//                           <button className='btn btn-danger px-4' onClick={() => downloadTableOnlyAsPDF('ALlTechnicalSData', `ALlTechnicalSData_${selectedYear}.pdf`, `ALL Technical Sanction Data ${selectedYear}`)}>{t("Download Pdf")}</button>
//                         </div>
//                         <div
//                           className="col-12 d-flex align-items-center mb-3"
//                           style={{
//                             gap: "10px",
//                             flexWrap: "wrap",
//                             justifyContent: "flex-end",
//                           }}
//                         >

//                           {/* District - State users only */}
//                           {/* {userData?.Department_Name === "State" && (
//     <select
//       className="form-select"
//       value={selectedAllTSDistrict}
//       onChange={(e) => {
//         setSelectedAllTSDistrict(e.target.value);
//         setSelectedAllTSTaluka("");
//         setCurrentPageAllTSData(1);
//         setShowAllTSDetails(false);
//       }}
//       style={{
//         width: "210px",
//         fontSize: "14px",
//       }}
//     >
//       <option value="">All Districts</option>

//       {[...new Set(
//         activeTSData
//           .map((item) => item.District)
//           .filter(Boolean)
//       )]
//         .sort()
//         .map((district, index) => (
//           <option key={index} value={district}>
//             {district}
//           </option>
//         ))}
//     </select>
//   )} */}

//                           {/* Taluka - Always visible */}
//                           <select
//                             className="form-select"
//                             value={selectedAllTSTaluka}
//                             onChange={(e) => {
//                               setSelectedAllTSTaluka(e.target.value);
//                               setCurrentPageAllTSData(1);
//                               setShowAllTSDetails(false);
//                             }}
//                             style={{
//                               width: "210px",
//                               fontSize: "14px",
//                             }}
//                           >
//                             <option value="">All Talukas</option>

//                             {[...new Set(
//                               activeTSData
//                                 .filter((item) =>
//                                   !selectedAllTSDistrict ||
//                                   item.District === selectedAllTSDistrict
//                                 )
//                                 .map((item) => item.Taluka)
//                                 .filter(Boolean)
//                             )]
//                               .sort()
//                               .map((taluka, index) => (
//                                 <option key={index} value={taluka}>
//                                   {taluka}
//                                 </option>
//                               ))}
//                           </select>

//                           {/* HeadCode - Non-State users only */}
//                           {userData?.Department_Name !== "State" && (
//                             <select
//                               className="form-select"
//                               value={selectedAllTSHeadCode}
//                               onChange={(e) => {
//                                 setSelectedAllTSHeadCode(e.target.value);
//                                 setCurrentPageAllTSData(1);
//                                 setShowAllTSDetails(false);
//                               }}
//                               style={{
//                                 width: "250px",
//                                 fontSize: "14px",
//                               }}
//                             >
//                               <option value="">All Head Codes</option>

//                               {[...new Set(
//                                 activeTSData
//                                   .map((item) => item.HeadCode)
//                                   .filter(Boolean)
//                               )]
//                                 .sort()
//                                 .map((headCode, index) => (
//                                   <option key={index} value={headCode}>
//                                     {headCode}
//                                   </option>
//                                 ))}
//                             </select>
//                           )}

//                           {/* Random Search - Always visible */}
//                           <input
//                             type="text"
//                             className="form-control"
//                             placeholder="Search anything..."
//                             value={searchAllTS}
//                             onChange={(e) => {
//                               setSearchAllTS(e.target.value);
//                               setCurrentPageAllTSData(1);
//                               setShowAllTSDetails(false);
//                             }}
//                             style={{
//                               width: "250px",
//                               fontSize: "14px",
//                             }}
//                           />

//                         </div>
//                       </div>
//                     </div>
//                     <div className="col-12 pb-5">
//                       <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>

//                         <div className='col-12 tableDesign DistrictTableContianerModel2' style={{
//                           background: '#2C78DB', overflowX: "auto",
//                           overflowY: "auto",
//                           maxHeight: "600px", // change height as needed
//                           position: "relative",
//                         }}>
//                           <table className='m-0 p-0 ALlTechnicalSData' style={{ width: 'max-content', borderCollapse: 'collapse' }}>
//                             <thead style={{
//                               position: "sticky", backgroundColor: "#1976d2",
//                               top: 0,
//                               zIndex: 10,
//                             }}>
//                               <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
//                                 <th style={{ minWidth: "50px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Sr.No</th>
//                                 <th style={{ minWidth: "160px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Approved Work Name</th>
//                                 <th style={{ minWidth: "190px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Head Code</th> {/* changed from 9 to 7 */}
//                                 <th style={{ minWidth: "150px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Technical Sanction UID</th>
//                                 <th style={{ minWidth: "150px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>MHUID Number</th>
//                                 <th style={{ minWidth: "220px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Area</th>
//                                 <th style={{ minWidth: "150px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>GR UID</th>
//                                 <th style={{ minWidth: "150px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Approved Year</th>
//                                 <th style={{ minWidth: "150px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Constituency Name</th>
//                                 <th style={{ minWidth: "150px", padding: "8px" }} rowSpan={2} colSpan={1}>District</th>
//                                 <th style={{ minWidth: "150px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Taluka</th>
//                                 <th style={{ minWidth: "150px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Gram Panchayat</th>
//                                 <th style={{ minWidth: "150px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Type of Work</th>
//                                 <th style={{ minWidth: "150px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Technical Sanction Amount</th>
//                                 <th style={{ minWidth: "150px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Technical Sanction Copy</th>
//                                 <th style={{ minWidth: "150px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Date</th>
//                                 <th style={{ minWidth: "150px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Edited By</th>

//                                 <th style={{ minWidth: "150px", padding: "8px", fontSize: "18px" }} colSpan={2}>Approved by</th> {/* changed from 9 to 7 */}
//                                 {/* <th style={{ width: "12%", textAlign: "center", border: "1px solid white" }} colSpan={1} rowSpan={2}>Details</th> */}
//                               </tr>
//                               <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
//                                 <th style={{ minWidth: "150px", padding: "8px", fontSize: "18px" }}>Deputy Engineer</th>
//                                 <th style={{ minWidth: "150px", padding: "8px", fontSize: "18px" }}>Executive Engineer</th>
//                               </tr>
//                             </thead>

//                             <tbody >
//                               {currentAllTSData?.length === 0 ? (
//                                 <tr>
//                                   <td colSpan="10" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9', fontSize: "18px" }}>
//                                     No data available
//                                   </td>
//                                 </tr>
//                               ) : (
//                                 [...currentAllTSData]
//                                   .sort((a, b) => new Date(b.Date || 0) - new Date(a.Date || 0)) // newest first
//                                   .map((proposal, index) => {
//                                     const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                     return (
//                                       <tr style={{ backgroundColor: bgColor, fontSize: "18px" }} key={index}>
//                                         <td style={{ padding: '8px 8px', fontSize: "18px" }}>{(firstRecordIndexAllTSData + index + 1)}</td>
//                                         {/* <td style={{ padding: '8px 8px' }}>{(index + 1)}</td> */}
//                                         <td className='fw-bold' style={{ fontSize: "18px", padding: "5px" }}>{proposal.WorkName}</td>
//                                         <td style={{ padding: '8px 8px', fontSize: "18px" }}>{(proposal.HeadCode)}</td>
//                                         <td style={{ padding: '8px 8px', fontSize: "18px" }}>{(proposal.TS_ID)}</td>
//                                         <td style={{ padding: '8px 8px', fontSize: "18px" }}><a
//                                           href="#"
//                                           className='my-auto'
//                                           style={{ color: '#4f46e5', textDecoration: 'underline' }}
//                                           onClick={(e) => {
//                                             e.preventDefault();
//                                             FetchDataForMHUID(selectedYear, proposal.TechnicalSanctionNo, selectedHeadCode);
//                                           }}
//                                         >
//                                           {(proposal.TechnicalSanctionNo)}
//                                         </a></td>
//                                         <td style={{
//                                           padding: "8px",
//                                           minWidth: "220px",   // prevents shrink
//                                           maxWidth: "260px",
//                                           whiteSpace: "normal",
//                                           wordBreak: "break-word"
//                                         }}>{extractCoords(proposal.Area)}</td>
//                                         <td style={{ padding: '8px 8px', fontSize: "18px" }}>{(proposal.GR_UID)}</td>
//                                         <td style={{ padding: '8px 8px', fontSize: "18px" }}>{(proposal.SanctionYear)}</td>
//                                         <td style={{ padding: '8px 8px', fontSize: "18px" }}>{(proposal.ConstituencyName)}</td>
//                                         <td style={{ padding: '8px 8px', fontSize: "18px" }}>{(proposal.District)}</td>
//                                         <td style={{ padding: '8px 8px', fontSize: "18px" }}>{(proposal.Taluka)}</td>
//                                         <td style={{ padding: '8px 8px', fontSize: "18px" }}>{(proposal.GramPanchayat)}</td>
//                                         <td style={{ padding: '8px 8px', fontSize: "18px" }}>{(proposal.TypeofWork)}</td>
//                                         <td style={{ padding: '8px 8px', fontSize: "18px" }}>{(proposal.TechnicalSanctionAmt)}</td>
//                                         <td style={{ padding: '8px', fontSize: "18px" }}>
//                                           {proposal.TechnicalSanctionCopy ? (
//                                             <a href={`${apiurl}/TechincalSactionCopy/${proposal.TechnicalSanctionCopy}`} target="_blank" rel="noreferrer">{proposal.TechnicalSanctionCopy}</a>
//                                           ) : (
//                                             <p className='text-danger my-auto fw-bold'>No File</p>
//                                           )
//                                           }
//                                         </td>
//                                         <td style={{ padding: '8px 8px', fontSize: "18px" }}>{new Date(proposal.Date).toLocaleString("en-IN")}</td>
//                                         <td style={{ padding: '8px 8px', fontSize: "18px" }}>{
//                                           proposal.EditedBy ? (
//                                             <p className="text-black my-auto fw-bold">{proposal.EditedBy}</p>
//                                           ) : (
//                                             <p className="text-danger my-auto fw-bold">No One</p>
//                                           )
//                                         }</td>

//                                         <td style={{ padding: '8px', textAlign: 'center', fontSize: "18px" }}>
//                                           {proposal.Approvance2 === 'true' ? (<div className='m-auto'
//                                             style={{
//                                               width: '20px',
//                                               height: '20px',
//                                               borderRadius: '6px',
//                                               backgroundColor: '#16C60C',
//                                               border: 'none',
//                                               display: 'flex',
//                                               justifyContent: 'center',
//                                               alignItems: 'center',
//                                               fontSize: '13px',
//                                               color: 'white',
//                                               boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                             }}
//                                           >
//                                             ✓
//                                           </div>) : proposal.Approvance2 === 'false' ? (<div
//                                             className='m-auto'
//                                             style={{
//                                               width: '20px',
//                                               height: '20px',
//                                               borderRadius: '6px',
//                                               backgroundColor: '#dc2626',
//                                               border: 'none',
//                                               display: 'flex',
//                                               justifyContent: 'center',
//                                               alignItems: 'center',
//                                               fontSize: '13px',
//                                               color: 'white',
//                                               boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                             }}
//                                           >
//                                             ✕
//                                           </div>) : '-'}
//                                         </td>
//                                         <td style={{ padding: '8px', textAlign: 'center', fontSize: "18px" }}>
//                                           {proposal.Approvance3 === 'true' ? (<div className='m-auto'
//                                             style={{
//                                               width: '20px',
//                                               height: '20px',
//                                               borderRadius: '6px',
//                                               backgroundColor: '#16C60C',
//                                               border: 'none',
//                                               display: 'flex',
//                                               justifyContent: 'center',
//                                               alignItems: 'center',
//                                               fontSize: '13px',
//                                               color: 'white',
//                                               boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                             }}
//                                           >
//                                             ✓
//                                           </div>) : proposal.Approvance3 === 'false' ? (<div
//                                             className='m-auto'
//                                             style={{
//                                               width: '20px',
//                                               height: '20px',
//                                               borderRadius: '6px',
//                                               backgroundColor: '#dc2626',
//                                               border: 'none',
//                                               display: 'flex',
//                                               justifyContent: 'center',
//                                               alignItems: 'center',
//                                               fontSize: '13px',
//                                               color: 'white',
//                                               boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                             }}
//                                           >
//                                             ✕
//                                           </div>) : '-'}
//                                         </td>

//                                         {/* <td style={{ padding: '8px' }}>{proposal.Proposal_copy}</td> */}
//                                         {/* <td>
//                                                                 <button
//                                                                     className='m-auto'
//                                                                     onClick={() => selectedBillDetails(proposal.TS_ID)}
//                                                                     style={{
//                                                                         cursor: 'pointer',
//                                                                         background: "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
//                                                                         color: 'white',
//                                                                         border: 'none',
//                                                                         padding: '6px 20px',
//                                                                         borderRadius: '4px',
//                                                                         fontSize: "12px",
//                                                                         display: "flex",
//                                                                         justifyContent: "center",
//                                                                         alignItems: 'center',
//                                                                         width: "80%"
//                                                                     }}
//                                                                 >
//                                                                     <img src="/view32.png" alt="view" className='me-1' style={{ width: "12px", height: "12px" }} />
//                                                                     View
//                                                                 </button>
//                                                             </td> */}
//                                       </tr>

//                                     );
//                                   })
//                               )}
//                               {/* Page Total */}
//                               {currentAllTSData?.length > 0 && (
//                                 <tr
//                                   style={{
//                                     fontWeight: "bold",
//                                     backgroundColor: "#f0f0f0",
//                                     fontSize: "18px",
//                                     textAlign: "right"
//                                   }}
//                                 >
//                                   <td style={{ fontSize: "18px" }} colSpan={13}>
//                                     {t("Page Total")}
//                                   </td>

//                                   <td style={{ fontSize: "18px" }}>
//                                     ₹{" "}
//                                     {Number(
//                                       pageTotalAllTSAmount
//                                     ).toLocaleString("en-IN")}
//                                   </td>

//                                   <td style={{ fontSize: "18px" }} colSpan={5}></td>
//                                 </tr>
//                               )}

//                               {/* Grand Total */}
//                               {sortedTS?.length > 0 && (
//                                 <tr
//                                   style={{
//                                     fontWeight: "bold",
//                                     backgroundColor: "#e0e0e0",
//                                     fontSize: "18px"
//                                     , textAlign: "right"
//                                   }}
//                                 >
//                                   <td style={{ fontSize: "18px" }} colSpan={13}>
//                                     {t("Gross Total")}
//                                   </td>

//                                   <td style={{ fontSize: "18px" }}>
//                                     ₹{" "}
//                                     {Number(
//                                       grandTotalAllTSAmount
//                                     ).toLocaleString("en-IN")}
//                                   </td>

//                                   <td style={{ fontSize: "18px" }} colSpan={5}></td>
//                                 </tr>
//                               )}
//                             </tbody>
//                           </table>
//                         </div>
//                         <div
//                           style={{
//                             display: "flex",
//                             justifyContent: "space-between",
//                             alignItems: "center",
//                             marginTop: "20px",
//                           }}
//                         >
//                           <p className="text-gray-600 m-0" style={{ fontSize: "18px" }}>
//                             {t("Showing")}{" "}
//                             {sortedTS.length > 0
//                               ? showAllTSDetails
//                                 ? 1
//                                 : firstRecordIndexAllTSData + 1
//                               : 0}{" "}
//                             {t("to")}{" "}
//                             {showAllTSDetails
//                               ? sortedTS.length
//                               : Math.min(lastRecordIndexAllTSData, sortedTS.length)}{" "}
//                             {t("of")} {sortedTS.length} {t("entries")}
//                           </p>

//                           <div style={{ display: "flex", alignItems: "center", gap: "10px", fontSize: "18px" }}>

//                             <button
//                               type="button"
//                               onClick={() => {
//                                 setShowAllTSDetails(!showAllTSDetails);
//                                 setCurrentPageAllTSData(1);
//                               }}
//                               style={{
//                                 border: "none",
//                                 outline: "none",
//                                 cursor: "pointer",
//                                 padding: "8px 16px",
//                                 borderRadius: "20px",
//                                 fontSize: "18px",
//                                 fontWeight: "600",
//                                 color: "#fff",
//                                 background: showAllTSDetails
//                                   ? "linear-gradient(135deg, #28a745, #20c997)"
//                                   : "linear-gradient(135deg, #0067ab, #0098d5)",
//                                 boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
//                               }}
//                             >
//                               {showAllTSDetails ? "✓ Showing All" : "View All"}
//                             </button>

//                             {!showAllTSDetails && (
//                               <GooglePagination
//                                 currentPage={currentPageAllTSData}
//                                 totalPages={totalPagesAllTSData}
//                                 onPageChange={setCurrentPageAllTSData}
//                               />
//                             )}

//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//             </>
//           )
//         }

//         {/* Technical S Page 2 after Clicking MHUID clicking */}
//         {
//           selectedYear &&
//           showspecific === 111 &&
//           (
//             <>

//               <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
//                 <div className="col-11 m-auto">
//                   <div className='col-12' >

//                     <div className="col-12">
//                       <button className='btn btn-danger px-3 rounded-4 mb-3 mt-3' onClick={() => setShowSpecific(110)}>{t("Back")}</button>
//                     </div>

//                     <div className="col-11 my-0 mx-auto">
//                       <div className="row">
//                         <div className="col-12 py-2 d-flex justify-content-left align-items-center">

//                           <h5 className="my-auto fw-bold d-flex align-items-center">
//                             <img src="/GR-Approval64.png" alt="" style={{ width: "24px", height: "24px" }} className="me-2" />
//                             <span>
//                               {t("ALL Progress Details of ")} {MHUIDnumber} {selectedYear}
//                             </span>
//                           </h5>
//                         </div>

//                         <div className="col-12 d-flex justify-content-end mt-3 mb-3 gap-2">
//                           <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("ProgressTableData", "ProgressTableData.xlsx")}>{t("Download Excel")}</button>
//                           <button className='btn btn-danger px-4' onClick={() => downloadTableOnlyAsPDF('ProgressTableData', `ProgressTableData_${selectedYear}.pdf`, `Progress Details Data ${selectedYear}`)}>{t("Download Pdf")}</button>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="col-12 pb-5">
//                       <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>

//                         <div
//                           className="col-12 tableDesign DistrictTableContianerModel2"
//                           style={{ background: "#2C78DB", overflowX: "scroll" }}
//                         >
//                           <table
//                             className="m-0 p-0 ProgressTableData"
//                             style={{ width: "100%", borderCollapse: "collapse" }}
//                           >
//                             <thead>
//                               <tr
//                                 style={{
//                                   color: "white",
//                                   border: "none",
//                                   height: "3rem",
//                                   fontSize: "18px",
//                                 }}
//                               >
//                                 <th style={{ padding: "7px 10px", minWidth: "60px", fontSize: "18px" }}>Sr.No.</th>
//                                 {/* <th style={{ padding: "7px 10px", minWidth: "160px" }}>Common WorkOrder ID</th> */}


//                                 <th style={{ padding: "7px 10px", minWidth: "200px", fontSize: "18px" }}>Head Code</th>
//                                 <th style={{ padding: "7px 10px", minWidth: "150px", fontSize: "18px" }}>Proposal Year</th>
//                                 <th style={{ padding: "7px 10px", minWidth: "150px", fontSize: "18px" }}>MH UID</th>
//                                 <th style={{ padding: "7px 10px", minWidth: "180px", fontSize: "18px" }}>Work Name</th>
//                                 <th style={{ padding: "7px 10px", minWidth: "150px", fontSize: "18px" }}>District</th>
//                                 <th style={{ padding: "7px 10px", minWidth: "150px", fontSize: "18px" }}>Taluka</th>
//                                 <th style={{ padding: "7px 10px", minWidth: "150px", fontSize: "18px" }}>Physical Progress (%)</th>
//                                 <th style={{ padding: "7px 10px", minWidth: "220px", fontSize: "18px" }}>File Upload</th>
//                                 <th style={{ padding: "7px 10px", minWidth: "150px", fontSize: "18px" }}>Date</th>
//                                 <th style={{ padding: "7px 10px", minWidth: "180px", fontSize: "18px" }}>Remark</th>
//                                 <th style={{ padding: "7px 10px", minWidth: "180px", fontSize: "18px" }}>Approval 1</th>
//                                 <th style={{ padding: "7px 10px", minWidth: "180px", fontSize: "18px" }}>Approval 2</th>

//                               </tr>
//                             </thead>

//                             <tbody>
//                               {FilterDataOfMHUID?.length === 0 ? (
//                                 <tr>
//                                   <td
//                                     colSpan="16"
//                                     style={{
//                                       textAlign: "center",
//                                       padding: "20px",
//                                       backgroundColor: "#f9f9f9",
//                                     }}
//                                   >
//                                     No data available
//                                   </td>
//                                 </tr>
//                               ) : (
//                                 currentProgressData?.map((proposal, index) => {
//                                   const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                   const statusBox = (value) => {
//                                     if (value === "true") {
//                                       return (
//                                         <div
//                                           className="m-auto"
//                                           style={{
//                                             width: "20px",
//                                             height: "20px",
//                                             borderRadius: "6px",
//                                             backgroundColor: "#16C60C",
//                                             display: "flex",
//                                             justifyContent: "center",
//                                             alignItems: "center",
//                                             color: "white",
//                                             fontWeight: "bold",
//                                           }}
//                                         >
//                                           ✓
//                                         </div>
//                                       );
//                                     } else if (value === "false") {
//                                       return (
//                                         <div
//                                           className="m-auto"
//                                           style={{
//                                             width: "20px",
//                                             height: "20px",
//                                             borderRadius: "6px",
//                                             backgroundColor: "#dc2626",
//                                             display: "flex",
//                                             justifyContent: "center",
//                                             alignItems: "center",
//                                             color: "white",
//                                             fontWeight: "bold",
//                                           }}
//                                         >
//                                           ✕
//                                         </div>
//                                       );
//                                     } else {
//                                       return "-";
//                                     }
//                                   };

//                                   return (
//                                     <tr style={{ backgroundColor: bgColor }} key={index}>
//                                       <td style={{ padding: "8px", fontSize: "18px" }}>
//                                         {firstRecordIndexProgress + index + 1}
//                                       </td>
//                                       {/* <td style={{ padding: "8px" }}>
//                                                                {proposal.CommonWorkOrderID || "-"}
//                                                              </td> */}


//                                       <td style={{ padding: "8px", fontSize: "18px" }}>
//                                         {proposal.Head_Code || "-"}
//                                       </td>
//                                       <td style={{ padding: "8px", fontSize: "18px" }}>
//                                         {proposal.ProposalYear || "-"}
//                                       </td>
//                                       <td style={{ padding: "8px", fontSize: "18px" }}>
//                                         {proposal.TechnicalUID || "-"}
//                                       </td>
//                                       <td style={{ padding: "8px", fontSize: "18px" }}>
//                                         {proposal.WorkOrderNo || "-"}
//                                       </td>
//                                       <td style={{ padding: "8px", fontSize: "18px" }}>
//                                         {proposal.District || "-"}
//                                       </td>
//                                       <td style={{ padding: "8px", fontSize: "18px" }}>
//                                         {proposal.Taluka || "-"}
//                                       </td>
//                                       <td style={{ padding: "8px", fontSize: "18px" }}>
//                                         {proposal.physicalValue || "0"}
//                                       </td>

//                                       <td style={{ padding: "8px", fontSize: "18px" }}>
//                                         {proposal.Upload ? (
//                                           (() => {
//                                             let files = [];

//                                             try {
//                                               // Case 1: JSON array string
//                                               files = Array.isArray(proposal.Upload)
//                                                 ? proposal.Upload
//                                                 : JSON.parse(proposal.Upload);
//                                             } catch (e) {
//                                               // Case 2: comma-separated string OR single file
//                                               files = proposal.Upload.split(",").map(f => f.trim());
//                                             }

//                                             return files.map((file, index) => (
//                                               <span key={index}>
//                                                 <a
//                                                   href={`${apiurl}/UploadProgressDocsImages/${file}`}
//                                                   target="_blank"
//                                                   rel="noreferrer"
//                                                   style={{ color: "#0d6efd", textDecoration: "underline" }}
//                                                 >
//                                                   {file}
//                                                 </a>
//                                                 {index !== files.length - 1 && ", "}
//                                               </span>
//                                             ));
//                                           })()
//                                         ) : (
//                                           <span className="text-danger fw-bold">No File</span>
//                                         )}
//                                       </td>

//                                       <td style={{ padding: "8px", fontSize: "18px" }}>
//                                         {proposal.Date
//                                           ? new Date(proposal.Date).toLocaleString()
//                                           : "-"}
//                                       </td>
//                                       <td style={{ padding: "8px", fontSize: "18px" }}>
//                                         {proposal.Remark || "-"}
//                                       </td>
//                                       <td style={{ padding: "8px", textAlign: "center", fontSize: "18px" }}>
//                                         {statusBox(proposal.Approvance1)}
//                                       </td>
//                                       <td style={{ padding: "8px", textAlign: "center", fontSize: "18px" }}>
//                                         {statusBox(proposal.Approvance2)}
//                                       </td>

//                                     </tr>
//                                   );
//                                 })
//                               )}
//                             </tbody>
//                           </table>
//                         </div>

//                         <div className='col-12 mt-3 mb-2'>
//                           <div className="row">

//                             <div className='col-6'>
//                               <p className="text-gray-600" style={{ fontSize: "18px" }}>
//                                 {t("Showing")} {firstRecordIndexProgress + 1} {t("to")}{" "}
//                                 {Math.min(lastRecordIndexProgress, FilterDataOfMHUID?.length || 0)}{" "}
//                                 {t("of")} {FilterDataOfMHUID?.length || 0} {t("entries")}
//                               </p>
//                             </div>

//                             <div className='col-6 text-end'>
//                               <GooglePagination
//                                 currentPage={currentPageProgress}
//                                 totalPages={totalProgressPages}
//                                 onPageChange={setCurrentPageProgress}
//                               />
//                             </div>

//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//             </>
//           )
//         }

//         {/* Series for Part 5 for Total TS created */}
//         {
//           districtDRSummary.length > 0 &&
//           showspecific === 112 &&
//           (
//             <>

//               <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
//                 <div className="col-11 m-auto">
//                   <div className='col-12' >

//                     <div className="col-12">
//                       <button className='btn btn-danger px-3 rounded-4 mb-3 mt-3' onClick={() => setShowSpecific(0)}>{t("Back")}</button>
//                     </div>

//                     <div className="col-11 my-0 mx-auto">
//                       <div className="row">
//                         <div className="col-12 py-2 d-flex justify-content-left align-items-center">

//                           <h5 className="my-auto fw-bold d-flex align-items-center">
//                             <img
//                               src="/GR-Approval64.png"
//                               alt=""
//                               style={{ width: "24px", height: "24px" }}
//                               className="me-2"
//                             />
//                             <span>
//                               {t("Demand Request created in the Year")} {selectedYear}
//                             </span>
//                           </h5>
//                         </div>

//                         {/* <div className="col-12 d-flex justify-content-end mt-3 mb-3 gap-2">
//                           <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("ALlDistrictFinanceData", "AllDistrictReleaseData.xlsx")}>{t("Download Excel")}</button>
//                           <button className='btn btn-danger px-4' onClick={() => downloadPageAsPDF('ALlDistrictFinanceData', `ALlDistrictFinanceData_${selectedYear}.pdf`, `ALlDistrict Finance Data ${selectedYear}`)}>{t("Download Pdf")}</button>
//                         </div> */}
//                       </div>
//                     </div>
//                     <div className="col-12 pb-5">
//                       <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>

//                         <div className='col-12 tableDesign DistrictTableContianerModel2' style={{ background: '#2C78DB', overflowX: 'auto' }}>
//                           <table className='m-0 py-0 ALlDistrictFinanceData' style={{ width: '100%', borderCollapse: 'collapse' }}>
//                             <thead>
//                               <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
//                                 <th style={{ width: "10%" }}>{t("Sr No")}</th>
//                                 <th style={{ minWidth: "250px", padding: "8px" }}>{t("District")}</th>
//                                 <th style={{ minWidth: "250px", padding: "8px" }}>{t("Year")}</th>
//                                 <th style={{ minWidth: "250px", padding: "8px" }}>{t("Total Demand")}</th>
//                                 <th style={{ minWidth: "250px", padding: "8px" }}>{t("Gross Amount")}</th>
//                               </tr>
//                             </thead>

//                             <tbody>
//                               {
//                                 districtDRSummary &&
//                                   districtDRSummary.length > 0 ?
//                                   (() => {
//                                     const totaltscount = districtDRSummary.reduce((sum, val) => sum + parseFloat(val.TotalDemand || 0), 0);
//                                     const totaltsamount = districtDRSummary.reduce((sum, val) => sum + parseFloat(val.TotalAmount || 0), 0);

//                                     return (
//                                       <>
//                                         {
//                                           districtDRSummary.map((item, idx) => {
//                                             const bgColor = idx % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                             return (
//                                               <tr key={idx} style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "400" }}>
//                                                 <td>{idx + 1}</td>
//                                                 <td><a
//                                                   href="#"
//                                                   className='my-auto'
//                                                   style={{ color: '#4f46e5', textDecoration: 'underline' }}
//                                                   onClick={(e) => {
//                                                     e.preventDefault();
//                                                     showDistrictDR(item.District);
//                                                   }}
//                                                 >
//                                                   {item.District}
//                                                 </a></td>
//                                                 <td>{selectedYear}</td>
//                                                 <td>{item.TotalDemand}</td>
//                                                 <td>
//                                                   ₹ {Number(item.TotalAmount).toLocaleString("en-IN")}
//                                                 </td>
//                                               </tr>
//                                             );
//                                           })
//                                         }

//                                         <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0', textAlign: "right" }}>
//                                           <td colSpan={3}>{t("Gross Total")}</td>
//                                           <td>{Number(totaltscount).toLocaleString("en-IN")}</td>
//                                           <td>₹ {Number(totaltsamount).toLocaleString("en-IN")}</td>
//                                         </tr>
//                                       </>
//                                     );
//                                   })()
//                                   :
//                                   (
//                                     <tr>
//                                       <td colSpan={5} className='fw-bold'>{t("No data found")}</td>
//                                     </tr>
//                                   )
//                               }
//                             </tbody>

//                           </table>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//             </>
//           )
//         }

//         {/* this is all demandgeneration data  */}
//         {
//           selectedYear &&
//           showspecific === 113 &&
//           (
//             <>

//               <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
//                 <div className="col-11 m-auto">
//                   <div className='col-12' >

//                     <div className="col-12">
//                       <button className='btn btn-danger px-3 rounded-4 mb-3 mt-3' onClick={() => {
//                         setShowSpecific(112)
//                         setFilteredDRData([]);
//                       }}>{t("Back")}</button>
//                     </div>

//                     <div className="col-11 my-0 mx-auto">
//                       <div className="row">
//                         <div className="col-12 py-2 d-flex justify-content-left align-items-center">

//                           <h5 className="my-auto fw-bold d-flex align-items-center">
//                             <img src="/GR-Approval64.png" alt="" style={{ width: "24px", height: "24px" }} className="me-2" />
//                             <span>
//                               {t("ALL Demand Generated Details of ")} {selectedYear}
//                             </span>
//                           </h5>
//                         </div>

//                         <div className="col-12 d-flex justify-content-end mt-3 mb-3 gap-2">
//                           <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("DemandGeneratedData", "DemandGeneratedData.xlsx")}>{t("Download Excel")}</button>
//                           <button className='btn btn-danger px-4' onClick={() => downloadTableOnlyAsPDF('DemandGeneratedData', `DemandGeneratedData_${selectedYear}.pdf`, `Demand Generated Data ${selectedYear}`)}>{t("Download Pdf")}</button>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="col-12 pb-5">
//                       <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>

//                         <div className='col-12 tableDesign DistrictTableContianerModel2' style={{ background: '#2C78DB', overflowX: 'scroll' }}>
//                           <table className='m-0 p-0 DemandGeneratedData' style={{ width: '100%', borderCollapse: 'collapse' }}>
//                             <thead>
//                               <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
//                                 <th style={{ minWidth: "50px", padding: "8px" }} rowSpan={2} colSpan={1}>Sr.No.</th>
//                                 <th style={{ minWidth: "100px", padding: "8px" }} rowSpan={2} colSpan={1}>Financial Year</th>
//                                 <th style={{ minWidth: "180px", padding: "8px" }} rowSpan={2} colSpan={1}>Head Code</th>
//                                 <th style={{ minWidth: "160px", padding: "8px" }} rowSpan={2} colSpan={1}>Work Name</th>
//                                 <th style={{ minWidth: "120px", padding: "8px" }} rowSpan={2} colSpan={1}>MHUID Number</th>
//                                 <th style={{ minWidth: "120px", padding: "8px" }} rowSpan={2} colSpan={1}>Physical Progress (%)</th>
//                                 <th style={{ minWidth: "80px", padding: "8px" }} rowSpan={2} colSpan={1}>District</th>
//                                 <th style={{ minWidth: "100px", padding: "8px" }} rowSpan={2} colSpan={1}>Expenditure Amount</th>
//                                 <th style={{ minWidth: "150px", padding: "8px" }} rowSpan={2} colSpan={1}>Approved Demand Request Amount</th>
//                                 <th style={{ minWidth: "150px", padding: "8px" }} rowSpan={2} colSpan={1}>Available Work Order Amount</th>
//                                 <th style={{ minWidth: "150px", padding: "8px" }} rowSpan={2} colSpan={1}>Available Amount for Demand Request</th>
//                                 <th style={{ minWidth: "100px", padding: "8px" }} rowSpan={2} colSpan={1}>Date</th>
//                                 <th style={{ minWidth: "150px", padding: "8px" }} colSpan={2}>Approved by</th>
//                               </tr>
//                               <tr style={{ color: 'white', border: 'none', height: '3rem' }}>
//                                 <th style={{ minWidth: "80px", padding: "8px" }}>District Department Maker</th>
//                                 <th style={{ minWidth: "80px", padding: "8px" }}>Department HOD(EE)</th>
//                               </tr>
//                             </thead>

//                             <tbody >
//                               {currentDRtableData?.length === 0 ? (
//                                 <tr>
//                                   <td colSpan="10" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
//                                     No data available
//                                   </td>
//                                 </tr>
//                               ) : (
//                                 [...currentDRtableData]
//                                   .sort((a, b) =>
//                                     new Date(b.created_At || 0) - new Date(a.created_At || 0)
//                                   ) // newest first
//                                   .map((proposal, index) => {
//                                     const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                     return (
//                                       <tr style={{ backgroundColor: bgColor }} key={index}>
//                                         <td style={{ padding: '8px 8px' }}>{firstRecordIndexDRtableData + index + 1}</td>
//                                         <td style={{ padding: '8px 8px' }}>{proposal.Year}</td>
//                                         <td style={{ padding: '8px 8px' }}>{proposal.HeadCode}</td>
//                                         <td style={{ padding: '8px 8px' }}>{proposal.ProposalWorkName}</td>
//                                         <td style={{ padding: '8px 8px' }}>{proposal.MHUID}</td>
//                                         <td style={{ padding: '8px 8px' }}>{proposal.physicalValue}</td>
//                                         <td style={{ padding: '8px 8px' }}>{proposal.District}</td>
//                                         <td style={{ padding: '8px 8px' }}>{proposal.ExpenditureAmount}</td>
//                                         <td style={{ padding: '8px 8px' }}>{proposal.ApprovedDemandRequest}</td>
//                                         <td style={{ padding: '8px 8px' }}>{proposal.AvailableWorkOrderAmount}</td>
//                                         <td style={{ padding: '8px 8px' }}>{proposal.AvailableAmountForDemandRequest}</td>
//                                         <td style={{ padding: '8px 8px' }}>{new Date(proposal.created_At).toLocaleString("en-IN")}</td>
//                                         <td style={{ padding: '8px 8px' }}>
//                                           {proposal.Approvance1 === 'true' ? (
//                                             <div className='m-auto'
//                                               style={{
//                                                 width: '20px',
//                                                 height: '20px',
//                                                 borderRadius: '6px',
//                                                 backgroundColor: '#16C60C',
//                                                 border: 'none',
//                                                 display: 'flex',
//                                                 justifyContent: 'center',
//                                                 alignItems: 'center',
//                                                 fontSize: '13px',
//                                                 color: 'white',
//                                                 boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                               }}
//                                             >
//                                               ✓
//                                             </div>
//                                           ) : proposal.Approvance1 === 'false' ? (
//                                             <div
//                                               className='m-auto'
//                                               style={{
//                                                 width: '20px',
//                                                 height: '20px',
//                                                 borderRadius: '6px',
//                                                 backgroundColor: '#dc2626',
//                                                 border: 'none',
//                                                 display: 'flex',
//                                                 justifyContent: 'center',
//                                                 alignItems: 'center',
//                                                 fontSize: '13px',
//                                                 color: 'white',
//                                                 boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                               }}
//                                             >
//                                               ✕
//                                             </div>
//                                           ) : '-'}
//                                         </td>
//                                         <td style={{ padding: '8px 8px' }}>
//                                           {proposal.Approvance2 === 'true' ? (<div className='m-auto'
//                                             style={{
//                                               width: '20px',
//                                               height: '20px',
//                                               borderRadius: '6px',
//                                               backgroundColor: '#16C60C',
//                                               border: 'none',
//                                               display: 'flex',
//                                               justifyContent: 'center',
//                                               alignItems: 'center',
//                                               fontSize: '13px',
//                                               color: 'white',
//                                               boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                             }}
//                                           >
//                                             ✓
//                                           </div>) : proposal.Approvance2 === 'false' ? (<div
//                                             className='m-auto'
//                                             style={{
//                                               width: '20px',
//                                               height: '20px',
//                                               borderRadius: '6px',
//                                               backgroundColor: '#dc2626',
//                                               border: 'none',
//                                               display: 'flex',
//                                               justifyContent: 'center',
//                                               alignItems: 'center',
//                                               fontSize: '13px',
//                                               color: 'white',
//                                               boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                             }}
//                                           >
//                                             ✕
//                                           </div>) : '-'}
//                                         </td>
//                                       </tr>

//                                     );
//                                   })
//                               )}
//                             </tbody>
//                           </table>
//                         </div>
//                         <div className='col-12 mt-4 mb-2'>
//                           <div className="row">
//                             <div className='col-6'>
//                               <p className="text-gray-600" style={{ fontSize: "14px" }}>{t("Showing")} {firstRecordIndexDRtableData + 1} {t("to")} {Math.min(lastRecordIndexDRtableData, totalRecordsDRtableData)} {t("of")} {totalRecordsDRtableData} {t("entries")}</p>
//                             </div>
//                             <div className='col-6' style={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
//                               <button onClick={() => setCurrentPageDRtableData(1)} disabled={currentPageDRtableData === 1}
//                                 style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', width: '2rem' }}>&laquo;</button>
//                               <button onClick={() => setCurrentPageDRtableData(currentPageDRtableData - 1)} disabled={currentPageDRtableData === 1}
//                                 style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>&lt;</button>
//                               <button
//                                 style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '20px', width: '2.4rem', border: '1px solid lightgrey', borderLeft: "none" }}>
//                                 {currentPageDRtableData}
//                               </button>
//                               <button onClick={() => setCurrentPageDRtableData(currentPageDRtableData + 1)} disabled={currentPageDRtableData === totalPagesDRtableData || totalPagesDRtableData === 0}
//                                 style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>&gt;</button>
//                               <button onClick={() => setCurrentPageDRtableData(totalPagesDRtableData)} disabled={currentPageDRtableData === totalPagesDRtableData || totalPagesDRtableData === 0}
//                                 style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>&raquo;</button>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//             </>
//           )
//         }

//         {/* Series for Part 6 for Total WO created */}
//         {
//           districtWOSummary.length > 0 &&
//           showspecific === 115 &&
//           (
//             <>

//               <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
//                 <div className="col-11 m-auto">
//                   <div className='col-12' >

//                     <div className="col-12">
//                       <button
//                         className="btn btn-danger px-3 rounded-4 mb-3 mt-3"
//                         onClick={() => {
//                           // Go back
//                           setShowSpecific(0);

//                           // Reset Work Order filters
//                           setSelectedWODistrict("");
//                           setSearchWO("");

//                           // Reset pagination
//                           setDistrictWOPage(1);

//                           // Reset View All
//                           setShowAllDistrictWO(false);
//                         }}
//                       >
//                         {t("Back")}
//                       </button>
//                     </div>

//                     <div className="col-11 my-0 mx-auto">
//                       <div className="row">
//                         <div className="col-12 py-2 d-flex justify-content-left align-items-center">

//                           <h5 className="my-auto fw-bold d-flex align-items-center">
//                             <img
//                               src="/GR-Approval64.png"
//                               alt=""
//                               style={{ width: "24px", height: "24px" }}
//                               className="me-2"
//                             />
//                             <span>
//                               {t("Total Work Order created in the Year")} {selectedYear}
//                             </span>
//                           </h5>
//                         </div>

//                         {/* <div className="col-12 d-flex justify-content-end mt-3 mb-3 gap-2">
//                           <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("ALlDistrictFinanceData", "AllDistrictReleaseData.xlsx")}>{t("Download Excel")}</button>
//                           <button className='btn btn-danger px-4' onClick={() => downloadPageAsPDF('ALlDistrictFinanceData', `ALlDistrictFinanceData_${selectedYear}.pdf`, `ALlDistrict Finance Data ${selectedYear}`)}>{t("Download Pdf")}</button>
//                         </div> */}
//                                                 <div className="col-12 d-flex justify-content-end mt-3 mb-3 gap-2">
//   <button
//     className="btn btn-success px-4"
//     onClick={() =>
//       exportTableByClassToExcel(
//         "ALlDistrictFinanceData",
//         `WorkOrder_Summary_${selectedYear}.xlsx`
//       )
//     }
//   >
//     {t("Download Excel")}
//   </button>

//   <button
//     className="btn btn-danger px-4"
//     onClick={() =>
//       downloadTableOnlyAsPDF(
//         "ALlDistrictFinanceData",
//         `WorkOrder_Summary_${selectedYear}.pdf`,
//         `Total Work Order created in the Year ${selectedYear}`
//       )
//     }
//   >
//     {t("Download PDF")}
//   </button>
// </div>
//                       </div>
//                     </div>
//                     {/* Work Order Filters */}
//                     <div
//                       className="d-flex justify-content-end align-items-center mb-3"
//                       style={{
//                         gap: "10px",
//                         flexWrap: "wrap",
//                       }}
//                     >

//                       {/* District Filter - State Login Only */}
//                       {userData?.Department_Name === "State" && (
//                         <select
//                           className="form-select"
//                           value={selectedWODistrict}
//                           onChange={(e) => {
//                             setSelectedWODistrict(e.target.value);
//                             setDistrictWOPage(1);
//                             setShowAllDistrictWO(false);
//                           }}
//                           style={{
//                             width: "220px",
//                             fontSize: "14px",
//                           }}
//                         >
//                           <option value="">All Districts</option>

//                           {[...new Set(
//                             districtWOSummary
//                               .map((item) => getMainDistrict(item.District))
//                               .filter(Boolean)
//                           )]
//                             .sort()
//                             .map((district, index) => (
//                               <option key={index} value={district}>
//                                 {district}
//                               </option>
//                             ))}
//                         </select>
//                       )}

//                       {/* Random Search - Always Visible */}
//                       <input
//                         type="text"
//                         className="form-control"
//                         placeholder="Search anything..."
//                         value={searchWO}
//                         onChange={(e) => {
//                           setSearchWO(e.target.value);
//                           setDistrictWOPage(1);
//                           setShowAllDistrictWO(false);
//                         }}
//                         style={{
//                           width: "250px",
//                           fontSize: "14px",
//                         }}
//                       />

//                     </div>
//                     <div className="col-12 pb-5">
//                       <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>

//                         <div className='col-12 tableDesign DistrictTableContianerModel2' style={{
//                           background: '#2C78DB', overflowX: "auto",
//                           overflowY: "auto",
//                           maxHeight: "600px", // change height as needed
//                           position: "relative",
//                         }}>
//                           <table className='m-0 py-0 ALlDistrictFinanceData' style={{ width: '100%', borderCollapse: 'collapse' }}>
//                             <thead style={{
//                               position: "sticky", backgroundColor: "#1976d2",
//                               top: 0,
//                               zIndex: 10,
//                             }}>
//                               <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
//                                 <th style={{ width: "10%" }}>{t("Sr No")}</th>
//                                 <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("District")}</th>
//                                 <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("Year")}</th>
//                                 <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("Total Work Orders")}</th>
//                                 <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("Total Approved Amount")}</th>
//                               </tr>
//                             </thead>

//                             <tbody>
//                               {
//                                 districtWOSummary &&
//                                   districtWOSummary.length > 0 ?
//                                   (() => {
//                                     const pageTotalWOCount = paginatedWOData.reduce(
//                                       (sum, val) => sum + parseFloat(val.TotalWO || 0),
//                                       0
//                                     );

//                                     const pageTotalWOAmount = paginatedWOData.reduce(
//                                       (sum, val) => sum + parseFloat(val.TotalAmount || 0),
//                                       0
//                                     );

//                                     const grandTotalWOCount = filteredDistrictWOSummary.reduce(
//                                       (sum, val) => sum + parseFloat(val.TotalWO || 0),
//                                       0
//                                     );

//                                     const grandTotalWOAmount = filteredDistrictWOSummary.reduce(
//                                       (sum, val) => sum + parseFloat(val.TotalAmount || 0),
//                                       0
//                                     );

//                                     return (
//                                       <>
//                                         {
//                                           paginatedWOData.map((item, idx) => {
//                                             const bgColor = idx % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                             return (
//                                               <tr key={idx} style={{ backgroundColor: bgColor, fontSize: "18px", fontWeight: "400" }}>
//                                                 <td style={{ fontSize: "18px" }}>{((districtWOPage - 1) * woRecordsPerPage) + idx + 1}</td>
//                                                 <td style={{ fontSize: "18px" }}><a
//                                                   href="#"
//                                                   className='my-auto'
//                                                   style={{ color: '#4f46e5', textDecoration: 'underline' }}
//                                                   onClick={(e) => {
//                                                     e.preventDefault();
//                                                     showDistrictWO(item.District);
//                                                   }}
//                                                 >
//                                                   {item.District}
//                                                 </a></td>
//                                                 <td style={{ fontSize: "18px" }}>{selectedYear}</td>
//                                                 <td style={{ fontSize: "18px" }}>{item.TotalWO}</td>
//                                                 <td style={{ fontSize: "18px" }}>
//                                                   ₹ {Number(item.TotalAmount).toLocaleString("en-IN")}
//                                                 </td>
//                                               </tr>
//                                             );
//                                           })
//                                         }

//                                         {/* Page Total */}
//                                         <tr
//                                           style={{
//                                             fontWeight: "bold",
//                                             backgroundColor: "#f0f0f0",
//                                             fontSize: "18px"
//                                           }}
//                                         >
//                                           <td colSpan={3} style={{
//                                             fontSize: "18px", textAlign: "right"
//                                           }}>
//                                             {t("Page Total")}
//                                           </td>

//                                           <td style={{
//                                             fontSize: "18px"
//                                           }}>
//                                             {Number(pageTotalWOCount).toLocaleString("en-IN")}
//                                           </td>

//                                           <td style={{
//                                             fontSize: "18px"
//                                           }}>
//                                             ₹ {Number(pageTotalWOAmount).toLocaleString("en-IN")}
//                                           </td>
//                                         </tr>

//                                         {/* Grand Total */}
//                                         <tr
//                                           style={{
//                                             fontWeight: "bold",
//                                             backgroundColor: "#e0e0e0",
//                                             fontSize: "18px"
//                                           }}
//                                         >
//                                           <td colSpan={3} style={{
//                                             fontSize: "18px", textAlign: "right"
//                                           }}>
//                                             {t("Gross Total")}
//                                           </td>

//                                           <td style={{
//                                             fontSize: "18px"
//                                           }}>
//                                             {Number(grandTotalWOCount).toLocaleString("en-IN")}
//                                           </td>

//                                           <td style={{
//                                             fontSize: "18px"
//                                           }}>
//                                             ₹ {Number(grandTotalWOAmount).toLocaleString("en-IN")}
//                                           </td>
//                                         </tr>
//                                       </>
//                                     );
//                                   })()
//                                   :
//                                   (
//                                     <tr>
//                                       <td colSpan={5} className='fw-bold' style={{
//                                         fontSize: "18px"
//                                       }}>{t("No data found")}</td>
//                                     </tr>
//                                   )
//                               }
//                             </tbody>

//                           </table>
//                         </div>
//                         <div className='col-12 mt-3 mb-2'>
//                           <div className="row">

//                             <div className='col-6'>
//                               <p className="text-gray-600" style={{ fontSize: "18px" }}>
//                                 {t("Showing")}{" "}
//                                 {filteredDistrictWOSummary.length > 0
//                                   ? (districtWOPage - 1) * woRecordsPerPage + 1
//                                   : 0}{" "}
//                                 {t("to")}{" "}
//                                 {Math.min(
//                                   districtWOPage * woRecordsPerPage,
//                                   filteredDistrictWOSummary.length
//                                 )}{" "}
//                                 {t("of")}{" "}
//                                 {filteredDistrictWOSummary.length}{" "}
//                                 {t("entries")}
//                               </p>
//                             </div>

//                             <div className='col-6 text-end'>
//                               <GooglePagination
//                                 currentPage={districtWOPage}
//                                 totalPages={totalWOPages}
//                                 onPageChange={setDistrictWOPage}
//                               />
//                             </div>

//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//             </>
//           )
//         }

//         {/* this is for work order created */}
//         {
//           selectedYear &&
//           showspecific === 114 &&
//           (
//             <>

//               <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
//                 <div className="col-11 m-auto">
//                   <div className='col-12' >

//                     <div className="col-12">
//                       <button
//                         className="btn btn-danger px-3 rounded-4 mb-3 mt-3"
//                         onClick={() => {
//                           // Go back
//                           setShowSpecific(115);

//                           // Reset HeadCode filter
//                           setSelectedWOHeadCode("");

//                           // Reset random search
//                           setSearchWorkOrder("");

//                           // Clear previous Work Order filtered data
//                           setFilteredWOData([]);

//                           // Reset pagination
//                           setCurrentPageWorkOrderData(1);
//                         }}
//                       >
//                         {t("Back")}
//                       </button>
//                     </div>

//                     <div className="col-11 my-0 mx-auto">
//                       <div className="row">
//                         <div className="col-12 py-2 d-flex justify-content-left align-items-center">

//                           <h5 className="my-auto fw-bold d-flex align-items-center">
//                             <img src="/GR-Approval64.png" alt="" style={{ width: "24px", height: "24px" }} className="me-2" />
//                             <span>
//                               {t("ALL Work Order Generated of ")} {selectedYear}
//                             </span>
//                           </h5>
//                         </div>

//                         <div className="col-12 d-flex justify-content-end mt-3 mb-3 gap-2">
//                           <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("WorkOrderData", "WorkOrderData.xlsx")}>{t("Download Excel")}</button>
//                           <button className='btn btn-danger px-4' onClick={() => downloadTableOnlyAsPDF('WorkOrderData', `WorkOrderData_${selectedYear}.pdf`, `Work Order Data ${selectedYear}`)}>{t("Download Pdf")}</button>
//                         </div>
//                       </div>
//                     </div>
//                     {/* Work Order Filters */}
//                     <div
//                       className="d-flex justify-content-end align-items-center mb-3"
//                       style={{
//                         gap: "10px",
//                         flexWrap: "wrap",
//                       }}
//                     >
//                       {/* HeadCode - Non-State users only */}
//                       {userData?.Department_Name !== "State" && (
//                         <select
//                           className="form-select"
//                           value={selectedWOHeadCode}
//                           onChange={(e) => {
//                             setSelectedWOHeadCode(e.target.value);
//                             setCurrentPageWorkOrderData(1);
//                           }}
//                           style={{
//                             width: "250px",
//                             fontSize: "14px",
//                           }}
//                         >
//                           <option value="">All Head Codes</option>

//                           {[...new Set(
//                             activeWOData
//                               .map((item) => item.HeadCode)
//                               .filter(Boolean)
//                           )]
//                             .sort()
//                             .map((headCode, index) => (
//                               <option key={index} value={headCode}>
//                                 {headCode}
//                               </option>
//                             ))}
//                         </select>
//                       )}

//                       {/* Random Search - Always visible */}
//                       <input
//                         type="text"
//                         className="form-control"
//                         placeholder="Search anything..."
//                         value={searchWorkOrder}
//                         onChange={(e) => {
//                           setSearchWorkOrder(e.target.value);
//                           setCurrentPageWorkOrderData(1);
//                         }}
//                         style={{
//                           width: "250px",
//                           fontSize: "14px",
//                         }}
//                       />
//                     </div>
//                     <div className="col-12 pb-5">
//                       <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "150%", overflowX: "hidden" }}>

//                         <div className='col-12 tableDesign DistrictTableContianerModel2' style={{
//                           background: '#2C78DB', overflowX: "auto",
//                           overflowY: "auto",
//                           maxHeight: "600px", // change height as needed
//                           position: "relative",
//                         }}>
//                           <table className='m-0 p-0 WorkOrderData' style={{ width: '100%', borderCollapse: 'collapse' }}>
//                             <thead style={{
//                               position: "sticky", backgroundColor: "#1976d2",
//                               top: 0,
//                               zIndex: 10,
//                             }}>
//                               <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
//                                 <th style={{ minWidth: "50px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Sr.No.</th>
//                                 <th style={{ minWidth: "160px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Work Order UID</th>
//                                 <th style={{ minWidth: "160px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Work Order Number</th>
//                                 <th style={{ minWidth: "160px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Work Order Name</th>
//                                 <th style={{ minWidth: "160px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Head Code</th>
//                                 <th style={{ minWidth: "160px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>MH UID</th>
//                                 <th style={{ minWidth: "160px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Approved Work Name</th>
//                                 <th style={{ minWidth: "130px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Approved Year</th>
//                                 <th style={{ minWidth: "130px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>District</th>
//                                 <th style={{ minWidth: "130px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Approved Work Amount</th>
//                                 <th style={{ minWidth: "130px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Remaining Amount</th>
//                                 <th style={{ minWidth: "130px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Paid Amount</th>
//                                 <th style={{ minWidth: "160px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Work Order Date</th>
//                                 <th style={{ minWidth: "160px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Work Order End Date</th>
//                                 <th style={{ minWidth: "160px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Work Order Copy</th>
//                                 <th style={{ minWidth: "160px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Date</th>
//                                 <th style={{ minWidth: "160px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Edited By</th>


//                                 <th style={{ minWidth: "160px", padding: "8px", fontSize: "18px" }} colSpan={1}>Approved by</th> {/* changed from 9 to 7 */}

//                                 {/* <th tyle={{ minWidth: "160px", padding: "8px" }} colSpan={1} rowSpan={2}>Details</th> */}
//                               </tr>
//                               <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
//                                 {/* <th tyle={{ minWidth: "160px", padding: "8px" }}>Deputy Engineer</th> */}
//                                 <th tyle={{ minWidth: "160px", padding: "8px", fontSize: "18px" }}>Department HOD(EE)</th>
//                               </tr>
//                             </thead>

//                             <tbody >
//                               {currentWorkOrderData?.length === 0 ? (
//                                 <tr>
//                                   <td colSpan="10" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
//                                     No data available
//                                   </td>
//                                 </tr>
//                               ) : (
//                                 [...currentWorkOrderData]
//                                   .sort((a, b) =>
//                                     new Date(b.WorkOrderDate || 0) - new Date(a.WorkOrderDate || 0)
//                                   ) // newest first
//                                   .map((proposal, index) => {
//                                     const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                     return (
//                                       <tr style={{ backgroundColor: bgColor, fontSize: "18px" }} key={index}>
//                                         <td style={{ padding: '8px 8px', fontSize: "18px" }}>{firstRecordIndexWorkOrderData + index + 1}</td>
//                                         <td style={{ padding: '8px 8px', fontSize: "18px" }}>{proposal.WorkOrderID}</td>
//                                         <td style={{ padding: '8px 8px', fontSize: "18px" }}>{proposal.WorkOrderNo}</td>
//                                         <td style={{ padding: '8px 8px', fontSize: "18px" }}>{proposal.WorkName}</td>
//                                         <td style={{ padding: '8px 8px', fontSize: "18px" }}>{proposal.HeadCode}</td>
//                                         <td style={{ padding: '8px 8px', fontSize: "18px" }}>{proposal.TechnicalUID}</td>
//                                         <td style={{ padding: '8px 8px', fontSize: "18px" }}>{proposal.ProposalID}</td>
//                                         <td style={{ padding: '8px 8px', fontSize: "18px" }}>{proposal.ProposalYear}</td>
//                                         <td style={{ padding: '8px 8px', fontSize: "18px" }}>{proposal.talulka}</td>
//                                         <td style={{ padding: '8px 8px', fontSize: "18px" }}>{proposal.ApprovedWorkAmount}</td>
//                                         <td style={{ padding: '8px 8px', fontSize: "18px" }}>{proposal.BillRemainingAmount || 0}</td>
//                                         <td style={{ padding: '8px 8px', fontSize: "18px" }}>{proposal.BillPaidAmount || 0}</td>
//                                         <td style={{ padding: '8px 8px', fontSize: "18px" }}>{new Date(proposal.WorkOrderDate).toLocaleDateString("en-GB")}</td>
//                                         <td style={{ padding: '8px 8px', fontSize: "18px" }}>{new Date(proposal.WorkEndDate).toLocaleDateString("en-GB")}</td>
//                                         <td style={{ padding: '8px 8px', fontSize: "18px" }}>{
//                                           proposal.CopyofWorkOrder ? (
//                                             <a href={`${apiurl}/WorkOrderDocsImages/${proposal.CopyofWorkOrder}`} target='_blank'>{proposal.CopyofWorkOrder}
//                                             </a>
//                                           )
//                                             :
//                                             (
//                                               <p className='fw-bold text-danger my-auto'>No File</p>
//                                             )
//                                         }
//                                         </td>

//                                         <td style={{ padding: '8px 8px', fontSize: "18px" }}>{new Date(proposal.Date).toLocaleString("en-IN")}</td>
//                                         <td style={{ padding: '8px 8px', fontSize: "18px" }}>{
//                                           proposal.EditedBy ? (
//                                             <p className="text-black my-auto fw-bold">{proposal.EditedBy}</p>
//                                           ) : (
//                                             <p className="text-danger my-auto fw-bold">No One</p>
//                                           )
//                                         }</td>
//                                         <td style={{ padding: '8px', textAlign: 'center' }}>
//                                           {proposal.Approvance3 === 'true' ? (<div className='m-auto'
//                                             style={{
//                                               width: '20px',
//                                               height: '20px',
//                                               borderRadius: '6px',
//                                               backgroundColor: '#16C60C',
//                                               border: 'none',
//                                               display: 'flex',
//                                               justifyContent: 'center',
//                                               alignItems: 'center',
//                                               fontSize: '13px',
//                                               color: 'white',
//                                               boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                             }}
//                                           >
//                                             ✓
//                                           </div>) : proposal.Approvance3 === 'false' ? (<div
//                                             className='m-auto'
//                                             style={{
//                                               width: '20px',
//                                               height: '20px',
//                                               borderRadius: '6px',
//                                               backgroundColor: '#dc2626',
//                                               border: 'none',
//                                               display: 'flex',
//                                               justifyContent: 'center',
//                                               alignItems: 'center',
//                                               fontSize: '13px',
//                                               color: 'white',
//                                               boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                             }}
//                                           >
//                                             ✕
//                                           </div>) : '-'}
//                                         </td>
//                                       </tr>

//                                     );
//                                   })
//                               )}
//                               {/* Page Total */}
//                               <tr
//                                 style={{
//                                   fontWeight: "bold",
//                                   backgroundColor: "#f0f0f0",
//                                   textAlign: "right", fontSize: "18px"
//                                 }}
//                               >
//                                 <td colSpan={9} style={{ fontSize: "18px" }} >
//                                   {t("Page Total")}
//                                 </td>

//                                 <td style={{ fontSize: "18px" }}>
//                                   ₹{" "}
//                                   {Number(pageTotalWOApprovedAmount).toLocaleString("en-IN")}
//                                 </td>

//                                 <td style={{ fontSize: "18px" }}>
//                                   ₹{" "}
//                                   {Number(pageTotalWORemainingAmount).toLocaleString("en-IN")}
//                                 </td>

//                                 <td style={{ fontSize: "18px" }}>
//                                   ₹{" "}
//                                   {Number(pageTotalWOPaidAmount).toLocaleString("en-IN")}
//                                 </td>

//                                 <td colSpan={7} style={{ fontSize: "18px" }}></td>
//                               </tr>

//                               {/* Grand Total */}
//                               <tr
//                                 style={{
//                                   fontWeight: "bold",
//                                   backgroundColor: "#e0e0e0",
//                                   textAlign: "right", fontSize: "18px"
//                                 }}
//                               >
//                                 <td colSpan={9} style={{ fontSize: "18px" }}>
//                                   {t("Gross Total")}
//                                 </td>

//                                 <td style={{ fontSize: "18px" }}>
//                                   ₹{" "}
//                                   {Number(grandTotalWOApprovedAmount).toLocaleString("en-IN")}
//                                 </td>

//                                 <td style={{ fontSize: "18px" }}>
//                                   ₹{" "}
//                                   {Number(grandTotalWORemainingAmount).toLocaleString("en-IN")}
//                                 </td>

//                                 <td style={{ fontSize: "18px" }}>
//                                   ₹{" "}
//                                   {Number(grandTotalWOPaidAmount).toLocaleString("en-IN")}
//                                 </td>

//                                 <td colSpan={7}></td>
//                               </tr>
//                             </tbody>

//                           </table>
//                         </div>
//                         <div className='col-12 mt-4 mb-2'>
//                           <div className="row">
//                             <div className='col-6'>
//                               <p className="text-gray-600" style={{ fontSize: "18px" }}>{t("Showing")} {firstRecordIndexWorkOrderData + 1} {t("to")} {Math.min(lastRecordIndexWorkOrderData, totalRecordsWorkOrderData)} {t("of")} {totalRecordsWorkOrderData} {t("entries")}</p>
//                             </div>
//                             <div className='col-6 text-end'>
//                               <GooglePagination
//                                 currentPage={currentPageWorkOrderData}
//                                 totalPages={totalPagesWorkOrderData}
//                                 onPageChange={setCurrentPageWorkOrderData}
//                               />
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//             </>
//           )
//         }
//       </div>

//       {loading && (
//         <div
//           style={{
//             position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(255, 255, 255, 0.7)', backdropFilter: 'blur(4px)', zIndex: 9999,
//             display: 'flex', justifyContent: 'center', alignItems: 'center'
//           }}>
//           <div style={{ border: '6px solid #f3f3f3', borderTop: '6px solid #007bff', borderRadius: '50%', width: '60px', height: '60px', animation: 'spin 1s linear infinite' }} />
//           <style>
//             {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
//           </style>
//         </div>
//       )}
//     </>
//   );

// };

// export default MISReport;



//--> updated code

import React, { useContext, useEffect, useState, useMemo } from 'react';
import AdminContext from '../../StateContext/Application';
import "./Dashboard.css"
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import {
  PieChart, Pie, Cell, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LabelList
} from 'recharts';
import { useLanguage } from '../../../../lang/langcontext/LanguageContext';
import { apiurl } from '../../../../path';
import autoTable from "jspdf-autotable";
import { jwtDecode } from "jwt-decode";
import GooglePagination from '../../styles/GooglePagination';

const MISReport = () => {
  // ... existing states ...
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("Token");
    if (token) {
      try {
        // Decode the JWT token to get user details
        const decoded = jwtDecode(token);
        setUserData(decoded);
        console.log("Logged User Info:", decoded);
      } catch (error) {
        console.error("Invalid token:", error);
      }
    }
  }, []);

  console.log("userData: ", userData);

  const { language, toggleLanguage, t } = useLanguage();
  const context = useContext(AdminContext);
  const { Getyears, GetBudgetHeadInfo, TechnicalOutwards, GetProgressReportOutwardsFucntion, GetDemandRequestOutwardsFunction, WorkOutwards } = context;
  const [showspecific, setShowSpecific] = useState(0);
  const [showGraph, setShowGraph] = useState("Table");
  const [releasefromfdutf, setreleasefromfdutf] = useState([]);
  const [proposal, setproposal] = useState([]);
  const [demandgeneration, setdemandgeneration] = useState([]);
  const [selectedYear, setSelectedYear] = useState('2026-2027');
  const [selectedDistrict, setSelectedDistrict] = useState('');
  const [selectedTaluka, setSelectedTaluka] = useState('');
  const [selectedBillDistrict, setSelectedBillDistrict] = useState('');
  const [billDistrictSearch, setBillDistrictSearch] = useState('');
  const [selectedTalukaHeadCode, setSelectedTalukaHeadCode] = useState("");
  const [showDemandDistrictTable, setShowDemandDistrictTable] = useState(false);
  const [selectedDemandDistrict, setSelectedDemandDistrict] = useState('');
  const [exportingPDF, setExportingPDF] = useState(false);

  const [selectedWorkname, setSelectedWorkname] = useState();
  const [selectedDemandID, setSelectedDemandID] = useState();
  const [selectedDemandTaluka, setSelectedDemandTaluka] = useState('');
  const [selectedContractor, setSelectedContractor] = useState();
  const [selectedGR, setSelectedGR] = useState();

  const [filteredreleaseudf, setfilterreleaseudf] = useState([]);
  const [talukawiseProposalData, settalukawiseProposalData] = useState();
  const [fetchSpecificProposalData, setFetchSpecificProposalData] = useState();
  const [fetchAllDemandBYDistrict, setFetchAllDemandBYDistrict] = useState([]);
  const [fetchSpecificDemandDeductionDetail, setfetchSpecficDemandDeductionDetail] = useState([]);
  const [talukawiseDemandData, setTalukawiseDemandData] = useState([]);
  const [sortedDemandDatabytaluka, setSortedDemanddatabytaluka] = useState([]);
  const [SpecificContractorDetail, setSpecificConstractorDetail] = useState();
  const [ContractorBillDetail, setConstractorBillDetail] = useState([]);
  const [totalGRCreated, setTotalGRCreated] = useState();
  const [AllGRS, setALLGRS] = useState([]);
  const [totalTSCreated, setTotalTSCreated] = useState([]);
  const [allTSData, setallTSData] = useState([]);
  const [originalTSData, setOriginalTSData] = useState([]);
  const [MHUIDnumber, setMHUID] = useState();
  const [totaldemandreqAMT, setTotaldemandreqAMT] = useState();
  const [DRtableData, setDRtableData] = useState([]);
  const [originalDRtableData, setOriginalDRtableData] = useState([]);
  const [workorderlength, setworkorderlength] = useState('0');
  const [workOrderData, setWorkOrderData] = useState([]);
  const [originalworkOrderData, setOriginalWorkOrderData] = useState([]);
  const [ProposalDetailByGR, setProposalDetailByGR] = useState([]);
  const [FilterDataOfMHUID, setFilterDataOfMHUID] = useState();
  const [loading, setLoading] = useState(false);
  const [searchBill, setSearchBill] = useState();
  const [searchTaluka, setSearchTaluka] = useState();
  const [searchGR, setSearchGR] = useState();
  const [searchGRSummary, setSearchGRSummary] = useState("");
  const [HeadCode, setHeadCode] = useState([]);
  const [selectedHeadCode, setSelectedHeadCode] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const [districtGRSummary, setDistrictGRSummary] = useState([]);
  const [filteredGRS, setFilteredGRS] = useState([]);

  const [districtTSSummary, setDistrictTSSummary] = useState([]);
  const [filteredTSData, setFilteredTSData] = useState([]);
  const [selectedTSDistrict, setSelectedTSDistrict] = useState("");
  const [selectedAllTSDistrict, setSelectedAllTSDistrict] = useState("");
  const [selectedAllTSTaluka, setSelectedAllTSTaluka] = useState("");
  const [selectedAllTSHeadCode, setSelectedAllTSHeadCode] = useState("");
  const [searchAllTS, setSearchAllTS] = useState("");

  const [districtDRSummary, setDistrictDRSummary] = useState([]);
  const [filteredDRData, setFilteredDRData] = useState([]);

  const [districtWOSummary, setDistrictWOSummary] = useState([]);
  const [filteredWOData, setFilteredWOData] = useState([]);
  const [selectedWOHeadCode, setSelectedWOHeadCode] = useState("");
  const [searchWorkOrder, setSearchWorkOrder] = useState("");
  const [districtPage, setDistrictPage] = useState(1);
  const [showAllDistrict, setShowAllDistrict] = useState(false);
  const [talukaPage, setTalukaPage] = useState(1);
  const [showAllTaluka, setShowAllTaluka] = useState(false);
  const [talukaDemandPage, setTalukaDemandPage] = useState(1);
  const [showAllTalukaDemand, setShowAllTalukaDemand] = useState(false);
  const [districtGRPage, setDistrictGRPage] = useState(1);
  const [showAllDistrictGR, setShowAllDistrictGR] = useState(false);
  const [selectedGRDistrict, setSelectedGRDistrict] = useState('');
  const [searchTSSummary, setSearchTSSummary] = useState("");
  const [showAllGR, setShowAllGR] = useState(false);
  const [showAllProposalGR, setShowAllProposalGR] = useState(false);
  const [showAllTS, setShowAllTS] = useState(false);
  const [showAllTSDetails, setShowAllTSDetails] = useState(false);
  const [districtWOPage, setDistrictWOPage] = useState(1);
  const [showAllDistrictWO, setShowAllDistrictWO] = useState(false);
  const [selectedWODistrict, setSelectedWODistrict] = useState("");
  const [searchWO, setSearchWO] = useState("");
  const [selectedTableHeadCode, setSelectedTableHeadCode] = useState("");

  const getMainDistrict = (district) => {
    if (!district) return "";

    return String(district).split("-")[0].trim();
  };

  const isDistrictMatch = (itemDistrict, selectedDistrict) => {
    if (!selectedDistrict) return true;

    return getMainDistrict(itemDistrict) === getMainDistrict(selectedDistrict);
  };


  const itemsPerPage = 10;

  const indexOfLastGRS = currentPage * itemsPerPage;
  const indexOfFirstGRS = indexOfLastGRS - itemsPerPage;

  const billRecordsPerPage = 10;

  const totalBillRecords = ContractorBillDetail?.length || 0;

  const indexOfLastBill = currentPage * billRecordsPerPage;

  const indexOfFirstBill = indexOfLastBill - billRecordsPerPage;
  const totalBillPages = Math.ceil(
    totalBillRecords / billRecordsPerPage
  );
  console.log("totalGRCreated ::", totalGRCreated);
  console.log("AllGRS ::", AllGRS);

  console.log("allTSData ::", allTSData);
  console.log("originalTSData ::", originalTSData);

  console.log("DRtableData ::", DRtableData);
  console.log("originalDRtableData ::", originalDRtableData);

  console.log("workOrderData ::", workOrderData);
  console.log("originalworkOrderData ::", originalworkOrderData);

  console.log("selectedYear: ", selectedYear);
  console.log("selectedHeadCode: ", selectedHeadCode);

  const currentBills = ContractorBillDetail?.slice(
    indexOfFirstBill,
    indexOfLastBill
  ) || [];

  // const indexOfLastGRS = currentPage * recordsPerPage;
  // const indexOfFirstGRS = indexOfLastBill - recordsPerPage;
  const currentAllGRS = AllGRS.slice(
    indexOfFirstGRS,
    indexOfLastGRS
  ) || [];

  // const displayedGRS = exportingPDF ? AllGRS : paginatedGRS;

  const recordsPerPageUDF = 10;
  const totalUDFRecords = talukawiseProposalData?.length || 0;
  const totalUDFPages = Math.ceil(totalUDFRecords / recordsPerPageUDF);

  const indexOfLastUDF = currentPage * recordsPerPageUDF;
  const indexOfFirstUDF = indexOfLastUDF - recordsPerPageUDF;

  const currenttalukawiseProposalData = Array.isArray(talukawiseProposalData)
    ? talukawiseProposalData.slice(indexOfFirstUDF, indexOfLastUDF)
    : [];

  // total records
  const totalRecordsDemandDatabytaluka =
    Array.isArray(sortedDemandDatabytaluka) ? sortedDemandDatabytaluka.length : 0;

  // total pages
  const totalPagesDatabytaluka = Math.ceil(
    totalRecordsDemandDatabytaluka / billRecordsPerPage
  );

  // pagination indexes
  const lastRecordIndexDatabytaluka = currentPage * billRecordsPerPage;
  const firstRecordIndexDatabytaluka =
    lastRecordIndexDatabytaluka - billRecordsPerPage;

  // current page data
  const talukaDemandRecordsPerPage = 10;

  const totalTalukaDemandPages = Math.ceil(
    sortedDemandDatabytaluka.length / talukaDemandRecordsPerPage
  );

  const currentTalukaDemandData = showAllTalukaDemand
    ? sortedDemandDatabytaluka
    : sortedDemandDatabytaluka.slice(
      (talukaDemandPage - 1) * talukaDemandRecordsPerPage,
      talukaDemandPage * talukaDemandRecordsPerPage
    );

  const tsRecordsPerPage = 10;

  const filteredDistrictTSSummary = districtTSSummary.filter((item) => {
    // District filter
    const districtMatch =
      isDistrictMatch(item.District, selectedTSDistrict);

    // Random search
    const searchText = searchTSSummary.trim().toLowerCase();

    const searchMatch =
      !searchText ||
      [
        item.District,
        selectedYear,
        item.TotalTS,
        item.TotalAmount,
      ].some((value) =>
        String(value ?? "")
          .toLowerCase()
          .includes(searchText)
      );

    return districtMatch && searchMatch;
  });

  const totalTSPages = Math.ceil(
    filteredDistrictTSSummary.length / tsRecordsPerPage
  );

  const paginatedTSData = showAllTS
    ? filteredDistrictTSSummary
    : filteredDistrictTSSummary.slice(
      (districtPage - 1) * tsRecordsPerPage,
      districtPage * tsRecordsPerPage
    );


  const [currentPageProgress, setCurrentPageProgress] = useState(1);

  const recordsPerPageProgress = 10;

  const totalProgressPages = Math.ceil(
    (FilterDataOfMHUID?.length || 0) / recordsPerPageProgress
  );

  const lastRecordIndexProgress =
    currentPageProgress * recordsPerPageProgress;

  const firstRecordIndexProgress =
    lastRecordIndexProgress - recordsPerPageProgress;

  const currentProgressData = FilterDataOfMHUID?.slice(
    firstRecordIndexProgress,
    lastRecordIndexProgress
  ) || [];

  const woRecordsPerPage = 10;

  const filteredDistrictWOSummary = districtWOSummary.filter((item) => {
    const districtMatch =
      isDistrictMatch(item.District, selectedWODistrict);

    const searchValue = searchWO.trim().toLowerCase();

    const searchMatch =
      !searchValue ||
      [
        item.District,
        selectedYear,
        item.TotalWO,
        item.TotalAmount,
      ].some((value) =>
        String(value ?? "")
          .toLowerCase()
          .includes(searchValue)
      );

    return districtMatch && searchMatch;
  });

  const totalWOPages = Math.ceil(
    filteredDistrictWOSummary.length / woRecordsPerPage
  );

  const paginatedWOData = showAllDistrictWO
    ? filteredDistrictWOSummary
    : filteredDistrictWOSummary.slice(
      (districtWOPage - 1) * woRecordsPerPage,
      districtWOPage * woRecordsPerPage
    );

  const [currentPageAllTSData, setCurrentPageAllTSData] = useState(1);
  const recordsPerPageAllTSData = 10;

  // index calculation
  const lastRecordIndexAllTSData =
    currentPageAllTSData * recordsPerPageAllTSData;

  const firstRecordIndexAllTSData =
    lastRecordIndexAllTSData - recordsPerPageAllTSData;

  const [currentPageProposalDetailByGR, setCurrentPageProposalDetailByGR] = useState(1);
  const recordsPerPageProposalDetailByGR = 10;
  // total records
  const totalRecordsProposalDetailByGR = ProposalDetailByGR?.length || 0;

  // total pages
  const totalPagesProposalDetailByGR = Math.ceil(
    totalRecordsProposalDetailByGR / recordsPerPageProposalDetailByGR
  );

  // index calculation
  const lastRecordIndexProposalDetailByGR =
    currentPageProposalDetailByGR * recordsPerPageProposalDetailByGR;

  const firstRecordIndexProposalDetailByGR =
    lastRecordIndexProposalDetailByGR - recordsPerPageProposalDetailByGR;

  // current page data
  const currentProposalDetailByGR = ProposalDetailByGR.slice(
    firstRecordIndexProposalDetailByGR,
    lastRecordIndexProposalDetailByGR
  );

  /////////////////////
  const [currentPageDRtableData, setCurrentPageDRtableData] = useState(1);
  const recordsPerPageDRtableData = 10;

  // index calculation
  const lastRecordIndexDRtableData =
    currentPageDRtableData * recordsPerPageDRtableData;

  const firstRecordIndexDRtableData =
    lastRecordIndexDRtableData - recordsPerPageDRtableData;

  /////////////////////////
  const [currentPageWorkOrderData, setCurrentPageWorkOrderData] = useState(1);
  const recordsPerPageWorkOrderData = 10;

  // index calculation
  const lastRecordIndexWorkOrderData =
    currentPageWorkOrderData * recordsPerPageWorkOrderData;

  const firstRecordIndexWorkOrderData =
    lastRecordIndexWorkOrderData - recordsPerPageWorkOrderData;

  const fetchAllHeads = async () => {
    try {
      let res = await GetBudgetHeadInfo('null', "AllHeadCode");
      const sortedData = res.sort((a, b) =>
        new Date(a.Date) - new Date(b.Date)
      );
      setHeadCode(sortedData);
    }
    catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    fetchAllHeads();
  }, [])

  const fetchData = async () => {
    const data = await Getyears("oldCode", "ALL", selectedHeadCode);
    setreleasefromfdutf(data?.projectQuery || []);
    setproposal(data?.ProposalQuery || []);   //this is setting empty
    setdemandgeneration(data?.projectQuery || []);
    console.log("Fetched Data of de gene:", data?.projectQuery);
  };

  useEffect(() => {
    fetchData();
  }, [selectedYear, selectedHeadCode]);

  const fetchAllData = async () => {
    try {
      const data1 = await Getyears("fetchTotalGRCreated", selectedYear, selectedHeadCode);
      setTotalGRCreated(data1.count);
      setALLGRS(data1.grs)
    }
    catch (err) {
      console.log(err);
    }
  }
  //fetching data or TS
  const fetchforTS = async () => {
    try {
      const data1 = await TechnicalOutwards("Technical");
      console.log("data for TS", data1);
      setTotalTSCreated(data1.message.length);
      setallTSData(data1.message);
      setOriginalTSData(data1.message);
    }
    catch (err) {
      console.log(err);
    }
  }

  //here to fetch MHUID details after clicking 
  const FetchDataForMHUID = async (selectedYear, MHUIDno, selectedHeadCode) => {
    try {
      let res = await GetProgressReportOutwardsFucntion();
      const { status, message } = res;

      if (status) {
        const sortedData = message.sort((a, b) =>
          new Date(a.Date) - new Date(b.Date)
        );
        console.log("✅ Progress Report Outwards Data:", sortedData);
        const filtered = sortedData.filter(item => item.ProposalYear === selectedYear && item.TechnicalUID === MHUIDno && item.Head_Code === selectedHeadCode);
        console.log("Filtered Data:", filtered);
        setFilterDataOfMHUID(filtered);
        setMHUID(MHUIDno);
        setShowSpecific(111);
      }
      else {
        alert(message);
      }
    } catch (error) {
      console.error("❌ Error fetching progress report outwards:", error);
    }

  };

  //fetching data for demand requ

  const getTechnicalInwardsList = async () => {
    let data = await GetDemandRequestOutwardsFunction('', '')
    const { status, message } = data;
    if (status) {
      const sortedData = message.sort((a, b) =>
        new Date(a.created_At) - new Date(b.created_At)
      );
      console.log("Demand Request Outwards Data:", sortedData);
      const totalDRAmount = sortedData.reduce((sum, row) => {
        //just becuase we have declare varchar instead of int
        const value = Number(String(row.DRAmount || "0").replace(/,/g, ""));
        return sum + value;
      }, 0);
      setTotaldemandreqAMT(totalDRAmount);
      setDRtableData(sortedData);
      setOriginalDRtableData(sortedData);
      console.log("Total DRAmount:", totalDRAmount);
      // setTechnicalInwards(sortedData);
      // setProposalList(sortedData);
    }
    else {
      alert(message);
    }

  }

  // fetch work order details
  const workOrderDetails = async () => {
    let data = await WorkOutwards()
    setworkorderlength(data.message.length)
    setWorkOrderData(data.message)
    setOriginalWorkOrderData(data.message)
    console.log("this is for work order outward", data);
  }


  useEffect(() => {
    if (selectedYear && selectedHeadCode) {
      fetchAllData();
      fetchforTS();
      getTechnicalInwardsList();
      workOrderDetails();
    }
  }, [selectedYear, selectedHeadCode]);

  // const allYears = [
  //   ...new Set([
  //     ...releasefromfdutf.map(item => item.ProposalYear),
  //   ]),
  // ].filter(Boolean).sort();

  const filterDemandByYear = (demandgeneration, selectedYear, selectedHeadCode) => {

    if (!selectedYear || !demandgeneration) return [];
    return demandgeneration.filter(item =>
      item.ProposalYear == selectedYear &&
      item.HeadCode == selectedHeadCode
    );
  };

  const filteredDemandGenerationData = filterDemandByYear(demandgeneration, selectedYear, selectedHeadCode);
  console.log("filteredDemandGenerationData", filteredDemandGenerationData);
  const totalDemandAmount = filteredDemandGenerationData.reduce((sum, item) => {
    return sum + (parseFloat(item.BillPaidAmount) || 0);
  }, 0);

  const demandDistrictSummary = filteredDemandGenerationData.reduce((acc, curr) => {
    const district = getMainDistrict(curr.talulka) || "Unknown";
    const amount = parseFloat(curr.BillPaidAmount) || 0;

    if (!acc[district]) {
      acc[district] = { District: district, TotalBillAmount: amount };
    } else {
      acc[district].TotalBillAmount += amount;
    }

    return acc;
  }, {});

  const demandDistrictData = Object.values(demandDistrictSummary);

  const filteredBillDistrictData = demandDistrictData.filter((item) => {
    const matchesDistrict =
      isDistrictMatch(item.District, selectedBillDistrict);

    const searchText = billDistrictSearch.toLowerCase().trim();

    const matchesSearch =
      !searchText ||
      String(item.District ?? "").toLowerCase().includes(searchText) ||
      String(selectedYear ?? "").toLowerCase().includes(searchText) ||
      String(item.HeadCode ?? selectedHeadCode ?? "").toLowerCase().includes(searchText) ||
      String(item.TotalBillAmount ?? "").toLowerCase().includes(searchText);

    return matchesDistrict && matchesSearch;
  });


  const districtRecordsPerPage = 10;

  const totalDistrictPages = Math.ceil(
    filteredBillDistrictData.length / districtRecordsPerPage
  );

  const paginatedDistrictData = showAllDistrict
    ? filteredBillDistrictData
    : filteredBillDistrictData.slice(
      (districtPage - 1) * districtRecordsPerPage,
      districtPage * districtRecordsPerPage
    );


  const filteredTalukaData = talukawiseDemandData.filter(
    (t) =>
      !searchTaluka ||
      t.taluka?.toLowerCase().includes(searchTaluka.toLowerCase())
  );

  const talukaRecordsPerPage = 10;

  const totalTalukaPages = Math.ceil(
    filteredTalukaData.length / talukaRecordsPerPage
  );

  const paginatedTalukaData = showAllTaluka
    ? filteredTalukaData
    : filteredTalukaData.slice(
      (talukaPage - 1) * talukaRecordsPerPage,
      talukaPage * talukaRecordsPerPage
    );

  const demandDataForDistrict = selectedDemandDistrict
    ? filteredDemandGenerationData.filter(item => isDistrictMatch(item.District, selectedDemandDistrict))
    : [];

  const filteredreleasefromfdutf = selectedYear
    ? releasefromfdutf.filter(item => item.ProposalYear === selectedYear && item.HeadCode == selectedHeadCode && item.HeadCode == selectedHeadCode)
    : [];

  const hasData = (selectedYear) && (
    filteredreleasefromfdutf.length > 0
  );

  const districtSummary = filteredreleasefromfdutf.reduce((acc, curr) => {
    const district = getMainDistrict(curr.District) || "Unknown";
    const amount = parseFloat(curr.OriginalLimitAllocatedAmount) || 0;
    if (!acc[district]) {
      acc[district] = { District: district, TotalLimitAllottedAmount: amount };
    } else {
      acc[district].TotalLimitAllottedAmount += amount;
    }

    return acc;
  }, {});

  const uniqueDistrictsData = Object.values(districtSummary);
  const districtGRRecordsPerPage = 10;

  const filteredDistrictGRSummary = districtGRSummary.filter((item) => {
    const districtMatch =
      isDistrictMatch(item.District, selectedGRDistrict);

    const searchText = searchGRSummary.trim().toLowerCase();

    const searchMatch =
      !searchText ||
      [
        item.District,
        selectedYear,
        item.TotalGR,
        item.TotalAmount,
      ].some((value) =>
        String(value ?? "")
          .toLowerCase()
          .includes(searchText)
      );

    return districtMatch && searchMatch;
  });
  const totalDistrictGRPages = Math.ceil(
    filteredDistrictGRSummary.length / districtGRRecordsPerPage
  );

  const paginatedDistrictGR = showAllDistrictGR
    ? filteredDistrictGRSummary
    : filteredDistrictGRSummary.slice(
      (districtGRPage - 1) * districtGRRecordsPerPage,
      districtGRPage * districtGRRecordsPerPage
    );
  const proposalGRRecordsPerPage = 10;

  const paginatedProposalGR = showAllProposalGR
    ? ProposalDetailByGR
    : ProposalDetailByGR.slice(
      firstRecordIndexProposalDetailByGR,
      lastRecordIndexProposalDetailByGR
    );

  const detailedDistrictData = selectedDistrict
    ? filteredreleasefromfdutf.filter(item => isDistrictMatch(item.District, selectedDistrict))
    : [];

  const filteredProposalData = selectedTaluka
    ? proposal.filter(
      item =>
        item.Proposal_year === selectedYear &&
        item.HeadCode == selectedHeadCode &&
        item.District === selectedDistrict &&
        item.Taluka === selectedTaluka
    )
    : [];


  const releasefromfdutfFields = ['District', 'Year', 'HeadCode', 'TotalLimitAllottedAmount'];

  // new function added fit release
  const totalLimitAllocationAmount = releasefromfdutf
    .filter(item => item.ProposalYear == selectedYear && item.HeadCode == selectedHeadCode)
    .reduce((sum, item) => {
      return sum + (parseFloat(item.OriginalLimitAllocatedAmount) || 0);
    }, 0);

  const fetchreleasefromUdfData = (year, district, selectedHeadCode) => {
    setSelectedDistrict(district);
    setSelectedYear(year);
    setSelectedHeadCode(selectedHeadCode);
    console.log("para i get :: ", year, district)
    let res = releasefromfdutf.filter((item) => item.ProposalYear == year && isDistrictMatch(item.District, district) && item.HeadCode == selectedHeadCode);
    let filtered = releasefromfdutf.filter((item) => item.ProposalYear == year && isDistrictMatch(item.District, district) && item.HeadCode == selectedHeadCode);

    const groupedByTaluka = {};

    filtered.forEach((item) => {
      const taluka = item.Taluka || "Unknown";
      const year = item.Proposal_year || "Unknown";
      const head = item.HeadCode || "Unknown";

      if (!groupedByTaluka[taluka]) {
        groupedByTaluka[taluka] = {
          year: year,
          head: head,
          Taluka: taluka,
          totalLimitAllocated: 0,
          totalRemainingLimit: 0,
          totalReleaseAmount: 0
        };
      }

      groupedByTaluka[taluka].totalProposalCost += parseFloat(item.ProposalCost || 0);
      groupedByTaluka[taluka].totalLimitAllocated += parseFloat(item.OriginalLimitAllocatedAmount || 0);
      groupedByTaluka[taluka].totalRemainingLimit += parseFloat(item.LimitAllottedAmount || 0);
      groupedByTaluka[taluka].totalReleaseAmount += parseFloat(item.ReleaseAmountTillDate || 0);
      // groupedByTaluka[taluka].records.push(item);
    });

    const talukaWiseData = Object.values(groupedByTaluka);
    console.log("Taluka-wise Aggregated Data ::", talukaWiseData);

    console.log("data set LL ", res);
    setfilterreleaseudf(talukaWiseData);
    setShowSpecific(2);
  };

  const fetchProposalfromReleaseBytaluka = (tal) => {
    let res = releasefromfdutf.filter((item) => item.Taluka == tal && item.ProposalYear == selectedYear);
    settalukawiseProposalData(res);
    setSelectedTaluka(tal);
    setShowSpecific(3);
  }

  const ProposalDataUsingSelectedProposal = async (ID) => {
    try {
      let res = await Getyears("FetchProposalbyworkname", ID, selectedHeadCode);
      setFetchSpecificProposalData(res);
      setSelectedWorkname(ID);
      setShowSpecific(4);
    }
    catch (err) {
      console.log(err);
    }
  }

  // Dmeand generation 
  const DemandGenerationSortByDistrict = async (district) => {
    try {
            const rawNames = [...new Set(
        demandgeneration
          .filter(i => i.HeadCode == selectedHeadCode &&
                       i.ProposalYear == selectedYear &&
                       isDistrictMatch(i.talulka, district))
          .map(i => i.talulka)
          .filter(Boolean)
      )];
      const names = rawNames.length ? rawNames : [district];

      const responses = await Promise.all(
        names.map(n =>
          Getyears(
            "FetchDemandbyDistrict",
            { district: n, year: selectedYear, head: selectedHeadCode },
            selectedHeadCode
          )
        )
      );
      let res = responses.flatMap(r => (Array.isArray(r) ? r : []));
      setFetchAllDemandBYDistrict(res);
      console.log("qww", res)
      setSelectedDemandDistrict(district);

      const talukaTotalsMap = {};

      res.forEach(item => {
        const taluka = item.ulb || "Unknown";
        const year = item.ProposalYear || "Unknown";
        const head = item.BudgetHead || "Unknown";
        const key = `${taluka}-${year}`;

        if (!talukaTotalsMap[key]) {
          talukaTotalsMap[key] = {
            totalBillAmount: 0,
            totalNetPayable: 0,
            totalDeduction: 0,
            taluka: taluka,
            year: selectedYear,
            head: selectedHeadCode
          };
        }

        talukaTotalsMap[key].totalBillAmount += parseFloat(item.BillAmount || 0);
        talukaTotalsMap[key].totalNetPayable += parseFloat(item.NetPayableAmount || 0);
        talukaTotalsMap[key].totalDeduction += parseFloat(item.DeductionAmount || 0);
      });

      const talukaTotalsArray = Object.values(talukaTotalsMap);

      setTalukawiseDemandData(talukaTotalsArray);
      setShowSpecific(51);
      console.log("Demand filtered by taluka:", talukaTotalsArray);
      setShowSpecific(51);
    }
    catch (err) {
      console.log(err);
    }
  }

  const DemandGenerationSortByTaluka = (tal) => {
    let res = fetchAllDemandBYDistrict.filter((item) => item.ulb == tal);
    setSortedDemanddatabytaluka(res);
    setSelectedDemandTaluka(tal);
    setShowSpecific(52);
  }

  const DemandDeductionDetailByBillID = async (ID, showid) => {
    console.log("ID and showid", ID, showid);

    try {
      let res = await Getyears("FetchDemandDeductionDetailbyBillID", ID, selectedHeadCode);
      console.log("resForDeduction", res);

      setfetchSpecficDemandDeductionDetail(res);
      setSelectedDemandID(ID);
      setShowSpecific(showid);
    }
    catch (err) {
      console.log(err);
    }
  }

  const VendorBillDetailByContractorName = async (name) => {
    try {
      let obj = {
        year: selectedYear,
        vendor: name,

      }
      let res = await Getyears("FetchVendorBillDetailByName", obj, selectedHeadCode);
      console.log("resVendor", res);

      setConstractorBillDetail(res);
      setSelectedContractor(name);
      setShowSpecific(57);
    }
    catch (err) {
      console.log(err);
    }
  }

  const ContractorDetailByContractorName = async (name) => {
    try {
      let res = await Getyears("FetchContractorDetailByName", name, "null");
      setSpecificConstractorDetail(res);
      setSelectedContractor(name);
      setShowSpecific(58);
    }
    catch (err) {
      console.log(err);
    }
  }

  // gr operation 
  const proposalDetailbyGR = async (GID) => {
    try {
      let res = await Getyears("FetchProposalDetailByGRID", GID, selectedHeadCode);
      setProposalDetailByGR(res);
      setSelectedGR(GID);
      setShowSpecific(101);
    }
    catch (err) {
      console.log(err);
    }
  }

  // useEffect(() => {
  //   if (selectedYear && selectedDistrict) {
  //     fetchreleasefromUdfData(selectedYear, selectedDistrict);
  //   }
  // }, [selectedDistrict, selectedYear]);


  // const exportTableByClassToExcel = (classname, filename = "Export.xlsx") => {
  //   const table = document.querySelector(`.${classname}`);
  //   if (!table) {
  //     alert("Table with the specified class not found!");
  //     return;
  //   }

  //   // Create worksheet from table
  //   const worksheet = XLSX.utils.table_to_sheet(table);

  //   const numCols = table.rows[0].cells.length;
  //   worksheet['!cols'] = Array(numCols).fill({ wch: 20 });
  //   worksheet['!freeze'] = { xSplit: 0, ySplit: 1 };

  //   worksheet['!autofilter'] = {
  //     ref: XLSX.utils.encode_range({
  //       s: { r: 0, c: 0 },
  //       e: { r: table.rows.length - 1, c: numCols - 1 }
  //     })
  //   };

  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  //   XLSX.writeFile(workbook, filename);
  // };
  const exportTableByClassToExcel = async (classname, filename = "Export.xlsx") => {
    // ---------- 0. Show ALL rows temporarily (no UI/button change needed) ----------
    const showAllMap = {
      "50:AllGR": [setShowAllDistrict, showAllDistrict],
      "100:AllGR": [setShowAllGR, showAllGR],
      "51:TalukaWiseDemandTable": [setShowAllTaluka, showAllTaluka],
      "52:BillsDataTable": [setShowAllTalukaDemand, showAllTalukaDemand],
      "99:ALlDistrictFinanceData": [setShowAllDistrictGR, showAllDistrictGR],
      "109:ALlDistrictFinanceData": [setShowAllTS, showAllTS],
      "115:ALlDistrictFinanceData": [setShowAllDistrictWO, showAllDistrictWO],
      "101:ProposalContainer": [setShowAllProposalGR, showAllProposalGR],
      "110:ALlTechnicalSData": [setShowAllTSDetails, showAllTSDetails],
    };
    const entry = showAllMap[`${showspecific}:${classname}`];
    const setShowAll = entry ? entry[0] : null;
    const previousShowAll = entry ? entry[1] : null;

    if (setShowAll && !previousShowAll) {
      setShowAll(true);
      await new Promise((res) => setTimeout(res, 700)); // wait for all rows to render
    }

    try {
      const table = document.querySelector(`.${classname}`);

      if (!table) {
        alert("Table with the specified class not found!");
        return;
      }

      const tableText = table.innerText.toLowerCase();
      const hasTotals =
        tableText.includes("page total") && tableText.includes("gross total");

      let worksheet;
      let bodyCount = 0;

      if (hasTotals) {
        const data = Array.from(table.rows).map((row) =>
          Array.from(row.cells).map((cell) => cell.innerText.trim())
        );

        const header = data[0];

        const body = Array.from(table.querySelectorAll("tbody tr"))
          .map((row) =>
            Array.from(row.cells).map((cell) => cell.innerText.trim())
          )
          .filter((row) => {
            const text = row.join(" ").toLowerCase();

            return (
              !text.includes("page total") &&
              !text.includes("gross total") &&
              !text.includes("no data") &&
              row.length > 1
            );
          });

        // Renumber Sr No from 1
        const firstHeader = String(header[0] || "").toLowerCase();
        if (firstHeader.startsWith("sr")) {
          body.forEach((row, i) => {
            row[0] = i + 1;
          });
        }

        // const isAmt = (s) => /^₹\s*-?[\d,]+(\.\d+)?$/.test(String(s ?? ""));
        // const toNum = (s) => Number(String(s).replace(/[₹,\s]/g, ""));

        const isAmt = (s) => {
          const value = String(s ?? "").trim();

          if (!value) return false;

          return /^₹?\s*-?[\d,]+(\.\d+)?$/.test(value);
        };

        const toNum = (s) =>
          Number(String(s ?? "").replace(/[₹,\s]/g, ""));

        // Amount columns = columns whose filled cells all look like "₹ 1,234"
        // const amountCols = header
        //   .map((_, c) => {
        //     const filled = body.filter((r) => r[c] !== undefined && r[c] !== "");
        //     return filled.length > 0 && filled.every((r) => isAmt(r[c])) ? c : -1;
        //   })
        //   .filter((c) => c >= 0);

        const amountCols = header
  .map((headerName, c) => {
    if (c === 0) return -1; // don't treat Sr.No as amount

    const filled = body
      .map((r) => r[c])
      .filter((v) => v !== undefined && String(v).trim() !== "");

    const headerText = String(headerName || "").toLowerCase();

    const isAmountHeader =
      headerText.includes("amount") ||
      headerText.includes("cost") ||
      headerText.includes("bill") ||
      headerText.includes("value");

    const isNumericColumn =
      filled.length > 0 && filled.every((v) => isAmt(v));

    return isAmountHeader && isNumericColumn ? c : -1;
  })
  .filter((c) => c >= 0);

        // Convert "₹ 1,128,498" -> 1128498 (real number)
        const numericBody = body.map((row) =>
          row.map((cell, c) =>
            amountCols.includes(c) && isAmt(cell) ? toNum(cell) : cell
          )
        );

        // Single Total row with sums
        const totalRow = new Array(header.length).fill("");
        // const labelCol = amountCols.length ? Math.max(amountCols[0] - 1, 0) : 0;
        // totalRow[labelCol] = "Total";

        if (amountCols.length > 0) {
          totalRow[amountCols[0] - 1] = "Total";
        } else {
          totalRow[0] = "Total";
        }

        amountCols.forEach((c) => {
          totalRow[c] = numericBody.reduce(
            (sum, r) => sum + (typeof r[c] === "number" ? r[c] : 0),
            0
          );
        });

        bodyCount = numericBody.length;
        worksheet = XLSX.utils.aoa_to_sheet([header, ...numericBody, totalRow]);

        // Thousands separators on the amount cells
        for (let r = 1; r <= bodyCount + 1; r++) {
          amountCols.forEach((c) => {
            const cell = worksheet[XLSX.utils.encode_cell({ r, c })];
            if (cell && cell.t === "n") cell.z = "#,##0";
          });
        }
      } else {
        worksheet = XLSX.utils.table_to_sheet(table);
        bodyCount = XLSX.utils.decode_range(worksheet["!ref"]).e.r;
      }

      const numCols = table.rows[0].cells.length;

      worksheet["!cols"] = Array(numCols).fill({ wch: 20 });

      // Autofilter on header + data rows only (Total row excluded)
      worksheet["!autofilter"] = {
        ref: XLSX.utils.encode_range({
          s: { r: 0, c: 0 },
          e: { r: bodyCount, c: numCols - 1 },
        }),
      };

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, filename);
    } catch (error) {
      console.error("Excel Export Error:", error);
    } finally {
      // Restore the previous pagination view
      if (setShowAll) setShowAll(previousShowAll);
    }
  };

  const isElementVisible = (element) => {
    if (!element) return false;
    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  };

  // Main function - Downloads both table and chart
  const downloadPageAsPDF = async (tableClass, chartClass, filename, title) => {
    setLoading(true);

    try {
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      let currentY = 15;

      if (title) {
        pdf.setFontSize(18);
        pdf.setFont(undefined, 'bold');
        pdf.text(title, pageWidth / 2, currentY, { align: 'center' });
        currentY += 10;
      }

      const originalShowGraph = showGraph;
      let chartAdded = false;
      let tableAdded = false;

      // Capture Chart
      if (originalShowGraph !== "Chart") {
        setShowGraph("Chart");
        await new Promise(resolve => setTimeout(resolve, 500));
      }

      const chartElement = document.querySelector(`.${chartClass}`);

      if (chartElement && isElementVisible(chartElement)) {
        pdf.setFontSize(14);
        pdf.text('Chart View', pageWidth / 2, currentY, { align: 'center' });
        currentY += 5;

        const chartCanvas = await html2canvas(chartElement, {
          scale: 2,
          useCORS: true,
          logging: false,
          backgroundColor: '#ffffff'
        });

        const chartImgData = chartCanvas.toDataURL('image/png');
        const chartWidth = pageWidth - 20;
        const chartHeight = (chartCanvas.height * chartWidth) / chartCanvas.width;

        // If chart image too tall for portrait page, put it on a landscape page
        if (chartHeight > pageHeight - currentY - 10) {
          // create a new landscape page and render chart there
          pdf.addPage('l');
          const landscapeWidth = pdf.internal.pageSize.getWidth();
          const landscapeHeight = pdf.internal.pageSize.getHeight();

          currentY = 15;
          pdf.setFontSize(14);
          pdf.text('Chart View', landscapeWidth / 2, currentY, { align: 'center' });
          currentY += 5;

          const adjustedWidth = landscapeWidth - 20;
          const adjustedHeight = (chartCanvas.height * adjustedWidth) / chartCanvas.width;

          pdf.addImage(chartImgData, 'PNG', 10, currentY, adjustedWidth, Math.min(adjustedHeight, landscapeHeight - 25));
        } else {
          pdf.addImage(chartImgData, 'PNG', 10, currentY, chartWidth, chartHeight);
          currentY += chartHeight + 10;
        }

        chartAdded = true;
      }

      // Capture Table
      setShowGraph("Table");
      await new Promise(resolve => setTimeout(resolve, 500));

      const tableElement = document.querySelector(`.${tableClass}`);

      if (tableElement && isElementVisible(tableElement)) {
        // If a chart was already added to the PDF's current page, create a new portrait page for the table.
        // If chart was NOT added, use the existing (first) page to render the table (avoids blank first page).
        if (chartAdded) {
          pdf.addPage('p');
        } else {
          // ensure we start at top of the existing page
          pdf.setPage(1);
        }

        currentY = 15;
        pdf.setFontSize(14);
        pdf.text('Table View', pdf.internal.pageSize.getWidth() / 2, currentY, { align: 'center' });
        currentY += 5;

        const tableCanvas = await html2canvas(tableElement, {
          scale: 2,
          useCORS: true,
          logging: false,
          backgroundColor: '#ffffff'
        });

        const tableImgData = tableCanvas.toDataURL('image/png');
        const tableWidth = pdf.internal.pageSize.getWidth() - 20;
        const tableHeight = (tableCanvas.height * tableWidth) / tableCanvas.width;

        // If table image is taller than a single page, let jsPDF split pages automatically by calculating placement.
        // For simplicity add the full image and let it flow (it will be placed starting at currentY).
        pdf.addImage(tableImgData, 'PNG', 10, currentY, tableWidth, tableHeight);

        tableAdded = true;
      }

      setShowGraph(originalShowGraph);

      if (!chartAdded && !tableAdded) {
        alert('No content found to export!');
        setLoading(false);
        return;
      }

      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        const currentPageWidth = pdf.internal.pageSize.getWidth();
        const currentPageHeight = pdf.internal.pageSize.getHeight();

        pdf.setFontSize(8);
        pdf.setTextColor(128);
        pdf.text(
          `Generated on: ${new Date().toLocaleDateString()} | Page ${i} of ${totalPages}`,
          currentPageWidth / 2,
          currentPageHeight - 5,
          { align: 'center' }
        );
      }

      pdf.save(filename);
      alert('PDF downloaded successfully!');

    } catch (error) {
      console.error('Error generating PDF:', error);
      alert('Failed to download PDF. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // // Download only table
  const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
    setExportingPDF(true);

    // ---------- 0. Show ALL rows temporarily (no UI/button change needed) ----------
    const showAllMap = {
      "50:AllGR": [setShowAllDistrict, showAllDistrict],
      "100:AllGR": [setShowAllGR, showAllGR],
      "51:TalukaWiseDemandTable": [setShowAllTaluka, showAllTaluka],
      "52:BillsDataTable": [setShowAllTalukaDemand, showAllTalukaDemand],
      "99:ALlDistrictFinanceData": [setShowAllDistrictGR, showAllDistrictGR],
      "109:ALlDistrictFinanceData": [setShowAllTS, showAllTS],
      "115:ALlDistrictFinanceData": [setShowAllDistrictWO, showAllDistrictWO],
      "101:ProposalContainer": [setShowAllProposalGR, showAllProposalGR],
      "110:ALlTechnicalSData": [setShowAllTSDetails, showAllTSDetails],
    };
    const entry = showAllMap[`${showspecific}:${tableClass}`];
    const setShowAll = entry ? entry[0] : null;
    const previousShowAll = entry ? entry[1] : null;

    if (setShowAll && !previousShowAll) {
      setShowAll(true);
      await new Promise((res) => setTimeout(res, 700)); // wait for all rows to render
    } else {
      await new Promise((res) => setTimeout(res, 300));
    }

    const originalTable = document.querySelector(`.${tableClass}`);
    if (!originalTable) {
      if (setShowAll) setShowAll(previousShowAll);
      setExportingPDF(false);
      return;
    }

    let clonedTable = null;
    let wrapper = null;

    try {
      // ---------- 1. Remove Page Total / Gross Total rows ----------
      const originalRows = Array.from(
        originalTable.querySelectorAll("tbody tr")
      ).filter((row) => {
        const text = row.textContent.trim().toLowerCase();
        return !text.includes("page total") && !text.includes("gross total");
      });

      // Real data rows only (skip "No data found" rows)
      const dataRows = originalRows.filter(
        (row) => row.querySelectorAll("td").length > 1
      );

      // ---------- 2. Detect amount columns (cells like "₹ 1,23,456") ----------
      const isAmt = (s) => /^₹\s*-?[\d,]+(\.\d+)?$/.test(String(s ?? "").trim());
      const toNum = (s) => Number(String(s).replace(/[₹,\s]/g, ""));

      const colCount = dataRows.length
        ? dataRows[0].querySelectorAll("td").length
        : 0;

      const amountCols = [];
      for (let c = 1; c < colCount; c++) {
        const filled = dataRows
          .map((r) => r.querySelectorAll("td")[c]?.textContent.trim())
          .filter((v) => v !== undefined && v !== "");
        if (filled.length > 0 && filled.every(isAmt)) amountCols.push(c);
      }

      // ---------- 3. Sum each amount column ----------
      const sums = {};
      amountCols.forEach((c) => {
        sums[c] = dataRows.reduce((sum, row) => {
          const txt = row.querySelectorAll("td")[c]?.textContent.trim();
          return sum + (isAmt(txt) ? toNum(txt) : 0);
        }, 0);
      });

      // ---------- 4. Build cloned table ----------
      clonedTable = originalTable.cloneNode(true);
      const clonedTbody = clonedTable.querySelector("tbody");

      const firstHeader = originalTable
        .querySelector("thead th")
        ?.textContent.trim()
        .toLowerCase();
      const hasSrNo = firstHeader && firstHeader.startsWith("sr");

      if (clonedTbody) {
        clonedTbody.innerHTML = "";

        dataRows.forEach((row, index) => {
          const clonedRow = row.cloneNode(true);

          // Renumber Sr No from 1
          if (hasSrNo) {
            const firstCell = clonedRow.querySelector("td");
            if (firstCell) firstCell.textContent = index + 1;
          }

          clonedTbody.appendChild(clonedRow);
        });

        // ---------- 5. Single Total row ----------
        if (dataRows.length > 0 && amountCols.length > 0) {
          const firstAmt = amountCols[0];
          const totalRow = document.createElement("tr");
          const base =
            "font-weight:bold;font-size:18px;padding:10px;background:#f0f0f0;";

          const labelCell = document.createElement("td");
          labelCell.colSpan = firstAmt;
          labelCell.textContent = "Total";
          labelCell.style.cssText = base + "text-align:right;";
          totalRow.appendChild(labelCell);

          for (let c = firstAmt; c < colCount; c++) {
            const cell = document.createElement("td");
            cell.style.cssText = base + "text-align:left;";
            cell.textContent = amountCols.includes(c)
              ? "₹ " + sums[c].toLocaleString("en-IN")
              : "";
            totalRow.appendChild(cell);
          }

          clonedTbody.appendChild(totalRow);
        }
      }

      // ---------- 6. Make header visible ----------
      clonedTable.querySelectorAll("thead th").forEach((th) => {
        th.style.backgroundColor = "#2C78DB";
        th.style.color = "#fff";
        th.style.fontWeight = "bold";
        th.style.position = "static"; // remove sticky behaviour in the clone
      });
      const clonedThead = clonedTable.querySelector("thead");
      if (clonedThead) clonedThead.style.position = "static";

      wrapper = document.createElement("div");
      wrapper.className = "tableDesign DistrictTableContianer";
      wrapper.style.cssText =
        "position:absolute;left:-9999px;top:0;background:#2C78DB;overflow:visible;max-height:none;width:" +
        originalTable.scrollWidth +
        "px;";
      wrapper.appendChild(clonedTable);
      document.body.appendChild(wrapper);

      // ---------- 7. Render to PDF (page-by-page slices) ----------
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const drawTitle = () => {
        pdf.setFontSize(16);
        pdf.setFont("helvetica", "bold");
        pdf.text(title, pageWidth / 2, 15, { align: "center" });
      };

      const imgWidth = pageWidth - 20;                 // mm
      const startY = 25;
      const wrapW = wrapper.offsetWidth;               // css px
      const pxPerMm = wrapW / imgWidth;                // css px per mm
      const limitPx = (pageHeight - startY - 8) * pxPerMm - 4; // small safety margin

      // ---- Measure header and every row (css px) ----
      const theadEl = clonedTable.querySelector("thead");
      const headH = theadEl ? theadEl.getBoundingClientRect().height : 0;
      const bodyRows = Array.from(clonedTable.querySelectorAll("tbody tr"));
      const heights = bodyRows.map((r) => r.getBoundingClientRect().height);

      // ---- Group whole rows into pages ----
      const pages = [];
      let current = [];
      let used = headH;

      heights.forEach((h, i) => {
        if (current.length > 0 && used + h > limitPx) {
          pages.push(current);
          current = [];
          used = headH;
        }
        current.push(i);
        used += h;
      });
      if (current.length) pages.push(current);

      // ---- Render each page separately: header + its rows ----
      for (let p = 0; p < pages.length; p++) {
        const pageWrapper = wrapper.cloneNode(false); // keeps class, width, background
        const pageTable = clonedTable.cloneNode(false);

        if (theadEl) pageTable.appendChild(theadEl.cloneNode(true));
        const tb = document.createElement("tbody");
        pages[p].forEach((i) => tb.appendChild(bodyRows[i].cloneNode(true)));
        pageTable.appendChild(tb);

        pageWrapper.appendChild(pageTable);
        document.body.appendChild(pageWrapper);

        const pageCanvas = await html2canvas(pageWrapper, {
          scale: 2,
          useCORS: true,
          backgroundColor: "#fff",
        });
        document.body.removeChild(pageWrapper);

        if (p > 0) pdf.addPage();
        drawTitle();
        pdf.addImage(
          pageCanvas.toDataURL("image/png"),
          "PNG",
          10,
          startY,
          imgWidth,
          (pageCanvas.height * imgWidth) / pageCanvas.width
        );
      }

      pdf.save(filename);
    } catch (error) {
      console.error("PDF Export Error:", error);
    } finally {
      if (wrapper && wrapper.parentNode) {
        wrapper.parentNode.removeChild(wrapper);
      }
      // Restore the previous pagination view
      if (setShowAll) setShowAll(previousShowAll);
      setExportingPDF(false);
    }
  };
  // const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
  //   setExportingPDF(true);

  //   // allow DOM re-render
  //   await new Promise(res => setTimeout(res, 300));

  //   const table = document.querySelector(`.${tableClass}`);
  //   if (!table) return;

  //   const pdf = new jsPDF("p", "mm", "a4");
  //   const pageWidth = pdf.internal.pageSize.getWidth();
  //   const pageHeight = pdf.internal.pageSize.getHeight();

  //   pdf.setFontSize(16);
  //   pdf.setFont("helvetica", "bold");
  //   pdf.text(title, pageWidth / 2, 15, { align: "center" });

  //   const canvas = await html2canvas(table, {
  //     scale: 2,
  //     useCORS: true,
  //     backgroundColor: "#fff",
  //   });

  //   const imgData = canvas.toDataURL("image/png");
  //   const imgWidth = pageWidth - 20;
  //   const imgHeight = (canvas.height * imgWidth) / canvas.width;

  //   let heightLeft = imgHeight;
  //   let position = 25;

  //   pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
  //   heightLeft -= pageHeight;

  //   while (heightLeft > 0) {
  //     position = heightLeft - imgHeight + 25;
  //     pdf.addPage();
  //     pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
  //     heightLeft -= pageHeight;
  //   }

  //   pdf.save(filename);

  //   setExportingPDF(false);
  // };
  // const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
  //   setExportingPDF(true);

  //   // allow DOM re-render
  //   await new Promise((res) => setTimeout(res, 300));

  //   const originalTable = document.querySelector(`.${tableClass}`);
  //   if (!originalTable) {
  //     setExportingPDF(false);
  //     return;
  //   }

  //   try {
  //     // =====================================================
  //     // Find "Amount" column index from header text
  //     // =====================================================
  //     const headerCellsRef = Array.from(
  //       originalTable.querySelectorAll("thead tr th")
  //     );
  //     const headerColCount = headerCellsRef.length;

  //     let amountColIndex = headerCellsRef.findIndex((th) =>
  //       th.textContent.trim().toLowerCase().includes("amount")
  //     );
  //     if (amountColIndex === -1) {
  //       amountColIndex = headerColCount - 1; // fallback: last column
  //     }

  //     // =====================================================
  //     // Drop "Page Total" / "Gross Total" rows
  //     // =====================================================
  //     const allOriginalRows = Array.from(
  //       originalTable.querySelectorAll("tbody tr")
  //     );

  //     const originalRows = allOriginalRows.filter((row) => {
  //       const text = row.textContent.trim().toLowerCase();
  //       if (text.includes("page total")) return false;
  //       if (text.includes("gross total")) return false;
  //       return true;
  //     });

  //     // =====================================================
  //     // Calculate overall Bill Amount total
  //     // =====================================================
  //     let totalAmount = 0;

  //     originalRows.forEach((row) => {
  //       const cells = row.querySelectorAll("td");
  //       const amountCell = cells[amountColIndex];

  //       if (amountCell) {
  //         const amountText = amountCell.textContent
  //           .replace(/,/g, "")
  //           .replace(/[₹$]/g, "")
  //           .replace(/\s+/g, "")
  //           .trim();

  //         const amount = parseFloat(amountText);
  //         if (!isNaN(amount)) {
  //           totalAmount += amount;
  //         }
  //       }
  //     });

  //     // =====================================================
  //     // Build cloned table: filtered rows, renumbered Sr No,
  //     // plus a single Total row
  //     // =====================================================
  //     const clonedTable = originalTable.cloneNode(true);
  //     const clonedTbody = clonedTable.querySelector("tbody");

  //     if (clonedTbody) {
  //       clonedTbody.innerHTML = "";

  //       originalRows.forEach((row, index) => {
  //         const clonedRow = row.cloneNode(true);

  //         // Renumber Sr No starting from 1
  //         const firstCell = clonedRow.querySelector("td");
  //         if (firstCell) {
  //           firstCell.textContent = index + 1;
  //         }

  //         clonedTbody.appendChild(clonedRow);
  //       });

  //       // Append single Total row
  //       const totalRow = document.createElement("tr");

  //       const totalLabelCell = document.createElement("td");
  //       totalLabelCell.textContent = "Total";
  //       totalLabelCell.style.fontWeight = "bold";
  //       totalLabelCell.style.fontSize = "18px";
  //       totalLabelCell.style.textAlign = "right";
  //       totalLabelCell.style.padding = "10px";
  //       totalLabelCell.colSpan = Math.max(amountColIndex, 1);
  //       totalRow.appendChild(totalLabelCell);

  //       const totalAmountCell = document.createElement("td");
  //       totalAmountCell.textContent = totalAmount.toLocaleString("en-IN", {
  //         minimumFractionDigits: 2,
  //         maximumFractionDigits: 2,
  //       });
  //       totalAmountCell.style.fontWeight = "bold";
  //       totalAmountCell.style.fontSize = "18px";
  //       totalAmountCell.style.textAlign = "right";
  //       totalAmountCell.style.padding = "10px";
  //       totalRow.appendChild(totalAmountCell);

  //       const remainingCols = headerColCount - amountColIndex - 1;
  //       if (remainingCols > 0) {
  //         const emptyCell = document.createElement("td");
  //         emptyCell.colSpan = remainingCols;
  //         totalRow.appendChild(emptyCell);
  //       }

  //       clonedTbody.appendChild(totalRow);
  //     }

  //     // Hide cloned table from view, ensure full width for wide tables
  //     clonedTable.style.position = "absolute";
  //     clonedTable.style.left = "-9999px";
  //     clonedTable.style.top = "0";
  //     clonedTable.style.width = originalTable.scrollWidth + "px";
  //     document.body.appendChild(clonedTable);

  //     const pdf = new jsPDF("p", "mm", "a4");
  //     const pageWidth = pdf.internal.pageSize.getWidth();
  //     const pageHeight = pdf.internal.pageSize.getHeight();

  //     pdf.setFontSize(16);
  //     pdf.setFont("helvetica", "bold");
  //     pdf.text(title, pageWidth / 2, 15, { align: "center" });

  //     const canvas = await html2canvas(clonedTable, {
  //       scale: 2,
  //       useCORS: true,
  //       backgroundColor: "#fff",
  //     });

  //     document.body.removeChild(clonedTable);

  //     const imgData = canvas.toDataURL("image/png");
  //     const imgWidth = pageWidth - 20;
  //     const imgHeight = (canvas.height * imgWidth) / canvas.width;

  //     let heightLeft = imgHeight;
  //     let position = 25;

  //     pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
  //     heightLeft -= pageHeight;

  //     while (heightLeft > 0) {
  //       position = heightLeft - imgHeight + 25;
  //       pdf.addPage();
  //       pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
  //       heightLeft -= pageHeight;
  //     }

  //     pdf.save(filename);
  //   } catch (error) {
  //     console.error("PDF Export Error:", error);
  //   } finally {
  //     setExportingPDF(false);
  //   }
  // };
  // Download only chart
  const downloadChartOnlyAsPDF = async (chartClass, filename, title) => {
    setLoading(true);

    try {
      const chartElement = document.querySelector(`.${chartClass}`);

      if (!chartElement) {
        alert('Chart not found!');
        setLoading(false);
        return;
      }

      const pdf = new jsPDF('l', 'mm', 'a4');
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      pdf.setFontSize(16);
      pdf.setFont(undefined, 'bold');
      pdf.text(title, pageWidth / 2, 15, { align: 'center' });

      const chartCanvas = await html2canvas(chartElement, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: '#ffffff'
      });

      const chartImgData = chartCanvas.toDataURL('image/png');
      const chartWidth = pageWidth - 20;
      const chartHeight = (chartCanvas.height * chartWidth) / chartCanvas.width;

      pdf.addImage(chartImgData, 'PNG', 10, 25, chartWidth, Math.min(chartHeight, pageHeight - 30));
      pdf.save(filename);

    } catch (error) {
      console.error('Error downloading chart:', error);
      alert('Failed to download chart as PDF');
    } finally {
      setLoading(false);
    }
  };
  // pie 

  const COLORS = ['#4f46e5', '#22c55e', '#f97316', '#06b6d4', '#ec4899', '#facc15', '#8b5cf6'];


  const yearMap = {};

  const years = [
    ...new Set(
      demandgeneration
        .map(item => item.Proposal_year)
        .filter(year => year) // Remove undefined/null
    )
  ].sort()
  console.log("years", years);
  years.forEach(year => {
    yearMap[year] = {
      year,
      totalRelease: 0,
      totalDemand: 0
    };
  });


  releasefromfdutf.forEach(item => {
    const year = item.ProposalYear;
    console.log("item", item);
    const releaseAmount = parseFloat(item.OriginalLimitAllocatedAmount || 0);

    if (yearMap[year]) {
      yearMap[year].totalRelease += releaseAmount;
      console.log("year data", yearMap[year]);
    }
  });

  demandgeneration.forEach(item => {
    const year = item.Proposal_year;
    const demandAmount = parseFloat(item.BillAmount || 0);
    console.log("demand item", demandAmount);
    if (yearMap[year]) {
      yearMap[year].totalDemand += demandAmount;
      console.log("year data demand", yearMap[year]);
    }
  });


  const barChartData = useMemo(() => {
    // Filter data based on selectedHeadCode (if selected, otherwise show all)
    let filteredReleases = selectedHeadCode
      ? releasefromfdutf.filter(item => item.HeadCode === selectedHeadCode)
      : releasefromfdutf;

    let filteredDemands = selectedHeadCode
      ? demandgeneration.filter(item => item.HeadCode === selectedHeadCode)
      : demandgeneration;

    if (selectedYear) {
      filteredReleases = filteredReleases.filter(item => item.ProposalYear === selectedYear);
      filteredDemands = filteredDemands.filter(item => item.ProposalYear === selectedYear);
    }

    console.log("Filtered Releases for chart:", filteredReleases);
    console.log("Filtered Demands for chart:", filteredDemands);

    const yearMap = {};

    // Get all unique years from both datasets
    const releaseYears = filteredReleases.map(item => item.ProposalYear).filter(Boolean);
    const demandYears = filteredDemands.map(item => item.ProposalYear).filter(Boolean);

    const years = [...new Set([...releaseYears, ...demandYears])].sort();

    console.log("All years for chart:", years);

    // Initialize yearMap for all years
    years.forEach(year => {
      yearMap[year] = {
        year,
        totalRelease: 0,
        totalDemand: 0
      };
    });

    // Calculate releases per year
    filteredReleases.forEach(item => {
      const year = item.ProposalYear;
      const releaseAmount = parseFloat(item.ApprovedWorkAmount || 0);

      if (year && yearMap[year]) {
        yearMap[year].totalRelease += releaseAmount;
      }
    });

    // Calculate demands per year
    filteredDemands.forEach(item => {
      const year = item.ProposalYear;
      const demandAmount = parseFloat(item.BillPaidAmount || 0);

      if (year && yearMap[year]) {
        yearMap[year].totalDemand += demandAmount;
      }
    });

    console.log("Year Map:", yearMap);

    // Convert to chart data format
    const chartData = years.map(year => ({
  year,
  release: +(yearMap[year].totalRelease).toFixed(2),
  demand: +(yearMap[year].totalDemand).toFixed(2)
}));

    console.log("Final Bar Chart Data:", chartData);

    return chartData;

  }, [releasefromfdutf, demandgeneration, selectedHeadCode, selectedYear]);

  console.log("barchartdata", barChartData);


  useEffect(() => {
    setShowGraph("Table");
  }, [showspecific])

  function extractCoords(raw) {
    if (!raw) return "";

    // Remove escaped quotes
    const str = String(raw).replace(/\\"/g, '"');

    const start = str.indexOf('[[');
    const end = str.lastIndexOf(']]');

    if (start === -1 || end === -1) return raw;

    return str.substring(start, end + 2); // full [[...]]
  }

  const proposalChartData = React.useMemo(() => {
    if (!talukawiseProposalData || talukawiseProposalData.length === 0) return [];

    const map = {};

    talukawiseProposalData.forEach(item => {
      const proposal = item.ProposalID;
      const amountRs = Number(item.OriginalLimitAllocatedAmount || 0);

      if (!map[proposal]) {
        map[proposal] = {
          proposal,
          amountRs: 0,
          amountCr: 0,
        };
      }

      map[proposal].amountRs += amountRs;
      map[proposal].amountCr += amountRs / 10000000; // convert to Cr
    });

    return Object.values(map);
  }, [talukawiseProposalData]);

  const grouped = talukawiseDemandData.reduce((acc, cur) => {
    const taluka = (cur.taluka || "Unknown").trim();
    const amount = parseFloat(cur.totalBillAmount || 0);

    if (!acc[taluka]) acc[taluka] = 0;
    acc[taluka] += amount;

    return acc;
  }, {});

  const chartData = Object.keys(grouped).map(taluka => ({
    taluka,
    rawAmount: grouped[taluka],                                // ₹
    amountCr: Number((grouped[taluka] / 10000000).toFixed(3)) // Cr
  }));

  const demandChartData = sortedDemandDatabytaluka.map(item => {
    const billRs = Number(item.BillAmount || 0);

    return {
      proposal: item.Work_name,
      amountRs: billRs,
      amountCr: billRs / 10000000   // ₹ → Cr (number)
    };
  });

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedContractor]);

  const exportContractorBillsToExcel = (data, filename = "ContractorBills.xlsx") => {
    if (!data || data.length === 0) {
      alert("No data available!");
      return;
    }

    const worksheetData = [
      [
        "Vendor Name",
        "Year",
        "Bill ID",
        "Bill Amount",
        "Payable Amount",
        "Deduction Amount",
        "Date"
      ],
      ...data.map(item => [
        item.ContractorName,
        selectedYear,
        item.DemandGenerationID,
        item.BillAmount,
        item.NetPayableAmount,
        item.DeductionAmount,
        item.Date ? new Date(item.Date).toLocaleString() : ""
      ])
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    worksheet['!cols'] = [
      { wch: 25 },
      { wch: 10 },
      { wch: 20 },
      { wch: 15 },
      { wch: 18 },
      { wch: 18 },
      { wch: 22 }
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Bills");

    XLSX.writeFile(workbook, filename);
  };

  const downloadContractorBillsTablePDF = (data, filename, title) => {
    if (!data || data.length === 0) {
      alert("No data available");
      return;
    }

    const pdf = new jsPDF("l", "mm", "a4"); // landscape for better width

    // Title
    pdf.setFontSize(14);
    pdf.text(title, pdf.internal.pageSize.getWidth() / 2, 12, {
      align: "center",
    });

    // Prepare table body
    const tableBody = data.map((item, index) => ([
      index + 1,
      item.ContractorName,
      selectedYear,
      item.DemandGenerationID,
      Number(item.BillAmount).toLocaleString(),
      Number(item.NetPayableAmount).toLocaleString(),
      Number(item.DeductionAmount).toLocaleString(),
      item.Date ? new Date(item.Date).toLocaleDateString() : "",
    ]));

    autoTable(pdf, {
      startY: 18,
      head: [[
        "Sr No",
        "Vendor Name",
        "Year",
        "Bill ID",
        "Bill Amount",
        "Payable Amount",
        "Deduction Amount",
        "Date",
      ]],
      body: tableBody,
      theme: "grid",
      styles: {
        fontSize: 9,
        cellPadding: 3,
        halign: "center",
      },
      headStyles: {
        fillColor: [79, 70, 229], // blue header
        textColor: 255,
        halign: "center",
      },
      columnStyles: {
        1: { halign: "left" }, // Contractor Name
        3: { halign: "left" }, // Bill ID
      },
      didDrawPage: (data) => {
        pdf.setFontSize(9);
        pdf.text(
          `Page ${pdf.internal.getNumberOfPages()}`,
          pdf.internal.pageSize.getWidth() - 20,
          pdf.internal.pageSize.getHeight() - 10
        );
      },
    });

    pdf.save(filename);
  };

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  const contractorTotalRow = {
    ContractorName: "Total Amount",
    Year: "",
    DemandGenerationID: "",
    BillAmount: ContractorBillDetail.reduce(
      (s, v) => s + Number(v.BillAmount || 0),
      0
    ),
    NetPayableAmount: ContractorBillDetail.reduce(
      (s, v) => s + Number(v.NetPayableAmount || 0),
      0
    ),
    DeductionAmount: ContractorBillDetail.reduce(
      (s, v) => s + Number(v.DeductionAmount || 0),
      0
    ),
    Date: ""
  };

  const contractorExportData = [
    ...ContractorBillDetail,
    contractorTotalRow
  ];

  const getDistrictGRSummary = (data) => {
    const map = {};

    data.forEach((gr) => {
      const district = getMainDistrict(gr.ZillaParishad) || "Unknown";

      if (!map[district]) {
        map[district] = {
          District: district,
          TotalGR: 0,
          TotalAmount: 0,
        };
      }

      map[district].TotalGR += 1;
      map[district].TotalAmount += Number(gr.GRAmount || 0);
    });

    return Object.values(map).sort((a, b) => b.TotalGR - a.TotalGR);
  };

  useEffect(() => {
    if (AllGRS?.length) {
      setDistrictGRSummary(getDistrictGRSummary(AllGRS));
    }
  }, [AllGRS]);

  const showDistrictGR = (district) => {
    const filtered = AllGRS.filter(
      (gr) => isDistrictMatch(gr.ZillaParishad, district)
    );

    setFilteredGRS(filtered);
    setCurrentPage(1);
    setShowAllGR(false);
    setShowSpecific(100); // open your GR table view
  };

  // choose data source
  const sourceGRS = filteredGRS.length ? filteredGRS : AllGRS;

  // ✅ SORT FIRST (newest first)
  const sortedGRS = [...sourceGRS].sort(
    (a, b) => Number(b.ID) - Number(a.ID)
  );

  // pagination calculations
  const totalPages = Math.ceil(sortedGRS.length / itemsPerPage);

  const paginatedGRS = sortedGRS.slice(
    indexOfFirstGRS,
    indexOfLastGRS
  );

  console.log("paginatedGRS: ", paginatedGRS);

  const filteredHeadCodes = useMemo(() => {

    const roleHeadMap = {
      "State-2515-RDD Checker(ASO)": [
        "2515-1238(MLA Representative)"
      ],
      "State-2515-RDD Section Officer": [
        "2515-1238(MLA Representative)"
      ],

      "State-RDD Checker(ASO)": [
        "3054-2419(Roads and bridge repair maintenance program)"
      ],
      "State-RDD Section Officer": [
        "3054-2419(Roads and bridge repair maintenance program)"
      ],

      "State-Deputy Secretary": [
        "3054-2419(Roads and bridge repair maintenance program)",
        "2515-1238(MLA Representative)"
      ],
    };

    const allowedHeads = roleHeadMap[userData?.FullName];

    if (allowedHeads) {
      return HeadCode.filter(val =>
        allowedHeads.includes(val.HeadName)
      );
    }

    return HeadCode;

  }, [userData, HeadCode]);

  useEffect(() => {
    if (!filteredHeadCodes?.length) return;

    const role = userData?.FullName;

    // Roles that must auto-select single option
    const autoSelectRoles = [
      "State-2515-RDD Checker(ASO)",
      "State-2515-RDD Section Officer",
      "State-RDD Checker(ASO)",
      "State-RDD Section Officer",
    ];

    // Default selection for Deputy Secretary
    if (role !== "State-2515-RDD Checker(ASO)" &&
      role !== "State-2515-RDD Section Officer") {
      const defaultHead = filteredHeadCodes.find(
        h => h.HeadName ===
          "3054-2419(Roads and bridge repair maintenance program)"
      );

      if (defaultHead && !selectedHeadCode) {
        setSelectedHeadCode(defaultHead.HeadID);
      }
      return;
    }

    // Auto select when only one option
    if (autoSelectRoles.includes(role) && filteredHeadCodes.length === 1) {
      setSelectedHeadCode(filteredHeadCodes[0].HeadID);
    }

  }, [filteredHeadCodes, userData]);

  const getDistrictTSSummary = (data) => {
    const map = {};

    data.forEach((ts) => {
      const district = getMainDistrict(ts.District) || "Unknown";

      if (!map[district]) {
        map[district] = {
          District: district,
          TotalTS: 0,
          TotalAmount: 0,
        };
      }

      map[district].TotalTS += 1;
      map[district].TotalAmount += Number(ts.TechnicalSanctionAmt || 0);
    });

    return Object.values(map).sort((a, b) => b.TotalTS - a.TotalTS);
  };

  useEffect(() => {
    if (allTSData?.length) {
      setDistrictTSSummary(getDistrictTSSummary(allTSData));
    }
  }, [allTSData]);

  const showDistrictTS = (district) => {
        const filtered = allTSData.filter(
      (ts) => isDistrictMatch(ts.District, district)
    );

    setFilteredTSData(filtered);
    setCurrentPageAllTSData(1);   // ⭐ important for pagination
    setShowSpecific(110);
  };

  const activeTSData = filteredTSData.length
    ? filteredTSData
    : allTSData;

  const filteredAllTSData = activeTSData.filter((item) => {
    const districtMatch =
      isDistrictMatch(item.District, selectedAllTSDistrict);

    const talukaMatch =
      !selectedAllTSTaluka ||
      item.Taluka === selectedAllTSTaluka;

    const headCodeMatch =
      !selectedAllTSHeadCode ||
      item.HeadCode === selectedAllTSHeadCode;

    const searchKeyword = searchAllTS.trim().toLowerCase();

    const searchMatch =
      !searchKeyword ||
      [
        item.WorkName,
        item.HeadCode,
        item.TS_ID,
        item.TechnicalSanctionNo,
        item.Area,
        item.GR_UID,
        item.SanctionYear,
        item.ConstituencyName,
        item.District,
        item.Taluka,
        item.GramPanchayat,
        item.TypeofWork,
        item.TechnicalSanctionAmt,
        item.TechnicalSanctionCopy,
        item.EditedBy,
        item.Date,
      ].some((value) =>
        String(value || "").toLowerCase().includes(searchKeyword)
      );

    return (
      districtMatch &&
      talukaMatch &&
      headCodeMatch &&
      searchMatch
    );
  });

  // SORT FIRST
  const sortedTS = [...filteredAllTSData].sort(
    (a, b) => new Date(b.Date || 0) - new Date(a.Date || 0)
  );

  const totalRecordsAllTSData = sortedTS.length;

  const totalPagesAllTSData = Math.ceil(
    totalRecordsAllTSData / recordsPerPageAllTSData
  );

  const currentAllTSData = showAllTSDetails
    ? sortedTS
    : sortedTS.slice(
      firstRecordIndexAllTSData,
      lastRecordIndexAllTSData
    );

  // Page Total - only currently visible records
  const pageTotalAllTSAmount = currentAllTSData.reduce(
    (sum, val) => sum + parseFloat(val.TechnicalSanctionAmt || 0),
    0
  );

  // Grand Total - all filtered records
  const grandTotalAllTSAmount = sortedTS.reduce(
    (sum, val) => sum + parseFloat(val.TechnicalSanctionAmt || 0),
    0
  );
  const getDistrictDRSummary = (data) => {
    const map = {};

    data.forEach((dr) => {
     const district = getMainDistrict(dr.District) || "Unknown";

      if (!map[district]) {
        map[district] = {
          District: district,
          TotalDemand: 0,
          TotalAmount: 0,
        };
      }

      map[district].TotalDemand += 1;
      map[district].TotalAmount += Number(dr.ApprovedDemandRequest || 0);
    });

    return Object.values(map).sort((a, b) => b.TotalDemand - a.TotalDemand);
  };

  useEffect(() => {
    if (DRtableData?.length) {
      setDistrictDRSummary(getDistrictDRSummary(DRtableData));
    }
  }, [DRtableData]);

  const showDistrictDR = (district) => {
    const filtered = DRtableData.filter(
      (dr) => isDistrictMatch(dr.District, district)
    );

    setFilteredDRData(filtered);
    setCurrentPageDRtableData(1);   // ⭐ reset pagination
    setShowSpecific(113);
  };

  const activeDRData = filteredDRData?.length
    ? filteredDRData
    : DRtableData;

  // ✅ SORT FIRST (newest first)
  const sortedDR = [...activeDRData].sort((a, b) => new Date(b.created_At || 0) - new Date(a.created_At || 0));

  const totalRecordsDRtableData = sortedDR.length;

  const totalPagesDRtableData = Math.ceil(
    totalRecordsDRtableData / recordsPerPageDRtableData
  );

  const currentDRtableData = sortedDR.slice(
    firstRecordIndexDRtableData,
    lastRecordIndexDRtableData
  );

  const getDistrictWOSummary = (data) => {
    const map = {};

    data.forEach((wo) => {
    const district = getMainDistrict(wo.talulka) || "Unknown";

      if (!map[district]) {
        map[district] = {
          District: district,
          TotalWO: 0,
          TotalAmount: 0,
        };
      }

      map[district].TotalWO += 1;
      map[district].TotalAmount += Number(wo.ApprovedWorkAmount || 0);
    });

    return Object.values(map).sort((a, b) => b.TotalWO - a.TotalWO);
  };

  useEffect(() => {
    if (workOrderData?.length) {
      setDistrictWOSummary(getDistrictWOSummary(workOrderData));
    }
  }, [workOrderData]);

  const showDistrictWO = (district) => {
       const filtered = workOrderData.filter(
      (wo) => isDistrictMatch(wo.talulka, district)
    );

    setFilteredWOData(filtered);
    setCurrentPageWorkOrderData(1);   // ⭐ important
    setShowSpecific(114);
  };

  const activeWOData = filteredWOData.length
    ? filteredWOData
    : workOrderData;

  // HeadCode + Random Search
  const filteredWorkOrderData = activeWOData.filter((item) => {

    // HeadCode filter
    const headCodeMatch =
      !selectedWOHeadCode ||
      String(item.HeadCode || "") === String(selectedWOHeadCode);

    // Random search
    const searchText = searchWorkOrder.trim().toLowerCase();

    const searchMatch =
      !searchText ||
      [
        item.WorkOrderID,
        item.WorkOrderNo,
        item.WorkName,
        item.HeadCode,
        item.TechnicalUID,
        item.ProposalID,
        item.ProposalYear,
        item.talulka,
        item.ApprovedWorkAmount,
        item.BillRemainingAmount,
        item.BillPaidAmount,
        item.WorkOrderDate,
        item.WorkEndDate,
        item.CopyofWorkOrder,
        item.Date,
        item.EditedBy,
      ].some((value) =>
        String(value ?? "").toLowerCase().includes(searchText)
      );

    return headCodeMatch && searchMatch;
  });

  // SORT FIRST
  const sortedWO = [...filteredWorkOrderData].sort(
    (a, b) =>
      new Date(b.WorkOrderDate || 0) -
      new Date(a.WorkOrderDate || 0)
  );

  const totalRecordsWorkOrderData = sortedWO.length;

  const totalPagesWorkOrderData = Math.ceil(
    totalRecordsWorkOrderData / recordsPerPageWorkOrderData
  );

  const currentWorkOrderData = sortedWO.slice(
    firstRecordIndexWorkOrderData,
    lastRecordIndexWorkOrderData
  );

  // Page Total - current page only
  const pageTotalWOApprovedAmount = currentWorkOrderData.reduce(
    (sum, item) =>
      sum + parseFloat(item.ApprovedWorkAmount || 0),
    0
  );

  const pageTotalWORemainingAmount = currentWorkOrderData.reduce(
    (sum, item) =>
      sum + parseFloat(item.BillRemainingAmount || 0),
    0
  );

  const pageTotalWOPaidAmount = currentWorkOrderData.reduce(
    (sum, item) =>
      sum + parseFloat(item.BillPaidAmount || 0),
    0
  );

  // Grand Total - all filtered records
  const grandTotalWOApprovedAmount = sortedWO.reduce(
    (sum, item) =>
      sum + parseFloat(item.ApprovedWorkAmount || 0),
    0
  );

  const grandTotalWORemainingAmount = sortedWO.reduce(
    (sum, item) =>
      sum + parseFloat(item.BillRemainingAmount || 0),
    0
  );

  const grandTotalWOPaidAmount = sortedWO.reduce(
    (sum, item) =>
      sum + parseFloat(item.BillPaidAmount || 0),
    0
  );


  useEffect(() => {
    // Always start from the original full list
    let filtered = [...originalTSData];

    // filter by head code
    // Ensure we check for "null" string if your select default is value="null"
    if (selectedHeadCode && selectedHeadCode !== "null") {
      filtered = filtered.filter(
        item => String(item.HeadCode) === String(selectedHeadCode)
      );
    }

    // filter by year
    if (selectedYear) {
      filtered = filtered.filter(
        item => item.SanctionYear === selectedYear || item.ProposalYear === selectedYear
      );
    }

    setallTSData(filtered);
    setTotalTSCreated(filtered.length);

    // Always start from the original full list
    let filteredDR = [...originalDRtableData];

    // filter by head code
    // Ensure we check for "null" string if your select default is value="null"
    if (selectedHeadCode && selectedHeadCode !== "null") {
      filteredDR = filteredDR.filter(
        item => String(item.HeadCode) === String(selectedHeadCode)
      );
    }

    // filter by year
    if (selectedYear) {
      filteredDR = filteredDR.filter(
        item => item.Year === selectedYear || item.ProposalYear === selectedYear
      );
    }

    const totalDRAmount = filteredDR.reduce((sum, row) => {
      //just becuase we have declare varchar instead of int
      const value = Number(String(row.DRAmount || "0").replace(/,/g, ""));
      return sum + value;
    }, 0);

    setDRtableData(filteredDR);
    setTotaldemandreqAMT(totalDRAmount);

    // Always start from the original full list
    let filteredWO = [...originalworkOrderData];

    // filter by head code
    // Ensure we check for "null" string if your select default is value="null"
    if (selectedHeadCode && selectedHeadCode !== "null") {
      filteredWO = filteredWO.filter(
        item => String(item.HeadCode) === String(selectedHeadCode)
      );
    }

    // filter by year
    if (selectedYear) {
      filteredWO = filteredWO.filter(
        item => item.ProposalYear === selectedYear || item.ProposalYear === selectedYear
      );
    }

    setWorkOrderData(filteredWO);
    setworkorderlength(filteredWO.length)

  }, [selectedHeadCode, selectedYear, originalTSData, originalDRtableData, originalworkOrderData]);

  return (
    <>
      <div className="col-12" style={{ backgroundColor: "#EFF3F8", overflowY: 'auto', height: '90vh' }}>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "10px 4rem",
          }}
        >
          <h4
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
              margin: 0,
            }}
          >
            <img src="\MIS-Report-Blue-64.png" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
            {t("MIS Report")}
          </h4>
        </div>

        {
          showspecific === 0 &&
          (
            <div className='col-12' style={{ padding: '1rem', width: '100%' }}>
              <div style={{ padding: '30px', borderRadius: '10px', background: "linear-gradient(135deg, rgba(56, 67, 159, 0.2), rgba(4, 142, 204, 0.2))", boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', marginBottom: '20px' }}>
                <div style={{ display: 'flex', gap: '2rem' }}>
                  <div style={{ flex: 1 }}>
                    <span style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', padding: '0px 3rem' }}>
                      <label style={{ width: '12rem', fontWeight: "700" }}>{t("Select Year")}</label>
                      <select value={selectedYear} onChange={(e) => { setSelectedYear(e.target.value); setSelectedDistrict(''); setSelectedDemandDistrict(''); }} style={{ width: '100%', padding: '0.5rem', borderRadius: 6, border: '1px solid #4338ca', fontSize: 16, color: '#4338ca' }}>
                        <option value="" disabled>{t("Select Year")}</option>
                        <option value="2019-2020">2019-2020</option>
                        <option value="2020-2021">2020-2021</option>
                        <option value="2021-2022">2021-2022</option>
                        <option value="2022-2023">2022-2023</option>
                        <option value="2023-2024">2023-2024</option>
                        <option value="2024-2025">2024-2025</option>
                        <option value="2025-2026">2025-2026</option>
                        <option value="2026-2027" selected>2026-2027</option>
                        {/* {allYears.map(year => (<option key={year} value={year}>{year}</option>))} */}
                      </select>
                    </span>
                  </div>

                  <div style={{ flex: 1 }}>

                    <span style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', padding: '0px 0rem' }}>
                      <label style={{ width: '18rem', fontWeight: "700" }}>{t("Choose Head Code")}</label>
                      <select value={selectedHeadCode} onChange={(e) => { setSelectedHeadCode(e.target.value); setSelectedDistrict(''); setSelectedDemandDistrict(''); }} style={{ width: '100%', padding: '0.5rem', borderRadius: 6, border: '1px solid #4338ca', fontSize: 16, color: '#4338ca' }}>
                        < option value="null">{t("Choose Head Code")}</option>
                        {filteredHeadCodes && filteredHeadCodes.map((val, index) => {
                          return (
                            <option key={index} value={val.HeadID}>{val.HeadName}</option>
                          )
                        })
                        }
                      </select>
                    </span>
                  </div>
                </div>
              </div>

              <div className='col-12'>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
                    gap: "2rem",
                    width: "100%",
                    justifyItems: "center",
                    marginTop: "20px"
                  }}
                >

                  {/* <div className='icon-wrapper'>
                    <div className='col-12'>
                      {
                        selectedYear && selectedHeadCode && (
                          <div
                            onClick={() => {
                              setShowDemandDistrictTable(!showDemandDistrictTable);
                              setSelectedDemandDistrict("");
                              setShowSpecific(1);
                            }}
                            style={{
                              width: "22rem",
                              height: "6rem",
                              borderRadius: "14px",
                              background: "#f2e2d9",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              padding: "1rem 1.25rem",
                              boxShadow: "0 8px 18px rgba(0,0,0,0.06)",
                              cursor: "pointer"
                            }}
                          >
                            <div style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "12px",
                              background: "#f2e2d9",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexShrink: 0
                            }}>
                              <img
                                src="/Total-Original-Limit-Allocated.png"
                                style={{ width: "70px", height: "70px", objectFit: "contain" }}
                              />
                            </div>

                            <div style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
                              <span style={{ fontSize: "0.9rem", fontWeight: 600, color: "#444" }}>
                                {t("Total Original LimitAllocated:")}
                              </span>
                              <span style={{ fontSize: "1.3rem", fontWeight: 700 }}>
                                ₹{Number(totalLimitAllocationAmount).toLocaleString("en-IN")}
                              </span>
                            </div>

                            <div className='arrow-icon'>
                              <img src="/Arrow-Total-Original-Limit-Allocated.png" style={{
                                width: "42px",
                                height: "42px",
                                borderRadius: "50%",
                                background: "#f2e2d9",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                              }} />
                            </div>
                          </div>
                        )}
                    </div>
                  </div> */}

                  <div className='icon-wrapper'>
                    <div className='col-12'>
                      {selectedYear && selectedHeadCode && (
                        <div
                          onClick={() => {
                            if (totalDemandAmount > 0) {
                              setShowDemandDistrictTable(!showDemandDistrictTable);
                              setSelectedDemandDistrict("");
                              setShowSpecific(50);
                            }
                          }}
                          style={{
                            width: "22rem",
                            height: "6rem",
                            borderRadius: "14px",
                            background: "#ddd9f3",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "1rem 1.25rem",
                            boxShadow: "0 8px 18px rgba(0,0,0,0.06)",
                            cursor: totalDemandAmount > 0 ? "pointer" : "not-allowed",
                            opacity: totalDemandAmount > 0 ? 1 : 0.6,
                          }}
                        >
                          <div style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "12px",
                            background: "#ddd9f3",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0
                          }}>
                            <img
                              src="/Total-Bill-Amount-for.png"
                              style={{ width: "70px", height: "70px", objectFit: "contain" }}
                            />
                          </div>

                          <div style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
                            <span style={{ fontSize: "0.9rem", fontWeight: 600, color: "#444" }}>
                              {t("Total Bill Amount:")}
                            </span>
                            <span style={{ fontSize: "1.3rem", fontWeight: 700 }}>
                              ₹{Number(totalDemandAmount).toLocaleString("en-IN")}
                            </span>
                          </div>

                          <div className='arrow-icon'>
                            <img src="/Arrow-Total-Bill-Amount-for.png" style={{
                              width: "42px",
                              height: "42px",
                              borderRadius: "50%",
                              background: "#ddd9f3",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center"
                            }} />
                          </div>
                        </div>

                      )}
                    </div>
                  </div>

                  <div className='icon-wrapper'>
                    <div className='col-12'>
                      {selectedYear && selectedHeadCode &&
                        (
                          <div
                            onClick={() => {
                              if (totalGRCreated > 0) setShowSpecific(99);
                            }}
                            style={{
                              width: "20rem",
                              height: "6rem",
                              borderRadius: "14px",
                              background: "#d7e9e2",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              padding: "1rem 1.25rem",
                              boxShadow: "0 8px 18px rgba(0,0,0,0.06)",
                              cursor: totalGRCreated > 0 ? "pointer" : "not-allowed",
                              opacity: totalGRCreated > 0 ? 1 : 0.6,
                            }}
                          >
                            <div style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "12px",
                              background: "#d7e9e2",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexShrink: 0
                            }}>
                              <img
                                src="/Total-Demand-Request-Created.png"
                                style={{ width: "70px", height: "70px", objectFit: "contain" }}
                              />
                            </div>

                            <div style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
                              <span style={{ fontSize: "0.9rem", fontWeight: 600, color: "#444" }}>
                                {t("Total GR Created:")}
                              </span>
                              <span style={{ fontSize: "1.3rem", fontWeight: 700 }}>
                                {totalGRCreated || 0}
                              </span>
                            </div>

                            <div className='arrow-icon'>
                              <img src="/Arrow-Total-Demand-Request-Created.png"
                                style={{
                                  width: "42px",
                                  height: "42px",
                                  borderRadius: "50%",
                                  background: "#d7e9e2",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center"
                                }} />
                            </div>
                          </div>

                        )}
                    </div>
                  </div>

                  <div className='icon-wrapper'>
                    <div className='col-12'>
                      {
                        selectedYear && selectedHeadCode && (
                          <div
                            onClick={() => {
                              if (totalTSCreated > 0) setShowSpecific(109);
                            }}
                            style={{
                              width: "22rem",
                              height: "6rem",
                              borderRadius: "14px",
                              background: "#d1e5fa",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              padding: "1rem 1.25rem",
                              boxShadow: "0 8px 18px rgba(0,0,0,0.06)",
                              cursor: totalTSCreated > 0 ? "pointer" : "not-allowed",
                              opacity: totalTSCreated > 0 ? 1 : 0.6,
                            }}
                          >
                            {/* Left Icon Box */}
                            <div style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "12px",
                              background: "#d1e5fa",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexShrink: 0
                            }}>
                              <img
                                src="/Total-Technical_S-Created.png"
                                style={{ width: "70px", height: "70px", objectFit: "contain" }}
                              />
                            </div>

                            {/* Text */}
                            <div style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
                              <span style={{ fontSize: "0.9rem", fontWeight: 600, color: "#444" }}>
                                {t("Total Technical_S Created:")}
                              </span>
                              <span style={{ fontSize: "1.3rem", fontWeight: 700 }}>
                                {totalTSCreated || 0}
                              </span>
                            </div>

                            {/* Right Arrow */}
                            <div className='arrow-icon'>
                              <img src="/Arrow-Total-Technical_S-Created.png" style={{
                                width: "42px",
                                height: "42px",
                                borderRadius: "50%",
                                background: "#d1e5fa",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                              }} />
                            </div>
                          </div>


                        )}
                    </div>
                  </div>

                  {/* <div className='icon-wrapper'>
                    <div className='col-12'>
                      {
                        selectedYear && selectedHeadCode && (
                          <div
                            onClick={() => {

                              setShowSpecific(112);
                            }}
                            style={{
                              width: "22rem",
                              height: "6rem",
                              borderRadius: "14px",
                              background: "#fff1dc",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              padding: "1rem 1.25rem",
                              boxShadow: "0 8px 18px rgba(0,0,0,0.06)",
                              cursor: "pointer"
                            }}
                          >
                            <div style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "12px",
                              background: "#fff1dc",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexShrink: 0
                            }}>
                              <img
                                src="/Total-GR-Created.png"
                                style={{ width: "70px", height: "70px", objectFit: "contain" }}
                              />
                            </div>

                            <div style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
                              <span style={{ fontSize: "0.9rem", fontWeight: 600, color: "#444" }}>
                                {t("Total Demand Request Created:")}
                              </span>
                              <span style={{ fontSize: "1.3rem", fontWeight: 700 }}>
                                ₹{Number(totaldemandreqAMT || 0).toLocaleString("en-IN")}
                              </span>
                            </div>

                            <div className='arrow-icon'>
                              <img src="/Arrow-Total-GR-Created.png" style={{
                                width: "42px",
                                height: "42px",
                                borderRadius: "50%",
                                background: "#fff1dc",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                              }} />
                            </div>
                          </div>


                        )}
                    </div>
                  </div> */}

                  <div className='icon-wrapper'>
                    <div className='col-12'>
                      {
                        selectedYear && selectedHeadCode && (
                          <div
                            onClick={() => {
                              if (workorderlength > 0) setShowSpecific(115);
                            }}
                            style={{
                              width: "20rem",
                              height: "6rem",
                              borderRadius: "14px",
                              background: "#ffe1e8",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              padding: "1rem 1.25rem",
                              boxShadow: "0 8px 18px rgba(0,0,0,0.06)",
                              cursor: workorderlength > 0 ? "pointer" : "not-allowed",
                              opacity: workorderlength > 0 ? 1 : 0.6,
                            }}
                          >
                            {/* Left Icon Box */}
                            <div style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "12px",
                              background: "#ffe1e8",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexShrink: 0
                            }}>
                              <img
                                src="/Total-Work-Order-Created.png"
                                style={{ width: "70px", height: "70px", objectFit: "contain" }}
                              />
                            </div>

                            {/* Text */}
                            <div style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
                              <span style={{ fontSize: "0.9rem", fontWeight: 600, color: "#444" }}>
                                {t("Total Work Order Created:")}
                              </span>
                              <span style={{ fontSize: "1.3rem", fontWeight: 700 }}>
                                {workorderlength || 0}
                              </span>
                            </div>

                            {/* Right Arrow */}
                            <div className='arrow-icon'>
                              <img src="/Arrow-Total-Work-Order-Created.png" style={{
                                width: "42px",
                                height: "42px",
                                borderRadius: "50%",
                                background: "#ffe1e8",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                              }} />
                            </div>
                          </div>


                        )}
                    </div>
                  </div>

                </div>
              </div>

              {
                selectedYear && selectedHeadCode &&
                (
                  <>

                    <div className="col-12 my-5 bar-chart-container" >
                      <div className="col-11 mx-auto">
                        <h4 className="text-center mb-4" style={{ color: '#1f2937', fontWeight: '700' }}>
                          {t("Year-wise Demand vs Release Comparison (in ₹ Rs)")}
                        </h4>

                        <ResponsiveContainer width="100%" height={420}>
                          <BarChart
                            data={barChartData}
                            margin={{ top: 30, right: 40, left: 40, bottom: 30 }}
                            barCategoryGap="20%"
                            barSize={100}
                          >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis
                              dataKey="year"
                              tick={{ fontSize: 12, fill: "#374151" }}
                              label={{ value: "Year", position: "bottom", offset: 30, fontSize: 15 }}
                            />
                            <YAxis
                              tick={{ fontSize: 12, fill: "#374151" }}
                              tickFormatter={(value) => `${value} Rs`}
                              label={{ value: "Amount (₹ Rs)", angle: -90, position: "insideLeft", offset: -30, fontSize: 15 }}
                            />
                            <Tooltip
                              formatter={(value) => `₹ ${Number(value).toLocaleString("en-IN")} Rs`}
                              contentStyle={{ fontSize: 13 }}
                            />
                            <Legend wrapperStyle={{ fontSize: 13 }} />

                            <Bar dataKey="release" fill="#4f46e5" name="Work order Aprroved Amount (Rs)" radius={[4, 4, 0, 0]}>
                              <LabelList dataKey="release" position="top" formatter={(v) => `${v} Rs`} style={{ fontSize: 12, fill: '#111827' }} />
                            </Bar>
                            <Bar dataKey="demand" fill="#10b981" name="Bill Paid Amount (Rs)" radius={[4, 4, 0, 0]}>
                              <LabelList dataKey="demand" position="top" formatter={(v) => `${v} Rs`} style={{ fontSize: 12, fill: '#111827' }} />
                            </Bar>
                          </BarChart>
                        </ResponsiveContainer>
                      </div>
                    </div>

                  </>
                )
              }
            </div>

          )
        }

        {/* Series for Part 1 for Release from UdF */}
        {
          selectedYear &&
          showspecific === 1 &&
          (
            <>

              <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
                <div className="col-11 m-auto">
                  <div className='col-12' >

                    <div className="col-12">
                      <button className='btn btn-danger px-3 rounded-4 mb-3 mt-3' onClick={() => setShowSpecific(0)}>{t("Back")}</button>
                    </div>

                    <div className="col-11 my-0 mx-auto">
                      <div className="row">
                        <div className="col-12 py-2 d-flex justify-content-left align-items-center">

                          <h5 className="my-auto fw-bold d-flex align-items-center">
                            <img
                              src="/GR-Approval64.png"
                              alt=""
                              style={{ width: "24px", height: "24px" }}
                              className="me-2"
                            />
                            <span>
                              {t("Limit Allocation Detail for Year")} {selectedYear}
                            </span>
                          </h5>
                        </div>

                        <div className="col-12 d-flex justify-content-end mt-3 mb-3 gap-2">
                          <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("ALlDistrictFinanceData", "AllDistrictReleaseData.xlsx")}>{t("Download Excel")}</button>
                          <button className='btn btn-danger px-4' onClick={() => downloadPageAsPDF('ALlDistrictFinanceData', `ALlDistrictFinanceData_${selectedYear}.pdf`, `ALlDistrict Finance Data ${selectedYear}`)}>{t("Download Pdf")}</button>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 pb-5">
                      <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>

                        <div className='col-12 tableDesign DistrictTableContianerModel2' style={{ background: '#2C78DB', overflowX: 'auto' }}>
                          <table className='m-0 py-0 ALlDistrictFinanceData' style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                              <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
                                <th style={{ minWidth: "250px", padding: "8px" }}>{t("District")}</th>
                                <th style={{ minWidth: "250px", padding: "8px" }}>{t("Year")}</th>
                                <th style={{ minWidth: "250px", padding: "8px" }}>{t("HeadCode")}</th>
                                <th style={{ minWidth: "250px", padding: "8px" }}>{t("Total Limit Allocated Amount")}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {
                                uniqueDistrictsData &&
                                  uniqueDistrictsData.length > 0 ? (
                                  uniqueDistrictsData.map((item, idx) => {
                                    const bgColor = idx % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                    return (
                                      <tr key={idx} style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "400" }}>
                                        <td><a
                                          href="#"
                                          className='my-auto'
                                          style={{ color: '#4f46e5', textDecoration: 'underline' }}
                                          onClick={(e) => {
                                            e.preventDefault();
                                            fetchreleasefromUdfData(selectedYear, item.District, selectedHeadCode);
                                          }}
                                        >
                                          {item.District}
                                        </a></td>
                                        <td>{selectedYear}</td>
                                        <td>{selectedHeadCode}</td>
                                        <td>
                                          ₹ {Number(item.TotalLimitAllottedAmount).toLocaleString("en-IN")}
                                        </td>
                                      </tr>
                                    )
                                  })

                                )
                                  :
                                  (
                                    <tr>
                                      <td colSpan={5} className='fw-bold'>{t("No data found")}</td>
                                    </tr>
                                  )
                              }
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </>
          )
        }

        {
          selectedDistrict &&
          showspecific === 2 &&
          (
            <>
              <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
                <div className="col-11 m-auto">
                  <div className='col-12' >

                    <div className="col-12">
                      {/* Smart Back: if in Chart view, go to Table; otherwise go back to previous screen */}
                      <button
                        className='btn btn-danger px-3 rounded-4 mb-3 mt-3'
                        onClick={() => {
                          if (showGraph === "Chart") {
                            // stay on showspecific===2 but switch to Table view
                            setShowGraph("Table");
                          } else {
                            // go back to parent screen
                            setShowSpecific(1);
                          }
                        }}
                      >
                        {t("Back")}
                      </button>
                    </div>

                    {
                      showGraph === "Table" &&
                      (
                        <>
                          <div className="col-11 my-4 mx-auto">
                            <div className="row">
                              <div className="d-flex justify-content-between align-items-center flex-wrap">
                                <h5 className="my-auto fw-bold d-flex align-items-center">
                                  <img src="/GR-Approval64.png" alt="" style={{ width: "24px", height: "24px" }} className="me-2" />
                                  <span>{t("All Entries for District:")}{selectedDistrict}</span>
                                </h5>
                              </div>

                              <div className="col-12 d-flex justify-content-end mt-3 mb-3 gap-2">
                                <button className="btn btn-primary px-4"
                                  onClick={() =>
                                    downloadPageAsPDF(
                                      "TalukaWiseDemandTable",
                                      "bar-chart-container",
                                      `DistrictWiseProposalTable_${selectedYear}.pdf`,
                                      `District Wise Table ${selectedYear}`
                                    )}
                                >
                                  📄 {t("Download Complete Report")}
                                </button>

                                <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("TalukaWiseDemandTable", "TalukaWiseReleasedata.xlsx")}>{t("Download Excel")}</button>

                                <button
                                  className="btn btn-danger px-4"
                                  onClick={() =>
                                    downloadTableOnlyAsPDF(
                                      "TalukaWiseDemandTable",          // ✅ TABLE CLASS
                                      `District_Table_${selectedYear}.pdf`,
                                      `All Entries of ${selectedYear}`
                                    )
                                  }
                                >
                                  {t("Download Pdf")}
                                </button>
                              </div>
                            </div>
                          </div>

                          <div className="col-12 pb-5">
                            <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>
                              <div className="col-md-6 col-sm-12 d-flex justify-content-start mb-3 text-center">
                                <button className={showGraph === "Table" ? "px-5 btn btn-success mx-2" : "px-5 btn btn-secondary mx-2"} onClick={() => setShowGraph("Table")}>{t("Table")}</button>
                                <button className={showGraph === "Chart" ? "px-5 btn btn-success" : "px-5 btn btn-secondary"} onClick={() => setShowGraph("Chart")} >{t("Chart")}</button>
                              </div>

                              <div className="m-auto tableDesign DistrictTableContianerModel2" style={{
                                background: '#2C78DB', overflowX: "auto",
                                overflowY: "auto",
                                maxHeight: "600px", // change height as needed
                                position: "relative"
                              }}>
                                <table className='m-0 p-0 TalukaWiseDemandTable' style={{ width: '100%', borderCollapse: 'collapse' }}>
                                  <thead style={{
                                    position: "sticky", backgroundColor: "#1976d2",
                                    top: 0,
                                    zIndex: 10,
                                  }}>
                                    <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
                                      <th style={{ width: "10%" }}>{t("Sr No")}</th>
                                      <th style={{ width: "20%" }}>{t("Taluka")}</th>
                                      <th style={{ width: "15%" }}>{t("Year")}</th>
                                      <th style={{ width: "35%" }}>{t("HeadCode")}</th>
                                      <th style={{ width: "20%" }}>{t("Limit Allocated Amount")}</th>
                                      <th style={{ width: "25%" }}>{t("Remaining Limit")}</th>
                                      <th style={{ width: "25%" }}>{t("Release Amount")}</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {
                                      filteredreleaseudf && filteredreleaseudf.length > 0 ? (() => {
                                        const totalLamount = filteredreleaseudf.reduce((sum, val) => sum + parseFloat(val.totalLimitAllocated || 0), 0);
                                        const totalRemainingLamount = filteredreleaseudf.reduce((sum, val) => sum + parseFloat(val.totalRemainingLimit || 0), 0);
                                        const totalRamount = filteredreleaseudf.reduce((sum, val) => sum + parseFloat(val.totalReleaseAmount || 0), 0);

                                        return (
                                          <>
                                            {
                                              filteredreleaseudf.map((val, index) => {
                                                const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                                return (
                                                  <tr key={index} style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "400" }}>
                                                    <td>{index + 1}</td>
                                                    <td onClick={() => fetchProposalfromReleaseBytaluka(val.Taluka)}>
                                                      <p className='makeitlink my-auto'>{val.Taluka}</p>
                                                    </td>
                                                    <td>{selectedYear}</td>
                                                    <td>{val.head || selectedHeadCode}</td>
                                                    <td>{Number(val.totalLimitAllocated).toLocaleString("en-IN")}</td>
                                                    <td>{Number(val.totalRemainingLimit).toLocaleString("en-IN")}</td>
                                                    <td>{Number(val.totalReleaseAmount).toLocaleString("en-IN")}</td>
                                                  </tr>
                                                );
                                              })
                                            }

                                            <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>
                                              <td colSpan={4}>{t("Total Amount")}</td>
                                              <td>₹ {Number(totalLamount).toLocaleString("en-IN")}</td>
                                              <td>₹ {Number(totalRemainingLamount).toLocaleString("en-IN")}</td>
                                              <td>₹ {Number(totalRamount).toLocaleString("en-IN")}</td>
                                            </tr>
                                          </>
                                        )
                                      })() : (
                                        <tr>
                                          <td colSpan={7} className='fw-bold'>{t("No data found")}</td>
                                        </tr>
                                      )
                                    }
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </>
                      )
                    }
                  </div>
                </div>

                {
                  // ---------- Chart Section: use aggregated data from filteredreleaseudf ----------
                  showGraph === "Chart" &&
                  filteredreleaseudf &&
                  filteredreleaseudf.length > 0 && (
                    <div className="col-12 mb-5 bar-chart-container">
                      <div className="col-11 mx-auto">
                        <h4 className="text-center mb-4" style={{ color: '#1f2937', fontWeight: '700' }}>
                          {t("Taluka-wise Limit Allocated (in ₹ Crores)")}
                        </h4>

                        {(() => {
                          // Aggregate by Taluka (same source as the table)
                          const grouped = filteredreleaseudf.reduce((acc, cur) => {
                            const tal = (cur.Taluka || 'Unknown').toString().trim();
                            const amount = parseFloat(cur.totalLimitAllocated || 0) || 0;
                            if (!acc[tal]) acc[tal] = 0;
                            acc[tal] += amount;
                            return acc;
                          }, {});

                          // convert to array and convert to Crores for display
                          const chartData = Object.keys(grouped).map(tal => ({
                            Taluka: tal,
                            rawAmount: grouped[tal], // rupees
                            totalLimitAllocatedInCr: Number((grouped[tal] / 10000000).toFixed(4)) // crore (keep some precision)
                          })).sort((a, b) => b.rawAmount - a.rawAmount);

                          // debug: verify chartData contains all talukas
                          console.log("Taluka chartData:", chartData);

                          return (
                            <ResponsiveContainer width="100%" height={450}>
                              <BarChart
                                data={chartData}
                                margin={{ top: 30, right: 40, left: 40, bottom: 60 }}
                                barCategoryGap="20%"
                                barGap={6}
                              >
                                <CartesianGrid strokeDasharray="3 3" />

                                <XAxis
                                  dataKey="Taluka"
                                  tick={{ fontSize: 12, fill: "#374151" }}
                                  interval={0}
                                  angle={-25}
                                  textAnchor="end"
                                  height={80}
                                  tickFormatter={(v) => (v && v.length > 16 ? v.slice(0, 16) + '...' : v)}
                                />

                                <YAxis
                                  tick={{ fontSize: 12, fill: "#374151" }}
                                  tickFormatter={(value) => `${value} Cr`}
                                  label={{ value: "Amount (₹ Cr)", angle: -90, position: "insideLeft", offset: -30, fontSize: 13 }}
                                />

                                <Tooltip
                                  formatter={(value, name, props) => {
                                    // value = Cr number, payload.rawAmount is rupee number
                                    const raw = props.payload && props.payload.rawAmount ? props.payload.rawAmount : 0;
                                    return [`₹ ${Number(raw).toLocaleString("en-IN")}`, `${name} (₹)`];
                                  }}
                                  labelFormatter={(label) => `Taluka: ${label}`}
                                  contentStyle={{ fontSize: 13, fontWeight: "600" }}
                                  cursor={{ fill: 'rgba(0, 0, 0, 0.05)' }}
                                />

                                <Legend wrapperStyle={{ fontSize: 13 }} />

                                <Bar
                                  dataKey="totalLimitAllocatedInCr"
                                  fill="#4f46e5"
                                  name="Limit Allocated (Cr)"
                                  radius={[4, 4, 0, 0]}
                                  barSize={40}
                                  minPointSize={6}            // CRITICAL: ensures very small values still render visibly
                                >
                                  <LabelList
                                    dataKey="totalLimitAllocatedInCr"
                                    position="top"
                                    formatter={(v) => `${v} Cr`}
                                    style={{ fontSize: 12, fill: '#111827', fontWeight: "600" }}
                                  />
                                </Bar>
                              </BarChart>
                            </ResponsiveContainer>
                          );
                        })()}
                      </div>
                    </div>
                  )
                }

              </div>
            </>
          )
        }

        {
          selectedDistrict &&
          showspecific === 3 &&
          (
            <>
              <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
                <div className="col-11 m-auto">
                  <div className='col-12' >

                    <div className="col-12">
                      <button
                        className='btn btn-danger px-3 rounded-4 mb-3 mt-3'
                        onClick={() => {
                          if (showGraph === "Chart") {
                            setShowGraph("Table");   // go back to table inside same level
                          } else {
                            setShowSpecific(2);      // go back to District level
                          }
                        }}
                      >
                        {t("Back")}
                      </button>
                    </div>

                    {
                      showGraph === "Table" &&
                      (
                        <>
                          <div className="col-11 my-4 mx-auto">
                            <div className="row">

                              <div className="d-flex justify-content-between align-items-center flex-wrap">
                                <h5 className="my-auto fw-bold d-flex align-items-center">
                                  <img
                                    src="/GR-Approval64.png"
                                    alt=""
                                    style={{ width: "24px", height: "24px" }}
                                    className="me-2"
                                  />
                                  <span>
                                    {t("All Entries for Taluka:")} {selectedTaluka}
                                  </span>
                                </h5>
                              </div>

                              <div className="col-12 d-flex justify-content-end mt-3 gap-2">
                                <button
                                  className="btn btn-primary px-4"
                                  onClick={() =>
                                    downloadPageAsPDF(
                                      "TalukaWiseProposalData",
                                      "bar-chart-container",
                                      `TalukaWiseProposalData_${selectedYear}.pdf`,
                                      `TalukaWise Proposal Data ${selectedYear}`
                                    )
                                  }
                                >
                                  📄 {t("Download Complete Report")}
                                </button>
                                <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("TalukaWiseProposalData", "TalukaWiseProposalData.xlsx")}>{t("Download Excel")}</button>
                                <button className='btn btn-danger px-4' onClick={() => downloadTableOnlyAsPDF('TalukaWiseProposalData', 'All Entries of Taluka', `TalukaWiseProposalData_${selectedYear}.pdf`, `TalukaWise Proposal Data ${selectedYear}`)}>{t("Download Pdf")}</button>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 pb-5">
                            <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>
                              <div className="col-md-6 col-sm-12 d-flex justify-content-start mb-3 text-center"></div>
                              <div className="col-md-6 col-sm-12 d-flex justify-content-start mb-3 text-center">
                                <button className={showGraph === "Table" ? "px-5 btn btn-success mx-2" : "px-5 btn btn-secondary mx-2"} onClick={() => setShowGraph("Table")}>Table</button>
                                <button className={showGraph === "Chart" ? "px-5 btn btn-success" : "px-5 btn btn-secondary"} onClick={() => setShowGraph("Chart")} >Chart</button>
                              </div>
                              <div className="m-auto tableDesign DistrictTableContianer" style={{
                                background: '#2C78DB', overflowX: "auto",
                                overflowY: "auto",
                                maxHeight: "600px", // change height as needed
                                position: "relative"
                              }}>
                                <table className='m-0 p-0 TalukaWiseProposalData' style={{ width: '100%', borderCollapse: 'collapse' }}>
                                  <thead style={{
                                    position: "sticky", backgroundColor: "#1976d2",
                                    top: 0,
                                    zIndex: 10,
                                  }}>
                                    <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
                                      <th style={{ width: "6%" }}>{t("Sr No")}</th>
                                      <th style={{ width: "15%" }}>{t("Proposal Name")}</th>
                                      <th style={{ width: "10%" }}>{t("Year")}</th>
                                      <th style={{ width: "10%" }}>{t("HeadCode")}</th>
                                      <th style={{ width: "15%" }}>{t("Proposal Amount")}</th>
                                      <th style={{ width: "15%" }}>{t("Limit Allocated Amount")}</th>
                                      <th style={{ width: "15%" }}>{t("Remaining Limit")}</th>
                                      <th style={{ width: "15%" }}>{t("Release Amount")}</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {
                                      currenttalukawiseProposalData &&
                                        currenttalukawiseProposalData.length > 0 ? (() => {
                                          const totalProposalamount = currenttalukawiseProposalData.reduce((sum, val) => sum + parseFloat(val.ProposalCost || 0), 0);
                                          const totalLimitamount = currenttalukawiseProposalData.reduce((sum, val) => sum + parseFloat(val.OriginalLimitAllocatedAmount || 0), 0);
                                          const totalRemainingLimit = currenttalukawiseProposalData.reduce((sum, val) => sum + parseFloat(val.LimitAllottedAmount || 0), 0);
                                          const totalReleaseamount = currenttalukawiseProposalData.reduce((sum, val) => sum + parseFloat(val.ReleaseAmountTillDate || 0), 0);

                                          return (
                                            <>
                                              {
                                                [...currenttalukawiseProposalData]
                                                  .sort((a, b) => b.ID - a.ID) //newest first
                                                  .map((val, index) => {
                                                    const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                                    return (
                                                      <tr key={index} style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "400" }}>
                                                        <td>{indexOfFirstUDF + index + 1}</td>
                                                        <td onClick={() => ProposalDataUsingSelectedProposal(val.ProposalID)}>
                                                          <p className='makeitlink my-auto'>{val.ProposalID}</p>
                                                        </td>
                                                        <td>{selectedYear}</td>
                                                        <td>{selectedHeadCode}</td>
                                                        <td>₹ {Number(val.ProposalCost).toLocaleString("en-IN")}</td>
                                                        <td>₹ {Number(val.OriginalLimitAllocatedAmount).toLocaleString("en-IN")}</td>
                                                        <td>₹ {Number(val.LimitAllottedAmount).toLocaleString("en-IN")}</td>
                                                        <td>₹ {Number(val.ReleaseAmountTillDate).toLocaleString("en-IN")}</td>
                                                      </tr>
                                                    );
                                                  }
                                                  )
                                              }

                                              <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>
                                                <td colSpan={4}>{t("Total Amount")}</td>
                                                <td>₹ {Number(totalProposalamount).toLocaleString("en-IN")}</td>
                                                <td>₹ {Number(totalLimitamount).toLocaleString("en-IN")}</td>
                                                <td>₹ {Number(totalRemainingLimit).toLocaleString("en-IN")}</td>
                                                <td>₹ {Number(totalReleaseamount).toLocaleString("en-IN")}</td>
                                              </tr>


                                            </>
                                          )

                                        }
                                        )()
                                        :
                                        (
                                          <tr>
                                            <td colSpan={5} className='fw-bold'>{t("No data found")}</td>
                                          </tr>
                                        )
                                    }
                                  </tbody>
                                </table>
                              </div>
                              <div className='col-12 mt-4 mb-2'>
                                <div className="row">
                                  <div className='col-6'>
                                    <p className="text-gray-600" style={{ fontSize: "14px" }}>{t("Showing")} {indexOfFirstUDF + 1} {t("to")} {Math.min(indexOfLastUDF, talukawiseProposalData.length)} {t("of")} {talukawiseProposalData.length} {t("entries")}</p>
                                  </div>
                                  <div className='col-6' style={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
                                    <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
                                      style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', width: '2rem' }}>&laquo;</button>
                                    <button onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}
                                      style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>&lt;</button>
                                    <button
                                      style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '20px', width: '2.4rem', border: '1px solid lightgrey', borderLeft: "none" }}>
                                      {currentPage}
                                    </button>
                                    <button onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === totalUDFPages || totalUDFPages === 0}
                                      style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>&gt;</button>
                                    <button onClick={() => setCurrentPage(totalUDFPages)} disabled={currentPage === totalUDFPages || totalUDFPages === 0}
                                      style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>&raquo;</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )
                    }
                  </div>
                </div>
                {
                  showGraph === "Chart" &&
                  talukawiseProposalData &&
                  talukawiseProposalData.length > 0 && (
                    <div className="col-12 mb-5 bar-chart-container">
                      <div className="col-11 mx-auto">
                        <h4 className="text-center mb-4" style={{ color: '#1f2937', fontWeight: '700' }}>
                          {t("Proposal-wise Limit Allocated (in ₹ Crores)")}
                        </h4>

                        <ResponsiveContainer width="100%" height={500}>
                          <BarChart
                            data={proposalChartData}
                            margin={{ top: 40, right: 30, left: 40, bottom: 140 }}
                            barCategoryGap="30%"
                          >
                            <CartesianGrid strokeDasharray="3 3" />

                            <XAxis
                              dataKey="proposal"
                              interval={0}
                              angle={-30}
                              textAnchor="end"
                              height={120}
                              tick={{ fontSize: 12 }}
                              label={{
                                value: t("Proposal Name"),
                                position: "bottom",
                                offset: 90,
                                fontSize: 14
                              }}
                            />

                            <YAxis
                              tickFormatter={(v) => `${v} Cr`}
                              label={{
                                value: t("Amount (₹ Cr)"),
                                angle: -90,
                                position: "insideLeft",
                                offset: -10,
                                fontSize: 14
                              }}
                            />

                            <Tooltip
                              formatter={(value, name, props) => {
                                const rs = props.payload.amountRs;
                                return [`₹ ${rs.toLocaleString("en-IN")}`, t("Limit Allocated")];
                              }}
                              labelFormatter={(label) => `${t("Proposal")}: ${label}`}
                              contentStyle={{ fontSize: 13, fontWeight: 600 }}
                            />

                            <Legend />

                            <Bar
                              dataKey="amountCr"
                              name={t("Limit Allocated (Cr)")}
                              fill="#4f46e5"
                              radius={[6, 6, 0, 0]}
                              maxBarSize={60}
                            >
                              <LabelList
                                dataKey="amountCr"
                                position="top"
                                formatter={(v) => `${v} Cr`}
                                style={{ fontSize: 11, fontWeight: 600 }}
                              />
                            </Bar>
                          </BarChart>
                        </ResponsiveContainer>
                      </div>
                    </div>
                  )
                }

              </div>


            </>
          )
        }

        {
          selectedWorkname &&
          showspecific === 4 &&
          <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
            <div className="col-11 m-auto">
              <div className='col-12' >

                <div className="col-12">
                  <button className='btn btn-danger px-3 rounded-4 mb-3 mt-3' onClick={() => setShowSpecific(3)}>{t("Back")}</button>
                </div>

                <div className="col-11 my-4 mx-auto">
                  <div className="row">

                    <div className="d-flex justify-content-between align-items-center flex-wrap">
                      <h5 className="my-auto fw-bold d-flex align-items-center">
                        <img
                          src="/GR-Approval64.png"
                          alt=""
                          style={{ width: "24px", height: "24px" }}
                          className="me-2"
                        />
                        <span>
                          {t("Proposal :")}{selectedWorkname}
                        </span>
                      </h5>
                    </div>

                    <div className="col-12 d-flex justify-content-end mt-3 gap-2">
                      <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("ProposalDataTable", "Proposal.xlsx")}>Download Excel</button>
                      <button className='btn btn-danger px-4' onClick={() => downloadTableOnlyAsPDF('ProposalDataTable', `ProposalDataTable${selectedYear}.pdf`, `Proposal Data Table ${selectedYear}`)}>Download Pdf</button>
                    </div>
                  </div>
                </div>


                <div className="m-auto tableDesign DistrictTableContianer" style={{
                  background: '#2C78DB', overflowX: "auto",
                  overflowY: "auto",
                  maxHeight: "600px", // change height as needed
                  position: "relative"
                }}>
                  <table className='p-0 m-0 ProposalDataTable' style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead style={{
                      position: "sticky", backgroundColor: "#1976d2",
                      top: 0,
                      zIndex: 10,
                    }}>
                      <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
                        {/* <th style={{ width: "10%" }}>Proposal ID</th> */}
                        <th style={{ width: "20%" }}>{t("Proposal Name")}</th>
                        {/* <th style={{ width: "20%" }}>Scheme</th> */}
                        <th style={{ width: "20%" }}>{t("Constituency Name")}</th>
                        <th style={{ width: "20%" }}>{t("Proposal Amount")}</th>
                        <th style={{ width: "20%" }}>{t("Date")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        fetchSpecificProposalData &&
                          fetchSpecificProposalData.length > 0 ? (
                          fetchSpecificProposalData.map((val, index) => {
                            const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                            return (
                              <tr key={index} style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "400" }}>
                                <td><p className='my-auto'>{val.Work_name}</p></td>
                                {/* <td>{val.SchemeName}</td> */}
                                <td>{val.Constituency_name}</td>
                                <td>₹ {Number(val.Proposal_amount).toLocaleString("en-IN")}</td>
                                <td>{new Date(val.created_at).toLocaleString("en-IN")}</td>
                              </tr>
                            )
                          })
                        )
                          :
                          (
                            <tr>
                              <td colSpan={5} className='fw-bold'>{t("No data found")}</td>
                            </tr>
                          )
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        }

        {/* Series for part 2 For Demand Reliated Data */}
        {
          selectedYear &&
          showspecific === 50 &&
          (
            <>
              <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
                <div className="col-11 m-auto">
                  <div className='col-12' >

                    <div className="col-12">
                      <button
                        className='btn btn-danger px-3 rounded-4 mb-3 mt-3'
                        onClick={() => {
                          setSelectedBillDistrict('');
                          setBillDistrictSearch('');
                          setDistrictPage(1);
                          setShowAllDistrict(false);
                          setShowSpecific(0);
                        }}
                      >
                        {t("Back")}
                      </button>
                    </div>

                    {
                      showGraph === "Table" && (
                        <>
                          <div className="col-11 my-4 mx-auto">
                            <div className="row align-items-center justify-content-between">
                              <div className="col-md-6 col-sm-12 my-auto">
                                <h5 className='my-auto fw-bold'>
                                  <img src="/GR-Approval64.png" alt="" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
                                  <span className='my-auto'>{t("Bill Amount by District for")} {selectedYear} </span>
                                </h5>
                              </div>

                              <div className="col-md-6 col-sm-12 d-flex justify-content-end gap-2">
                                <button className='btn btn-success px-2 mb-2' onClick={() => exportTableByClassToExcel("AllGR", "ProposalAmount.xlsx")}>{t("Download Excel")}</button>
                                <button className='btn btn-danger px-2 mb-2' onClick={() => downloadTableOnlyAsPDF('AllGR', `AllGR_${selectedYear}.pdf`, `All GR for ${selectedYear}`)}>
                                  {t("Download PDF")}
                                </button>
                              </div>
                            </div>
                          </div>
                          <div
                            className="d-flex justify-content-end mb-3"
                            style={{ gap: "10px" }}
                          >
                            {userData?.Department_Name === "State" && (
                              <select
                                className="form-select"
                                value={selectedBillDistrict}
                                onChange={(e) => {
                                  setSelectedBillDistrict(e.target.value);
                                  setDistrictPage(1);
                                  setShowAllDistrict(false);
                                }}
                                style={{
                                  width: "220px",
                                  border: "1px solid #ccc",
                                  borderRadius: "8px",
                                  padding: "8px 12px",
                                  fontSize: "16px",
                                }}
                              >
                                <option value="">All Districts</option>

                                {[...new Set(
                                  demandDistrictData
                                    .map(item => getMainDistrict(item.District))
                                    .filter(Boolean)
                                )]
                                  .sort()
                                  .map((district, index) => (
                                    <option key={index} value={district}>
                                      {district}
                                    </option>
                                  ))}
                              </select>
                            )}

                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search..."
                              value={billDistrictSearch}
                              onChange={(e) => {
                                setBillDistrictSearch(e.target.value);
                                setDistrictPage(1);
                                setShowAllDistrict(false);
                              }}
                              style={{
                                width: "220px",
                                border: "1px solid #ccc",
                                borderRadius: "8px",
                                padding: "8px 12px",
                                fontSize: "16px",
                              }}
                            />
                          </div>
                          <div className="col-12 pb-5">
                            <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>
                              <div className='col-12 tableDesign DistrictTableContianerModel2' style={{
                                background: '#2C78DB', overflowX: "auto",
                                overflowY: "auto",
                                maxHeight: "600px", // change height as needed
                                position: "relative"
                              }}>
                                <table className='m-0 p-0 AllGR' style={{ width: '100%', borderCollapse: 'collapse', tableLayout: "fixed", fontSize: "18px" }}>
                                  <thead style={{
                                    position: "sticky", backgroundColor: "#1976d2",
                                    top: 0,
                                    zIndex: 10,
                                  }}>
                                    <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
                                      <th style={{ width: "12%", fontSize: "18px" }}>{t("Sr No")}</th>
                                      <th style={{ width: "45%", fontSize: "18px" }}>{t("District")}</th>
                                      <th style={{ width: "45%", fontSize: "18px" }}>{t("Year")}</th>
                                      <th style={{ width: "45%", fontSize: "18px" }}>{t("HeadCode")}</th>
                                      <th style={{ width: "43%", fontSize: "18px" }}>{t("Bill Amount")}</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {
                                      demandDistrictData &&
                                        demandDistrictData.length > 0 ?
                                        (() => {
                                          const totalamount = filteredBillDistrictData.reduce((sum, val) => sum + parseFloat(val.TotalBillAmount || 0), 0);
                                          const pageTotalAmount = paginatedDistrictData.reduce(
                                            (sum, val) => sum + parseFloat(val.TotalBillAmount || 0),
                                            0
                                          );

                                          return (
                                            <>
                                              {
                                                paginatedDistrictData.map((val, index) => {
                                                  const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                                  return (
                                                    <tr key={index} style={{ backgroundColor: bgColor, fontSize: "18px", fontWeight: "400", fontSize: "18px" }}>
                                                      <td style={{ fontSize: "18px" }}>
                                                        {showAllDistrict
                                                          ? index + 1
                                                          : (districtPage - 1) * districtRecordsPerPage + index + 1}
                                                      </td>
                                                      <td style={{ fontSize: "18px", textAlign: 'center' }}>
                                                        <p style={{ fontSize: "18px", textAlign: 'center' }} className='makeitlink my-auto' onClick={() => DemandGenerationSortByDistrict(val.District)}>{val.District}</p>
                                                      </td>
                                                      <td style={{ fontSize: "18px" }}>{selectedYear}</td>
                                                      <td style={{ fontSize: "18px" }}>{selectedHeadCode}</td>
                                                      <td style={{ fontSize: "18px" }}>₹ {Number(val.TotalBillAmount).toLocaleString("en-IN")}</td>
                                                    </tr>
                                                  );
                                                })
                                              }

                                              <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0', fontSize: "18px", textAlign: "right" }}>
                                                <td colSpan={4} style={{ fontSize: "18px" }}>
                                                  {t("Page Total")}
                                                </td>
                                                <td style={{ fontSize: "18px" }}>
                                                  ₹ {Number(pageTotalAmount).toLocaleString("en-IN")}
                                                </td>
                                              </tr>
                                              <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0', fontSize: "18px", textAlign: "right" }}>
                                                <td colSpan={4} style={{ fontSize: "18px" }}>{t("Gross Total")}</td>
                                                <td style={{ fontSize: "18px" }}>₹ {Number(totalamount).toLocaleString("en-IN")}</td>
                                              </tr>
                                            </>
                                          );
                                        })()
                                        :
                                        (
                                          <tr>
                                            <td colSpan={5} className='fw-bold'>{t("No data found")}</td>
                                          </tr>
                                        )
                                    }
                                  </tbody>
                                </table>
                              </div>

                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  marginTop: "20px",
                                }}
                              >
                                <p className="text-gray-600 m-0" style={{ fontSize: "18px" }}>
                                  {t("Showing")}{" "}
                                  {demandDistrictData.length > 0
                                    ? showAllDistrict
                                      ? 1
                                      : (districtPage - 1) * districtRecordsPerPage + 1
                                    : 0}{" "}
                                  {t("to")}{" "}
                                  {showAllDistrict
                                    ? demandDistrictData.length
                                    : Math.min(
                                      districtPage * districtRecordsPerPage,
                                      demandDistrictData.length
                                    )}{" "}
                                  {t("of")} {demandDistrictData.length} {t("entries")}
                                </p>

                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      setShowAllDistrict(!showAllDistrict);
                                      setDistrictPage(1);
                                    }}
                                    style={{
                                      border: "none",
                                      outline: "none",
                                      cursor: "pointer",
                                      padding: "8px 16px",
                                      borderRadius: "20px",
                                      fontSize: "13px",
                                      fontWeight: "600",
                                      color: "#fff",
                                      background: showAllDistrict
                                        ? "linear-gradient(135deg, #28a745, #20c997)"
                                        : "linear-gradient(135deg, #0067ab, #0098d5)",
                                      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                                      transition: "all 0.3s ease",
                                    }}
                                  >
                                    {showAllDistrict ? "✓ Showing All" : "View All"}
                                  </button>

                                  {!showAllDistrict && (
                                    <GooglePagination
                                      currentPage={districtPage}
                                      totalPages={totalDistrictPages}
                                      onPageChange={setDistrictPage}
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                        </>
                      )
                    }
                  </div>
                </div>
                {
                  showGraph === "Chart" &&
                  demandDistrictData &&
                  demandDistrictData.length > 0 && (
                    <div className="col-12 mb-5 bar-chart-container">
                      <div className="col-11 mx-auto">
                        <h4 className="text-center mb-4" style={{ color: '#1f2937', fontWeight: '700' }}>
                          {t("District-wise Demand Generated (in ₹ Crores)")}
                        </h4>

                        <ResponsiveContainer width="100%" height={450}>
                          <BarChart
                            data={demandDistrictData.map(item => ({
                              District: item.District,
                              totalBillAmount: (parseFloat(item.TotalBillAmount || 0) / 10000000).toFixed(2) // Convert to Cr
                            }))}
                            margin={{ top: 30, right: 40, left: 40, bottom: 30 }}
                            barCategoryGap="1%"
                            barSize={100}
                            barGap={0}

                          >
                            <CartesianGrid strokeDasharray="3 3" />

                            <XAxis
                              dataKey="District"
                              tick={{ fontSize: 12, fill: "#374151" }}
                              interval={0}
                              angle={0}
                              textAnchor="end"
                              height={70}
                              label={{ value: "District", position: "bottom", offset: -30, fontSize: 15 }}
                            />

                            <YAxis
                              tick={{ fontSize: 12, fill: "#374151" }}
                              tickFormatter={(value) => `${value} Cr`}
                              label={{ value: "Amount (₹ Cr)", angle: -90, position: "insideLeft", offset: -30, fontSize: 15 }}
                            />

                            <Tooltip
                              formatter={(value) => `₹ ${Number(value).toLocaleString("en-IN")} Cr`}
                              contentStyle={{ fontSize: 13, fontWeight: "600" }}
                              cursor={{ fill: 'rgba(0, 0, 0, 0.1)' }}
                            />

                            <Legend wrapperStyle={{ fontSize: 13 }} />

                            <Bar dataKey="totalBillAmount" fill="#4f46e5" name="Demand Generated (Cr)" radius={[4, 4, 0, 0]}>
                              <LabelList
                                dataKey="totalBillAmount"
                                position="top"
                                formatter={(v) => `${v} Cr`}
                                style={{ fontSize: 12, fill: '#111827', fontWeight: "600" }}

                              />
                            </Bar>
                          </BarChart>
                        </ResponsiveContainer>
                      </div>
                    </div>
                  )
                }
              </div>
            </>
          )
        }

        {/* district  */}
        {
          fetchAllDemandBYDistrict &&
          showspecific === 51 && (
            <>
              <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
                <div className="col-11 m-auto">
                  <div className='col-12' >

                    <div className="col-12">
                      <button
                        className="btn btn-danger px-3 rounded-4 mb-3 mt-3"
                        onClick={() => {
                          if (showGraph === "Chart") {
                            setShowGraph("Table");     // stay in showspecific === 51
                          } else {
                            setShowSpecific(50);      // go back to previous screen
                          }
                        }}
                      >
                        {t("Back")}
                      </button>
                    </div>

                    {
                      showGraph === "Table" && (
                        <>
                          <div className="col-11 my-4 mx-auto">
                            <div className="row">

                              <div className="d-flex justify-content-between align-items-center flex-wrap">

                                <h5 className="my-auto fw-bold d-flex align-items-center">
                                  <img
                                    src="/GR-Approval64.png"
                                    alt=""
                                    style={{ width: "24px", height: "24px" }}
                                    className="me-2"
                                  />
                                  <span>
                                    {t("Total Bill Amount in ")}{selectedDemandDistrict} in {selectedYear}
                                  </span>
                                </h5>
                              </div>


                              <div className="col-12 d-flex justify-content-end mt-3 gap-2">
                                <button
                                  className="btn btn-primary px-4"
                                  onClick={() =>
                                    downloadPageAsPDF(
                                      "TalukaWiseDemandTable",      // TABLE
                                      "bar-chart-container",        // CHART
                                      `TalukaWiseDemand_Complete_${selectedYear}.pdf`,
                                      `Taluka-wise Demand Report ${selectedYear}`
                                    )
                                  }
                                >
                                  📄 {t("Download Complete Report")}
                                </button>

                                <button
                                  className="btn btn-success px-4"
                                  onClick={() =>
                                    exportTableByClassToExcel(
                                      "TalukaWiseDemandTable",
                                      "TalukaWiseDemandAmount.xlsx"
                                    )
                                  }
                                >
                                  {t("Download Excel")}
                                </button>

                                <button
                                  className="btn btn-danger px-4"
                                  onClick={() =>
                                    downloadTableOnlyAsPDF(
                                      "TalukaWiseDemandTable",
                                      `TalukaWiseDemandTable_${selectedYear}.pdf`,
                                      `Taluka-wise Demand Table ${selectedYear}`
                                    )
                                  }
                                >
                                  {t("Download Table PDF")}
                                </button>
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-12 d-flex align-items-center mb-3"
                            style={{
                              gap: "10px",
                              flexWrap: "nowrap",
                            }}
                          >
                            <button
                              className={
                                showGraph === "Table"
                                  ? "px-5 btn btn-success mx-2"
                                  : "px-5 btn btn-secondary mx-2"
                              }
                              onClick={() => setShowGraph("Table")}
                            >
                              {t("Table")}
                            </button>

                            <button
                              className={
                                showGraph === "Chart"
                                  ? "px-5 btn btn-success"
                                  : "px-5 btn btn-secondary"
                              }
                              onClick={() => setShowGraph("Chart")}
                            >
                              {t("Chart")}
                            </button>

                            {/* HeadCode Filter */}
                            {/* {userData?.Department_Name !== "State" && (
  <select
    className="form-select"
    value={selectedTableHeadCode}
    onChange={(e) => {
      setSelectedTableHeadCode(e.target.value);
      setCurrentPage(1);
      setShowAllTaluka(false);
    }}
    style={{
      width: "180px",
      height: "54px",
      border: "1px solid #ccc",
      borderRadius: "8px",
      padding: "8px 12px",
      fontSize: "16px",
    }}
  >
    <option value="">All HeadCodes</option>

    {filteredHeadCodes?.map((val, index) => (
      <option key={index} value={val.HeadID}>
        {val.HeadName}
      </option>
    ))}
  </select>
)} */}

                            {/* Search Taluka */}
                            <div
                              style={{
                                position: "relative",
                                width: "250px",
                                minWidth: "250px",
                                marginLeft: "5px",
                              }}
                            >
                              <img
                                src="/Search32.png"
                                alt="Search Icon"
                                style={{
                                  position: "absolute",
                                  top: "50%",
                                  left: "10px",
                                  transform: "translateY(-50%)",
                                  width: "16px",
                                  height: "16px",
                                  opacity: 0.6,
                                }}
                              />

                              <input
                                type="text"
                                className="form-control ps-4"
                                placeholder="Search Taluka"
                                value={searchTaluka}
                                onChange={(e) => {
                                  setSearchTaluka(e.target.value);
                                  setTalukaPage(1);
                                  setShowAllTaluka(false);
                                }}
                                style={{
                                  width: "100%",
                                  border: "1px solid #ccc",
                                  borderRadius: "8px",
                                  padding: "8px 12px 8px 30px",
                                  fontSize: "16px",
                                }}
                              />
                            </div>

                          </div>


                          <div className="col-12 pb-5">
                            <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>



                              <div
                                className="col-12 tableDesign DistrictTableContianer"
                                style={{
                                  background: "#2C78DB",
                                  overflowX: "hidden",
                                  width: "100%",
                                }}
                              >
                                <table
                                  className="m-0 p-0 TalukaWiseDemandTable"
                                  style={{
                                    width: "100%",
                                    tableLayout: "fixed",
                                    borderCollapse: "collapse",
                                  }}
                                >
                                  <thead>
                                    <tr
                                      style={{
                                        color: "white",
                                        border: "none",
                                        height: "3rem",
                                        fontSize: "18px",
                                      }}
                                    >
                                      <th style={{ width: "15%" }}>
                                        {t("Taluka")}
                                      </th>

                                      <th style={{ width: "10%" }}>
                                        {t("Year")}
                                      </th>

                                      <th style={{ width: "15%" }}>
                                        {t("HeadCode")}
                                      </th>

                                      <th
                                        style={{
                                          width: "20%",
                                          textAlign: "left",
                                          whiteSpace: "normal",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {t("Total Bill Amount")}
                                      </th>

                                      <th
                                        style={{
                                          width: "20%",
                                          textAlign: "left",
                                          whiteSpace: "normal",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {t("Total Net Payable Amount")}
                                      </th>

                                      <th
                                        style={{
                                          width: "20%",
                                          textAlign: "left",
                                          whiteSpace: "normal",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {t("Total Deduction Amount")}
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {
                                      talukawiseDemandData &&
                                        talukawiseDemandData.length > 0 ? (() => {
                                          const filteredData = talukawiseDemandData.filter((t) => {
                                            const talukaMatch =
                                              !searchTaluka ||
                                              t.taluka?.toLowerCase().includes(searchTaluka.toLowerCase());

                                            const headCodeMatch =
                                              !selectedTableHeadCode ||
                                              t.head === selectedTableHeadCode;

                                            return talukaMatch && headCodeMatch;
                                          });

                                          const totalBill = filteredData.reduce((sum, val) => sum + parseFloat(val.totalBillAmount || 0), 0);
                                          const totalNetPayable = filteredData.reduce((sum, val) => sum + parseFloat(val.totalNetPayable || 0), 0);
                                          const totalDeduction = filteredData.reduce((sum, val) => sum + parseFloat(val.totalDeduction || 0), 0);

                                          const pageTotalBill = paginatedTalukaData.reduce(
                                            (sum, val) => sum + parseFloat(val.totalBillAmount || 0),
                                            0
                                          );

                                          const pageTotalNetPayable = paginatedTalukaData.reduce(
                                            (sum, val) => sum + parseFloat(val.totalNetPayable || 0),
                                            0
                                          );

                                          const pageTotalDeduction = paginatedTalukaData.reduce(
                                            (sum, val) => sum + parseFloat(val.totalDeduction || 0),
                                            0
                                          );

                                          return (
                                            <>
                                              {paginatedTalukaData.map((item, index) => {
                                                const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                                return (
                                                  <tr key={index} style={{ backgroundColor: bgColor, fontSize: "18px", fontWeight: "400" }}>
                                                    <td style={{ fontSize: "18px" }}>
                                                      <p className='makeitlink my-auto' onClick={() => DemandGenerationSortByTaluka(item.taluka)}>
                                                        {item.taluka}
                                                      </p>
                                                    </td>
                                                    <td style={{ fontSize: "18px" }}>{item.year || selectedYear}</td>
                                                    <td style={{ fontSize: "18px" }}>{item.head || selectedHeadCode}</td>
                                                    <td style={{ textAlign: "left", fontSize: "18px" }}>₹ {Number(item.totalBillAmount).toLocaleString("en-IN")}</td>
                                                    <td style={{ textAlign: "left", fontSize: "18px" }}>₹ {Number(item.totalNetPayable).toLocaleString("en-IN")}</td>
                                                    <td style={{ textAlign: "left", fontSize: "18px" }}>₹ {Number(item.totalDeduction).toLocaleString("en-IN")}</td>
                                                  </tr>
                                                );
                                              })}

                                              {/* Page Total Row */}
                                              <tr
                                                style={{
                                                  fontWeight: "bold",
                                                  backgroundColor: "#f0f0f0",
                                                  fontSize: "18px"
                                                }}
                                              >
                                                <td colSpan={3} style={{ textAlign: "center", fontSize: "18px", textAlign: "right" }}>
                                                  Page Total
                                                </td>

                                                <td style={{ textAlign: "left", fontSize: "18px" }}>
                                                  ₹ {Number(pageTotalBill).toLocaleString("en-IN")}
                                                </td>

                                                <td style={{ textAlign: "left", fontSize: "18px" }}>
                                                  ₹ {Number(pageTotalNetPayable).toLocaleString("en-IN")}
                                                </td>

                                                <td style={{ textAlign: "left", fontSize: "18px" }}>
                                                  ₹ {Number(pageTotalDeduction).toLocaleString("en-IN")}
                                                </td>
                                              </tr>

                                              {/* Total Row */}
                                              <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0', fontSize: "18px", textAlign: "right" }}>
                                                <td style={{ fontSize: "18px" }} colSpan={3}>Gross Total</td>
                                                <td style={{ textAlign: "left", fontSize: "18px" }}>₹ {Number(totalBill).toLocaleString("en-IN")}</td>
                                                <td style={{ textAlign: "left", fontSize: "18px" }}>₹ {Number(totalNetPayable).toLocaleString("en-IN")}</td>
                                                <td style={{ textAlign: "left", fontSize: "18px" }}>₹ {Number(totalDeduction).toLocaleString("en-IN")}</td>
                                              </tr>
                                            </>
                                          );
                                        })() : (
                                        <tr>
                                          <td style={{ fontSize: "18px" }} colSpan={5} className='fw-bold'>{t("No data found")}</td>
                                        </tr>
                                      )
                                    }
                                  </tbody>
                                </table>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  marginTop: "20px",
                                }}
                              >
                                <p className="text-gray-600 m-0" style={{ fontSize: "18px" }}>
                                  {t("Showing")}{" "}
                                  {filteredTalukaData.length > 0
                                    ? showAllTaluka
                                      ? 1
                                      : (talukaPage - 1) * talukaRecordsPerPage + 1
                                    : 0}{" "}
                                  {t("to")}{" "}
                                  {showAllTaluka
                                    ? filteredTalukaData.length
                                    : Math.min(
                                      talukaPage * talukaRecordsPerPage,
                                      filteredTalukaData.length
                                    )}{" "}
                                  {t("of")} {filteredTalukaData.length} {t("entries")}
                                </p>

                                <div style={{ display: "flex", alignItems: "center", gap: "10px", fontSize: "18px" }}>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      setShowAllTaluka(!showAllTaluka);
                                      setTalukaPage(1);
                                    }}
                                    style={{
                                      border: "none",
                                      outline: "none",
                                      cursor: "pointer",
                                      padding: "8px 16px",
                                      borderRadius: "20px",
                                      fontSize: "13px",
                                      fontWeight: "600",
                                      color: "#fff",
                                      background: showAllTaluka
                                        ? "linear-gradient(135deg, #28a745, #20c997)"
                                        : "linear-gradient(135deg, #0067ab, #0098d5)",
                                      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                                      transition: "all 0.3s ease",
                                    }}
                                  >
                                    {showAllTaluka ? "✓ Showing All" : "View All"}
                                  </button>

                                  {!showAllTaluka && (
                                    <GooglePagination
                                      currentPage={talukaPage}
                                      totalPages={totalTalukaPages}
                                      onPageChange={setTalukaPage}
                                    />
                                  )}
                                </div>
                              </div>

                            </div>
                          </div>
                        </>
                      )
                    }
                  </div>
                </div>

                {
                  showGraph === "Chart" &&
                  talukawiseDemandData &&
                  talukawiseDemandData.length > 0 && (
                    <>
                      {/* ADD THIS NEW SECTION */}
                      <div className="col-11 my-4 mx-auto">
                        <div className="row">
                          <div className="d-flex justify-content-between align-items-center flex-wrap">
                            <h5 className="my-auto fw-bold d-flex align-items-center">
                              <span>
                                {t("Total Bill Amount in")} {selectedDemandDistrict} {t("in")} {selectedYear}
                              </span>
                            </h5>
                          </div>

                          <div className="col-12 d-flex justify-content-end mt-3 gap-2">
                            <button
                              className="btn btn-primary px-4"
                              onClick={() =>
                                downloadPageAsPDF(
                                  "TalukaWiseDemandTable",
                                  "bar-chart-container",
                                  `TalukaWiseDemand_Complete_${selectedYear}.pdf`,
                                  `Taluka-wise Demand Report ${selectedYear}`
                                )
                              }
                            >
                              📄 {t("Download Complete Report")}
                            </button>

                            <button
                              className="btn btn-danger px-4"
                              onClick={() =>
                                downloadChartOnlyAsPDF(
                                  "bar-chart-container",
                                  `TalukaWiseDemand_Chart_${selectedYear}.pdf`,
                                  `Taluka-wise Demand Chart ${selectedYear}`
                                )
                              }
                            >
                              {t("Download Chart PDF")}
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 mb-5 bar-chart-container">
                        <div className="col-11 mx-auto">
                          <h4 className="text-center mb-4" style={{ color: '#1f2937', fontWeight: '700' }}>
                            {t("Taluka-wise Demand Generated (in ₹ Crores)")}
                          </h4>

                          <ResponsiveContainer width="100%" height={450}>
                            <BarChart
                              data={chartData}
                              margin={{ top: 30, right: 40, left: 40, bottom: 80 }}
                              barCategoryGap="20%"
                            >
                              <CartesianGrid strokeDasharray="3 3" />

                              <XAxis
                                dataKey="taluka"
                                interval={0}
                                angle={-25}
                                textAnchor="end"
                                height={90}
                              />

                              <YAxis
                                tickFormatter={(v) => `${v} Cr`}
                                label={{
                                  value: "Amount (₹ Cr)",
                                  angle: -90,
                                  position: "insideLeft",
                                  offset: -30
                                }}
                              />

                              <Tooltip
                                formatter={(v, _, props) => [
                                  `₹ ${Number(props.payload.rawAmount).toLocaleString("en-IN")}`,
                                  "Total Bill Amount"
                                ]}
                              />

                              <Bar
                                dataKey="amountCr"
                                fill="#4f46e5"
                                minPointSize={6}
                                radius={[4, 4, 0, 0]}
                              >
                                <LabelList
                                  dataKey="amountCr"
                                  position="top"
                                  formatter={(v) => `${v} Cr`}
                                />
                              </Bar>
                            </BarChart>
                          </ResponsiveContainer>
                        </div>
                      </div>
                    </>
                  )
                }
              </div>
            </>
          )
        }

        {/* Demadn Talukd  */}
        {
          fetchAllDemandBYDistrict &&
          showspecific === 52 &&
          (
            <>
              <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
                <div className="col-11 m-auto">
                  <div className='col-12' >

                    <div className="col-12">
                      <button className='btn btn-danger px-3 rounded-4 mb-3 mt-3'
                        onClick={() => {
                          if (showGraph === "Chart") {
                            setShowGraph("Table");   // go back to table inside same level
                          } else {
                            setShowSpecific(51);      // go back to District level
                          }
                        }}
                      >{t("Back")}</button>
                    </div>

                    {
                      showGraph === "Table" &&
                      (
                        <>
                          <div className="col-11 my-4 mx-auto">
                            <div className="row">
                              <div className="d-flex justify-content-between align-items-center flex-wrap">
                                <h5 className="my-auto fw-bold d-flex align-items-center">
                                  <img src="/GR-Approval64.png" alt="" style={{ width: "24px", height: "24px" }} className="me-2" />
                                  <span className='my-auto'>{t("Bill Created in")} {selectedDemandTaluka} {t("for Year")} {selectedYear}</span>
                                </h5>



                              </div>
                              <div className="col-12 d-flex justify-content-end mt-3 gap-2">
                                <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("BillsDataTable", "BillCreated.xlsx")}>{t("Download Excel")}</button>
                                <button className='btn btn-danger px-4'
                                  onClick={() =>
                                    downloadTableOnlyAsPDF(
                                      "BillsDataTable",
                                      "Bill Created Data",
                                      `BillsData_${selectedYear}.pdf`,
                                      `Bills Created in ${selectedDemandTaluka} (${selectedYear})`
                                    )
                                  }
                                >{t("Download Pdf")}</button>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-12 d-flex justify-content-start align-items-center mb-3 text-center" style={{ gap: "12px" }}>
                            <button className={showGraph === "Table" ? "px-5 btn btn-success" : "px-5 btn btn-secondary"} onClick={() => setShowGraph("Table")}>{t("Table")}</button>
                            <button className={showGraph === "Chart" ? "px-5 btn btn-success" : "px-5 btn btn-secondary"} onClick={() => setShowGraph("Chart")} >{t("Chart")}</button>
                            <div style={{ width: "250px", position: "relative" }}>
                              <img
                                src="/Search32.png"
                                alt="Search Icon"
                                style={{
                                  position: "absolute",
                                  top: "50%",
                                  left: "10px",
                                  transform: "translateY(-50%)",
                                  width: "16px",
                                  height: "16px",
                                  opacity: 0.6
                                }}
                              />
                              <input
                                type="text"
                                className="form-control ps-4"
                                placeholder={t("Search Here")}
                                value={searchBill}
                                onChange={(e) => setSearchBill(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-12 pb-5">
                            <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>

                              <div className='col-12 tableDesign DistrictTableContianerModel2' style={{
                                background: '#2C78DB', overflowX: "auto",
                                overflowY: "auto",
                                maxHeight: "600px", // change height as needed
                                position: "relative"
                              }}>
                                <table
                                  className="m-0 p-0 BillsDataTable"
                                  id="BillsDataTable"
                                  style={{ width: '100%', borderCollapse: 'collapse', overflowInline: 'scroll' }}
                                >
                                  <thead style={{
                                    position: "sticky", backgroundColor: "#1976d2",
                                    top: 0,
                                    zIndex: 10,
                                  }}>
                                    <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
                                      <th style={{ width: "6%", fontSize: "18px" }}>{t("Sr No")}</th>
                                      <th style={{ width: "13%", fontSize: "18px" }}>{t("Work Name")}</th>
                                      {/* <th style={{ width: "5%" }}>Taluka</th> */}
                                      <th style={{ width: "12%", fontSize: "18px" }}>{t("Vendor Name")}</th>
                                      <th style={{ width: "12%", textAlign: "left", fontSize: "18px" }}>{t("Year")}</th>
                                      <th style={{ width: "12%", textAlign: "left", fontSize: "18px" }}>{t("HeadCode")}</th>
                                      <th style={{ width: "10%", fontSize: "18px" }}>{t("Date")}</th>
                                      <th style={{ width: "8%", fontSize: "18px" }}>{t("Approvance")}</th>
                                      <th style={{ width: "8%", textAlign: "left", fontSize: "18px" }}>{t("Bill Amount")}</th>
                                      <th style={{ width: "13%", textAlign: "left", fontSize: "18px" }}>{t("Net Payable Amount")}</th>
                                      <th style={{ width: "12%", textAlign: "left", fontSize: "18px" }}>{t("Deduction Amount")}</th>


                                    </tr>
                                  </thead>
                                  <tbody>
                                    {
                                      currentTalukaDemandData &&
                                        currentTalukaDemandData.length > 0 ? (() => {
                                          const filteredData = currentTalukaDemandData
                                            .filter(val => {
                                              if (!searchBill) return true;

                                              const keyword = searchBill.toLowerCase();

                                              return (
                                                String(val.ProjectID || "").toLowerCase().includes(keyword) ||
                                                String(val.ContractorName || "").toLowerCase().includes(keyword) ||
                                                String(val.BillAmount || "").includes(keyword) ||
                                                String(val.NetPayableAmount || "").includes(keyword) ||
                                                String(val.DeductionAmount || "").includes(keyword)
                                              );
                                            })
                                            .sort((a, b) => b.DemandGenerationID - a.DemandGenerationID) // ✅ newest first

                                          const totalBill = filteredData.reduce((sum, val) => sum + parseFloat(val.BillAmount || 0), 0);
                                          const totalNetPayable = filteredData.reduce((sum, val) => sum + parseFloat(val.NetPayableAmount || 0), 0);
                                          const totalDeduction = filteredData.reduce((sum, val) => sum + parseFloat(val.DeductionAmount || 0), 0);

                                          // Grand total across ALL pages (not just the current page), respecting the search filter
                                          const allFilteredDataForGrandTotal = sortedDemandDatabytaluka.filter(val => {
                                            if (!searchBill) return true;

                                            const keyword = searchBill.toLowerCase();

                                            return (
                                              String(val.ProjectID || "").toLowerCase().includes(keyword) ||
                                              String(val.ContractorName || "").toLowerCase().includes(keyword) ||
                                              String(val.BillAmount || "").includes(keyword) ||
                                              String(val.NetPayableAmount || "").includes(keyword) ||
                                              String(val.DeductionAmount || "").includes(keyword)
                                            );
                                          });

                                          const grandTotalBill = allFilteredDataForGrandTotal.reduce((sum, val) => sum + parseFloat(val.BillAmount || 0), 0);
                                          const grandTotalNetPayable = allFilteredDataForGrandTotal.reduce((sum, val) => sum + parseFloat(val.NetPayableAmount || 0), 0);
                                          const grandTotalDeduction = allFilteredDataForGrandTotal.reduce((sum, val) => sum + parseFloat(val.DeductionAmount || 0), 0);

                                          return (
                                            <>
                                              {filteredData.map((val, index) => {
                                                const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                                return (
                                                  <tr key={index} style={{ backgroundColor: bgColor, fontSize: "18px", fontWeight: "400" }}>
                                                    <td style={{ fontSize: "18px" }}>{firstRecordIndexDatabytaluka + index + 1}</td>
                                                    <td style={{ fontSize: "18px" }}>{val.ProjectID}</td>
                                                    {/* <td>{val.Taluka}</td> */}
                                                    <td style={{ fontSize: "18px" }}>
                                                      <p className='makeitlink my-auto' onClick={() => VendorBillDetailByContractorName(val.ContractorName)}>
                                                        {val.ContractorName}
                                                      </p>
                                                    </td>
                                                    <td style={{ fontSize: "18px" }}>{selectedYear}</td>
                                                    <td style={{ fontSize: "18px" }}>{selectedHeadCode}</td>
                                                    <td style={{ fontSize: "18px" }}>{new Date(val.Date).toLocaleString("en-IN")}</td>
                                                    <td style={{ fontSize: "18px" }} onClick={() => DemandDeductionDetailByBillID(val.DemandGenerationID, 55)}>
                                                      <p className='makeitlink my-auto' style={{ textAlign: "center" }}>{t("View")}</p>
                                                    </td>
                                                    <td style={{ textAlign: "left", fontSize: "18px" }}>₹ {Number(val.BillAmount).toLocaleString("en-IN")}</td>
                                                    <td style={{ textAlign: "left", fontSize: "18px" }}>₹ {Number(val.NetPayableAmount).toLocaleString("en-IN")}</td>
                                                    <td style={{ fontSize: "18px" }} onClick={() => DemandDeductionDetailByBillID(val.DemandGenerationID, 54)}>
                                                      <p className='makeitlink my-auto' style={{ textAlign: "left" }}>₹ {Number(val.DeductionAmount).toLocaleString("en-IN")}</p>
                                                    </td>


                                                  </tr>
                                                );
                                              })}

                                              {/* Page Total Row - sums only the rows visible on this page */}
                                              <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0', fontSize: "18px", fontWeight: "600", textAlign: "right" }}>
                                                <td style={{ fontSize: "18px" }} colSpan={7}>{t("Page Total")}</td>
                                                <td style={{ textAlign: "left", fontSize: "18px" }}>₹ {Number(totalBill).toLocaleString("en-IN")}</td>
                                                <td style={{ textAlign: "left", fontSize: "18px" }}>₹ {Number(totalNetPayable).toLocaleString("en-IN")}</td>
                                                <td style={{ textAlign: "left", fontSize: "18px" }}>₹ {Number(totalDeduction).toLocaleString("en-IN")}</td>
                                              </tr>

                                              {/* Total Amount Row - grand total across all pages */}
                                              <tr style={{ fontWeight: 'bold', backgroundColor: '#e0e0e0', fontSize: "18px", fontWeight: "600", textAlign: "right" }}>
                                                <td style={{ fontSize: "18px" }} colSpan={7}>{t("Gross Total")}</td>
                                                <td style={{ textAlign: "left", fontSize: "18px" }}>₹ {Number(grandTotalBill).toLocaleString("en-IN")}</td>
                                                <td style={{ textAlign: "left", fontSize: "18px" }}>₹ {Number(grandTotalNetPayable).toLocaleString("en-IN")}</td>
                                                <td style={{ textAlign: "left", fontSize: "18px" }}>₹ {Number(grandTotalDeduction).toLocaleString("en-IN")}</td>
                                              </tr>
                                            </>
                                          );
                                        })() : (
                                        <tr>
                                          <td style={{ fontSize: "18px" }} colSpan={10} className='fw-bold'>{t("No data found")}</td>
                                        </tr>
                                      )
                                    }
                                  </tbody>
                                </table>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  marginTop: "20px",
                                }}
                              >
                                <p className="text-gray-600 m-0" style={{ fontSize: "18px" }}>
                                  {t("Showing")}{" "}
                                  {sortedDemandDatabytaluka.length > 0
                                    ? showAllTalukaDemand
                                      ? 1
                                      : (talukaDemandPage - 1) * talukaDemandRecordsPerPage + 1
                                    : 0}{" "}
                                  {t("to")}{" "}
                                  {showAllTalukaDemand
                                    ? sortedDemandDatabytaluka.length
                                    : Math.min(
                                      talukaDemandPage * talukaDemandRecordsPerPage,
                                      sortedDemandDatabytaluka.length
                                    )}{" "}
                                  {t("of")} {sortedDemandDatabytaluka.length} {t("entries")}
                                </p>

                                <div style={{ display: "flex", alignItems: "center", gap: "10px", fontSize: "18px" }}>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      setShowAllTalukaDemand(!showAllTalukaDemand);
                                      setTalukaDemandPage(1);
                                    }}
                                    style={{
                                      border: "none",
                                      outline: "none",
                                      cursor: "pointer",
                                      padding: "8px 16px",
                                      borderRadius: "20px",
                                      fontSize: "18px",
                                      fontWeight: "600",
                                      color: "#fff",
                                      background: showAllTalukaDemand
                                        ? "linear-gradient(135deg, #28a745, #20c997)"
                                        : "linear-gradient(135deg, #0067ab, #0098d5)",
                                      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                                    }}
                                  >
                                    {showAllTalukaDemand ? "✓ Showing All" : "View All"}
                                  </button>

                                  {!showAllTalukaDemand && (
                                    <GooglePagination
                                      currentPage={talukaDemandPage}
                                      totalPages={totalTalukaDemandPages}
                                      onPageChange={setTalukaDemandPage}
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )
                    }

                    {
                      showGraph === "Chart" &&
                      currentTalukaDemandData &&
                      currentTalukaDemandData.length > 0 && (
                        <div className="col-12 mb-5 bar-chart-container">
                          <div className="col-11 mx-auto">
                            <h4 className="text-center mb-4" style={{ color: '#1f2937', fontWeight: '700' }}>
                              {t("Proposal-wise Demand Generated (in ₹ Crores)")}
                            </h4>

                            <ResponsiveContainer width="100%" height={450}>
                              <BarChart
                                data={demandChartData}
                                margin={{ top: 40, right: 30, left: 40, bottom: 140 }}
                                barCategoryGap="30%"
                              >
                                <CartesianGrid strokeDasharray="3 3" />

                                <XAxis
                                  dataKey="proposal"
                                  interval={0}
                                  angle={-30}
                                  textAnchor="end"
                                  height={120}
                                  tick={{ fontSize: 12 }}
                                  label={{
                                    value: "Proposals",
                                    position: "bottom",
                                    offset: 90,
                                    fontSize: 14
                                  }}
                                />

                                <YAxis
                                  tickFormatter={(v) => `${v.toFixed(2)} Cr`}
                                  label={{
                                    value: "Amount (₹ Cr)",
                                    angle: -90,
                                    position: "insideLeft",
                                    offset: -10,
                                    fontSize: 14
                                  }}
                                  domain={[0, 'auto']}
                                />

                                <Tooltip
                                  formatter={(value, name, props) => {
                                    const rs = props.payload.amountRs;
                                    return [`₹ ${rs.toLocaleString("en-IN")}`, "Demand Generated"];
                                  }}
                                  labelFormatter={(label) => `Proposal: ${label}`}
                                  contentStyle={{ fontSize: 13, fontWeight: 600 }}
                                />

                                <Legend />

                                <Bar
                                  dataKey="amountCr"
                                  name="Demand Generated (Cr)"
                                  fill="#4f46e5"
                                  radius={[6, 6, 0, 0]}
                                  maxBarSize={60}
                                >
                                  <LabelList
                                    dataKey="amountCr"
                                    position="top"
                                    formatter={(v) => `${v.toFixed(2)} Cr`}
                                    style={{ fontSize: 11, fontWeight: 600 }}
                                  />
                                </Bar>
                              </BarChart>
                            </ResponsiveContainer>
                          </div>
                        </div>
                      )
                    }

                  </div>
                </div>
              </div>
            </>
          )
        }

        {
          selectedDemandID &&
          showspecific === 54 &&
          (
            <>
              <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "134vh", overflowX: "hidden", overflowY: "scroll" }}>
                <div className="col-11 m-auto">
                  <div className='col-12' >

                    <div className="col-12">
                      <button className='btn btn-danger px-3 rounded-4 mb-3 mt-3' onClick={() => setShowSpecific(52)}>{t("Back")}</button>
                    </div>

                    <div className="col-11 my-4 mx-auto">
                      <div className="row">

                        <div className="d-flex justify-content-between align-items-center flex-wrap">

                          <h5 className="my-auto fw-bold d-flex align-items-center">
                            <img src="/GR-Approval64.png" alt="" style={{ width: "24px", height: "24px" }} className="me-2" />
                            <span>
                              {t("Deduction Data of Bill")} {selectedDemandID}
                            </span>
                          </h5>

                        </div>

                        <div className="col-12 d-flex justify-content-end mt-3 gap-2">
                          <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("DeductionTable", "Deduction.xlsx")}>Download Excel</button>
                          <button className='btn btn-danger px-4' onClick={() => downloadPageAsPDF('DeductionTable', `Deduction Table_${selectedYear}.pdf`, `Deduction Table ${selectedYear}`)}>Download Pdf</button>
                        </div>
                      </div>
                    </div>
                    <div className="m-auto tableDesign DistrictTableContianer" style={{
                      background: '#2C78DB', overflowX: "auto",
                      overflowY: "auto",
                      maxHeight: "600px", // change height as needed
                      position: "relative"
                    }}>
                      <table className='m-0 p-0 DeductionTable' style={{ width: '100%', borderCollapse: 'collapse', overflowInline: 'scroll' }}>

                        <thead style={{
                          position: "sticky", backgroundColor: "#1976d2",
                          top: 0,
                          zIndex: 10,
                        }}>
                          <tr style={{ fontSize: "18px" }}>
                            <th style={{ width: "10%", fontSize: "18px" }}>{t("Sr No")}</th>
                            <th style={{ width: "45%", fontSize: "18px" }}>{t("Deduction Name")}</th>
                            <th style={{ width: "45%", textAlign: "left", fontSize: "18px" }}>{t("Deduction Amount")}</th>

                          </tr>
                        </thead>
                        <tbody>
                          {
                            fetchSpecificDemandDeductionDetail &&
                              fetchSpecificDemandDeductionDetail.length > 0 ?
                              <>
                                {
                                  fetchSpecificDemandDeductionDetail
                                    .filter((item) => item.TypeOfAmount !== "Total Amount Payable")
                                    .map((val, index) => {
                                      const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                      return (
                                        <tr key={index} style={{ backgroundColor: bgColor, fontSize: "18px", fontWeight: "400" }}>
                                          <td style={{ fontSize: "18px" }}>{index + 1}</td>
                                          <td style={{ fontSize: "18px" }}>{val.TypeOfAmount}</td>
                                          <td style={{ textAlign: "left", fontSize: "18px" }}>₹ {Number(val.TotalAmount).toLocaleString("en-IN")}</td>
                                        </tr>
                                      );
                                    })
                                }


                                <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0', fontSize: "18px" }}>
                                  <td style={{ fontSize: "18px" }} colSpan={2}>{t("Total Deduction Amount")}</td>
                                  <td style={{ textAlign: "left", fontSize: "18px" }}>
                                    ₹ {Number(
                                      fetchSpecificDemandDeductionDetail
                                        .filter(item => item.TypeOfAmount !== "Total Amount Payable")
                                        .reduce((acc, curr) => acc + parseFloat(curr.TotalAmount || 0), 0)
                                    ).toLocaleString()
                                      // .toFixed(2)
                                    }
                                  </td>
                                </tr>
                              </>
                              :
                              (
                                <tr>
                                  <td style={{ fontSize: "18px" }} colSpan={5} className='fw-bold'>{t("No data found")}</td>
                                </tr>
                              )
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )
        }

        {
          selectedContractor &&
          showspecific === 57 && (
            <div
              className="col-12"
              style={{
                overflowX: "hidden",
                height: "89vh",
                overflowY: "scroll",
                scrollbarWidth: "none"
              }}
            >
              {/* BACK BUTTON */}
              <div className="row m-auto px-3">
                <div className="col-12 mb-3">
                  <button
                    className="btn btn-primary px-5"
                    onClick={() => setShowSpecific(52)}
                  >
                    {t("Back")}
                  </button>
                </div>
              </div>

              {/* HEADER */}
              {/* HEADER */}
              <div className="row align-items-center px-3 m-auto">

                {/* LEFT SIDE - TITLE */}
                <div className="col-md-6">
                  <h2
                    style={{
                      color: "#4f46e5",
                      fontWeight: "700",
                      fontSize: "1.4rem",
                      margin: 0
                    }}
                  >
                    Vendor '{selectedContractor}' {t("Bill Details")}
                  </h2>
                </div>

                {/* RIGHT SIDE - BUTTONS */}
                <div className="col-md-6 d-flex justify-content-md-end gap-2 mt-3 mt-md-0">
                  <button
                    className="btn btn-success px-4"
                    onClick={() =>
                      exportContractorBillsToExcel(
                        contractorExportData,
                        "ContractorBills.xlsx"
                      )
                    }
                  >
                    {t("Download Excel")}
                  </button>

                  <button
                    className="btn btn-danger px-4"
                    onClick={() =>
                      downloadContractorBillsTablePDF(
                        contractorExportData,
                        `ContractorBillDetail_${selectedYear}.pdf`,
                        `Contractor Bill Detail ${selectedYear}`
                      )
                    }
                  >
                    {t("Download Pdf")}
                  </button>
                </div>
              </div>

              {/* TABLE */}
              <div className="m-auto DistrictTableContianerModel3 mb-5">
                <table className="m-auto my-4 ContractorBillDetailTable">
                  <thead>
                    <tr style={{ fontSize: "18px" }}>
                      <th style={{ fontSize: "18px" }}>{t("Vendor Name")}</th>
                      <th style={{ fontSize: "18px" }}>{t("Year")}</th>
                      <th style={{ fontSize: "18px" }}>{t("Bill ID")}</th>
                      <th style={{ fontSize: "18px" }}>{t("Bill Amount")}</th>
                      <th style={{ fontSize: "18px" }}>{t("Payable Amount")}</th>
                      <th style={{ fontSize: "18px" }}>{t("Deduction Amount")}</th>
                      <th style={{ fontSize: "18px" }}>{t("Date")}</th>
                    </tr>
                  </thead>

                  <tbody>
                    {currentBills.length > 0 ? (
                      <>
                        {[...currentBills]
                          .sort((a, b) => new Date(b.Date || 0) - new Date(a.Date || 0)) // newest first
                          .map((val, index) => (
                            <tr key={index}>
                              <td style={{ fontSize: "18px" }}>
                                <p
                                  className="makeitlink my-auto"
                                  onClick={() =>
                                    ContractorDetailByContractorName(val.ContractorName)
                                  }
                                >
                                  {val.ContractorName}
                                </p>
                              </td>
                              <td style={{ fontSize: "18px" }}>{selectedYear}</td>
                              <td style={{ fontSize: "18px" }}>{val.DemandGenerationID}</td>
                              <td style={{ fontSize: "18px" }}>₹ {Number(val.BillAmount).toLocaleString("en-IN")}</td>
                              <td style={{ fontSize: "18px" }}>₹ {Number(val.NetPayableAmount).toLocaleString("en-IN")}</td>
                              <td style={{ fontSize: "18px" }}>₹ {Number(val.DeductionAmount).toLocaleString("en-IN")}</td>
                              <td style={{ fontSize: "18px" }}>{new Date(val.Date).toLocaleString("en-IN")}</td>
                            </tr>
                          ))}

                        {/* TOTAL ROW (FULL DATA TOTAL) */}
                        <tr
                          style={{
                            fontWeight: "600",
                            backgroundColor: "#f0f0f0",
                            fontSize: "18px"
                          }}
                        >
                          <td style={{ fontSize: "18px" }} colSpan={3}>{t("Gross Amount")}</td>
                          <td style={{ fontSize: "18px" }}>
                            ₹{" "}
                            {ContractorBillDetail.reduce(
                              (s, v) => s + Number(v.BillAmount || 0),
                              0
                            ).toLocaleString("en-IN")}
                          </td>
                          <td style={{ fontSize: "18px" }}>
                            ₹{" "}
                            {ContractorBillDetail.reduce(
                              (s, v) => s + Number(v.NetPayableAmount || 0),
                              0
                            ).toLocaleString("en-IN")}
                          </td>
                          <td style={{ fontSize: "18px" }}>
                            ₹{" "}
                            {ContractorBillDetail.reduce(
                              (s, v) => s + Number(v.DeductionAmount || 0),
                              0
                            ).toLocaleString("en-IN")}
                          </td>
                          <td></td>
                        </tr>
                      </>
                    ) : (
                      <tr>
                        <td style={{ fontSize: "18px" }} colSpan={7} className="fw-bold text-center">
                          {t("No data found")}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                {/* PAGINATION */}
                <div className='col-12 mt-4 p-2'>
                  <div className="row">
                    <div className='col-6'>
                      <p style={{ fontSize: "18px" }}>
                        {t("Showing")} {indexOfFirstBill + 1}{" "}
                        {t("to")}{" "}
                        {Math.min(indexOfLastBill, totalBillRecords)} {t("of")}{" "}
                        {totalBillRecords} {t("entries")}
                      </p>
                    </div>

                    <div
                      className='col-6'
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: "end"
                      }}
                    >
                      <GooglePagination
                        currentPage={currentPage}
                        totalPages={totalBillPages}
                        onPageChange={setCurrentPage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        }

        {/* 52 -> 55 approvance */}
        {
          selectedDemandID &&
          showspecific == 55 &&
          <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
            <div className="col-11 m-auto">
              <div className='col-12' >

                <div className="col-12">
                  <button className='btn btn-danger px-3 rounded-4 mb-3 mt-3' onClick={() => setShowSpecific(52)}>{t("Back")}</button>
                </div>

                <div className="col-11 my-4 mx-auto">
                  <div className="row">

                    <div className="d-flex justify-content-between align-items-center flex-wrap">
                      <h5 className="my-auto fw-bold d-flex align-items-center">
                        <img src="/GR-Approval64.png" alt="" style={{ width: "24px", height: "24px" }} className="me-2" />
                        <span className='my-auto'> {t("Approvance for Bill ID")} {selectedDemandID} {t("Detail")}</span>
                      </h5>
                    </div>

                    <div className="col-12 d-flex justify-content-end mt-3 gap-2">
                      <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("DemandApprovanceTable", "DemandApprovanceTable.xlsx")}>{t("Download Excel")}</button>
                      <button className='btn btn-danger px-4' onClick={() => downloadPageAsPDF('DemandApprovanceTable', `DemandApprovanceTable_${selectedYear}.pdf`, `Demand Approvance Table ${selectedYear}`)}>{t("Download Pdf")}</button>
                    </div>
                  </div>
                </div>
                <div className="m-auto tableDesign DistrictTableContianerModel3" style={{ background: '#2C78DB', overflowX: 'hidden' }}>
                  <table className='m-0 p-0 DemandApprovanceTable' style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
                        <th style={{ width: "10%", border: "1px solid white" }} rowSpan={2} colSpan={1}>{t("Bill Number")}</th>
                        <th style={{ width: "80%", border: "1px solid white" }} colSpan={7}>{t("Approved by")}</th>
                      </tr>
                      <tr style={{ color: 'white', border: 'none', height: '3rem' }}>
                        <th style={{ width: "15%", border: "1px solid white" }}>{t("Department Auditor")}</th>
                        <th style={{ width: "15%", border: "1px solid white" }}>{t("Department HOD(EE)")}</th>
                        <th style={{ width: "10%", border: "1px solid white" }}>{t("FD Auditor")}</th>
                        <th style={{ width: "10%", border: "1px solid white" }}>{t("FD AAO")}</th>
                        {/* <th style={{ width: "10%", border: "1px solid white" }}>{t("FD AO")}</th> */}
                        <th style={{ width: "10%", border: "1px solid white" }}>{t("Deputy CAFO")}</th>
                        <th style={{ width: "10%", border: "1px solid white" }}>{t("CAFO")}</th>
                      </tr>
                    </thead>

                    <tbody >
                      {fetchSpecificDemandDeductionDetail?.length === 0 ? (
                        <tr>
                          <td colSpan="10" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
                            {t("No data available")}
                          </td>
                        </tr>
                      ) : (
                        fetchSpecificDemandDeductionDetail?.filter(
                          (proposal, index, self) =>
                            index === self.findIndex((p) => p.DemandGenerationID === proposal.DemandGenerationID)
                        )?.map((proposal, index) => {
                          const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                          return (
                            <tr key={index} style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "400" }}>
                              <td className='fw-bold' style={{ fontSize: "12px", padding: "5px" }}>{proposal.DemandGenerationID}</td>
                              <td style={{ padding: '8px', textAlign: 'center' }}>
                                {proposal.Approvance1 === 'true' ? (
                                  <div className='m-auto'
                                    style={{
                                      width: '20px',
                                      height: '20px',
                                      borderRadius: '6px',
                                      backgroundColor: '#16C60C',
                                      border: 'none',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      fontSize: '13px',
                                      color: 'white',
                                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                    }}
                                  >
                                    ✓
                                  </div>
                                ) : proposal.Approvance1 === 'false' ? (
                                  <div
                                    className='m-auto'
                                    style={{
                                      width: '20px',
                                      height: '20px',
                                      borderRadius: '6px',
                                      backgroundColor: '#dc2626',
                                      border: 'none',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      fontSize: '13px',
                                      color: 'white',
                                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                    }}
                                  >
                                    ✕
                                  </div>
                                ) : '-'}
                              </td>
                              <td style={{ padding: '8px', textAlign: 'center' }}>
                                {proposal.Approvance2 === 'true' ? (<div className='m-auto'
                                  style={{
                                    width: '20px',
                                    height: '20px',
                                    borderRadius: '6px',
                                    backgroundColor: '#16C60C',
                                    border: 'none',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    fontSize: '13px',
                                    color: 'white',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                  }}
                                >
                                  ✓
                                </div>) : proposal.Approvance2 === 'false' ? (<div
                                  className='m-auto'
                                  style={{
                                    width: '20px',
                                    height: '20px',
                                    borderRadius: '6px',
                                    backgroundColor: '#dc2626',
                                    border: 'none',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    fontSize: '13px',
                                    color: 'white',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                  }}
                                >
                                  ✕
                                </div>) : '-'}
                              </td>
                              <td style={{ padding: '8px', textAlign: 'center' }}>
                                {proposal.Approvance3 === 'true' ? (<div className='m-auto'
                                  style={{
                                    width: '20px',
                                    height: '20px',
                                    borderRadius: '6px',
                                    backgroundColor: '#16C60C',
                                    border: 'none',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    fontSize: '13px',
                                    color: 'white',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                  }}
                                >
                                  ✓
                                </div>) : proposal.Approvance3 === 'false' ? (<div
                                  className='m-auto'
                                  style={{
                                    width: '20px',
                                    height: '20px',
                                    borderRadius: '6px',
                                    backgroundColor: '#dc2626',
                                    border: 'none',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    fontSize: '13px',
                                    color: 'white',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                  }}
                                >
                                  ✕
                                </div>) : '-'}
                              </td>
                              <td style={{ padding: '8px', textAlign: 'center' }}>
                                {proposal.Approvance4 === 'true' ? (<div className='m-auto'
                                  style={{
                                    width: '20px',
                                    height: '20px',
                                    borderRadius: '6px',
                                    backgroundColor: '#16C60C',
                                    border: 'none',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    fontSize: '13px',
                                    color: 'white',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                  }}
                                >
                                  ✓
                                </div>) : proposal.Approvance4 === 'false' ? (<div
                                  className='m-auto'
                                  style={{
                                    width: '20px',
                                    height: '20px',
                                    borderRadius: '6px',
                                    backgroundColor: '#dc2626',
                                    border: 'none',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    fontSize: '13px',
                                    color: 'white',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                  }}
                                >
                                  ✕
                                </div>) : '-'}
                              </td>
                              {/* <td style={{ padding: '8px', textAlign: 'center' }}>
                                {proposal.Approvance5 === 'true' ? (<div className='m-auto'
                                  style={{
                                    width: '20px',
                                    height: '20px',
                                    borderRadius: '6px',
                                    backgroundColor: '#16C60C',
                                    border: 'none',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    fontSize: '13px',
                                    color: 'white',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                  }}
                                >
                                  ✓
                                </div>) : proposal.Approvance5 === 'false' ? (<div
                                  className='m-auto'
                                  style={{
                                    width: '20px',
                                    height: '20px',
                                    borderRadius: '6px',
                                    backgroundColor: '#dc2626',
                                    border: 'none',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    fontSize: '13px',
                                    color: 'white',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                  }}
                                >
                                  ✕
                                </div>) : '-'}
                              </td> */}
                              <td style={{ padding: '8px', textAlign: 'center' }}>
                                {proposal.Approvance6 === 'true' ? (<div className='m-auto'
                                  style={{
                                    width: '20px',
                                    height: '20px',
                                    borderRadius: '6px',
                                    backgroundColor: '#16C60C',
                                    border: 'none',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    fontSize: '13px',
                                    color: 'white',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                  }}
                                >
                                  ✓
                                </div>) : proposal.Approvance6 === 'false' ? (<div
                                  className='m-auto'
                                  style={{
                                    width: '20px',
                                    height: '20px',
                                    borderRadius: '6px',
                                    backgroundColor: '#dc2626',
                                    border: 'none',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    fontSize: '13px',
                                    color: 'white',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                  }}
                                >
                                  ✕
                                </div>) : '-'}
                              </td>
                              <td style={{ padding: '8px', textAlign: 'center' }}>
                                {proposal.Approvance7 === 'true' ? (<div className='m-auto'
                                  style={{
                                    width: '20px',
                                    height: '20px',
                                    borderRadius: '6px',
                                    backgroundColor: '#16C60C',
                                    border: 'none',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    fontSize: '13px',
                                    color: 'white',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                  }}
                                >
                                  ✓
                                </div>) : proposal.Approvance7 === 'false' ? (<div
                                  className='m-auto'
                                  style={{
                                    width: '20px',
                                    height: '20px',
                                    borderRadius: '6px',
                                    backgroundColor: '#dc2626',
                                    border: 'none',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    fontSize: '13px',
                                    color: 'white',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                  }}
                                >
                                  ✕
                                </div>) : '-'}
                              </td>
                            </tr>

                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        }

        {
          selectedContractor &&
          showspecific === 58 &&
          <div className="col-12">

            <div className="col-12 m-auto px-4">
              <button
                className="btn btn-danger px-3 rounded-4 mb-3 mt-3"
                onClick={() => setShowSpecific(57)}
              >
                {t("Back")}
              </button>
            </div>

            <div className="col-12 my-4 m-auto px-4">
              <div className="row align-items-center">

                {/* LEFT SIDE */}
                <div className="col-md-6">
                  <h2
                    style={{
                      color: "#4f46e5",
                      fontWeight: "700",
                      fontSize: "1.4rem",
                      marginBottom: 0
                    }}
                  >
                    {t("Vendor")} {selectedContractor} {t("Detail")}
                  </h2>
                </div>

                {/* RIGHT SIDE */}
                <div className="col-md-6 d-flex justify-content-md-end gap-2 mt-3 mt-md-0">
                  <button
                    className="btn btn-success px-4"
                    onClick={() =>
                      exportTableByClassToExcel(
                        "ContractorDetailTable",
                        "Contractor.xlsx"
                      )
                    }
                  >
                    Download Excel
                  </button>

                  <button
                    className="btn btn-danger px-4"
                    onClick={() =>
                      downloadPageAsPDF(
                        "ContractorDetailTable",
                        `ContractorDetailTable_${selectedYear}.pdf`,
                        `Contractor Detail Table ${selectedYear}`
                      )
                    }
                  >
                    Download Pdf
                  </button>
                </div>

              </div>
            </div>
            <div className="m-auto DistrictTableContianerModel3">
              <table className='m-auto my-4 ContractorDetailTable '>
                <thead>
                  <tr>
                    <th style={{ width: "20%" }}>{t("Vendor Name")}</th>
                    <th style={{ width: "5%" }}>{t("City")}</th>
                    <th style={{ width: "10%" }}>{t("GST Number")}</th>
                    <th style={{ width: "10%" }}>{t("Adhaar Number")}</th>
                    {/* <th style={{ width: "10%" }}>Mobile Number</th> */}
                    <th style={{ width: "10%" }}>{t("Email")}</th>
                    <th style={{ width: "15%" }}>{t("Bank Name")}</th>
                    <th style={{ width: "10%" }}>{t("Branch Name")}</th>
                    <th style={{ width: "10%" }}>{t("Account Number")}</th>
                    <th style={{ width: "10%" }}>{t("IFSC Code")}</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    SpecificContractorDetail &&
                      SpecificContractorDetail.length > 0 ? (
                      SpecificContractorDetail.map((val, index) => {
                        return (
                          <tr key={index}>
                            <td>{val.Bidder_CompanyName}</td>
                            <td>{val.City}</td>
                            <td>{val.GST_No}</td>
                            <td>{val.AadhaarNo}</td>
                            {/* <td>{val.Mobile_No}</td> */}
                            <td>{val.Email}</td>
                            <td>{val.BANK_NAME}</td>
                            <td>{val.BranchName}</td>
                            <td>{val.Account_Number}</td>
                            <td>{val.IFSC_CODE}</td>
                          </tr>
                        )
                      })
                    )
                      :
                      (
                        <tr>
                          <td colSpan={10} className='fw-bold'>{t("No data found")}</td>
                        </tr>
                      )
                  }
                </tbody>
              </table>
            </div>
          </div>
        }

        {/* Series for Part 3 for Total Gr created */}
        {
          districtGRSummary.length > 0 &&
          showspecific === 99 &&
          (
            <>

              <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
                <div className="col-11 m-auto">
                  <div className='col-12' >

                    <div className="col-12">
                      <button
                        className='btn btn-danger px-3 rounded-4 mb-3 mt-3'
                        onClick={() => {
                          setShowSpecific(0);
                          setSelectedGRDistrict('');
                          setDistrictGRPage(1);
                          setShowAllDistrictGR(false);
                        }}
                      >{t("Back")}</button>
                    </div>

                    <div className="col-11 my-0 mx-auto">
                      <div className="row">
                        <div className="col-12 py-2 d-flex justify-content-left align-items-center">

                          <h5 className="my-auto fw-bold d-flex align-items-center">
                            <img
                              src="/GR-Approval64.png"
                              alt=""
                              style={{ width: "24px", height: "24px" }}
                              className="me-2"
                            />
                            <span>
                              {t("GR Created in the Year")} {selectedYear}
                            </span>
                          </h5>
                        </div>

                        {/* <div className="col-12 d-flex justify-content-end mt-3 mb-3 gap-2">
                          <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("ALlDistrictFinanceData", "AllDistrictReleaseData.xlsx")}>{t("Download Excel")}</button>
                          <button className='btn btn-danger px-4' onClick={() => downloadPageAsPDF('ALlDistrictFinanceData', `ALlDistrictFinanceData_${selectedYear}.pdf`, `ALlDistrict Finance Data ${selectedYear}`)}>{t("Download Pdf")}</button>
                        </div> */}
                                                <div className="col-12 d-flex justify-content-end mt-3 mb-3 gap-2">
  <button
    className="btn btn-success px-4"
    onClick={() =>
      exportTableByClassToExcel(
        "ALlDistrictFinanceData",
        `GR_Summary_${selectedYear}.xlsx`
      )
    }
  >
    {t("Download Excel")}
  </button>

  <button
    className="btn btn-danger px-4"
    onClick={() =>
      downloadTableOnlyAsPDF(
        "ALlDistrictFinanceData",
        `GR_Summary_${selectedYear}.pdf`,
        `GR Created in the Year ${selectedYear}`
      )
    }
  >
    {t("Download PDF")}
  </button>
</div>
                      </div>
                    </div>
                    <div
                      className="col-11 mx-auto d-flex justify-content-end align-items-center mb-3"
                      style={{
                        gap: "10px",
                        flexWrap: "wrap",
                      }}
                    >
                      {/* District Filter - State users only */}
                      {userData?.Department_Name === "State" && (
                        <select
                          className="form-select"
                          value={selectedGRDistrict}
                          onChange={(e) => {
                            setSelectedGRDistrict(e.target.value);
                            setDistrictGRPage(1);
                            setShowAllDistrictGR(false);
                          }}
                          style={{
                            width: "220px",
                            border: "1px solid #ccc",
                            borderRadius: "8px",
                            padding: "8px 12px",
                            fontSize: "16px",
                          }}
                        >
                          <option value="">{t("All Districts")}</option>

                          {[
                            ...new Set(
                              districtGRSummary
                                .map((item) => getMainDistrict(item.District))
                                .filter(Boolean)
                            ),
                          ].map((district, index) => (
                            <option key={index} value={district}>
                              {district}
                            </option>
                          ))}
                        </select>
                      )}

                      {/* Random Search - All users */}
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search anything..."
                        value={searchGRSummary}
                        onChange={(e) => {
                          setSearchGRSummary(e.target.value);
                          setDistrictGRPage(1);
                          setShowAllDistrictGR(false);
                        }}
                        style={{
                          width: "250px",
                          fontSize: "14px",
                        }}
                      />
                    </div>

                    <div className="col-12 pb-5">
                      <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>

                        <div className='col-12 tableDesign DistrictTableContianerModel2' style={{
                          background: '#2C78DB', overflowX: "auto",
                          overflowY: "auto",
                          maxHeight: "600px", // change heigh
                          position: "relative"
                        }}>
                          <table className='m-0 py-0 ALlDistrictFinanceData' style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead style={{
                              position: "sticky", backgroundColor: "#1976d2",
                              top: 0,
                              zIndex: 10,
                            }} >
                              <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
                                <th style={{ width: "10%", fontSize: "18px" }}>{t("Sr No")}</th>
                                <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("District")}</th>
                                <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("Year")}</th>
                                <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("Total GR")}</th>
                                <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("Total Amount")}</th>
                              </tr>
                            </thead>

                            <tbody>
                              {
                                districtGRSummary &&
                                  districtGRSummary.length > 0 ?
                                  (() => {
                                    const totaltscount = filteredDistrictGRSummary.reduce((sum, val) => sum + parseFloat(val.TotalGR || 0), 0);
                                    const totaltsamount = filteredDistrictGRSummary.reduce((sum, val) => sum + parseFloat(val.TotalAmount || 0), 0);
                                    const pageTotalGRCount = paginatedDistrictGR.reduce((sum, val) => sum + parseFloat(val.TotalGR || 0), 0);
                                    const pageTotalGRAmount = paginatedDistrictGR.reduce((sum, val) => sum + parseFloat(val.TotalAmount || 0), 0);
                                    return (
                                      <>
                                        {
                                          paginatedDistrictGR.map((item, idx) => {
                                            const bgColor = idx % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                            return (
                                              <tr key={idx} style={{ backgroundColor: bgColor, fontSize: "18px", fontWeight: "400" }}>
                                                <td style={{ fontSize: "18px" }} >{(districtGRPage - 1) * districtGRRecordsPerPage + idx + 1}</td>
                                                <td style={{ fontSize: "18px" }}><a
                                                  href="#"
                                                  className='my-auto'
                                                  style={{ color: '#4f46e5', textDecoration: 'underline' }}
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    showDistrictGR(item.District);
                                                  }}
                                                >
                                                  {item.District}
                                                </a></td>
                                                <td style={{ fontSize: "18px" }}>{selectedYear}</td>
                                                <td style={{ fontSize: "18px" }}>{item.TotalGR}</td>
                                                <td style={{ fontSize: "18px" }}>
                                                  ₹ {Number(item.TotalAmount).toLocaleString("en-IN")}
                                                </td>
                                              </tr>
                                            );
                                          })
                                        }

                                        <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0', fontSize: "18px", textAlign: "right" }}>
                                          <td colSpan={3} style={{ fontSize: "18px" }}>{t("Page Total")}</td>
                                          <td style={{ fontSize: "18px" }}>{Number(pageTotalGRCount).toLocaleString("en-IN")}</td>
                                          <td style={{ fontSize: "18px" }}>₹ {Number(pageTotalGRAmount).toLocaleString("en-IN")}</td>
                                        </tr>

                                        <tr style={{ fontWeight: 'bold', backgroundColor: '#e0e0e0', fontSize: "18px", textAlign: "right" }}>
                                          <td colSpan={3} style={{ fontSize: "18px" }}>{t("Gross Total")}</td>
                                          <td style={{ fontSize: "18px" }}>{Number(totaltscount).toLocaleString("en-IN")}</td>
                                          <td style={{ fontSize: "18px" }}>₹ {Number(totaltsamount).toLocaleString("en-IN")}</td>
                                        </tr>
                                      </>
                                    );
                                  })()
                                  :
                                  (
                                    <tr>
                                      <td colSpan={5} className='fw-bold'>{t("No data found")}</td>
                                    </tr>
                                  )
                              }
                            </tbody>
                          </table>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginTop: "20px",
                          }}
                        >
                          <p className="text-gray-600 m-0" style={{ fontSize: "18px" }}>
                            {t("Showing")}{" "}
                            {filteredDistrictGRSummary.length > 0
                              ? showAllDistrictGR
                                ? 1
                                : (districtGRPage - 1) * districtGRRecordsPerPage + 1
                              : 0}{" "}
                            {t("to")}{" "}
                            {showAllDistrictGR
                              ? filteredDistrictGRSummary.length
                              : Math.min(
                                districtGRPage * districtGRRecordsPerPage,
                                filteredDistrictGRSummary.length
                              )}{" "}
                            {t("of")} {filteredDistrictGRSummary.length} {t("entries")}
                          </p>

                          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <button
                              type="button"
                              onClick={() => {
                                setShowAllDistrictGR(!showAllDistrictGR);
                                setDistrictGRPage(1);
                              }}
                              style={{
                                border: "none",
                                outline: "none",
                                cursor: "pointer",
                                padding: "8px 16px",
                                borderRadius: "20px",
                                fontSize: "13px",
                                fontWeight: "600",
                                color: "#fff",
                                background: showAllDistrictGR
                                  ? "linear-gradient(135deg, #28a745, #20c997)"
                                  : "linear-gradient(135deg, #0067ab, #0098d5)",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                              }}
                            >
                              {showAllDistrictGR ? "✓ Showing All" : "View All"}
                            </button>

                            {!showAllDistrictGR && (
                              <GooglePagination
                                currentPage={districtGRPage}
                                totalPages={totalDistrictGRPages}
                                onPageChange={setDistrictGRPage}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </>
          )
        }

        {/* Series for part 3 For GR */}
        {
          AllGRS &&
          showspecific === 100 &&
          <div className='col-12' style={{
            backgroundColor: "#EFF3F8",
            height: exportingPDF ? "auto" : "90vh",
            overflowY: exportingPDF ? "visible" : "scroll",
          }}
          >
            <div className="col-11 m-auto">
              <div className='col-12' >

                <div className="col-12">
                  <button className='btn btn-danger px-3 rounded-4 mb-3 mt-3' onClick={() => setShowSpecific(99)}>{t("Back")}</button>
                </div>

                <div className="col-10 my-4 mx-auto">
                  <div className="row">
                    <div className="d-flex justify-content-between align-items-center flex-wrap">
                      <h5 className="my-auto fw-bold d-flex align-items-center">
                        <img src="/GR-Approval64.png" alt="" style={{ width: "24px", height: "24px" }} className="me-2" />
                        <span className='my-auto'> {t("GR Created in")} {getMainDistrict(paginatedGRS[0]?.ZillaParishad) || "Unknown"}</span>
                      </h5>
                    </div>
                  </div>


                  <div className="col-12 d-flex justify-content-end mt-3 gap-2">
                    <div style={{ position: "relative", width: "250px" }}>
                      <img
                        src="/Search32.png"
                        alt="Search Icon"
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "10px",
                          transform: "translateY(-50%)",
                          width: "16px",
                          height: "16px",
                          opacity: 0.6
                        }}
                      />
                      <input
                        type="text"
                        className="form-control ps-4"
                        placeholder={t("Search Here")}
                        value={searchGR}
                        onChange={(e) => {
                          setSearchGR(e.target.value);
                          setCurrentPage(1);
                          setShowAllGR(false);
                        }}
                      />
                    </div>
                    <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("AllGR", "GRS.xlsx")}>{t("Download Excel")}</button>
                    <button
                      className="btn btn-danger px-4"
                      onClick={() =>
                        downloadTableOnlyAsPDF(
                          "AllGR",
                          `AllGR_${selectedYear}.pdf`,
                          `All GR ${selectedYear}`
                        )
                      }
                    >
                      {t("Download PDF")}
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-12 pb-5">
                <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>
                  <div className='col-12 tableDesign DistrictTableContianerModel2' style={{
                    background: '#2C78DB', overflowX: "auto",
                    overflowY: "auto",
                    maxHeight: "600px", // change height as needed
                    position: "relative"
                  }}>
                    <table className='m-0 p-0 AllGR' style={{ width: '100%', borderCollapse: 'collapse', tableLayout: "fixed" }}>
                      <thead style={{
                        position: "sticky", backgroundColor: "#1976d2",
                        top: 0,
                        zIndex: 10,
                      }}>
                        <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
                          <th style={{ width: "7%", padding: "4px", fontSize: "18px" }}>{t("Sr No")}</th>
                          <th style={{ minWidth: "100px", padding: "8px", width: "100px", fontSize: "18px" }}>{t("GR UID")}</th>
                          <th style={{ minWidth: "100px", padding: "8px", width: "100px", fontSize: "18px" }}>{t("GR Number")}</th>
                          <th style={{ minWidth: "100px", padding: "8px", width: "100px", fontSize: "18px" }}>{t("District")}</th>
                          <th style={{ width: "15%", fontSize: "18px" }}>{t("Year")}</th>
                          <th style={{ width: "35%", padding: "8px", fontSize: "18px" }}>{t("HeadCode")}</th>
                          <th style={{ width: "20%", fontSize: "18px" }}>{t("GR Date")}</th>
                          <th style={{ width: "20%", textAlign: "left", fontSize: "18px" }}>{t("GR Amount")}</th>

                          {/* <th style={{ width: "15%" }}>Status</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {
                          paginatedGRS &&
                            paginatedGRS.length > 0 ? (() => {
                              const filteredData = sourceGRS.filter(val =>
                                !searchGR ||
                                String(val.GRID).toLowerCase().startsWith(searchGR.toLowerCase()) ||
                                String(val.GRNumber).toLowerCase().startsWith(searchGR.toLowerCase())
                              );

                              const paginatedData = showAllGR
                                ? filteredData
                                : filteredData.slice(
                                  (currentPage - 1) * billRecordsPerPage,
                                  currentPage * billRecordsPerPage
                                );

                              const pageTotalGRAmount = paginatedData.reduce(
                                (sum, val) => sum + parseFloat(val.GRAmount || 0),
                                0
                              );

                              const grandTotalGRAmount = filteredData.reduce(
                                (sum, val) => sum + parseFloat(val.GRAmount || 0),
                                0
                              );
                              return (
                                <>
                                  {
                                    paginatedData.map((val, index) => {
                                      const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                      return (
                                        <tr key={index} style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "400" }}>
                                          <td style={{ fontSize: "18px" }}>{indexOfFirstGRS + index + 1}</td>
                                          <td style={{ minWidth: "100px", padding: "8px", width: "100px", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", fontSize: "18px" }}>{val.GRID}</td>
                                          <td style={{ fontSize: "18px" }}>
                                            <p className='makeitlink my-auto' onClick={() => proposalDetailbyGR(val.GRID)}>
                                              {val.GRNumber}
                                            </p>
                                          </td>
                                          <td style={{ fontSize: "18px" }}>{val.ZillaParishad}</td>
                                          <td style={{ fontSize: "18px" }}>{selectedYear}</td>
                                          <td style={{ fontSize: "18px" }}>{val.HeadCode}</td>
                                          <td style={{ fontSize: "18px" }}>{new Date(val.GRDate).toLocaleDateString("en-IN")}</td>
                                          <td style={{ textAlign: "left", fontSize: "18px" }} >
                                            ₹ {Number(val.GRAmount).toLocaleString("en-IN")}
                                          </td>

                                        </tr>
                                      );
                                    })
                                  }

                                  {/* Page Total */}
                                  <tr
                                    style={{
                                      fontWeight: "bold",
                                      backgroundColor: "#f0f0f0",
                                      fontSize: "18px", textAlign: "right"
                                    }}
                                  >
                                    <td style={{ fontSize: "18px", fontSize: "18px" }} colSpan={7}>{t("Page Total")}</td>
                                    <td style={{ textAlign: "left", fontSize: "18px" }}>
                                      ₹ {Number(pageTotalGRAmount).toLocaleString("en-IN")}
                                    </td>
                                    <td></td>
                                  </tr>

                                  {/* Grand Total */}
                                  <tr
                                    style={{
                                      fontWeight: "bold",
                                      backgroundColor: "#e0e0e0",
                                      fontSize: "18px", textAlign: "right"
                                    }}
                                  >
                                    <td style={{ fontSize: "18px" }} colSpan={7}>{t("Gross Total")}</td>
                                    <td style={{ textAlign: "left", fontSize: "18px" }}>
                                      ₹ {Number(grandTotalGRAmount).toLocaleString("en-IN")}
                                    </td>
                                    <td></td>
                                  </tr>
                                </>
                              );
                            })() : (
                            <tr>
                              <td style={{ fontSize: "18px" }} colSpan={10} className='fw-bold'>{t("No data found")}</td>
                            </tr>
                          )
                        }
                      </tbody>
                    </table>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginTop: "20px",
                    }}
                  >
                    <p className="text-gray-600 m-0" style={{ fontSize: "18px" }}>
                      {t("Showing")}{" "}
                      {showAllGR
                        ? (sourceGRS.length > 0 ? 1 : 0)
                        : (indexOfFirstGRS + 1)}{" "}
                      {t("to")}{" "}
                      {showAllGR
                        ? sourceGRS.length
                        : Math.min(indexOfLastGRS, sourceGRS.length)}{" "}
                      {t("of")} {sourceGRS.length} {t("entries")}
                    </p>

                    <div style={{ display: "flex", alignItems: "center", gap: "10px", fontSize: "18px" }}>
                      <button
                        type="button"
                        onClick={() => {
                          setShowAllGR(!showAllGR);
                          setCurrentPage(1);
                        }}
                        style={{
                          border: "none",
                          outline: "none",
                          cursor: "pointer",
                          padding: "8px 16px",
                          borderRadius: "20px",
                          fontSize: "13px",
                          fontWeight: "600",
                          color: "#fff",
                          background: showAllGR
                            ? "linear-gradient(135deg, #28a745, #20c997)"
                            : "linear-gradient(135deg, #0067ab, #0098d5)",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                        }}
                      >
                        {showAllGR ? "✓ Showing All" : "View All"}
                      </button>

                      {!showAllGR && (
                        <GooglePagination
                          currentPage={currentPage}
                          totalPages={totalPages}
                          onPageChange={handlePageChange}
                        />
                      )}
                    </div>
                  </div>
                </div>



              </div>
            </div>
          </div>
        }

        {
          selectedGR &&
          showspecific === 101 &&
          <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
            <div className="col-11 m-auto">
              <div className='col-12' >
                <div className="col-12">
                  <button className='btn btn-danger px-3 rounded-4 mb-3 mt-3' onClick={() => setShowSpecific(100)}>{t("Back")}</button>
                </div>

                <div className="col-11 my-4 mx-auto">
                  <div className="d-flex justify-content-between align-items-center flex-wrap">
                    {/* Title */}
                    <h5 className="my-auto fw-bold d-flex align-items-center">
                      <img src="/GR-Approval64.png" alt="" style={{ width: "24px", height: "24px" }} className="me-2" />
                      <span className="my-auto">GR {selectedGR} {t("Detail")}</span>
                    </h5>

                    {/* Buttons */}
                    <div className="d-flex gap-2 mt-2 mt-md-0">
                      <button
                        className="btn btn-success px-4"
                        onClick={() =>
                          exportTableByClassToExcel("ProposalContainer", "ProposalDetail.xlsx")
                        }
                      >
                        {t("Download Excel")}
                      </button>
                      <button
                        className="btn btn-danger px-4"
                        onClick={() =>
                          downloadTableOnlyAsPDF(
                            "ProposalContainer",
                            `GRdetialTable${selectedYear}.pdf`,
                            `GR Detail Table ${selectedYear}`
                          )
                        }
                      >
                        {t("Download PDF")}
                      </button>
                    </div>
                  </div>
                </div>

                <div className="col-12 pb-5">
                  <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>
                    <div className='col-12 tableDesign DistrictTableContianerModel2' style={{
                      background: '#2C78DB', overflowX: "auto",
                      overflowY: "auto",
                      maxHeight: "600px", // change height as needed
                      position: "relative"
                    }}>
                      <table className='m-0 p-0 ProposalContainer' style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead style={{
                          position: "sticky", backgroundColor: "#1976d2",
                          top: 0,
                          zIndex: 10,
                        }}>
                          <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
                            <th style={{ width: "8%", fontSize: "18px" }}>{t("Sr No")}</th>
                            {/* <th style={{ width: "20%" }}>Proposal ID</th> */}
                            <th style={{ width: "35%", fontSize: "18px" }}>{t("Proposal Name")}</th>
                            <th style={{ width: "20%", textAlign: "left", fontSize: "18px" }}>{t("Proposal Amount")}</th>
                            <th style={{ width: "20%", fontSize: "18px" }}>{t("Date")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            paginatedProposalGR &&
                              paginatedProposalGR.length > 0 ? (() => {
                                // const filteredData = AllGRS.filter(val =>
                                //   !searchBill ||
                                //   String(val.GRID).toLowerCase().startsWith(searchGR.toLowerCase()) ||
                                //   String(val.GRNumber).toLowerCase().startsWith(searchGR.toLowerCase())
                                // );

                                const totalGRAmount = paginatedProposalGR.reduce((sum, val) => sum + parseFloat(val.Proposal_amount || 0), 0);

                                return (
                                  <>
                                    {
                                      paginatedProposalGR.map((val, index) => {
                                        const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                        return (
                                          <tr key={index} style={{ backgroundColor: bgColor, fontSize: "18px", fontWeight: "400" }}>
                                            <td style={{ fontSize: "18px", fontSize: "18px" }}>{firstRecordIndexProposalDetailByGR + index + 1}</td>
                                            <td style={{ fontSize: "18px" }}>{val.Work_name}</td>

                                            {/* <td style={{ textAlign: "left" }}>₹ {Number(val.GRAmount).toLocaleString("en-IN")}</td> */}
                                            <td style={{ fontSize: "18px" }}>
                                              <p className='my-auto' style={{ textAlign: "left" }} >
                                                ₹ {Number(val.Proposal_amount).toLocaleString("en-IN")}
                                              </p>
                                            </td>
                                            <td style={{ fontSize: "18px" }}>{new Date(val.created_at).toLocaleString("en-IN")}</td>
                                          </tr>
                                        );
                                      })}

                                    {/* Total Row */}
                                    <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0', fontSize: "18px" }}>
                                      <td style={{ fontSize: "18px" }} colSpan={2}>{t("Total Proposal Amount")}</td>
                                      <td style={{ textAlign: "left", fontSize: "18px" }}>₹ {Number(totalGRAmount).toLocaleString("en-IN")}</td>
                                      <td></td>
                                    </tr>

                                  </>
                                );
                              })() : (
                              <tr>
                                <td style={{ fontSize: "18px" }} colSpan={10} className='fw-bold'>{t("No data found")}</td>
                              </tr>
                            )
                          }
                        </tbody>
                      </table>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: "20px",
                      }}
                    >
                      <p className="text-gray-600 m-0" style={{ fontSize: "14px", fontSize: "18px" }}>
                        {t("Showing")}{" "}
                        {ProposalDetailByGR.length > 0
                          ? showAllProposalGR
                            ? 1
                            : firstRecordIndexProposalDetailByGR + 1
                          : 0}{" "}
                        {t("to")}{" "}
                        {showAllProposalGR
                          ? ProposalDetailByGR.length
                          : Math.min(
                            lastRecordIndexProposalDetailByGR,
                            ProposalDetailByGR.length
                          )}{" "}
                        {t("of")} {ProposalDetailByGR.length} {t("entries")}
                      </p>

                      <div style={{ display: "flex", alignItems: "center", gap: "10px", fontSize: "18px" }}>
                        <button
                          type="button"
                          onClick={() => {
                            setShowAllProposalGR(!showAllProposalGR);
                            setCurrentPageProposalDetailByGR(1);
                          }}
                          style={{
                            border: "none",
                            outline: "none",
                            cursor: "pointer",
                            padding: "8px 16px",
                            borderRadius: "20px",
                            fontSize: "13px",
                            fontWeight: "600",
                            color: "#fff",
                            background: showAllProposalGR
                              ? "linear-gradient(135deg, #28a745, #20c997)"
                              : "linear-gradient(135deg, #0067ab, #0098d5)",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                          }}
                        >
                          {showAllProposalGR ? "✓ Showing All" : "View All"}
                        </button>

                        {!showAllProposalGR && (
                          <GooglePagination
                            currentPage={currentPageProposalDetailByGR}
                            totalPages={totalPagesProposalDetailByGR}
                            onPageChange={setCurrentPageProposalDetailByGR}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

        {/* Series for Part 4 for Total TS created */}
        {
          districtTSSummary.length > 0 &&
          showspecific === 109 &&
          (
            <>

              <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
                <div className="col-11 m-auto">
                  <div className='col-12' >

                    <div className="col-12">
                      <button
                        className="btn btn-danger px-3 rounded-4 mb-3 mt-3"
                        onClick={() => {
                          // Go back to main dashboard
                          setShowSpecific(0);

                          // Reset Technical Sanction summary filter
                          setSelectedTSDistrict("");

                          // Reset All Technical Sanction filters
                          setSelectedAllTSTaluka("");
                          setSelectedAllTSHeadCode("");
                          setSearchAllTS("");

                          // Clear previously selected Technical Sanction data
                          setFilteredTSData([]);

                          // Reset pagination
                          setDistrictPage(1);
                          setCurrentPageAllTSData(1);

                          // Reset View All
                          setShowAllTS(false);
                          setShowAllTSDetails(false);
                        }}
                      >
                        {t("Back")}
                      </button>
                    </div>

                    <div className="col-11 my-0 mx-auto">
                      <div className="row">
                        <div className="col-12 py-2 d-flex justify-content-left align-items-center">

                          <h5 className="my-auto fw-bold d-flex align-items-center">
                            <img
                              src="/GR-Approval64.png"
                              alt=""
                              style={{ width: "24px", height: "24px" }}
                              className="me-2"
                            />
                            <span>
                              {t("Technical Sanction in the Year")} {selectedYear}
                            </span>
                          </h5>
                        </div>

                        {/* <div className="col-12 d-flex justify-content-end mt-3 mb-3 gap-2">
                          <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("ALlDistrictFinanceData", "AllDistrictReleaseData.xlsx")}>{t("Download Excel")}</button>
                          <button className='btn btn-danger px-4' onClick={() => downloadPageAsPDF('ALlDistrictFinanceData', `ALlDistrictFinanceData_${selectedYear}.pdf`, `ALlDistrict Finance Data ${selectedYear}`)}>{t("Download Pdf")}</button>
                        </div> */}
                                                <div className="col-12 d-flex justify-content-end mt-3 mb-3 gap-2">
  <button
    className="btn btn-success px-4"
    onClick={() =>
      exportTableByClassToExcel(
        "ALlDistrictFinanceData",
        `TechnicalSanction_Summary_${selectedYear}.xlsx`
      )
    }
  >
    {t("Download Excel")}
  </button>

  <button
    className="btn btn-danger px-4"
    onClick={() =>
      downloadTableOnlyAsPDF(
        "ALlDistrictFinanceData",
        `TechnicalSanction_Summary_${selectedYear}.pdf`,
        `Technical Sanction in the Year ${selectedYear}`
      )
    }
  >
    {t("Download PDF")}
  </button>
</div>
                      </div>
                    </div>
                    <div
                      className="col-11 mx-auto d-flex justify-content-end align-items-center mb-3"
                      style={{
                        gap: "10px",
                        flexWrap: "wrap",
                      }}
                    >
                      {/* District Filter - State only */}
                      {userData?.Department_Name === "State" && (
                        <select
                          className="form-select"
                          value={selectedTSDistrict}
                          onChange={(e) => {
                            setSelectedTSDistrict(e.target.value);
                            setDistrictPage(1);
                            setShowAllTS(false);
                          }}
                          style={{
                            width: "220px",
                            border: "1px solid #ccc",
                            borderRadius: "8px",
                            padding: "8px 12px",
                            fontSize: "16px",
                          }}
                        >
                          <option value="">{t("All Districts")}</option>

                          {[
                            ...new Set(
                              districtTSSummary
                                .map((item) => getMainDistrict(item.District))
                                .filter(Boolean)
                            ),
                          ].map((district, index) => (
                            <option key={index} value={district}>
                              {district}
                            </option>
                          ))}
                        </select>
                      )}

                      {/* Random Search - Everyone */}
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search anything..."
                        value={searchTSSummary}
                        onChange={(e) => {
                          setSearchTSSummary(e.target.value);
                          setDistrictPage(1);
                          setShowAllTS(false);
                        }}
                        style={{
                          width: "250px",
                          fontSize: "14px",
                        }}
                      />
                    </div>
                    <div className="col-12 pb-5">
                      <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>

                        <div className='col-12 tableDesign DistrictTableContianerModel2' style={{
                          background: '#2C78DB', overflowX: "auto",
                          overflowY: "auto",
                          maxHeight: "600px", // change height as needed
                          position: "relative",
                        }}>
                          <table className='m-0 py-0 ALlDistrictFinanceData' style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead style={{
                              position: "sticky", backgroundColor: "#1976d2",
                              top: 0,
                              zIndex: 10,
                            }}>
                              <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
                                <th style={{ width: "10%", fontSize: "18px" }}>{t("Sr No")}</th>
                                <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("District")}</th>
                                <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("Year")}</th>
                                <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("Total TS")}</th>
                                <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("Total Amount")}</th>
                              </tr>
                            </thead>

                            <tbody>
                              {
                                districtTSSummary &&
                                  districtTSSummary.length > 0 ?
                                  (() => {
                                    const pageTotalTSCount = paginatedTSData.reduce(
                                      (sum, val) => sum + parseFloat(val.TotalTS || 0),
                                      0
                                    );

                                    const pageTotalTSAmount = paginatedTSData.reduce(
                                      (sum, val) => sum + parseFloat(val.TotalAmount || 0),
                                      0
                                    );

                                    const grandTotalTSCount = filteredDistrictTSSummary.reduce(
                                      (sum, val) => sum + parseFloat(val.TotalTS || 0),
                                      0
                                    );

                                    const grandTotalTSAmount = filteredDistrictTSSummary.reduce(
                                      (sum, val) => sum + parseFloat(val.TotalAmount || 0),
                                      0
                                    );

                                    return (
                                      <>
                                        {
                                          paginatedTSData.map((item, idx) => {
                                            const bgColor = idx % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                            return (
                                              <tr key={idx} style={{ backgroundColor: bgColor, fontSize: "18px", fontWeight: "400" }}>
                                                <td style={{ fontSize: "18px" }}>
                                                  {showAllTS
                                                    ? idx + 1
                                                    : (districtPage - 1) * tsRecordsPerPage + idx + 1}
                                                </td>
                                                <td style={{ fontSize: "18px" }}><a
                                                  href="#"
                                                  className='my-auto'
                                                  style={{ color: '#4f46e5', textDecoration: 'underline' }}
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    showDistrictTS(item.District);
                                                  }}
                                                >
                                                  {item.District}
                                                </a></td>
                                                <td style={{ fontSize: "18px" }}>{selectedYear}</td>
                                                <td style={{ fontSize: "18px" }}>{item.TotalTS}</td>
                                                <td style={{ fontSize: "18px" }}>
                                                  ₹ {Number(item.TotalAmount).toLocaleString("en-IN")}
                                                </td>
                                              </tr>
                                            );
                                          })
                                        }

                                        {/* Page Total */}
                                        <tr
                                          style={{
                                            fontWeight: "bold",
                                            backgroundColor: "#f0f0f0",
                                            fontSize: "18px",
                                            textAlign: "right"
                                          }}
                                        >
                                          <td colSpan={3} style={{ fontSize: "18px" }}>
                                            {t("Page Total")}
                                          </td>

                                          <td style={{ fontSize: "18px" }}>
                                            {Number(pageTotalTSCount).toLocaleString("en-IN")}
                                          </td>

                                          <td style={{ fontSize: "18px" }}>
                                            ₹ {Number(pageTotalTSAmount).toLocaleString("en-IN")}
                                          </td>
                                        </tr>

                                        {/* Grand Total */}
                                        <tr
                                          style={{
                                            fontWeight: "bold",
                                            backgroundColor: "#e0e0e0",
                                            fontSize: "18px",
                                            textAlign: "right"
                                          }}
                                        >
                                          <td colSpan={3} style={{ fontSize: "18px" }}>
                                            {t("Gross Total")}
                                          </td>

                                          <td style={{ fontSize: "18px" }}>
                                            {Number(grandTotalTSCount).toLocaleString("en-IN")}
                                          </td>

                                          <td style={{ fontSize: "18px" }}>
                                            ₹ {Number(grandTotalTSAmount).toLocaleString("en-IN")}
                                          </td>
                                        </tr>
                                      </>
                                    );
                                  })()
                                  :
                                  (
                                    <tr>
                                      <td colSpan={5} className='fw-bold'>{t("No data found")}</td>
                                    </tr>
                                  )
                              }
                            </tbody>

                          </table>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginTop: "20px",
                          }}
                        >
                          <p className="text-gray-600 m-0" style={{ fontSize: "14px" }}>
                            {t("Showing")}{" "}
                            {districtTSSummary.length > 0
                              ? showAllTS
                                ? 1
                                : (districtPage - 1) * tsRecordsPerPage + 1
                              : 0}{" "}
                            {t("to")}{" "}
                            {showAllTS
                              ? districtTSSummary.length
                              : Math.min(
                                districtPage * tsRecordsPerPage,
                                districtTSSummary.length
                              )}{" "}
                            {t("of")} {districtTSSummary.length} {t("entries")}
                          </p>

                          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <button
                              type="button"
                              onClick={() => {
                                setShowAllTS(!showAllTS);
                                setDistrictPage(1);
                              }}
                              style={{
                                border: "none",
                                outline: "none",
                                cursor: "pointer",
                                padding: "8px 16px",
                                borderRadius: "20px",
                                fontSize: "13px",
                                fontWeight: "600",
                                color: "#fff",
                                background: showAllTS
                                  ? "linear-gradient(135deg, #28a745, #20c997)"
                                  : "linear-gradient(135deg, #0067ab, #0098d5)",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                              }}
                            >
                              {showAllTS ? "✓ Showing All" : "View All"}
                            </button>

                            {!showAllTS && (
                              <GooglePagination
                                currentPage={districtPage}
                                totalPages={totalTSPages}
                                onPageChange={setDistrictPage}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </>
          )
        }

        {/* Technical Sanction Page 1 after Clicking */}
        {
          selectedYear &&
          showspecific === 110 &&
          (
            <>

              <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
                <div className="col-11 m-auto">
                  <div className='col-12' >

                    <div className="col-12">
                      <button
                        className="btn btn-danger px-3 rounded-4 mb-3 mt-3"
                        onClick={() => {
                          // Go back
                          setShowSpecific(109);

                          // Clear filters
                          setSelectedAllTSTaluka("");
                          setSelectedAllTSHeadCode("");
                          setSearchAllTS("");

                          // Clear previously selected/detail data
                          setFilteredTSData([]);

                          // Reset pagination
                          setCurrentPageAllTSData(1);

                          // Reset View All
                          setShowAllTSDetails(false);
                        }}
                      >
                        {t("Back")}
                      </button>
                    </div>

                    <div className="col-11 my-0 mx-auto">
                      <div className="row">
                        <div className="col-12 py-2 d-flex justify-content-left align-items-center">

                          <h5 className="my-auto fw-bold d-flex align-items-center">
                            <img src="/GR-Approval64.png" alt="" style={{ width: "24px", height: "24px" }} className="me-2" />
                            <span>
                              {t("All Technical Sanction in Year")} {selectedYear}
                            </span>
                          </h5>
                        </div>

                        <div className="col-12 d-flex justify-content-end mt-3 mb-3 gap-2">
                          <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("ALlTechnicalSData", "ALlTechnicalSData.xlsx")}>{t("Download Excel")}</button>
                          <button className='btn btn-danger px-4' onClick={() => downloadTableOnlyAsPDF('ALlTechnicalSData', `ALlTechnicalSData_${selectedYear}.pdf`, `ALL Technical Sanction Data ${selectedYear}`)}>{t("Download Pdf")}</button>
                        </div>
                        <div
                          className="col-12 d-flex align-items-center mb-3"
                          style={{
                            gap: "10px",
                            flexWrap: "wrap",
                            justifyContent: "flex-end",
                          }}
                        >

                          {/* District - State users only */}
                          {/* {userData?.Department_Name === "State" && (
    <select
      className="form-select"
      value={selectedAllTSDistrict}
      onChange={(e) => {
        setSelectedAllTSDistrict(e.target.value);
        setSelectedAllTSTaluka("");
        setCurrentPageAllTSData(1);
        setShowAllTSDetails(false);
      }}
      style={{
        width: "210px",
        fontSize: "14px",
      }}
    >
      <option value="">All Districts</option>

      {[...new Set(
        activeTSData
          .map((item) => item.District)
          .filter(Boolean)
      )]
        .sort()
        .map((district, index) => (
          <option key={index} value={district}>
            {district}
          </option>
        ))}
    </select>
  )} */}

                          {/* Taluka - Always visible */}
                          <select
                            className="form-select"
                            value={selectedAllTSTaluka}
                            onChange={(e) => {
                              setSelectedAllTSTaluka(e.target.value);
                              setCurrentPageAllTSData(1);
                              setShowAllTSDetails(false);
                            }}
                            style={{
                              width: "210px",
                              fontSize: "14px",
                            }}
                          >
                            <option value="">All Talukas</option>

                            {[...new Set(
                              activeTSData
                                .filter((item) =>
                                  !selectedAllTSDistrict ||
                                  item.District === selectedAllTSDistrict
                                )
                                .map((item) => item.Taluka)
                                .filter(Boolean)
                            )]
                              .sort()
                              .map((taluka, index) => (
                                <option key={index} value={taluka}>
                                  {taluka}
                                </option>
                              ))}
                          </select>

                          {/* HeadCode - Non-State users only */}
                          {userData?.Department_Name !== "State" && (
                            <select
                              className="form-select"
                              value={selectedAllTSHeadCode}
                              onChange={(e) => {
                                setSelectedAllTSHeadCode(e.target.value);
                                setCurrentPageAllTSData(1);
                                setShowAllTSDetails(false);
                              }}
                              style={{
                                width: "250px",
                                fontSize: "14px",
                              }}
                            >
                              <option value="">All Head Codes</option>

                              {[...new Set(
                                activeTSData
                                  .map((item) => item.HeadCode)
                                  .filter(Boolean)
                              )]
                                .sort()
                                .map((headCode, index) => (
                                  <option key={index} value={headCode}>
                                    {headCode}
                                  </option>
                                ))}
                            </select>
                          )}

                          {/* Random Search - Always visible */}
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search anything..."
                            value={searchAllTS}
                            onChange={(e) => {
                              setSearchAllTS(e.target.value);
                              setCurrentPageAllTSData(1);
                              setShowAllTSDetails(false);
                            }}
                            style={{
                              width: "250px",
                              fontSize: "14px",
                            }}
                          />

                        </div>
                      </div>
                    </div>
                    <div className="col-12 pb-5">
                      <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>

                        <div className='col-12 tableDesign DistrictTableContianerModel2' style={{
                          background: '#2C78DB', overflowX: "auto",
                          overflowY: "auto",
                          maxHeight: "600px", // change height as needed
                          position: "relative",
                        }}>
                          <table className='m-0 p-0 ALlTechnicalSData' style={{ width: 'max-content', borderCollapse: 'collapse' }}>
                            <thead style={{
                              position: "sticky", backgroundColor: "#1976d2",
                              top: 0,
                              zIndex: 10,
                            }}>
                              <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
                                <th style={{ minWidth: "50px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Sr.No</th>
                                <th style={{ minWidth: "160px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Approved Work Name</th>
                                <th style={{ minWidth: "190px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Head Code</th> {/* changed from 9 to 7 */}
                                <th style={{ minWidth: "150px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Technical Sanction UID</th>
                                <th style={{ minWidth: "150px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>MHUID Number</th>
                                <th style={{ minWidth: "220px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Area</th>
                                <th style={{ minWidth: "150px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>GR UID</th>
                                <th style={{ minWidth: "150px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Approved Year</th>
                                <th style={{ minWidth: "150px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Constituency Name</th>
                                <th style={{ minWidth: "150px", padding: "8px" }} rowSpan={2} colSpan={1}>District</th>
                                <th style={{ minWidth: "150px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Taluka</th>
                                <th style={{ minWidth: "150px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Gram Panchayat</th>
                                <th style={{ minWidth: "150px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Type of Work</th>
                                <th style={{ minWidth: "150px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Technical Sanction Amount</th>
                                <th style={{ minWidth: "150px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Technical Sanction Copy</th>
                                <th style={{ minWidth: "150px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Date</th>
                                <th style={{ minWidth: "150px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Edited By</th>

                                <th style={{ minWidth: "150px", padding: "8px", fontSize: "18px" }} colSpan={2}>Approved by</th> {/* changed from 9 to 7 */}
                                {/* <th style={{ width: "12%", textAlign: "center", border: "1px solid white" }} colSpan={1} rowSpan={2}>Details</th> */}
                              </tr>
                              <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
                                <th style={{ minWidth: "150px", padding: "8px", fontSize: "18px" }}>Deputy Engineer</th>
                                <th style={{ minWidth: "150px", padding: "8px", fontSize: "18px" }}>Executive Engineer</th>
                              </tr>
                            </thead>

                            <tbody >
                              {currentAllTSData?.length === 0 ? (
                                <tr>
                                  <td colSpan="10" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9', fontSize: "18px" }}>
                                    No data available
                                  </td>
                                </tr>
                              ) : (
                                [...currentAllTSData]
                                  .sort((a, b) => new Date(b.Date || 0) - new Date(a.Date || 0)) // newest first
                                  .map((proposal, index) => {
                                    const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                    return (
                                      <tr style={{ backgroundColor: bgColor, fontSize: "18px" }} key={index}>
                                        <td style={{ padding: '8px 8px', fontSize: "18px" }}>{(firstRecordIndexAllTSData + index + 1)}</td>
                                        {/* <td style={{ padding: '8px 8px' }}>{(index + 1)}</td> */}
                                        <td className='fw-bold' style={{ fontSize: "18px", padding: "5px" }}>{proposal.WorkName}</td>
                                        <td style={{ padding: '8px 8px', fontSize: "18px" }}>{(proposal.HeadCode)}</td>
                                        <td style={{ padding: '8px 8px', fontSize: "18px" }}>{(proposal.TS_ID)}</td>
                                        <td style={{ padding: '8px 8px', fontSize: "18px" }}><a
                                          href="#"
                                          className='my-auto'
                                          style={{ color: '#4f46e5', textDecoration: 'underline' }}
                                          onClick={(e) => {
                                            e.preventDefault();
                                            FetchDataForMHUID(selectedYear, proposal.TechnicalSanctionNo, selectedHeadCode);
                                          }}
                                        >
                                          {(proposal.TechnicalSanctionNo)}
                                        </a></td>
                                        <td style={{
                                          padding: "8px",
                                          minWidth: "220px",   // prevents shrink
                                          maxWidth: "260px",
                                          whiteSpace: "normal",
                                          wordBreak: "break-word"
                                        }}>{extractCoords(proposal.Area)}</td>
                                        <td style={{ padding: '8px 8px', fontSize: "18px" }}>{(proposal.GR_UID)}</td>
                                        <td style={{ padding: '8px 8px', fontSize: "18px" }}>{(proposal.SanctionYear)}</td>
                                        <td style={{ padding: '8px 8px', fontSize: "18px" }}>{(proposal.ConstituencyName)}</td>
                                        <td style={{ padding: '8px 8px', fontSize: "18px" }}>{(proposal.District)}</td>
                                        <td style={{ padding: '8px 8px', fontSize: "18px" }}>{(proposal.Taluka)}</td>
                                        <td style={{ padding: '8px 8px', fontSize: "18px" }}>{(proposal.GramPanchayat)}</td>
                                        <td style={{ padding: '8px 8px', fontSize: "18px" }}>{(proposal.TypeofWork)}</td>
                                        <td style={{ padding: '8px 8px', fontSize: "18px" }}>{(proposal.TechnicalSanctionAmt)}</td>
                                        <td style={{ padding: '8px', fontSize: "18px" }}>
                                          {proposal.TechnicalSanctionCopy ? (
                                            <a href={`${apiurl}/TechincalSactionCopy/${proposal.TechnicalSanctionCopy}`} target="_blank" rel="noreferrer">{proposal.TechnicalSanctionCopy}</a>
                                          ) : (
                                            <p className='text-danger my-auto fw-bold'>No File</p>
                                          )
                                          }
                                        </td>
                                        <td style={{ padding: '8px 8px', fontSize: "18px" }}>{new Date(proposal.Date).toLocaleString("en-IN")}</td>
                                        <td style={{ padding: '8px 8px', fontSize: "18px" }}>{
                                          proposal.EditedBy ? (
                                            <p className="text-black my-auto fw-bold">{proposal.EditedBy}</p>
                                          ) : (
                                            <p className="text-danger my-auto fw-bold">No One</p>
                                          )
                                        }</td>

                                        <td style={{ padding: '8px', textAlign: 'center', fontSize: "18px" }}>
                                          {proposal.Approvance2 === 'true' ? (<div className='m-auto'
                                            style={{
                                              width: '20px',
                                              height: '20px',
                                              borderRadius: '6px',
                                              backgroundColor: '#16C60C',
                                              border: 'none',
                                              display: 'flex',
                                              justifyContent: 'center',
                                              alignItems: 'center',
                                              fontSize: '13px',
                                              color: 'white',
                                              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                            }}
                                          >
                                            ✓
                                          </div>) : proposal.Approvance2 === 'false' ? (<div
                                            className='m-auto'
                                            style={{
                                              width: '20px',
                                              height: '20px',
                                              borderRadius: '6px',
                                              backgroundColor: '#dc2626',
                                              border: 'none',
                                              display: 'flex',
                                              justifyContent: 'center',
                                              alignItems: 'center',
                                              fontSize: '13px',
                                              color: 'white',
                                              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                            }}
                                          >
                                            ✕
                                          </div>) : '-'}
                                        </td>
                                        <td style={{ padding: '8px', textAlign: 'center', fontSize: "18px" }}>
                                          {proposal.Approvance3 === 'true' ? (<div className='m-auto'
                                            style={{
                                              width: '20px',
                                              height: '20px',
                                              borderRadius: '6px',
                                              backgroundColor: '#16C60C',
                                              border: 'none',
                                              display: 'flex',
                                              justifyContent: 'center',
                                              alignItems: 'center',
                                              fontSize: '13px',
                                              color: 'white',
                                              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                            }}
                                          >
                                            ✓
                                          </div>) : proposal.Approvance3 === 'false' ? (<div
                                            className='m-auto'
                                            style={{
                                              width: '20px',
                                              height: '20px',
                                              borderRadius: '6px',
                                              backgroundColor: '#dc2626',
                                              border: 'none',
                                              display: 'flex',
                                              justifyContent: 'center',
                                              alignItems: 'center',
                                              fontSize: '13px',
                                              color: 'white',
                                              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                            }}
                                          >
                                            ✕
                                          </div>) : '-'}
                                        </td>

                                        {/* <td style={{ padding: '8px' }}>{proposal.Proposal_copy}</td> */}
                                        {/* <td>
                                                                <button
                                                                    className='m-auto'
                                                                    onClick={() => selectedBillDetails(proposal.TS_ID)}
                                                                    style={{
                                                                        cursor: 'pointer',
                                                                        background: "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                                                                        color: 'white',
                                                                        border: 'none',
                                                                        padding: '6px 20px',
                                                                        borderRadius: '4px',
                                                                        fontSize: "12px",
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: 'center',
                                                                        width: "80%"
                                                                    }}
                                                                >
                                                                    <img src="/view32.png" alt="view" className='me-1' style={{ width: "12px", height: "12px" }} />
                                                                    View
                                                                </button>
                                                            </td> */}
                                      </tr>

                                    );
                                  })
                              )}
                              {/* Page Total */}
                              {currentAllTSData?.length > 0 && (
                                <tr
                                  style={{
                                    fontWeight: "bold",
                                    backgroundColor: "#f0f0f0",
                                    fontSize: "18px",
                                    textAlign: "right"
                                  }}
                                >
                                  <td style={{ fontSize: "18px" }} colSpan={13}>
                                    {t("Page Total")}
                                  </td>

                                  <td style={{ fontSize: "18px" }}>
                                    ₹{" "}
                                    {Number(
                                      pageTotalAllTSAmount
                                    ).toLocaleString("en-IN")}
                                  </td>

                                  <td style={{ fontSize: "18px" }} colSpan={5}></td>
                                </tr>
                              )}

                              {/* Grand Total */}
                              {sortedTS?.length > 0 && (
                                <tr
                                  style={{
                                    fontWeight: "bold",
                                    backgroundColor: "#e0e0e0",
                                    fontSize: "18px"
                                    , textAlign: "right"
                                  }}
                                >
                                  <td style={{ fontSize: "18px" }} colSpan={13}>
                                    {t("Gross Total")}
                                  </td>

                                  <td style={{ fontSize: "18px" }}>
                                    ₹{" "}
                                    {Number(
                                      grandTotalAllTSAmount
                                    ).toLocaleString("en-IN")}
                                  </td>

                                  <td style={{ fontSize: "18px" }} colSpan={5}></td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginTop: "20px",
                          }}
                        >
                          <p className="text-gray-600 m-0" style={{ fontSize: "18px" }}>
                            {t("Showing")}{" "}
                            {sortedTS.length > 0
                              ? showAllTSDetails
                                ? 1
                                : firstRecordIndexAllTSData + 1
                              : 0}{" "}
                            {t("to")}{" "}
                            {showAllTSDetails
                              ? sortedTS.length
                              : Math.min(lastRecordIndexAllTSData, sortedTS.length)}{" "}
                            {t("of")} {sortedTS.length} {t("entries")}
                          </p>

                          <div style={{ display: "flex", alignItems: "center", gap: "10px", fontSize: "18px" }}>

                            <button
                              type="button"
                              onClick={() => {
                                setShowAllTSDetails(!showAllTSDetails);
                                setCurrentPageAllTSData(1);
                              }}
                              style={{
                                border: "none",
                                outline: "none",
                                cursor: "pointer",
                                padding: "8px 16px",
                                borderRadius: "20px",
                                fontSize: "18px",
                                fontWeight: "600",
                                color: "#fff",
                                background: showAllTSDetails
                                  ? "linear-gradient(135deg, #28a745, #20c997)"
                                  : "linear-gradient(135deg, #0067ab, #0098d5)",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                              }}
                            >
                              {showAllTSDetails ? "✓ Showing All" : "View All"}
                            </button>

                            {!showAllTSDetails && (
                              <GooglePagination
                                currentPage={currentPageAllTSData}
                                totalPages={totalPagesAllTSData}
                                onPageChange={setCurrentPageAllTSData}
                              />
                            )}

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </>
          )
        }

        {/* Technical S Page 2 after Clicking MHUID clicking */}
        {
          selectedYear &&
          showspecific === 111 &&
          (
            <>

              <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
                <div className="col-11 m-auto">
                  <div className='col-12' >

                    <div className="col-12">
                      <button className='btn btn-danger px-3 rounded-4 mb-3 mt-3' onClick={() => setShowSpecific(110)}>{t("Back")}</button>
                    </div>

                    <div className="col-11 my-0 mx-auto">
                      <div className="row">
                        <div className="col-12 py-2 d-flex justify-content-left align-items-center">

                          <h5 className="my-auto fw-bold d-flex align-items-center">
                            <img src="/GR-Approval64.png" alt="" style={{ width: "24px", height: "24px" }} className="me-2" />
                            <span>
                              {t("ALL Progress Details of ")} {MHUIDnumber} {selectedYear}
                            </span>
                          </h5>
                        </div>

                        <div className="col-12 d-flex justify-content-end mt-3 mb-3 gap-2">
                          <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("ProgressTableData", "ProgressTableData.xlsx")}>{t("Download Excel")}</button>
                          <button className='btn btn-danger px-4' onClick={() => downloadTableOnlyAsPDF('ProgressTableData', `ProgressTableData_${selectedYear}.pdf`, `Progress Details Data ${selectedYear}`)}>{t("Download Pdf")}</button>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 pb-5">
                      <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>

                        <div
                          className="col-12 tableDesign DistrictTableContianerModel2"
                          style={{ background: "#2C78DB", overflowX: "scroll" }}
                        >
                          <table
                            className="m-0 p-0 ProgressTableData"
                            style={{ width: "100%", borderCollapse: "collapse" }}
                          >
                            <thead>
                              <tr
                                style={{
                                  color: "white",
                                  border: "none",
                                  height: "3rem",
                                  fontSize: "18px",
                                }}
                              >
                                <th style={{ padding: "7px 10px", minWidth: "60px", fontSize: "18px" }}>Sr.No.</th>
                                {/* <th style={{ padding: "7px 10px", minWidth: "160px" }}>Common WorkOrder ID</th> */}


                                <th style={{ padding: "7px 10px", minWidth: "200px", fontSize: "18px" }}>Head Code</th>
                                <th style={{ padding: "7px 10px", minWidth: "150px", fontSize: "18px" }}>Proposal Year</th>
                                <th style={{ padding: "7px 10px", minWidth: "150px", fontSize: "18px" }}>MH UID</th>
                                <th style={{ padding: "7px 10px", minWidth: "180px", fontSize: "18px" }}>Work Name</th>
                                <th style={{ padding: "7px 10px", minWidth: "150px", fontSize: "18px" }}>District</th>
                                <th style={{ padding: "7px 10px", minWidth: "150px", fontSize: "18px" }}>Taluka</th>
                                <th style={{ padding: "7px 10px", minWidth: "150px", fontSize: "18px" }}>Physical Progress (%)</th>
                                <th style={{ padding: "7px 10px", minWidth: "220px", fontSize: "18px" }}>File Upload</th>
                                <th style={{ padding: "7px 10px", minWidth: "150px", fontSize: "18px" }}>Date</th>
                                <th style={{ padding: "7px 10px", minWidth: "180px", fontSize: "18px" }}>Remark</th>
                                <th style={{ padding: "7px 10px", minWidth: "180px", fontSize: "18px" }}>Approval 1</th>
                                <th style={{ padding: "7px 10px", minWidth: "180px", fontSize: "18px" }}>Approval 2</th>

                              </tr>
                            </thead>

                            <tbody>
                              {FilterDataOfMHUID?.length === 0 ? (
                                <tr>
                                  <td
                                    colSpan="16"
                                    style={{
                                      textAlign: "center",
                                      padding: "20px",
                                      backgroundColor: "#f9f9f9",
                                    }}
                                  >
                                    No data available
                                  </td>
                                </tr>
                              ) : (
                                currentProgressData?.map((proposal, index) => {
                                  const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                  const statusBox = (value) => {
                                    if (value === "true") {
                                      return (
                                        <div
                                          className="m-auto"
                                          style={{
                                            width: "20px",
                                            height: "20px",
                                            borderRadius: "6px",
                                            backgroundColor: "#16C60C",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            color: "white",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          ✓
                                        </div>
                                      );
                                    } else if (value === "false") {
                                      return (
                                        <div
                                          className="m-auto"
                                          style={{
                                            width: "20px",
                                            height: "20px",
                                            borderRadius: "6px",
                                            backgroundColor: "#dc2626",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            color: "white",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          ✕
                                        </div>
                                      );
                                    } else {
                                      return "-";
                                    }
                                  };

                                  return (
                                    <tr style={{ backgroundColor: bgColor }} key={index}>
                                      <td style={{ padding: "8px", fontSize: "18px" }}>
                                        {firstRecordIndexProgress + index + 1}
                                      </td>
                                      {/* <td style={{ padding: "8px" }}>
                                                               {proposal.CommonWorkOrderID || "-"}
                                                             </td> */}


                                      <td style={{ padding: "8px", fontSize: "18px" }}>
                                        {proposal.Head_Code || "-"}
                                      </td>
                                      <td style={{ padding: "8px", fontSize: "18px" }}>
                                        {proposal.ProposalYear || "-"}
                                      </td>
                                      <td style={{ padding: "8px", fontSize: "18px" }}>
                                        {proposal.TechnicalUID || "-"}
                                      </td>
                                      <td style={{ padding: "8px", fontSize: "18px" }}>
                                        {proposal.WorkOrderNo || "-"}
                                      </td>
                                      <td style={{ padding: "8px", fontSize: "18px" }}>
                                        {proposal.District || "-"}
                                      </td>
                                      <td style={{ padding: "8px", fontSize: "18px" }}>
                                        {proposal.Taluka || "-"}
                                      </td>
                                      <td style={{ padding: "8px", fontSize: "18px" }}>
                                        {proposal.physicalValue || "0"}
                                      </td>

                                      <td style={{ padding: "8px", fontSize: "18px" }}>
                                        {proposal.Upload ? (
                                          (() => {
                                            let files = [];

                                            try {
                                              // Case 1: JSON array string
                                              files = Array.isArray(proposal.Upload)
                                                ? proposal.Upload
                                                : JSON.parse(proposal.Upload);
                                            } catch (e) {
                                              // Case 2: comma-separated string OR single file
                                              files = proposal.Upload.split(",").map(f => f.trim());
                                            }

                                            return files.map((file, index) => (
                                              <span key={index}>
                                                <a
                                                  href={`${apiurl}/UploadProgressDocsImages/${file}`}
                                                  target="_blank"
                                                  rel="noreferrer"
                                                  style={{ color: "#0d6efd", textDecoration: "underline" }}
                                                >
                                                  {file}
                                                </a>
                                                {index !== files.length - 1 && ", "}
                                              </span>
                                            ));
                                          })()
                                        ) : (
                                          <span className="text-danger fw-bold">No File</span>
                                        )}
                                      </td>

                                      <td style={{ padding: "8px", fontSize: "18px" }}>
                                        {proposal.Date
                                          ? new Date(proposal.Date).toLocaleString()
                                          : "-"}
                                      </td>
                                      <td style={{ padding: "8px", fontSize: "18px" }}>
                                        {proposal.Remark || "-"}
                                      </td>
                                      <td style={{ padding: "8px", textAlign: "center", fontSize: "18px" }}>
                                        {statusBox(proposal.Approvance1)}
                                      </td>
                                      <td style={{ padding: "8px", textAlign: "center", fontSize: "18px" }}>
                                        {statusBox(proposal.Approvance2)}
                                      </td>

                                    </tr>
                                  );
                                })
                              )}
                            </tbody>
                          </table>
                        </div>

                        <div className='col-12 mt-3 mb-2'>
                          <div className="row">

                            <div className='col-6'>
                              <p className="text-gray-600" style={{ fontSize: "18px" }}>
                                {t("Showing")} {firstRecordIndexProgress + 1} {t("to")}{" "}
                                {Math.min(lastRecordIndexProgress, FilterDataOfMHUID?.length || 0)}{" "}
                                {t("of")} {FilterDataOfMHUID?.length || 0} {t("entries")}
                              </p>
                            </div>

                            <div className='col-6 text-end'>
                              <GooglePagination
                                currentPage={currentPageProgress}
                                totalPages={totalProgressPages}
                                onPageChange={setCurrentPageProgress}
                              />
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </>
          )
        }

        {/* Series for Part 5 for Total TS created */}
        {
          districtDRSummary.length > 0 &&
          showspecific === 112 &&
          (
            <>

              <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
                <div className="col-11 m-auto">
                  <div className='col-12' >

                    <div className="col-12">
                      <button className='btn btn-danger px-3 rounded-4 mb-3 mt-3' onClick={() => setShowSpecific(0)}>{t("Back")}</button>
                    </div>

                    <div className="col-11 my-0 mx-auto">
                      <div className="row">
                        <div className="col-12 py-2 d-flex justify-content-left align-items-center">

                          <h5 className="my-auto fw-bold d-flex align-items-center">
                            <img
                              src="/GR-Approval64.png"
                              alt=""
                              style={{ width: "24px", height: "24px" }}
                              className="me-2"
                            />
                            <span>
                              {t("Demand Request created in the Year")} {selectedYear}
                            </span>
                          </h5>
                        </div>

                        {/* <div className="col-12 d-flex justify-content-end mt-3 mb-3 gap-2">
                          <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("ALlDistrictFinanceData", "AllDistrictReleaseData.xlsx")}>{t("Download Excel")}</button>
                          <button className='btn btn-danger px-4' onClick={() => downloadPageAsPDF('ALlDistrictFinanceData', `ALlDistrictFinanceData_${selectedYear}.pdf`, `ALlDistrict Finance Data ${selectedYear}`)}>{t("Download Pdf")}</button>
                        </div> */}
                      </div>
                    </div>
                    <div className="col-12 pb-5">
                      <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>

                        <div className='col-12 tableDesign DistrictTableContianerModel2' style={{ background: '#2C78DB', overflowX: 'auto' }}>
                          <table className='m-0 py-0 ALlDistrictFinanceData' style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                              <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
                                <th style={{ width: "10%" }}>{t("Sr No")}</th>
                                <th style={{ minWidth: "250px", padding: "8px" }}>{t("District")}</th>
                                <th style={{ minWidth: "250px", padding: "8px" }}>{t("Year")}</th>
                                <th style={{ minWidth: "250px", padding: "8px" }}>{t("Total Demand")}</th>
                                <th style={{ minWidth: "250px", padding: "8px" }}>{t("Gross Amount")}</th>
                              </tr>
                            </thead>

                            <tbody>
                              {
                                districtDRSummary &&
                                  districtDRSummary.length > 0 ?
                                  (() => {
                                    const totaltscount = districtDRSummary.reduce((sum, val) => sum + parseFloat(val.TotalDemand || 0), 0);
                                    const totaltsamount = districtDRSummary.reduce((sum, val) => sum + parseFloat(val.TotalAmount || 0), 0);

                                    return (
                                      <>
                                        {
                                          districtDRSummary.map((item, idx) => {
                                            const bgColor = idx % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                            return (
                                              <tr key={idx} style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "400" }}>
                                                <td>{idx + 1}</td>
                                                <td><a
                                                  href="#"
                                                  className='my-auto'
                                                  style={{ color: '#4f46e5', textDecoration: 'underline' }}
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    showDistrictDR(item.District);
                                                  }}
                                                >
                                                  {item.District}
                                                </a></td>
                                                <td>{selectedYear}</td>
                                                <td>{item.TotalDemand}</td>
                                                <td>
                                                  ₹ {Number(item.TotalAmount).toLocaleString("en-IN")}
                                                </td>
                                              </tr>
                                            );
                                          })
                                        }

                                        <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0', textAlign: "right" }}>
                                          <td colSpan={3}>{t("Gross Total")}</td>
                                          <td>{Number(totaltscount).toLocaleString("en-IN")}</td>
                                          <td>₹ {Number(totaltsamount).toLocaleString("en-IN")}</td>
                                        </tr>
                                      </>
                                    );
                                  })()
                                  :
                                  (
                                    <tr>
                                      <td colSpan={5} className='fw-bold'>{t("No data found")}</td>
                                    </tr>
                                  )
                              }
                            </tbody>

                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </>
          )
        }

        {/* this is all demandgeneration data  */}
        {
          selectedYear &&
          showspecific === 113 &&
          (
            <>

              <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
                <div className="col-11 m-auto">
                  <div className='col-12' >

                    <div className="col-12">
                      <button className='btn btn-danger px-3 rounded-4 mb-3 mt-3' onClick={() => {
                        setShowSpecific(112)
                        setFilteredDRData([]);
                      }}>{t("Back")}</button>
                    </div>

                    <div className="col-11 my-0 mx-auto">
                      <div className="row">
                        <div className="col-12 py-2 d-flex justify-content-left align-items-center">

                          <h5 className="my-auto fw-bold d-flex align-items-center">
                            <img src="/GR-Approval64.png" alt="" style={{ width: "24px", height: "24px" }} className="me-2" />
                            <span>
                              {t("ALL Demand Generated Details of ")} {selectedYear}
                            </span>
                          </h5>
                        </div>

                        <div className="col-12 d-flex justify-content-end mt-3 mb-3 gap-2">
                          <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("DemandGeneratedData", "DemandGeneratedData.xlsx")}>{t("Download Excel")}</button>
                          <button className='btn btn-danger px-4' onClick={() => downloadTableOnlyAsPDF('DemandGeneratedData', `DemandGeneratedData_${selectedYear}.pdf`, `Demand Generated Data ${selectedYear}`)}>{t("Download Pdf")}</button>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 pb-5">
                      <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>

                        <div className='col-12 tableDesign DistrictTableContianerModel2' style={{ background: '#2C78DB', overflowX: 'scroll' }}>
                          <table className='m-0 p-0 DemandGeneratedData' style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                              <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
                                <th style={{ minWidth: "50px", padding: "8px" }} rowSpan={2} colSpan={1}>Sr.No.</th>
                                <th style={{ minWidth: "100px", padding: "8px" }} rowSpan={2} colSpan={1}>Financial Year</th>
                                <th style={{ minWidth: "180px", padding: "8px" }} rowSpan={2} colSpan={1}>Head Code</th>
                                <th style={{ minWidth: "160px", padding: "8px" }} rowSpan={2} colSpan={1}>Work Name</th>
                                <th style={{ minWidth: "120px", padding: "8px" }} rowSpan={2} colSpan={1}>MHUID Number</th>
                                <th style={{ minWidth: "120px", padding: "8px" }} rowSpan={2} colSpan={1}>Physical Progress (%)</th>
                                <th style={{ minWidth: "80px", padding: "8px" }} rowSpan={2} colSpan={1}>District</th>
                                <th style={{ minWidth: "100px", padding: "8px" }} rowSpan={2} colSpan={1}>Expenditure Amount</th>
                                <th style={{ minWidth: "150px", padding: "8px" }} rowSpan={2} colSpan={1}>Approved Demand Request Amount</th>
                                <th style={{ minWidth: "150px", padding: "8px" }} rowSpan={2} colSpan={1}>Available Work Order Amount</th>
                                <th style={{ minWidth: "150px", padding: "8px" }} rowSpan={2} colSpan={1}>Available Amount for Demand Request</th>
                                <th style={{ minWidth: "100px", padding: "8px" }} rowSpan={2} colSpan={1}>Date</th>
                                <th style={{ minWidth: "150px", padding: "8px" }} colSpan={2}>Approved by</th>
                              </tr>
                              <tr style={{ color: 'white', border: 'none', height: '3rem' }}>
                                <th style={{ minWidth: "80px", padding: "8px" }}>District Department Maker</th>
                                <th style={{ minWidth: "80px", padding: "8px" }}>Department HOD(EE)</th>
                              </tr>
                            </thead>

                            <tbody >
                              {currentDRtableData?.length === 0 ? (
                                <tr>
                                  <td colSpan="10" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
                                    No data available
                                  </td>
                                </tr>
                              ) : (
                                [...currentDRtableData]
                                  .sort((a, b) =>
                                    new Date(b.created_At || 0) - new Date(a.created_At || 0)
                                  ) // newest first
                                  .map((proposal, index) => {
                                    const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                    return (
                                      <tr style={{ backgroundColor: bgColor }} key={index}>
                                        <td style={{ padding: '8px 8px' }}>{firstRecordIndexDRtableData + index + 1}</td>
                                        <td style={{ padding: '8px 8px' }}>{proposal.Year}</td>
                                        <td style={{ padding: '8px 8px' }}>{proposal.HeadCode}</td>
                                        <td style={{ padding: '8px 8px' }}>{proposal.ProposalWorkName}</td>
                                        <td style={{ padding: '8px 8px' }}>{proposal.MHUID}</td>
                                        <td style={{ padding: '8px 8px' }}>{proposal.physicalValue}</td>
                                        <td style={{ padding: '8px 8px' }}>{proposal.District}</td>
                                        <td style={{ padding: '8px 8px' }}>{proposal.ExpenditureAmount}</td>
                                        <td style={{ padding: '8px 8px' }}>{proposal.ApprovedDemandRequest}</td>
                                        <td style={{ padding: '8px 8px' }}>{proposal.AvailableWorkOrderAmount}</td>
                                        <td style={{ padding: '8px 8px' }}>{proposal.AvailableAmountForDemandRequest}</td>
                                        <td style={{ padding: '8px 8px' }}>{new Date(proposal.created_At).toLocaleString("en-IN")}</td>
                                        <td style={{ padding: '8px 8px' }}>
                                          {proposal.Approvance1 === 'true' ? (
                                            <div className='m-auto'
                                              style={{
                                                width: '20px',
                                                height: '20px',
                                                borderRadius: '6px',
                                                backgroundColor: '#16C60C',
                                                border: 'none',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                fontSize: '13px',
                                                color: 'white',
                                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                              }}
                                            >
                                              ✓
                                            </div>
                                          ) : proposal.Approvance1 === 'false' ? (
                                            <div
                                              className='m-auto'
                                              style={{
                                                width: '20px',
                                                height: '20px',
                                                borderRadius: '6px',
                                                backgroundColor: '#dc2626',
                                                border: 'none',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                fontSize: '13px',
                                                color: 'white',
                                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                              }}
                                            >
                                              ✕
                                            </div>
                                          ) : '-'}
                                        </td>
                                        <td style={{ padding: '8px 8px' }}>
                                          {proposal.Approvance2 === 'true' ? (<div className='m-auto'
                                            style={{
                                              width: '20px',
                                              height: '20px',
                                              borderRadius: '6px',
                                              backgroundColor: '#16C60C',
                                              border: 'none',
                                              display: 'flex',
                                              justifyContent: 'center',
                                              alignItems: 'center',
                                              fontSize: '13px',
                                              color: 'white',
                                              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                            }}
                                          >
                                            ✓
                                          </div>) : proposal.Approvance2 === 'false' ? (<div
                                            className='m-auto'
                                            style={{
                                              width: '20px',
                                              height: '20px',
                                              borderRadius: '6px',
                                              backgroundColor: '#dc2626',
                                              border: 'none',
                                              display: 'flex',
                                              justifyContent: 'center',
                                              alignItems: 'center',
                                              fontSize: '13px',
                                              color: 'white',
                                              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                            }}
                                          >
                                            ✕
                                          </div>) : '-'}
                                        </td>
                                      </tr>

                                    );
                                  })
                              )}
                            </tbody>
                          </table>
                        </div>
                        <div className='col-12 mt-4 mb-2'>
                          <div className="row">
                            <div className='col-6'>
                              <p className="text-gray-600" style={{ fontSize: "14px" }}>{t("Showing")} {firstRecordIndexDRtableData + 1} {t("to")} {Math.min(lastRecordIndexDRtableData, totalRecordsDRtableData)} {t("of")} {totalRecordsDRtableData} {t("entries")}</p>
                            </div>
                            <div className='col-6' style={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
                              <button onClick={() => setCurrentPageDRtableData(1)} disabled={currentPageDRtableData === 1}
                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', width: '2rem' }}>&laquo;</button>
                              <button onClick={() => setCurrentPageDRtableData(currentPageDRtableData - 1)} disabled={currentPageDRtableData === 1}
                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>&lt;</button>
                              <button
                                style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '20px', width: '2.4rem', border: '1px solid lightgrey', borderLeft: "none" }}>
                                {currentPageDRtableData}
                              </button>
                              <button onClick={() => setCurrentPageDRtableData(currentPageDRtableData + 1)} disabled={currentPageDRtableData === totalPagesDRtableData || totalPagesDRtableData === 0}
                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>&gt;</button>
                              <button onClick={() => setCurrentPageDRtableData(totalPagesDRtableData)} disabled={currentPageDRtableData === totalPagesDRtableData || totalPagesDRtableData === 0}
                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>&raquo;</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </>
          )
        }

        {/* Series for Part 6 for Total WO created */}
        {
          districtWOSummary.length > 0 &&
          showspecific === 115 &&
          (
            <>

              <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
                <div className="col-11 m-auto">
                  <div className='col-12' >

                    <div className="col-12">
                      <button
                        className="btn btn-danger px-3 rounded-4 mb-3 mt-3"
                        onClick={() => {
                          // Go back
                          setShowSpecific(0);

                          // Reset Work Order filters
                          setSelectedWODistrict("");
                          setSearchWO("");

                          // Reset pagination
                          setDistrictWOPage(1);

                          // Reset View All
                          setShowAllDistrictWO(false);
                        }}
                      >
                        {t("Back")}
                      </button>
                    </div>

                    <div className="col-11 my-0 mx-auto">
                      <div className="row">
                        <div className="col-12 py-2 d-flex justify-content-left align-items-center">

                          <h5 className="my-auto fw-bold d-flex align-items-center">
                            <img
                              src="/GR-Approval64.png"
                              alt=""
                              style={{ width: "24px", height: "24px" }}
                              className="me-2"
                            />
                            <span>
                              {t("Total Work Order created in the Year")} {selectedYear}
                            </span>
                          </h5>
                        </div>

                        {/* <div className="col-12 d-flex justify-content-end mt-3 mb-3 gap-2">
                          <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("ALlDistrictFinanceData", "AllDistrictReleaseData.xlsx")}>{t("Download Excel")}</button>
                          <button className='btn btn-danger px-4' onClick={() => downloadPageAsPDF('ALlDistrictFinanceData', `ALlDistrictFinanceData_${selectedYear}.pdf`, `ALlDistrict Finance Data ${selectedYear}`)}>{t("Download Pdf")}</button>
                        </div> */}
                                                <div className="col-12 d-flex justify-content-end mt-3 mb-3 gap-2">
  <button
    className="btn btn-success px-4"
    onClick={() =>
      exportTableByClassToExcel(
        "ALlDistrictFinanceData",
        `WorkOrder_Summary_${selectedYear}.xlsx`
      )
    }
  >
    {t("Download Excel")}
  </button>

  <button
    className="btn btn-danger px-4"
    onClick={() =>
      downloadTableOnlyAsPDF(
        "ALlDistrictFinanceData",
        `WorkOrder_Summary_${selectedYear}.pdf`,
        `Total Work Order created in the Year ${selectedYear}`
      )
    }
  >
    {t("Download PDF")}
  </button>
</div>
                      </div>
                    </div>
                    {/* Work Order Filters */}
                    <div
                      className="d-flex justify-content-end align-items-center mb-3"
                      style={{
                        gap: "10px",
                        flexWrap: "wrap",
                      }}
                    >

                      {/* District Filter - State Login Only */}
                      {userData?.Department_Name === "State" && (
                        <select
                          className="form-select"
                          value={selectedWODistrict}
                          onChange={(e) => {
                            setSelectedWODistrict(e.target.value);
                            setDistrictWOPage(1);
                            setShowAllDistrictWO(false);
                          }}
                          style={{
                            width: "220px",
                            fontSize: "14px",
                          }}
                        >
                          <option value="">All Districts</option>

                          {[...new Set(
                            districtWOSummary
                              .map((item) => getMainDistrict(item.District))
                              .filter(Boolean)
                          )]
                            .sort()
                            .map((district, index) => (
                              <option key={index} value={district}>
                                {district}
                              </option>
                            ))}
                        </select>
                      )}

                      {/* Random Search - Always Visible */}
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search anything..."
                        value={searchWO}
                        onChange={(e) => {
                          setSearchWO(e.target.value);
                          setDistrictWOPage(1);
                          setShowAllDistrictWO(false);
                        }}
                        style={{
                          width: "250px",
                          fontSize: "14px",
                        }}
                      />

                    </div>
                    <div className="col-12 pb-5">
                      <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>

                        <div className='col-12 tableDesign DistrictTableContianerModel2' style={{
                          background: '#2C78DB', overflowX: "auto",
                          overflowY: "auto",
                          maxHeight: "600px", // change height as needed
                          position: "relative",
                        }}>
                          <table className='m-0 py-0 ALlDistrictFinanceData' style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead style={{
                              position: "sticky", backgroundColor: "#1976d2",
                              top: 0,
                              zIndex: 10,
                            }}>
                              <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
                                <th style={{ width: "10%" }}>{t("Sr No")}</th>
                                <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("District")}</th>
                                <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("Year")}</th>
                                <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("Total Work Orders")}</th>
                                <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("Total Approved Amount")}</th>
                              </tr>
                            </thead>

                            <tbody>
                              {
                                districtWOSummary &&
                                  districtWOSummary.length > 0 ?
                                  (() => {
                                    const pageTotalWOCount = paginatedWOData.reduce(
                                      (sum, val) => sum + parseFloat(val.TotalWO || 0),
                                      0
                                    );

                                    const pageTotalWOAmount = paginatedWOData.reduce(
                                      (sum, val) => sum + parseFloat(val.TotalAmount || 0),
                                      0
                                    );

                                    const grandTotalWOCount = filteredDistrictWOSummary.reduce(
                                      (sum, val) => sum + parseFloat(val.TotalWO || 0),
                                      0
                                    );

                                    const grandTotalWOAmount = filteredDistrictWOSummary.reduce(
                                      (sum, val) => sum + parseFloat(val.TotalAmount || 0),
                                      0
                                    );

                                    return (
                                      <>
                                        {
                                          paginatedWOData.map((item, idx) => {
                                            const bgColor = idx % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                            return (
                                              <tr key={idx} style={{ backgroundColor: bgColor, fontSize: "18px", fontWeight: "400" }}>
                                                <td style={{ fontSize: "18px" }}>{((districtWOPage - 1) * woRecordsPerPage) + idx + 1}</td>
                                                <td style={{ fontSize: "18px" }}><a
                                                  href="#"
                                                  className='my-auto'
                                                  style={{ color: '#4f46e5', textDecoration: 'underline' }}
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    showDistrictWO(item.District);
                                                  }}
                                                >
                                                  {item.District}
                                                </a></td>
                                                <td style={{ fontSize: "18px" }}>{selectedYear}</td>
                                                <td style={{ fontSize: "18px" }}>{item.TotalWO}</td>
                                                <td style={{ fontSize: "18px" }}>
                                                  ₹ {Number(item.TotalAmount).toLocaleString("en-IN")}
                                                </td>
                                              </tr>
                                            );
                                          })
                                        }

                                        {/* Page Total */}
                                        <tr
                                          style={{
                                            fontWeight: "bold",
                                            backgroundColor: "#f0f0f0",
                                            fontSize: "18px"
                                          }}
                                        >
                                          <td colSpan={3} style={{
                                            fontSize: "18px", textAlign: "right"
                                          }}>
                                            {t("Page Total")}
                                          </td>

                                          <td style={{
                                            fontSize: "18px"
                                          }}>
                                            {Number(pageTotalWOCount).toLocaleString("en-IN")}
                                          </td>

                                          <td style={{
                                            fontSize: "18px"
                                          }}>
                                            ₹ {Number(pageTotalWOAmount).toLocaleString("en-IN")}
                                          </td>
                                        </tr>

                                        {/* Grand Total */}
                                        <tr
                                          style={{
                                            fontWeight: "bold",
                                            backgroundColor: "#e0e0e0",
                                            fontSize: "18px"
                                          }}
                                        >
                                          <td colSpan={3} style={{
                                            fontSize: "18px", textAlign: "right"
                                          }}>
                                            {t("Gross Total")}
                                          </td>

                                          <td style={{
                                            fontSize: "18px"
                                          }}>
                                            {Number(grandTotalWOCount).toLocaleString("en-IN")}
                                          </td>

                                          <td style={{
                                            fontSize: "18px"
                                          }}>
                                            ₹ {Number(grandTotalWOAmount).toLocaleString("en-IN")}
                                          </td>
                                        </tr>
                                      </>
                                    );
                                  })()
                                  :
                                  (
                                    <tr>
                                      <td colSpan={5} className='fw-bold' style={{
                                        fontSize: "18px"
                                      }}>{t("No data found")}</td>
                                    </tr>
                                  )
                              }
                            </tbody>

                          </table>
                        </div>
                        <div className='col-12 mt-3 mb-2'>
                          <div className="row">

                            <div className='col-6'>
                              <p className="text-gray-600" style={{ fontSize: "18px" }}>
                                {t("Showing")}{" "}
                                {filteredDistrictWOSummary.length > 0
                                  ? (districtWOPage - 1) * woRecordsPerPage + 1
                                  : 0}{" "}
                                {t("to")}{" "}
                                {Math.min(
                                  districtWOPage * woRecordsPerPage,
                                  filteredDistrictWOSummary.length
                                )}{" "}
                                {t("of")}{" "}
                                {filteredDistrictWOSummary.length}{" "}
                                {t("entries")}
                              </p>
                            </div>

                            <div className='col-6 text-end'>
                              <GooglePagination
                                currentPage={districtWOPage}
                                totalPages={totalWOPages}
                                onPageChange={setDistrictWOPage}
                              />
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </>
          )
        }

        {/* this is for work order created */}
        {
          selectedYear &&
          showspecific === 114 &&
          (
            <>

              <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
                <div className="col-11 m-auto">
                  <div className='col-12' >

                    <div className="col-12">
                      <button
                        className="btn btn-danger px-3 rounded-4 mb-3 mt-3"
                        onClick={() => {
                          // Go back
                          setShowSpecific(115);

                          // Reset HeadCode filter
                          setSelectedWOHeadCode("");

                          // Reset random search
                          setSearchWorkOrder("");

                          // Clear previous Work Order filtered data
                          setFilteredWOData([]);

                          // Reset pagination
                          setCurrentPageWorkOrderData(1);
                        }}
                      >
                        {t("Back")}
                      </button>
                    </div>

                    <div className="col-11 my-0 mx-auto">
                      <div className="row">
                        <div className="col-12 py-2 d-flex justify-content-left align-items-center">

                          <h5 className="my-auto fw-bold d-flex align-items-center">
                            <img src="/GR-Approval64.png" alt="" style={{ width: "24px", height: "24px" }} className="me-2" />
                            <span>
                              {t("ALL Work Order Generated of ")} {selectedYear}
                            </span>
                          </h5>
                        </div>

                        <div className="col-12 d-flex justify-content-end mt-3 mb-3 gap-2">
                          <button className='btn btn-success px-4' onClick={() => exportTableByClassToExcel("WorkOrderData", "WorkOrderData.xlsx")}>{t("Download Excel")}</button>
                          <button className='btn btn-danger px-4' onClick={() => downloadTableOnlyAsPDF('WorkOrderData', `WorkOrderData_${selectedYear}.pdf`, `Work Order Data ${selectedYear}`)}>{t("Download Pdf")}</button>
                        </div>
                      </div>
                    </div>
                    {/* Work Order Filters */}
                    <div
                      className="d-flex justify-content-end align-items-center mb-3"
                      style={{
                        gap: "10px",
                        flexWrap: "wrap",
                      }}
                    >
                      {/* HeadCode - Non-State users only */}
                      {userData?.Department_Name !== "State" && (
                        <select
                          className="form-select"
                          value={selectedWOHeadCode}
                          onChange={(e) => {
                            setSelectedWOHeadCode(e.target.value);
                            setCurrentPageWorkOrderData(1);
                          }}
                          style={{
                            width: "250px",
                            fontSize: "14px",
                          }}
                        >
                          <option value="">All Head Codes</option>

                          {[...new Set(
                            activeWOData
                              .map((item) => item.HeadCode)
                              .filter(Boolean)
                          )]
                            .sort()
                            .map((headCode, index) => (
                              <option key={index} value={headCode}>
                                {headCode}
                              </option>
                            ))}
                        </select>
                      )}

                      {/* Random Search - Always visible */}
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search anything..."
                        value={searchWorkOrder}
                        onChange={(e) => {
                          setSearchWorkOrder(e.target.value);
                          setCurrentPageWorkOrderData(1);
                        }}
                        style={{
                          width: "250px",
                          fontSize: "14px",
                        }}
                      />
                    </div>
                    <div className="col-12 pb-5">
                      <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "150%", overflowX: "hidden" }}>

                        <div className='col-12 tableDesign DistrictTableContianerModel2' style={{
                          background: '#2C78DB', overflowX: "auto",
                          overflowY: "auto",
                          maxHeight: "600px", // change height as needed
                          position: "relative",
                        }}>
                          <table className='m-0 p-0 WorkOrderData' style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead style={{
                              position: "sticky", backgroundColor: "#1976d2",
                              top: 0,
                              zIndex: 10,
                            }}>
                              <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
                                <th style={{ minWidth: "50px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Sr.No.</th>
                                <th style={{ minWidth: "160px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Work Order UID</th>
                                <th style={{ minWidth: "160px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Work Order Number</th>
                                <th style={{ minWidth: "160px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Work Order Name</th>
                                <th style={{ minWidth: "160px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Head Code</th>
                                <th style={{ minWidth: "160px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>MH UID</th>
                                <th style={{ minWidth: "160px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Approved Work Name</th>
                                <th style={{ minWidth: "130px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Approved Year</th>
                                <th style={{ minWidth: "130px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>District</th>
                                <th style={{ minWidth: "130px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Approved Work Amount</th>
                                <th style={{ minWidth: "130px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Remaining Amount</th>
                                <th style={{ minWidth: "130px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Paid Amount</th>
                                <th style={{ minWidth: "160px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Work Order Date</th>
                                <th style={{ minWidth: "160px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Work Order End Date</th>
                                <th style={{ minWidth: "160px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Work Order Copy</th>
                                <th style={{ minWidth: "160px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Date</th>
                                <th style={{ minWidth: "160px", padding: "8px", fontSize: "18px" }} rowSpan={2} colSpan={1}>Edited By</th>


                                <th style={{ minWidth: "160px", padding: "8px", fontSize: "18px" }} colSpan={1}>Approved by</th> {/* changed from 9 to 7 */}

                                {/* <th tyle={{ minWidth: "160px", padding: "8px" }} colSpan={1} rowSpan={2}>Details</th> */}
                              </tr>
                              <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
                                {/* <th tyle={{ minWidth: "160px", padding: "8px" }}>Deputy Engineer</th> */}
                                <th tyle={{ minWidth: "160px", padding: "8px", fontSize: "18px" }}>Department HOD(EE)</th>
                              </tr>
                            </thead>

                            <tbody >
                              {currentWorkOrderData?.length === 0 ? (
                                <tr>
                                  <td colSpan="10" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
                                    No data available
                                  </td>
                                </tr>
                              ) : (
                                [...currentWorkOrderData]
                                  .sort((a, b) =>
                                    new Date(b.WorkOrderDate || 0) - new Date(a.WorkOrderDate || 0)
                                  ) // newest first
                                  .map((proposal, index) => {
                                    const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                    return (
                                      <tr style={{ backgroundColor: bgColor, fontSize: "18px" }} key={index}>
                                        <td style={{ padding: '8px 8px', fontSize: "18px" }}>{firstRecordIndexWorkOrderData + index + 1}</td>
                                        <td style={{ padding: '8px 8px', fontSize: "18px" }}>{proposal.WorkOrderID}</td>
                                        <td style={{ padding: '8px 8px', fontSize: "18px" }}>{proposal.WorkOrderNo}</td>
                                        <td style={{ padding: '8px 8px', fontSize: "18px" }}>{proposal.WorkName}</td>
                                        <td style={{ padding: '8px 8px', fontSize: "18px" }}>{proposal.HeadCode}</td>
                                        <td style={{ padding: '8px 8px', fontSize: "18px" }}>{proposal.TechnicalUID}</td>
                                        <td style={{ padding: '8px 8px', fontSize: "18px" }}>{proposal.ProposalID}</td>
                                        <td style={{ padding: '8px 8px', fontSize: "18px" }}>{proposal.ProposalYear}</td>
                                        <td style={{ padding: '8px 8px', fontSize: "18px" }}>{proposal.talulka}</td>
                                        <td style={{ padding: '8px 8px', fontSize: "18px" }}>{proposal.ApprovedWorkAmount}</td>
                                        <td style={{ padding: '8px 8px', fontSize: "18px" }}>{proposal.BillRemainingAmount || 0}</td>
                                        <td style={{ padding: '8px 8px', fontSize: "18px" }}>{proposal.BillPaidAmount || 0}</td>
                                        <td style={{ padding: '8px 8px', fontSize: "18px" }}>{new Date(proposal.WorkOrderDate).toLocaleDateString("en-GB")}</td>
                                        <td style={{ padding: '8px 8px', fontSize: "18px" }}>{new Date(proposal.WorkEndDate).toLocaleDateString("en-GB")}</td>
                                        <td style={{ padding: '8px 8px', fontSize: "18px" }}>{
                                          proposal.CopyofWorkOrder ? (
                                            <a href={`${apiurl}/WorkOrderDocsImages/${proposal.CopyofWorkOrder}`} target='_blank'>{proposal.CopyofWorkOrder}
                                            </a>
                                          )
                                            :
                                            (
                                              <p className='fw-bold text-danger my-auto'>No File</p>
                                            )
                                        }
                                        </td>

                                        <td style={{ padding: '8px 8px', fontSize: "18px" }}>{new Date(proposal.Date).toLocaleString("en-IN")}</td>
                                        <td style={{ padding: '8px 8px', fontSize: "18px" }}>{
                                          proposal.EditedBy ? (
                                            <p className="text-black my-auto fw-bold">{proposal.EditedBy}</p>
                                          ) : (
                                            <p className="text-danger my-auto fw-bold">No One</p>
                                          )
                                        }</td>
                                        <td style={{ padding: '8px', textAlign: 'center' }}>
                                          {proposal.Approvance3 === 'true' ? (<div className='m-auto'
                                            style={{
                                              width: '20px',
                                              height: '20px',
                                              borderRadius: '6px',
                                              backgroundColor: '#16C60C',
                                              border: 'none',
                                              display: 'flex',
                                              justifyContent: 'center',
                                              alignItems: 'center',
                                              fontSize: '13px',
                                              color: 'white',
                                              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                            }}
                                          >
                                            ✓
                                          </div>) : proposal.Approvance3 === 'false' ? (<div
                                            className='m-auto'
                                            style={{
                                              width: '20px',
                                              height: '20px',
                                              borderRadius: '6px',
                                              backgroundColor: '#dc2626',
                                              border: 'none',
                                              display: 'flex',
                                              justifyContent: 'center',
                                              alignItems: 'center',
                                              fontSize: '13px',
                                              color: 'white',
                                              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                            }}
                                          >
                                            ✕
                                          </div>) : '-'}
                                        </td>
                                      </tr>

                                    );
                                  })
                              )}
                              {/* Page Total */}
                              <tr
                                style={{
                                  fontWeight: "bold",
                                  backgroundColor: "#f0f0f0",
                                  textAlign: "right", fontSize: "18px"
                                }}
                              >
                                <td colSpan={9} style={{ fontSize: "18px" }} >
                                  {t("Page Total")}
                                </td>

                                <td style={{ fontSize: "18px" }}>
                                  ₹{" "}
                                  {Number(pageTotalWOApprovedAmount).toLocaleString("en-IN")}
                                </td>

                                <td style={{ fontSize: "18px" }}>
                                  ₹{" "}
                                  {Number(pageTotalWORemainingAmount).toLocaleString("en-IN")}
                                </td>

                                <td style={{ fontSize: "18px" }}>
                                  ₹{" "}
                                  {Number(pageTotalWOPaidAmount).toLocaleString("en-IN")}
                                </td>

                                <td colSpan={7} style={{ fontSize: "18px" }}></td>
                              </tr>

                              {/* Grand Total */}
                              <tr
                                style={{
                                  fontWeight: "bold",
                                  backgroundColor: "#e0e0e0",
                                  textAlign: "right", fontSize: "18px"
                                }}
                              >
                                <td colSpan={9} style={{ fontSize: "18px" }}>
                                  {t("Gross Total")}
                                </td>

                                <td style={{ fontSize: "18px" }}>
                                  ₹{" "}
                                  {Number(grandTotalWOApprovedAmount).toLocaleString("en-IN")}
                                </td>

                                <td style={{ fontSize: "18px" }}>
                                  ₹{" "}
                                  {Number(grandTotalWORemainingAmount).toLocaleString("en-IN")}
                                </td>

                                <td style={{ fontSize: "18px" }}>
                                  ₹{" "}
                                  {Number(grandTotalWOPaidAmount).toLocaleString("en-IN")}
                                </td>

                                <td colSpan={7}></td>
                              </tr>
                            </tbody>

                          </table>
                        </div>
                        <div className='col-12 mt-4 mb-2'>
                          <div className="row">
                            <div className='col-6'>
                              <p className="text-gray-600" style={{ fontSize: "18px" }}>{t("Showing")} {firstRecordIndexWorkOrderData + 1} {t("to")} {Math.min(lastRecordIndexWorkOrderData, totalRecordsWorkOrderData)} {t("of")} {totalRecordsWorkOrderData} {t("entries")}</p>
                            </div>
                            <div className='col-6 text-end'>
                              <GooglePagination
                                currentPage={currentPageWorkOrderData}
                                totalPages={totalPagesWorkOrderData}
                                onPageChange={setCurrentPageWorkOrderData}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </>
          )
        }
      </div>

      {loading && (
        <div
          style={{
            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(255, 255, 255, 0.7)', backdropFilter: 'blur(4px)', zIndex: 9999,
            display: 'flex', justifyContent: 'center', alignItems: 'center'
          }}>
          <div style={{ border: '6px solid #f3f3f3', borderTop: '6px solid #007bff', borderRadius: '50%', width: '60px', height: '60px', animation: 'spin 1s linear infinite' }} />
          <style>
            {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
          </style>
        </div>
      )}
    </>
  );

};

export default MISReport;

